"use client";
var J0 = Object.defineProperty;
var hf = (e) => {
  throw TypeError(e);
};
var ex = (e, t, n) => t in e ? J0(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var J = (e, t, n) => ex(e, typeof t != "symbol" ? t + "" : t, n), mf = (e, t, n) => t.has(e) || hf("Cannot " + n);
var wt = (e, t, n) => (mf(e, t, "read from private field"), n ? n.call(e) : t.get(e)), pf = (e, t, n) => t.has(e) ? hf("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n), Da = (e, t, n, r) => (mf(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n);
import { jsxs as L, jsx as h, Fragment as Oe } from "react/jsx-runtime";
import * as v from "react";
import Z, { useState as ue, createContext as Ye, useContext as Pe, useLayoutEffect as Dr, useRef as oe, useEffect as de, useCallback as Fe, useMemo as pe, useId as tx, Fragment as Hs, createElement as We, useInsertionEffect as xp, forwardRef as Ze, Component as nx, Children as hr, isValidElement as ws, cloneElement as Jc, useReducer as rx } from "react";
import { Loader2 as ox, X as eu, Loader2Icon as Sp, ChevronDown as Cp, ChevronUp as ix, CircleMinusIcon as sx, CirclePlusIcon as ax, MinusIcon as lx, Check as tu, SearchCheckIcon as cx, SearchIcon as Ml, ArrowUpDown as ux, ArrowDown as dx, ArrowUp as fx, TriangleAlertIcon as hx, EyeOffIcon as mx, MoveRightIcon as px, MoveLeftIcon as gx, DotIcon as gf, MoveUpIcon as vx, MoveDownIcon as yx, LockIcon as bx, LockOpenIcon as wx, ChevronRightIcon as so, FilterIcon as xx, GripVertical as Sx, FileUpIcon as Cx, ChevronRight as Tx, ChevronLeft as Px, Calendar as nu, CalendarIcon as Ex, Search as kx, ChevronLeftIcon as Xo } from "lucide-react";
import * as po from "react-dom";
import Dx, { flushSync as ru } from "react-dom";
import { escape as to, op as xs, from as Tp } from "arquero";
const Rx = (e, t) => new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: t,
  minimumFractionDigits: t
}).format(e), Mx = [
  // Percentage mask x 100
  {
    mask: /100#\.[#0]+%$/,
    apply: (e, t) => {
      e = typeof e == "string" ? parseFloat(e) : e, e *= 100;
      const n = t.match(/100#\.([#0]+)%$/)[1].length;
      return `${e.toFixed(n)}%`;
    }
  },
  // Percentage mask
  {
    mask: /#\.[#0]+%$/,
    apply: (e, t) => {
      e = typeof e == "string" ? parseFloat(e) : e;
      const n = t.match(/#\.([#0]+)%/)[1].length;
      return `${e.toFixed(n)}%`;
    }
  },
  // Dollar mask
  {
    mask: /\$#(\.[#0]*)?$/,
    apply: (e, t) => {
      e = typeof e == "string" ? parseFloat(e) : e;
      const n = t.match(/\$#(\.([#0]*))?$/)[2], r = n ? n.length : 0;
      return Rx(e, r);
    }
  },
  // Millions mask,
  {
    mask: /#\.[#0]+M$/,
    apply: (e, t) => {
      if (e) {
        const n = t.match(/#\.([#0]+)M$/)[1], r = n.length;
        e = Number(e);
        let o = (e / 1e6).toFixed(r);
        if (!n.includes("0")) {
          const i = new RegExp("\\.0+$|(?<=\\.[0-9]*[1-9])0+$");
          o = o.replace(i, ""), o.includes(".") || (o = o.concat(".0"));
        }
        return o.concat(" M");
      }
      return "";
    }
  },
  // TODO: Validate this
  {
    mask: /#\.#+M$/,
    apply: (e, t) => {
      if (e) {
        const n = t.split("."), r = n && n[1] ? n[1].length - 1 : 0;
        e = Number(e);
        const o = new RegExp("\\.0+$|(?<=\\.[0-9]*[1-9])0+$");
        let i = (e / 1e12).toFixed(r).replace(o, "");
        return i.includes(".") || (i = i.concat(".0")), i.concat(" T");
      }
      return "";
    }
  },
  // Thousands mask,
  {
    mask: /#\.[#0]+K$/,
    apply: (e, t) => {
      if (e) {
        const n = t.match(/#\.([#0]+)K$/)[1], r = n.length;
        e = Number(e);
        let o = (e / 1e3).toFixed(r);
        if (!n.includes("0")) {
          const i = new RegExp("\\.0+$|(?<=\\.[0-9]*[1-9])0+$");
          o = o.replace(i, ""), o.includes(".") || (o = o.concat(".0"));
        }
        return o.concat(" K");
      }
      return "";
    }
  },
  // Standard format: full number with commas as thousands separators
  {
    mask: /^#\.[#0]+$/,
    apply: (e, t) => {
      if (e !== "" && e !== null && e !== void 0) {
        e = Number(e);
        const n = t.split("."), r = n && n[1] ? n[1].length : 0;
        return new Intl.NumberFormat("en-US", {
          maximumFractionDigits: r,
          minimumFractionDigits: r
        }).format(e);
      }
      return "";
    }
  },
  {
    mask: ["#"],
    apply: (e) => e !== "" && e !== null && e !== void 0 ? (e = Number(e), new Intl.NumberFormat("en-US", {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0
    }).format(e)) : ""
  },
  {
    mask: ["#th"],
    // https://stackoverflow.com/questions/13627308/add-st-nd-rd-and-th-ordinal-suffix-to-a-number
    apply: (e, t) => {
      e = Number(e);
      const n = e % 10, r = e % 100;
      return n === 1 && r !== 11 ? e + "st" : n === 2 && r !== 12 ? e + "nd" : n === 3 && r !== 13 ? e + "rd" : e + "th";
    }
  }
];
function Al(e, t) {
  const n = Mx.find(
    (r) => Array.isArray(r.mask) && r.mask.includes(t) || !Array.isArray(r.mask) && t.match(r.mask)
  );
  return n ? n.apply(e, t) : "Invalid Mask";
}
const dV = (e) => e >= 1e6 ? `${(e / 1e6).toFixed(0)}M` : e >= 1e3 ? `${(e / 1e3).toFixed(0)}k` : e.toString(), Ax = (e, t = 0) => {
  const n = Math.pow(10, t);
  return Math.round(e * n) / n;
};
function Pp(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (n = Pp(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function He() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (t = Pp(e)) && (r && (r += " "), r += t);
  return r;
}
const ou = "-", Ox = (e) => {
  const t = _x(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (s) => {
      const a = s.split(ou);
      return a[0] === "" && a.length !== 1 && a.shift(), Ep(a, t) || Nx(s);
    },
    getConflictingClassGroupIds: (s, a) => {
      const l = n[s] || [];
      return a && r[s] ? [...l, ...r[s]] : l;
    }
  };
}, Ep = (e, t) => {
  var s;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), o = r ? Ep(e.slice(1), r) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const i = e.join(ou);
  return (s = t.validators.find(({
    validator: a
  }) => a(i))) == null ? void 0 : s.classGroupId;
}, vf = /^\[(.+)\]$/, Nx = (e) => {
  if (vf.test(e)) {
    const t = vf.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, _x = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return Lx(Object.entries(e.classGroups), n).forEach(([i, s]) => {
    Ol(s, r, i, t);
  }), r;
}, Ol = (e, t, n, r) => {
  e.forEach((o) => {
    if (typeof o == "string") {
      const i = o === "" ? t : yf(t, o);
      i.classGroupId = n;
      return;
    }
    if (typeof o == "function") {
      if (Ix(o)) {
        Ol(o(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: n
      });
      return;
    }
    Object.entries(o).forEach(([i, s]) => {
      Ol(s, yf(t, i), n, r);
    });
  });
}, yf = (e, t) => {
  let n = e;
  return t.split(ou).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, Ix = (e) => e.isThemeGetter, Lx = (e, t) => t ? e.map(([n, r]) => {
  const o = r.map((i) => typeof i == "string" ? t + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(([s, a]) => [t + s, a])) : i);
  return [n, o];
}) : e, $x = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const o = (i, s) => {
    n.set(i, s), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(i) {
      let s = n.get(i);
      if (s !== void 0)
        return s;
      if ((s = r.get(i)) !== void 0)
        return o(i, s), s;
    },
    set(i, s) {
      n.has(i) ? n.set(i, s) : o(i, s);
    }
  };
}, kp = "!", Fx = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, o = t[0], i = t.length, s = (a) => {
    const l = [];
    let c = 0, u = 0, d;
    for (let y = 0; y < a.length; y++) {
      let b = a[y];
      if (c === 0) {
        if (b === o && (r || a.slice(y, y + i) === t)) {
          l.push(a.slice(u, y)), u = y + i;
          continue;
        }
        if (b === "/") {
          d = y;
          continue;
        }
      }
      b === "[" ? c++ : b === "]" && c--;
    }
    const f = l.length === 0 ? a : a.substring(u), m = f.startsWith(kp), p = m ? f.substring(1) : f, g = d && d > u ? d - u : void 0;
    return {
      modifiers: l,
      hasImportantModifier: m,
      baseClassName: p,
      maybePostfixModifierPosition: g
    };
  };
  return n ? (a) => n({
    className: a,
    parseClassName: s
  }) : s;
}, Vx = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, Bx = (e) => ({
  cache: $x(e.cacheSize),
  parseClassName: Fx(e),
  ...Ox(e)
}), Wx = /\s+/, zx = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: o
  } = t, i = [], s = e.trim().split(Wx);
  let a = "";
  for (let l = s.length - 1; l >= 0; l -= 1) {
    const c = s[l], {
      modifiers: u,
      hasImportantModifier: d,
      baseClassName: f,
      maybePostfixModifierPosition: m
    } = n(c);
    let p = !!m, g = r(p ? f.substring(0, m) : f);
    if (!g) {
      if (!p) {
        a = c + (a.length > 0 ? " " + a : a);
        continue;
      }
      if (g = r(f), !g) {
        a = c + (a.length > 0 ? " " + a : a);
        continue;
      }
      p = !1;
    }
    const y = Vx(u).join(":"), b = d ? y + kp : y, x = b + g;
    if (i.includes(x))
      continue;
    i.push(x);
    const w = o(g, p);
    for (let S = 0; S < w.length; ++S) {
      const E = w[S];
      i.push(b + E);
    }
    a = c + (a.length > 0 ? " " + a : a);
  }
  return a;
};
function jx() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = Dp(t)) && (r && (r += " "), r += n);
  return r;
}
const Dp = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = Dp(e[r])) && (n && (n += " "), n += t);
  return n;
};
function Hx(e, ...t) {
  let n, r, o, i = s;
  function s(l) {
    const c = t.reduce((u, d) => d(u), e());
    return n = Bx(c), r = n.cache.get, o = n.cache.set, i = a, a(l);
  }
  function a(l) {
    const c = r(l);
    if (c)
      return c;
    const u = zx(l, n);
    return o(l, u), u;
  }
  return function() {
    return i(jx.apply(null, arguments));
  };
}
const je = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, Rp = /^\[(?:([a-z-]+):)?(.+)\]$/i, Ux = /^\d+\/\d+$/, Yx = /* @__PURE__ */ new Set(["px", "full", "screen"]), Gx = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Kx = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Xx = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, qx = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Qx = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Rn = (e) => no(e) || Yx.has(e) || Ux.test(e), jn = (e) => go(e, "length", iS), no = (e) => !!e && !Number.isNaN(Number(e)), Ra = (e) => go(e, "number", no), Po = (e) => !!e && Number.isInteger(Number(e)), Zx = (e) => e.endsWith("%") && no(e.slice(0, -1)), ve = (e) => Rp.test(e), Hn = (e) => Gx.test(e), Jx = /* @__PURE__ */ new Set(["length", "size", "percentage"]), eS = (e) => go(e, Jx, Mp), tS = (e) => go(e, "position", Mp), nS = /* @__PURE__ */ new Set(["image", "url"]), rS = (e) => go(e, nS, aS), oS = (e) => go(e, "", sS), Eo = () => !0, go = (e, t, n) => {
  const r = Rp.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, iS = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  Kx.test(e) && !Xx.test(e)
), Mp = () => !1, sS = (e) => qx.test(e), aS = (e) => Qx.test(e), lS = () => {
  const e = je("colors"), t = je("spacing"), n = je("blur"), r = je("brightness"), o = je("borderColor"), i = je("borderRadius"), s = je("borderSpacing"), a = je("borderWidth"), l = je("contrast"), c = je("grayscale"), u = je("hueRotate"), d = je("invert"), f = je("gap"), m = je("gradientColorStops"), p = je("gradientColorStopPositions"), g = je("inset"), y = je("margin"), b = je("opacity"), x = je("padding"), w = je("saturate"), S = je("scale"), E = je("sepia"), C = je("skew"), T = je("space"), P = je("translate"), D = () => ["auto", "contain", "none"], k = () => ["auto", "hidden", "clip", "visible", "scroll"], R = () => ["auto", ve, t], O = () => [ve, t], _ = () => ["", Rn, jn], $ = () => ["auto", no, ve], z = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], I = () => ["solid", "dashed", "dotted", "double", "none"], A = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], M = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], F = () => ["", "0", ve], W = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], ne = () => [no, ve];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Eo],
      spacing: [Rn, jn],
      blur: ["none", "", Hn, ve],
      brightness: ne(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Hn, ve],
      borderSpacing: O(),
      borderWidth: _(),
      contrast: ne(),
      grayscale: F(),
      hueRotate: ne(),
      invert: F(),
      gap: O(),
      gradientColorStops: [e],
      gradientColorStopPositions: [Zx, jn],
      inset: R(),
      margin: R(),
      opacity: ne(),
      padding: O(),
      saturate: ne(),
      scale: ne(),
      sepia: F(),
      skew: ne(),
      space: O(),
      translate: O()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", ve]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Hn]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": W()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": W()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...z(), ve]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: k()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": k()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": k()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: D()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": D()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": D()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [g]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [g]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [g]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [g]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [g]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [g]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [g]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [g]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [g]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Po, ve]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: R()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", ve]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: F()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: F()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Po, ve]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Eo]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Po, ve]
        }, ve]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": $()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": $()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Eo]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Po, ve]
        }, ve]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": $()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": $()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", ve]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", ve]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [f]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [f]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [f]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...M()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...M(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...M(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [x]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [x]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [x]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [x]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [x]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [x]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [x]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [x]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [x]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [y]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [y]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [y]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [y]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [y]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [y]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [y]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [y]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [y]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [T]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [T]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", ve, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [ve, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [ve, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [Hn]
        }, Hn]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [ve, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [ve, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [ve, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [ve, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Hn, jn]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Ra]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Eo]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", ve]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", no, Ra]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Rn, ve]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", ve]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", ve]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [b]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [b]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...I(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Rn, jn]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Rn, ve]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: O()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", ve]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", ve]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [b]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...z(), tS]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", eS]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, rS]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [p]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [m]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [a]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [a]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [a]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [a]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [a]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [a]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [a]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [a]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [a]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [b]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...I(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [a]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [a]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [b]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: I()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [o]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...I()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Rn, ve]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Rn, jn]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: _()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [b]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Rn, jn]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Hn, oS]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Eo]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [b]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...A(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": A()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Hn, ve]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [w]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [E]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [b]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [w]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [E]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [s]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [s]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [s]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", ve]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: ne()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", ve]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: ne()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", ve]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [S]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [S]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [S]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Po, ve]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [P]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [P]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [C]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [C]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", ve]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", ve]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": O()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": O()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": O()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": O()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": O()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": O()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": O()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": O()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": O()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": O()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": O()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": O()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": O()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": O()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": O()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": O()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": O()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": O()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", ve]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Rn, jn, Ra]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, cS = /* @__PURE__ */ Hx(lS);
function Q(...e) {
  return cS(He(e));
}
var uS = Object.defineProperty, iu = (e, t) => uS(e, "name", { value: t, configurable: !0 });
function Nl(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
iu(Nl, "setRef");
function Ap(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = Nl(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : Nl(e[o], null);
        }
      };
  };
}
iu(Ap, "composeRefs");
function be(...e) {
  return v.useCallback(Ap(...e), e);
}
iu(be, "useComposedRefs");
var dS = Object.defineProperty, Xt = (e, t) => dS(e, "name", { value: t, configurable: !0 }), fS = /* @__PURE__ */ Xt((e, t) => {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    if (/^on[A-Z]/.test(r))
      if (o && i) {
        const a = typeof o == "function", l = typeof i == "function";
        n[r] = (...c) => {
          const u = l ? i(...c) : void 0;
          return a && o(...c), u;
        };
      } else o && (n[r] = o);
    else r === "style" ? n[r] = {
      ...typeof o == "object" ? o : null,
      ...typeof i == "object" ? i : null
    } : r === "className" ? n[r] = [o, i].filter(Boolean).join(" ") : r === "aria-describedby" && (n[r] = Op(i, o));
  }
  return { ...e, ...n };
}, "mergeProps");
function Op(...e) {
  const t = /* @__PURE__ */ new Set();
  for (const n of e)
    if (typeof n == "string")
      for (const r of String(n).trim().split(/\s+/))
        r && t.add(r);
  return t.size > 0 ? Array.from(t).join(" ") : void 0;
}
Xt(Op, "concatAriaDescribedby");
var Np = v.createContext(fS);
Np.displayName = "SlotContext";
// @__NO_SIDE_EFFECTS__
function Cn(e) {
  const t = v.forwardRef((n, r) => {
    const o = v.useContext(Np);
    let { children: i, mergeProps: s = o, ...a } = n, l = null, c = !1;
    const u = [];
    _l(i) && typeof Bi == "function" && (i = Bi(i._payload)), v.Children.forEach(i, (p) => {
      var g;
      if ($p(p)) {
        c = !0;
        const y = p;
        let b = "child" in y.props ? y.props.child : y.props.children;
        _l(b) && typeof Bi == "function" && (b = Bi(b._payload)), l = mS(y, b), u.push((g = l == null ? void 0 : l.props) == null ? void 0 : g.children);
      } else
        u.push(p);
    }), l ? l = v.cloneElement(l, void 0, u) : (
      // A `Slottable` was found but it didn't resolve to a single element (e.g.
      // it wrapped multiple elements, text, or a render-prop `child` that
      // wasn't an element). Don't fall back to treating the `Slottable` wrapper
      // itself as the slot target — throw a descriptive error below instead.
      !c && v.Children.count(i) === 1 && v.isValidElement(i) && (l = i)
    );
    const d = l ? Lp(l) : void 0, f = be(r, d);
    if (!l) {
      if (i || i === 0)
        throw new Error(
          c ? vS(e) : gS(e)
        );
      return i;
    }
    const m = s(
      a,
      l.props ?? {}
    );
    return l.type !== v.Fragment && (m.ref = r ? f : d), v.cloneElement(l, m);
  });
  return t.displayName = `${e}.Slot`, t;
}
Xt(Cn, "createSlot");
var hS = /* @__PURE__ */ Cn("Slot"), _p = Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function Ip(e) {
  const t = /* @__PURE__ */ Xt((n) => "child" in n ? n.children(n.child) : n.children, "Slottable");
  return t.displayName = `${e}.Slottable`, t.__radixId = _p, t;
}
Xt(Ip, "createSlottable");
var mS = /* @__PURE__ */ Xt((e, t) => {
  if ("child" in e.props) {
    const n = e.props.child;
    return v.isValidElement(n) ? v.cloneElement(n, void 0, e.props.children(n.props.children)) : null;
  }
  return v.isValidElement(t) ? t : null;
}, "getSlottableElementFromSlottable");
function Lp(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
Xt(Lp, "getElementRef");
function $p(e) {
  return v.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === _p;
}
Xt($p, "isSlottable");
var pS = Symbol.for("react.lazy");
function _l(e) {
  return e != null && typeof e == "object" && "$$typeof" in e && e.$$typeof === pS && "_payload" in e && Fp(e._payload);
}
Xt(_l, "isLazyComponent");
function Fp(e) {
  return typeof e == "object" && e !== null && "then" in e;
}
Xt(Fp, "isPromiseLike");
var gS = /* @__PURE__ */ Xt((e) => `${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, "createSlotError"), vS = /* @__PURE__ */ Xt((e) => `${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, "createSlottableError"), Bi = v[" use ".trim().toString()];
const bf = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, wf = He, Rr = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null) return wf(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: o, defaultVariants: i } = t, s = Object.keys(o).map((c) => {
    const u = n == null ? void 0 : n[c], d = i == null ? void 0 : i[c];
    if (u === null) return null;
    const f = bf(u) || bf(d);
    return o[c][f];
  }), a = n && Object.entries(n).reduce((c, u) => {
    let [d, f] = u;
    return f === void 0 || (c[d] = f), c;
  }, {}), l = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((c, u) => {
    let { class: d, className: f, ...m } = u;
    return Object.entries(m).every((p) => {
      let [g, y] = p;
      return Array.isArray(y) ? y.includes({
        ...i,
        ...a
      }[g]) : {
        ...i,
        ...a
      }[g] === y;
    }) ? [
      ...c,
      d,
      f
    ] : c;
  }, []);
  return wf(e, s, l, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
}, Il = Rr(
  "inline-flex items-center justify-center whitespace-nowrap rounded-sm text-bold ring-offset-background transition-colors h-fit focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-100",
  {
    variants: {
      variant: {
        default: "border border-button-primary-bg text-button-primary-txt bg-button-primary-bg hover:bg-button-primary-hover hover:border-button-primary-hover active:bg-button-primary-active active:border-button-primary-active disabled:bg-button-primary-disabled disabled:border-button-primary-disabled disabled:text-button-primary-disabled-txt",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        danger: "bg-red-500 text-button-primary-txt hover:bg-red-600",
        warning: "bg-yellow-500 text-button-primary-txt hover:bg-yellow-600",
        outline: "border border-button-primary-outline-default text-button-primary-outline-default bg-button-primary-outline-bg hover:border-button-primary-outline-hover hover:text-button-primary-outline-hover active:border-button-primary-outline-active active:text-button-primary-outline-active disabled:border-button-primary-outline-disabled disabled:text-button-primary-outline-disabled",
        minimal: "border border-transparent text-button-primary-outline-default bg-transparent hover:text-button-primary-outline-hover active:text-button-primary-outline-active disabled:text-button-primary-outline-disabled",
        secondary: "border border-button-secondary-bg text-button-secondary-txt bg-button-secondary-bg hover:bg-button-secondary-hover hover:border-button-secondary-hover active:bg-button-secondary-active active:border-button-secondary-active disabled:bg-button-secondary-disabled disabled:border-button-secondary-disabled disabled:text-button-secondary-disabled-txt",
        secondaryOutline: "border border-button-secondary-outline-default text-button-secondary-outline-default bg-button-secondary-outline-bg hover:border-button-secondary-outline-hover hover:text-button-secondary-outline-hover active:border-button-secondary-outline-active active:text-button-secondary-outline-active disabled:border-button-secondary-outline-disabled disabled:text-button-secondary-outline-disabled",
        secondaryMinimal: "border border-transparent text-button-secondary-outline-default bg-transparent hover:text-button-secondary-outline-hover active:text-button-secondary-outline-active disabled:text-button-secondary-outline-disabled",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        // link: 'text-primary underline-offset-4 hover:underline',
        link: "text-primary"
      },
      size: {
        default: "control rounded-md",
        // xxs: 'control-xxs',
        xs: "control-xs",
        sm: "control-sm",
        md: "control-md rounded-lg",
        lg: "control-lg rounded-lg"
        // icon: 'h-10 w-10',
        // input: 'min-h-10 px-3 py-2',
        // 'icon-sm': 'h-6 w-6 p-1',
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), ke = v.forwardRef(
  ({ className: e, variant: t, size: n, asChild: r = !1, children: o, loading: i, ...s }, a) => {
    const l = r ? hS : "button";
    return s.type = s.type || "button", /* @__PURE__ */ L(l, { className: Q("relative", Il({ variant: t, size: n, className: e })), ref: a, ...s, children: [
      i && /* @__PURE__ */ h(
        "div",
        {
          className: Q(
            "absolute top-0 bottom-0 left-0 right-0 flex justify-center",
            "items-center bg-button-primary-disabled/50 rounded-md"
          ),
          children: /* @__PURE__ */ h(ox, { className: "animate-spin size-6" })
        }
      ),
      o
    ] });
  }
);
ke.displayName = "Button";
const fV = () => /* @__PURE__ */ h(ke, { children: "Btn!" });
var yS = Object.defineProperty, vo = (e, t) => yS(e, "name", { value: t, configurable: !0 }), Vp = !!(typeof window < "u" && window.document && window.document.createElement);
function re(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return /* @__PURE__ */ vo(function(o) {
    if (e == null || e(o), n === !1 || !o || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  }, "handleEvent");
}
vo(re, "composeEventHandlers");
function bS(e) {
  var t;
  if (!Vp)
    throw new Error("Cannot access window outside of the DOM");
  return ((t = e == null ? void 0 : e.ownerDocument) == null ? void 0 : t.defaultView) ?? window;
}
vo(bS, "getOwnerWindow");
function Ll(e) {
  if (!Vp)
    throw new Error("Cannot access document outside of the DOM");
  return (e == null ? void 0 : e.ownerDocument) ?? document;
}
vo(Ll, "getOwnerDocument");
function Bp(e, t = !1) {
  const { activeElement: n } = Ll(e);
  if (!(n != null && n.nodeName))
    return null;
  if (Wp(n) && n.contentDocument)
    return Bp(n.contentDocument.body, t);
  if (t) {
    const r = n.getAttribute("aria-activedescendant");
    if (r) {
      const o = Ll(n).getElementById(r);
      if (o)
        return o;
    }
  }
  return n;
}
vo(Bp, "getActiveElement");
function Wp(e) {
  return e.tagName === "IFRAME";
}
vo(Wp, "isFrame");
var wS = Object.defineProperty, Ht = (e, t) => wS(e, "name", { value: t, configurable: !0 });
// @__NO_SIDE_EFFECTS__
function xS(e, t) {
  const n = v.createContext(t);
  n.displayName = e + "Context";
  const r = /* @__PURE__ */ Ht((i) => {
    const { children: s, ...a } = i, l = v.useMemo(() => a, Object.values(a));
    return /* @__PURE__ */ h(n.Provider, { value: l, children: s });
  }, "Provider");
  r.displayName = e + "Provider";
  function o(i, s = {}) {
    const { optional: a = !1 } = s, l = v.useContext(n);
    if (l) return l;
    if (t !== void 0) return t;
    if (!a)
      throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return Ht(o, "useContext"), [r, o];
}
Ht(xS, "createContext");
// @__NO_SIDE_EFFECTS__
function It(e, t = []) {
  let n = [];
  function r(i, s) {
    const a = v.createContext(s);
    a.displayName = i + "Context";
    const l = n.length;
    n = [...n, s];
    const c = /* @__PURE__ */ Ht((d) => {
      var b;
      const { scope: f, children: m, ...p } = d, g = ((b = f == null ? void 0 : f[e]) == null ? void 0 : b[l]) || a, y = v.useMemo(() => p, Object.values(p));
      return /* @__PURE__ */ h(g.Provider, { value: y, children: m });
    }, "Provider");
    c.displayName = i + "Provider";
    function u(d, f, m = {}) {
      var b;
      const { optional: p = !1 } = m, g = ((b = f == null ? void 0 : f[e]) == null ? void 0 : b[l]) || a, y = v.useContext(g);
      if (y) return y;
      if (s !== void 0) return s;
      if (!p)
        throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return Ht(u, "useContext"), [c, u];
  }
  Ht(r, "createContext");
  const o = /* @__PURE__ */ Ht(() => {
    const i = n.map((s) => v.createContext(s));
    return /* @__PURE__ */ Ht(function(a) {
      const l = (a == null ? void 0 : a[e]) || i;
      return v.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: l } }),
        [a, l]
      );
    }, "useScope");
  }, "createScope");
  return o.scopeName = e, [r, zp(o, ...t)];
}
Ht(It, "createContextScope");
function zp(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = /* @__PURE__ */ Ht(() => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return /* @__PURE__ */ Ht(function(i) {
      const s = r.reduce((a, { useScope: l, scopeName: c }) => {
        const d = l(i)[`__scope${c}`];
        return { ...a, ...d };
      }, {});
      return v.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    }, "useComposedScopes");
  }, "createScope");
  return n.scopeName = t.scopeName, n;
}
Ht(zp, "composeContextScopes");
var qe = globalThis != null && globalThis.document ? v.useLayoutEffect : () => {
}, SS = Object.defineProperty, CS = (e, t) => SS(e, "name", { value: t, configurable: !0 }), TS = v[" useId ".trim().toString()] || (() => {
}), PS = 0;
function rn(e) {
  const [t, n] = v.useState(TS());
  return qe(() => {
    e || n((r) => r ?? String(PS++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
CS(rn, "useId");
var ES = Object.defineProperty, kS = (e, t) => ES(e, "name", { value: t, configurable: !0 }), xf = v[" useEffectEvent ".trim().toString()], Sf = v[" useInsertionEffect ".trim().toString()];
function jp(e) {
  if (typeof xf == "function")
    return xf(e);
  const t = v.useRef(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  return typeof Sf == "function" ? Sf(() => {
    t.current = e;
  }) : qe(() => {
    t.current = e;
  }), v.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
kS(jp, "useEffectEvent");
var DS = Object.defineProperty, mi = (e, t) => DS(e, "name", { value: t, configurable: !0 }), RS = v[" useInsertionEffect ".trim().toString()] || qe;
function qn({
  prop: e,
  defaultProp: t,
  onChange: n = /* @__PURE__ */ mi(() => {
  }, "onChange"),
  caller: r
}) {
  const [o, i, s] = Hp({
    defaultProp: t,
    onChange: n
  }), a = e !== void 0, l = a ? e : o, c = v.useCallback(
    (u) => {
      var d;
      if (a) {
        const f = Up(u) ? u(e) : u;
        f !== e && ((d = s.current) == null || d.call(s, f));
      } else
        i(u);
    },
    [a, e, i, s]
  );
  return [l, c];
}
mi(qn, "useControllableState");
function Hp({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = v.useState(e), o = v.useRef(n), i = v.useRef(t);
  return RS(() => {
    i.current = t;
  }, [t]), v.useEffect(() => {
    var s;
    o.current !== n && ((s = i.current) == null || s.call(i, n), o.current = n);
  }, [n, o]), [n, r, i];
}
mi(Hp, "useUncontrolledState");
function Up(e) {
  return typeof e == "function";
}
mi(Up, "isFunction");
var Cf = Symbol("RADIX:SYNC_STATE");
function MS(e, t, n, r) {
  const { prop: o, defaultProp: i, onChange: s, caller: a } = t, l = o !== void 0, c = jp(s), u = [{ ...n, state: i }];
  r && u.push(r);
  const [d, f] = v.useReducer(
    (y, b) => {
      if (b.type === Cf)
        return { ...y, state: b.state };
      const x = e(y, b);
      return l && !Object.is(x.state, y.state) && c(x.state), x;
    },
    ...u
  ), m = d.state, p = v.useRef(m);
  v.useEffect(() => {
    p.current !== m && (p.current = m, l || c(m));
  }, [m, p, l]);
  const g = v.useMemo(() => o !== void 0 ? { ...d, state: o } : d, [d, o]);
  return v.useEffect(() => {
    l && !Object.is(o, d.state) && f({ type: Cf, state: o });
  }, [o, d.state, l]), [g, f];
}
mi(MS, "useControllableStateReducer");
var AS = Object.defineProperty, OS = (e, t) => AS(e, "name", { value: t, configurable: !0 }), NS = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], me = NS.reduce((e, t) => {
  const n = /* @__PURE__ */ Cn(`Primitive.${t}`), r = v.forwardRef((o, i) => {
    const { asChild: s, ...a } = o, l = s ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ h(l, { ...a, ref: i });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function su(e, t) {
  e && po.flushSync(() => e.dispatchEvent(t));
}
OS(su, "dispatchDiscreteCustomEvent");
var _S = Object.defineProperty, IS = (e, t) => _S(e, "name", { value: t, configurable: !0 });
function Je(e) {
  const t = v.useRef(e);
  return v.useEffect(() => {
    t.current = e;
  }), v.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
IS(Je, "useCallbackRef");
var LS = Object.defineProperty, lt = (e, t) => LS(e, "name", { value: t, configurable: !0 }), $l = "dismissableLayer.update", $S = "dismissableLayer.pointerDownOutside", FS = "dismissableLayer.focusOutside", Tf, au = v.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set(),
  // Outside elements that belong to a layer's own dismiss affordance (eg, a
  // dialog overlay). Pressing them should dismiss the layer regardless of
  // whether or not they stop propagation.
  //
  // See https://github.com/radix-ui/primitives/issues/3346
  dismissableSurfaces: /* @__PURE__ */ new Set()
}), pi = /* @__PURE__ */ v.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ lt(function(t, n) {
    const {
      disableOutsidePointerEvents: r = !1,
      deferPointerDownOutside: o = !1,
      onEscapeKeyDown: i,
      onPointerDownOutside: s,
      onFocusOutside: a,
      onInteractOutside: l,
      onDismiss: c,
      ...u
    } = t, d = v.useContext(au), [f, m] = v.useState(null), p = (f == null ? void 0 : f.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, g] = v.useState({}), y = be(n, m), b = Array.from(d.layers), [x] = [
      ...d.layersWithOutsidePointerEventsDisabled
    ].slice(-1), w = x ? b.indexOf(x) : -1, S = f ? b.indexOf(f) : -1, E = d.layersWithOutsidePointerEventsDisabled.size > 0, C = S >= w, T = v.useRef(!1), P = Gp(
      (O) => {
        s == null || s(O), l == null || l(O), O.defaultPrevented || c == null || c();
      },
      {
        ownerDocument: p,
        deferPointerDownOutside: o,
        isDeferredPointerDownOutsideRef: T,
        dismissableSurfaces: d.dismissableSurfaces,
        shouldHandlePointerDownOutside: v.useCallback(
          (O) => {
            if (!(O instanceof Node))
              return !1;
            const _ = [...d.branches].some(
              ($) => $.contains(O)
            );
            return C && !_;
          },
          [d.branches, C]
        )
      }
    ), D = Kp((O) => {
      if (o && T.current)
        return;
      const _ = O.target;
      [...d.branches].some((z) => z.contains(_)) || (a == null || a(O), l == null || l(O), O.defaultPrevented || c == null || c());
    }, p), k = f ? S === b.length - 1 : !1, R = Je((O) => {
      O.key === "Escape" && (i == null || i(O), !O.defaultPrevented && c && (O.preventDefault(), c()));
    });
    return v.useEffect(() => {
      if (k)
        return p.addEventListener("keydown", R, { capture: !0 }), () => p.removeEventListener("keydown", R, { capture: !0 });
    }, [p, k, R]), v.useEffect(() => {
      if (f)
        return r && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (Tf = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(f)), d.layers.add(f), Fl(), () => {
          r && (d.layersWithOutsidePointerEventsDisabled.delete(f), d.layersWithOutsidePointerEventsDisabled.size === 0 && (p.body.style.pointerEvents = Tf));
        };
    }, [f, p, r, d]), v.useEffect(() => () => {
      f && (d.layers.delete(f), d.layersWithOutsidePointerEventsDisabled.delete(f), Fl());
    }, [f, d]), v.useEffect(() => {
      const O = /* @__PURE__ */ lt(() => g({}), "handleUpdate");
      return document.addEventListener($l, O), () => document.removeEventListener($l, O);
    }, []), /* @__PURE__ */ h(
      me.div,
      {
        ...u,
        ref: y,
        style: {
          pointerEvents: E ? C ? "auto" : "none" : void 0,
          ...t.style
        },
        onFocusCapture: re(t.onFocusCapture, D.onFocusCapture),
        onBlurCapture: re(t.onBlurCapture, D.onBlurCapture),
        onPointerDownCapture: re(
          t.onPointerDownCapture,
          P.onPointerDownCapture
        )
      }
    );
  }, "DismissableLayer")
), VS = /* @__PURE__ */ v.forwardRef(/* @__PURE__ */ lt(function(t, n) {
  const r = v.useContext(au), o = v.useRef(null), i = be(n, o);
  return v.useEffect(() => {
    const s = o.current;
    if (s)
      return r.branches.add(s), () => {
        r.branches.delete(s);
      };
  }, [r.branches]), /* @__PURE__ */ h(me.div, { ...t, ref: i });
}, "DismissableLayerBranch"));
function Yp() {
  const e = v.useContext(au), [t, n] = v.useState(null);
  return v.useEffect(() => {
    if (t)
      return e.dismissableSurfaces.add(t), () => {
        e.dismissableSurfaces.delete(t);
      };
  }, [t, e.dismissableSurfaces]), n;
}
lt(Yp, "useDismissableLayerSurface");
var BS = /* @__PURE__ */ lt(() => !0, "IS_TRUE");
function Gp(e, t) {
  const {
    ownerDocument: n = globalThis == null ? void 0 : globalThis.document,
    deferPointerDownOutside: r = !1,
    isDeferredPointerDownOutsideRef: o,
    dismissableSurfaces: i,
    shouldHandlePointerDownOutside: s = BS
  } = t, a = Je(e), l = v.useRef(!1), c = v.useRef(!1), u = v.useRef(/* @__PURE__ */ new Map()), d = v.useRef(() => {
  });
  return v.useEffect(() => {
    function f() {
      c.current = !1, o.current = !1, u.current.clear();
    }
    lt(f, "resetOutsideInteraction");
    function m() {
      return Array.from(u.current.values()).some(Boolean);
    }
    lt(m, "isOutsideInteractionIntercepted");
    function p(w) {
      if (!c.current)
        return;
      const S = w.target;
      S instanceof Node && [...i].some((C) => C.contains(S)) || u.current.set(w.type, !0), w.type === "click" && window.setTimeout(() => {
        c.current && d.current();
      }, 0);
    }
    lt(p, "handleInteractionCapture");
    function g(w) {
      c.current && u.current.set(w.type, !1);
    }
    lt(g, "handleInteractionBubble");
    const y = /* @__PURE__ */ lt((w) => {
      if (w.target && !l.current) {
        let S = function() {
          n.removeEventListener("click", d.current);
          const C = m();
          f(), C || lu(
            $S,
            a,
            E,
            { discrete: !0 }
          );
        };
        if (lt(S, "handleAndDispatchPointerDownOutsideEvent"), !s(w.target)) {
          n.removeEventListener("click", d.current), f(), l.current = !1;
          return;
        }
        const E = { originalEvent: w };
        c.current = !0, o.current = r && w.button === 0, u.current.clear(), !r || w.button !== 0 ? S() : (n.removeEventListener("click", d.current), d.current = S, n.addEventListener("click", d.current, { once: !0 }));
      } else
        n.removeEventListener("click", d.current), f();
      l.current = !1;
    }, "handlePointerDown"), b = [
      "pointerup",
      "mousedown",
      "mouseup",
      "touchstart",
      "touchend",
      "click"
    ];
    for (const w of b)
      n.addEventListener(w, p, !0), n.addEventListener(w, g);
    const x = window.setTimeout(() => {
      n.addEventListener("pointerdown", y);
    }, 0);
    return () => {
      window.clearTimeout(x), n.removeEventListener("pointerdown", y), n.removeEventListener("click", d.current);
      for (const w of b)
        n.removeEventListener(w, p, !0), n.removeEventListener(w, g);
    };
  }, [
    n,
    a,
    r,
    o,
    i,
    s
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: /* @__PURE__ */ lt(() => l.current = !0, "onPointerDownCapture")
  };
}
lt(Gp, "usePointerDownOutside");
function Kp(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Je(e), r = v.useRef(!1);
  return v.useEffect(() => {
    const o = /* @__PURE__ */ lt((i) => {
      i.target && !r.current && lu(FS, n, { originalEvent: i }, {
        discrete: !1
      });
    }, "handleFocus");
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: /* @__PURE__ */ lt(() => r.current = !0, "onFocusCapture"),
    onBlurCapture: /* @__PURE__ */ lt(() => r.current = !1, "onBlurCapture")
  };
}
lt(Kp, "useFocusOutside");
function Fl() {
  const e = new CustomEvent($l);
  document.dispatchEvent(e);
}
lt(Fl, "dispatchUpdate");
function lu(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? su(o, i) : o.dispatchEvent(i);
}
lt(lu, "handleAndDispatchCustomEvent");
var WS = Object.defineProperty, Ct = (e, t) => WS(e, "name", { value: t, configurable: !0 }), Ma = "focusScope.autoFocusOnMount", Aa = "focusScope.autoFocusOnUnmount", Pf = { bubbles: !1, cancelable: !0 }, cu = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ Ct(function(t, n) {
    const {
      loop: r = !1,
      trapped: o = !1,
      onMountAutoFocus: i,
      onUnmountAutoFocus: s,
      ...a
    } = t, [l, c] = v.useState(null), u = Je(i), d = Je(s), f = v.useRef(null), m = be(n, c), p = v.useRef({
      paused: !1,
      pause() {
        this.paused = !0;
      },
      resume() {
        this.paused = !1;
      }
    }).current;
    v.useEffect(() => {
      if (o) {
        let y = function(S) {
          if (p.paused || !l) return;
          const E = S.target;
          l.contains(E) ? f.current = E : On(f.current, { select: !0 });
        }, b = function(S) {
          if (p.paused || !l) return;
          const E = S.relatedTarget;
          E !== null && (l.contains(E) || On(f.current, { select: !0 }));
        }, x = function(S) {
          if (document.activeElement === document.body)
            for (const C of S)
              C.removedNodes.length > 0 && On(l);
        };
        Ct(y, "handleFocusIn"), Ct(b, "handleFocusOut"), Ct(x, "handleMutations"), document.addEventListener("focusin", y), document.addEventListener("focusout", b);
        const w = new MutationObserver(x);
        return l && w.observe(l, { childList: !0, subtree: !0 }), () => {
          document.removeEventListener("focusin", y), document.removeEventListener("focusout", b), w.disconnect();
        };
      }
    }, [o, l, p.paused]), v.useEffect(() => {
      if (l) {
        Ef.add(p);
        const y = document.activeElement;
        if (!l.contains(y)) {
          const x = new CustomEvent(Ma, Pf);
          l.addEventListener(Ma, u), l.dispatchEvent(x), x.defaultPrevented || (Xp(eg(uu(l)), { select: !0 }), document.activeElement === y && On(l));
        }
        return () => {
          l.removeEventListener(Ma, u), setTimeout(() => {
            const x = new CustomEvent(Aa, Pf);
            l.addEventListener(Aa, d), l.dispatchEvent(x), x.defaultPrevented || On(y ?? document.body, { select: !0 }), l.removeEventListener(Aa, d), Ef.remove(p);
          }, 0);
        };
      }
    }, [l, u, d, p]);
    const g = v.useCallback(
      (y) => {
        if (!r && !o || p.paused) return;
        const b = y.key === "Tab" && !y.altKey && !y.ctrlKey && !y.metaKey, x = document.activeElement;
        if (b && x) {
          const w = y.currentTarget, [S, E] = qp(w);
          S && E ? !y.shiftKey && x === E ? (y.preventDefault(), r && On(S, { select: !0 })) : y.shiftKey && x === S && (y.preventDefault(), r && On(E, { select: !0 })) : x === w && y.preventDefault();
        }
      },
      [r, o, p.paused]
    );
    return /* @__PURE__ */ h(me.div, { tabIndex: -1, ...a, ref: m, onKeyDown: g });
  }, "FocusScope")
);
function Xp(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (On(r, { select: t }), document.activeElement !== n) return;
}
Ct(Xp, "focusFirst");
function qp(e) {
  const t = uu(e), n = Vl(t, e), r = Vl(t.reverse(), e);
  return [n, r];
}
Ct(qp, "getTabbableEdges");
function uu(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: /* @__PURE__ */ Ct((r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }, "acceptNode")
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
Ct(uu, "getTabbableCandidates");
function Vl(e, t) {
  const n = typeof t.checkVisibility == "function" && t.checkVisibility({ checkVisibilityCSS: !0 });
  for (const r of e)
    if (!(n ? !r.checkVisibility({ checkVisibilityCSS: !0 }) : Qp(r, { upTo: t })))
      return r;
}
Ct(Vl, "findVisible");
function Qp(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
Ct(Qp, "isHidden");
function Zp(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
Ct(Zp, "isSelectableInput");
function On(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && Zp(e) && t && e.select();
  }
}
Ct(On, "focus");
var Ef = Jp();
function Jp() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Bl(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Bl(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
Ct(Jp, "createFocusScopesStack");
function Bl(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
Ct(Bl, "arrayRemove");
function eg(e) {
  return e.filter((t) => t.tagName !== "A");
}
Ct(eg, "removeLinks");
var zS = Object.defineProperty, jS = (e, t) => zS(e, "name", { value: t, configurable: !0 }), gi = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ jS(function(t, n) {
    var l;
    const { container: r, ...o } = t, [i, s] = v.useState(!1);
    qe(() => s(!0), []);
    const a = r || i && ((l = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : l.body);
    return a ? po.createPortal(/* @__PURE__ */ h(me.div, { ...o, ref: n }), a) : null;
  }, "Portal")
), HS = Object.defineProperty, Ln = (e, t) => HS(e, "name", { value: t, configurable: !0 });
function tg(e, t) {
  return v.useReducer((n, r) => t[n][r] ?? n, e);
}
Ln(tg, "useStateMachine");
var Lt = /* @__PURE__ */ Ln((e) => {
  const { present: t, children: n } = e, r = ng(t), o = typeof n == "function" ? n({ present: r.isPresent }) : v.Children.only(n), i = rg(r.ref, og(o));
  return typeof n == "function" || r.isPresent ? v.cloneElement(o, { ref: i }) : null;
}, "Presence");
function ng(e) {
  const [t, n] = v.useState(), r = v.useRef(null), o = v.useRef(e), i = v.useRef("none"), s = v.useRef(void 0), a = e ? "mounted" : "unmounted", [l, c] = tg(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return v.useEffect(() => {
    l === "mounted" ? (i.current = s.current ?? Gr(r.current), s.current = void 0) : i.current = "none";
  }, [l]), qe(() => {
    const u = r.current, d = o.current;
    if (d !== e) {
      const m = i.current, p = Gr(u);
      e ? (s.current = p, c("MOUNT")) : p === "none" || (u == null ? void 0 : u.display) === "none" ? c("UNMOUNT") : c(d && m !== p ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, c]), qe(() => {
    if (t) {
      let u;
      const d = t.ownerDocument.defaultView ?? window, f = /* @__PURE__ */ Ln((p) => {
        const y = Gr(r.current).includes(CSS.escape(p.animationName));
        if (p.target === t && y && (c("ANIMATION_END"), !o.current)) {
          const b = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = d.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = b);
          });
        }
      }, "handleAnimationEnd"), m = /* @__PURE__ */ Ln((p) => {
        p.target === t && (i.current = Gr(r.current));
      }, "handleAnimationStart");
      return t.addEventListener("animationstart", m), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        d.clearTimeout(u), t.removeEventListener("animationstart", m), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(l),
    ref: v.useCallback((u) => {
      if (u) {
        const d = getComputedStyle(u);
        r.current = d, s.current = Gr(d);
      } else
        r.current = null;
      n(u);
    }, [])
  };
}
Ln(ng, "usePresence");
function Wl(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
Ln(Wl, "setRef");
function rg(...e) {
  const t = v.useRef(e);
  return t.current = e, v.useCallback((n) => {
    const r = t.current;
    let o = !1;
    const i = r.map((s) => {
      const a = Wl(s, n);
      return !o && typeof a == "function" && (o = !0), a;
    });
    if (o)
      return () => {
        for (let s = 0; s < i.length; s++) {
          const a = i[s];
          typeof a == "function" ? a() : Wl(r[s], null);
        }
      };
  }, []);
}
Ln(rg, "useStableComposedRefs");
function Gr(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
Ln(Gr, "getAnimationName");
function og(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
Ln(og, "getElementRef");
var US = Object.defineProperty, du = (e, t) => US(e, "name", { value: t, configurable: !0 }), Wi = 0, pn = null;
function YS(e) {
  return vi(), e.children;
}
du(YS, "FocusGuards");
function vi() {
  v.useEffect(() => {
    pn || (pn = { start: zl(), end: zl() });
    const { start: e, end: t } = pn;
    return document.body.firstElementChild !== e && document.body.insertAdjacentElement("afterbegin", e), document.body.lastElementChild !== t && document.body.insertAdjacentElement("beforeend", t), Wi++, () => {
      Wi === 1 && (pn == null || pn.start.remove(), pn == null || pn.end.remove(), pn = null), Wi = Math.max(0, Wi - 1);
    };
  }, []);
}
du(vi, "useFocusGuards");
function zl() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
du(zl, "createFocusGuard");
var xt = function() {
  return xt = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, xt.apply(this, arguments);
};
function fu(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function ig(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, i; r < o; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var Vo = "right-scroll-bar-position", Bo = "width-before-scroll-bar", GS = "with-scroll-bars-hidden", KS = "--removed-body-scroll-bar-size";
function Oa(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function XS(e, t) {
  var n = ue(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var qS = typeof window < "u" ? v.useLayoutEffect : v.useEffect, kf = /* @__PURE__ */ new WeakMap();
function sg(e, t) {
  var n = XS(null, function(r) {
    return e.forEach(function(o) {
      return Oa(o, r);
    });
  });
  return qS(function() {
    var r = kf.get(n);
    if (r) {
      var o = new Set(r), i = new Set(e), s = n.current;
      o.forEach(function(a) {
        i.has(a) || Oa(a, null);
      }), i.forEach(function(a) {
        o.has(a) || Oa(a, s);
      });
    }
    kf.set(n, e);
  }, [e]), n;
}
function QS(e) {
  return e;
}
function ZS(e, t) {
  t === void 0 && (t = QS);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var s = t(i, r);
      return n.push(s), function() {
        n = n.filter(function(a) {
          return a !== s;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(i);
      }
      n = {
        push: function(a) {
          return i(a);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var s = [];
      if (n.length) {
        var a = n;
        n = [], a.forEach(i), s = n;
      }
      var l = function() {
        var u = s;
        s = [], u.forEach(i);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), n = {
        push: function(u) {
          s.push(u), c();
        },
        filter: function(u) {
          return s = s.filter(u), n;
        }
      };
    }
  };
  return o;
}
function ag(e) {
  e === void 0 && (e = {});
  var t = ZS(null);
  return t.options = xt({ async: !0, ssr: !1 }, e), t;
}
var lg = function(e) {
  var t = e.sideCar, n = fu(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return v.createElement(r, xt({}, n));
};
lg.isSideCarExport = !0;
function cg(e, t) {
  return e.useMedium(t), lg;
}
var ug = ag(), Na = function() {
}, Us = v.forwardRef(function(e, t) {
  var n = v.useRef(null), r = v.useState({
    onScrollCapture: Na,
    onWheelCapture: Na,
    onTouchMoveCapture: Na
  }), o = r[0], i = r[1], s = e.forwardProps, a = e.children, l = e.className, c = e.removeScrollBar, u = e.enabled, d = e.shards, f = e.sideCar, m = e.noRelative, p = e.noIsolation, g = e.inert, y = e.allowPinchZoom, b = e.as, x = b === void 0 ? "div" : b, w = e.gapMode, S = fu(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), E = f, C = sg([n, t]), T = xt(xt({}, S), o);
  return v.createElement(
    v.Fragment,
    null,
    u && v.createElement(E, { sideCar: ug, removeScrollBar: c, shards: d, noRelative: m, noIsolation: p, inert: g, setCallbacks: i, allowPinchZoom: !!y, lockRef: n, gapMode: w }),
    s ? v.cloneElement(v.Children.only(a), xt(xt({}, T), { ref: C })) : v.createElement(x, xt({}, T, { className: l, ref: C }), a)
  );
});
Us.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Us.classNames = {
  fullWidth: Bo,
  zeroRight: Vo
};
var JS = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function eC() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = JS();
  return t && e.setAttribute("nonce", t), e;
}
function tC(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function nC(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var rC = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = eC()) && (tC(t, n), nC(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, oC = function() {
  var e = rC();
  return function(t, n) {
    v.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, hu = function() {
  var e = oC(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, iC = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, _a = function(e) {
  return parseInt(e || "", 10) || 0;
}, sC = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [_a(n), _a(r), _a(o)];
}, aC = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return iC;
  var t = sC(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, lC = hu(), ro = "data-scroll-locked", cC = function(e, t, n, r) {
  var o = e.left, i = e.top, s = e.right, a = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(GS, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(a, "px ").concat(r, `;
  }
  body[`).concat(ro, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(a, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Vo, ` {
    right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(Bo, ` {
    margin-right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(Vo, " .").concat(Vo, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(Bo, " .").concat(Bo, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(ro, `] {
    `).concat(KS, ": ").concat(a, `px;
  }
`);
}, Df = function() {
  var e = parseInt(document.body.getAttribute(ro) || "0", 10);
  return isFinite(e) ? e : 0;
}, uC = function() {
  v.useEffect(function() {
    return document.body.setAttribute(ro, (Df() + 1).toString()), function() {
      var e = Df() - 1;
      e <= 0 ? document.body.removeAttribute(ro) : document.body.setAttribute(ro, e.toString());
    };
  }, []);
}, dg = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  uC();
  var i = v.useMemo(function() {
    return aC(o);
  }, [o]);
  return v.createElement(lC, { styles: cC(i, !t, o, n ? "" : "!important") });
}, jl = !1;
if (typeof window < "u")
  try {
    var zi = Object.defineProperty({}, "passive", {
      get: function() {
        return jl = !0, !0;
      }
    });
    window.addEventListener("test", zi, zi), window.removeEventListener("test", zi, zi);
  } catch {
    jl = !1;
  }
var Vr = jl ? { passive: !1 } : !1, dC = function(e) {
  return e.tagName === "TEXTAREA";
}, fg = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !dC(e) && n[t] === "visible")
  );
}, fC = function(e) {
  return fg(e, "overflowY");
}, hC = function(e) {
  return fg(e, "overflowX");
}, Rf = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = hg(e, r);
    if (o) {
      var i = mg(e, r), s = i[1], a = i[2];
      if (s > a)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, mC = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, pC = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, hg = function(e, t) {
  return e === "v" ? fC(t) : hC(t);
}, mg = function(e, t) {
  return e === "v" ? mC(t) : pC(t);
}, gC = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, vC = function(e, t, n, r, o) {
  var i = gC(e, window.getComputedStyle(t).direction), s = i * r, a = n.target, l = t.contains(a), c = !1, u = s > 0, d = 0, f = 0;
  do {
    if (!a)
      break;
    var m = mg(e, a), p = m[0], g = m[1], y = m[2], b = g - y - i * p;
    (p || b) && hg(e, a) && (d += b, f += p);
    var x = a.parentNode;
    a = x && x.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? x.host : x;
  } while (
    // portaled content
    !l && a !== document.body || // self content
    l && (t.contains(a) || t === a)
  );
  return (u && Math.abs(d) < 1 || !u && Math.abs(f) < 1) && (c = !0), c;
}, ji = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Mf = function(e) {
  return [e.deltaX, e.deltaY];
}, Af = function(e) {
  return e && "current" in e ? e.current : e;
}, yC = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, bC = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, wC = 0, Br = [];
function xC(e) {
  var t = v.useRef([]), n = v.useRef([0, 0]), r = v.useRef(), o = v.useState(wC++)[0], i = v.useState(hu)[0], s = v.useRef(e);
  v.useEffect(function() {
    s.current = e;
  }, [e]), v.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var g = ig([e.lockRef.current], (e.shards || []).map(Af), !0).filter(Boolean);
      return g.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), g.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var a = v.useCallback(function(g, y) {
    if ("touches" in g && g.touches.length === 2 || g.type === "wheel" && g.ctrlKey)
      return !s.current.allowPinchZoom;
    var b = ji(g), x = n.current, w = "deltaX" in g ? g.deltaX : x[0] - b[0], S = "deltaY" in g ? g.deltaY : x[1] - b[1], E, C = g.target, T = Math.abs(w) > Math.abs(S) ? "h" : "v";
    if ("touches" in g && T === "h" && C.type === "range")
      return !1;
    var P = window.getSelection(), D = P && P.anchorNode, k = D ? D === C || D.contains(C) : !1;
    if (k)
      return !1;
    var R = Rf(T, C);
    if (!R)
      return !0;
    if (R ? E = T : (E = T === "v" ? "h" : "v", R = Rf(T, C)), !R)
      return !1;
    if (!r.current && "changedTouches" in g && (w || S) && (r.current = E), !E)
      return !0;
    var O = r.current || E;
    return vC(O, y, g, O === "h" ? w : S);
  }, []), l = v.useCallback(function(g) {
    var y = g;
    if (!(!Br.length || Br[Br.length - 1] !== i)) {
      var b = "deltaY" in y ? Mf(y) : ji(y), x = t.current.filter(function(E) {
        return E.name === y.type && (E.target === y.target || y.target === E.shadowParent) && yC(E.delta, b);
      })[0];
      if (x && x.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!x) {
        var w = (s.current.shards || []).map(Af).filter(Boolean).filter(function(E) {
          return E.contains(y.target);
        }), S = w.length > 0 ? a(y, w[0]) : !s.current.noIsolation;
        S && y.cancelable && y.preventDefault();
      }
    }
  }, []), c = v.useCallback(function(g, y, b, x) {
    var w = { name: g, delta: y, target: b, should: x, shadowParent: SC(b) };
    t.current.push(w), setTimeout(function() {
      t.current = t.current.filter(function(S) {
        return S !== w;
      });
    }, 1);
  }, []), u = v.useCallback(function(g) {
    n.current = ji(g), r.current = void 0;
  }, []), d = v.useCallback(function(g) {
    c(g.type, Mf(g), g.target, a(g, e.lockRef.current));
  }, []), f = v.useCallback(function(g) {
    c(g.type, ji(g), g.target, a(g, e.lockRef.current));
  }, []);
  v.useEffect(function() {
    return Br.push(i), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", l, Vr), document.addEventListener("touchmove", l, Vr), document.addEventListener("touchstart", u, Vr), function() {
      Br = Br.filter(function(g) {
        return g !== i;
      }), document.removeEventListener("wheel", l, Vr), document.removeEventListener("touchmove", l, Vr), document.removeEventListener("touchstart", u, Vr);
    };
  }, []);
  var m = e.removeScrollBar, p = e.inert;
  return v.createElement(
    v.Fragment,
    null,
    p ? v.createElement(i, { styles: bC(o) }) : null,
    m ? v.createElement(dg, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function SC(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const CC = cg(ug, xC);
var Ys = v.forwardRef(function(e, t) {
  return v.createElement(Us, xt({}, e, { ref: t, sideCar: CC }));
});
Ys.classNames = Us.classNames;
var TC = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Wr = /* @__PURE__ */ new WeakMap(), Hi = /* @__PURE__ */ new WeakMap(), Ui = {}, Ia = 0, pg = function(e) {
  return e && (e.host || pg(e.parentNode));
}, PC = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = pg(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, EC = function(e, t, n, r) {
  var o = PC(t, Array.isArray(e) ? e : [e]);
  Ui[n] || (Ui[n] = /* @__PURE__ */ new WeakMap());
  var i = Ui[n], s = [], a = /* @__PURE__ */ new Set(), l = new Set(o), c = function(d) {
    !d || a.has(d) || (a.add(d), c(d.parentNode));
  };
  o.forEach(c);
  var u = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(f) {
      if (a.has(f))
        u(f);
      else
        try {
          var m = f.getAttribute(r), p = m !== null && m !== "false", g = (Wr.get(f) || 0) + 1, y = (i.get(f) || 0) + 1;
          Wr.set(f, g), i.set(f, y), s.push(f), g === 1 && p && Hi.set(f, !0), y === 1 && f.setAttribute(n, "true"), p || f.setAttribute(r, "true");
        } catch (b) {
          console.error("aria-hidden: cannot operate on ", f, b);
        }
    });
  };
  return u(t), a.clear(), Ia++, function() {
    s.forEach(function(d) {
      var f = Wr.get(d) - 1, m = i.get(d) - 1;
      Wr.set(d, f), i.set(d, m), f || (Hi.has(d) || d.removeAttribute(r), Hi.delete(d)), m || d.removeAttribute(n);
    }), Ia--, Ia || (Wr = /* @__PURE__ */ new WeakMap(), Wr = /* @__PURE__ */ new WeakMap(), Hi = /* @__PURE__ */ new WeakMap(), Ui = {});
  };
}, Gs = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = TC(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live], script"))), EC(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, kC = Object.defineProperty, $t = (e, t) => kC(e, "name", { value: t, configurable: !0 }), mu = "Dialog", [gg, hV] = /* @__PURE__ */ It(mu), [DC, ln] = gg(mu), vg = /* @__PURE__ */ $t((e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    modal: s = !0
  } = e, a = v.useRef(null), l = v.useRef(null), [c, u] = qn({
    prop: r,
    defaultProp: o ?? !1,
    onChange: i,
    caller: mu
  }), [d, f] = v.useState(0), [m, p] = v.useState(0);
  return /* @__PURE__ */ h(
    DC,
    {
      scope: t,
      triggerRef: a,
      contentRef: l,
      contentId: rn(),
      titleId: rn(),
      descriptionId: rn(),
      titlePresent: d > 0,
      descriptionPresent: m > 0,
      setTitleCount: f,
      setDescriptionCount: p,
      open: c,
      onOpenChange: u,
      onOpenToggle: v.useCallback(() => u((g) => !g), [u]),
      modal: s,
      children: n
    }
  );
}, "Dialog"), RC = "DialogTrigger", yg = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ $t(function(t, n) {
    const { __scopeDialog: r, ...o } = t, i = ln(RC, r), s = be(n, i.triggerRef);
    return /* @__PURE__ */ h(
      me.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.open ? i.contentId : void 0,
        "data-state": Ks(i.open),
        ...o,
        ref: s,
        onClick: re(t.onClick, i.onOpenToggle)
      }
    );
  }, "DialogTrigger")
), bg = "DialogPortal", [MC, wg] = gg(bg, {
  forceMount: void 0
}), xg = /* @__PURE__ */ $t((e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, i = ln(bg, t);
  return /* @__PURE__ */ h(MC, { scope: t, forceMount: n, children: v.Children.map(r, (s) => /* @__PURE__ */ h(Lt, { present: n || i.open, children: /* @__PURE__ */ h(gi, { asChild: !0, container: o, children: s }) })) });
}, "DialogPortal"), Hl = "DialogOverlay", pu = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ $t(function(t, n) {
    const r = wg(Hl, t.__scopeDialog), { forceMount: o = r.forceMount, ...i } = t, s = ln(Hl, t.__scopeDialog);
    return s.modal ? /* @__PURE__ */ h(Lt, { present: o || s.open, children: /* @__PURE__ */ h(OC, { ...i, ref: n }) }) : null;
  }, "DialogOverlay")
), AC = /* @__PURE__ */ Cn("DialogOverlay.RemoveScroll"), OC = /* @__PURE__ */ v.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ $t(function(t, n) {
    const { __scopeDialog: r, ...o } = t, i = ln(Hl, r), s = Yp(), a = be(n, s);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ h(Ys, { as: AC, allowPinchZoom: !0, shards: [i.contentRef], children: /* @__PURE__ */ h(
        me.div,
        {
          "data-state": Ks(i.open),
          ...o,
          ref: a,
          style: { pointerEvents: "auto", ...o.style }
        }
      ) })
    );
  }, "DialogOverlayImpl")
), qo = "DialogContent", gu = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ $t(function(t, n) {
    const r = wg(qo, t.__scopeDialog), { forceMount: o = r.forceMount, ...i } = t, s = ln(qo, t.__scopeDialog);
    return /* @__PURE__ */ h(Lt, { present: o || s.open, children: s.modal ? /* @__PURE__ */ h(NC, { ...i, ref: n }) : /* @__PURE__ */ h(_C, { ...i, ref: n }) });
  }, "DialogContent")
), NC = /* @__PURE__ */ v.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ $t(function(t, n) {
    const r = ln(qo, t.__scopeDialog), o = v.useRef(null), i = be(n, r.contentRef, o);
    return v.useEffect(() => {
      const s = o.current;
      if (s) return Gs(s);
    }, []), /* @__PURE__ */ h(
      Sg,
      {
        ...t,
        ref: i,
        trapFocus: r.open,
        disableOutsidePointerEvents: r.open,
        onCloseAutoFocus: re(t.onCloseAutoFocus, (s) => {
          var a;
          s.preventDefault(), (a = r.triggerRef.current) == null || a.focus();
        }),
        onPointerDownOutside: re(t.onPointerDownOutside, (s) => {
          const a = s.detail.originalEvent, l = a.button === 0 && a.ctrlKey === !0;
          (a.button === 2 || l) && s.preventDefault();
        }),
        onFocusOutside: re(
          t.onFocusOutside,
          (s) => s.preventDefault()
        )
      }
    );
  }, "DialogContentModal")
), _C = /* @__PURE__ */ v.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ $t(function(t, n) {
    const r = ln(qo, t.__scopeDialog), o = v.useRef(!1), i = v.useRef(!1);
    return /* @__PURE__ */ h(
      Sg,
      {
        ...t,
        ref: n,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (s) => {
          var a, l;
          (a = t.onCloseAutoFocus) == null || a.call(t, s), s.defaultPrevented || (o.current || (l = r.triggerRef.current) == null || l.focus(), s.preventDefault()), o.current = !1, i.current = !1;
        },
        onInteractOutside: (s) => {
          var c, u;
          (c = t.onInteractOutside) == null || c.call(t, s), s.defaultPrevented || (o.current = !0, s.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const a = s.target;
          ((u = r.triggerRef.current) == null ? void 0 : u.contains(a)) && s.preventDefault(), s.detail.originalEvent.type === "focusin" && i.current && s.preventDefault();
        }
      }
    );
  }, "DialogContentNonModal")
), Sg = /* @__PURE__ */ v.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ $t(function(t, n) {
    const {
      __scopeDialog: r,
      trapFocus: o,
      onOpenAutoFocus: i,
      onCloseAutoFocus: s,
      "aria-describedby": a,
      ...l
    } = t, c = ln(qo, r);
    return vi(), /* @__PURE__ */ h(Oe, { children: /* @__PURE__ */ h(
      cu,
      {
        asChild: !0,
        loop: !0,
        trapped: o,
        onMountAutoFocus: i,
        onUnmountAutoFocus: s,
        children: /* @__PURE__ */ h(
          pi,
          {
            role: "dialog",
            id: c.contentId,
            "aria-labelledby": c.titlePresent ? c.titleId : void 0,
            "aria-describedby": c.descriptionPresent ? Cg(a, c.descriptionId) : a,
            "data-state": Ks(c.open),
            ...l,
            ref: n,
            deferPointerDownOutside: !0,
            onDismiss: () => c.onOpenChange(!1)
          }
        )
      }
    ) });
  }, "DialogContentImpl")
), vu = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ $t(function(t, n) {
    const { __scopeDialog: r, ...o } = t, i = ln("DialogTitle", r), { setTitleCount: s } = i;
    return qe(() => (s((a) => a + 1), () => s((a) => a - 1)), [s]), /* @__PURE__ */ h(me.h2, { id: i.titleId, ...o, ref: n });
  }, "DialogTitle")
), yu = /* @__PURE__ */ v.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ $t(function(t, n) {
    const { __scopeDialog: r, ...o } = t, i = ln("DialogDescription", r), { setDescriptionCount: s } = i;
    return qe(() => (s((a) => a + 1), () => s((a) => a - 1)), [s]), /* @__PURE__ */ h(me.p, { id: i.descriptionId, ...o, ref: n });
  }, "DialogDescription")
), IC = "DialogClose", bu = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ $t(function(t, n) {
    const { __scopeDialog: r, ...o } = t, i = ln(IC, r);
    return /* @__PURE__ */ h(
      me.button,
      {
        type: "button",
        ...o,
        ref: n,
        onClick: re(t.onClick, () => i.onOpenChange(!1))
      }
    );
  }, "DialogClose")
);
function Cg(...e) {
  const t = /* @__PURE__ */ new Set();
  for (const n of e)
    if (typeof n == "string")
      for (const r of String(n).trim().split(/\s+/))
        r && t.add(r);
  return t.size > 0 ? Array.from(t).join(" ") : void 0;
}
$t(Cg, "concatAriaDescribedby");
function Ks(e) {
  return e ? "open" : "closed";
}
$t(Ks, "getState");
const Tg = vg, mV = yg, LC = xg, pV = bu, Pg = v.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  pu,
  {
    ref: n,
    className: Q(
      "fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t
  }
));
Pg.displayName = pu.displayName;
const wu = v.forwardRef(({ className: e, children: t, showCloseButton: n = !0, ...r }, o) => /* @__PURE__ */ L(LC, { children: [
  /* @__PURE__ */ h(Pg, {}),
  /* @__PURE__ */ L(
    gu,
    {
      ref: o,
      className: Q(
        "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-4 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
        e
      ),
      ...r,
      children: [
        t,
        n && /* @__PURE__ */ L(bu, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground", children: [
          /* @__PURE__ */ h(eu, { className: "h-4 w-4" }),
          /* @__PURE__ */ h("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
wu.displayName = gu.displayName;
const $C = ({ className: e, ...t }) => /* @__PURE__ */ h("div", { className: Q("flex flex-col space-y-1.5 text-center sm:text-left", e), ...t });
$C.displayName = "DialogHeader";
const Eg = ({ className: e, ...t }) => /* @__PURE__ */ h("div", { className: Q("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", e), ...t });
Eg.displayName = "DialogFooter";
const kg = v.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  vu,
  {
    ref: n,
    className: Q("text-lg font-semibold leading-none tracking-tight", e),
    ...t
  }
));
kg.displayName = vu.displayName;
const FC = v.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(yu, { ref: n, className: Q("text-sm text-muted-foreground", e), ...t }));
FC.displayName = yu.displayName;
function gr({ transparent: e, className: t, cover: n, iconSize: r }) {
  return /* @__PURE__ */ h(
    "div",
    {
      className: He(
        "w-full h-full flex justify-center items-center",
        t,
        n && "absolute top-0 left-0 right-0 bottom-0 rounded-lg ",
        !e && "bg-neutral-container/75"
      ),
      children: /* @__PURE__ */ h(Sp, { className: He("animate-spin text-button-primary-bg", !r && "h-10 w-10 "), size: r })
    }
  );
}
const Dg = Ye(void 0), gV = () => {
  const e = Pe(Dg);
  if (!e)
    throw new Error("useConfirmationModal must be used within a ConfirmationModalProvider");
  return e;
}, vV = ({ children: e }) => {
  const [t, n] = ue(!1), [r, o] = ue(!1), [i, s] = ue(null), a = () => {
    setTimeout(() => {
      s(null);
    }, 500);
  }, l = (m) => {
    s(m), n(!0);
  }, c = (m) => {
    s((p) => p ? { ...p, message: m } : null);
  }, u = async () => {
    o(!0);
    try {
      i != null && i.onConfirm && await i.onConfirm();
    } finally {
      n(!1), a(), o(!1);
    }
  }, d = () => {
    i != null && i.onCancel && i.onCancel(), n(!1), a();
  }, f = (m) => {
    i != null && i.isCancelDisabled || (!m && (i != null && i.onCancel) && (i == null || i.onCancel()), n(m), a());
  };
  return /* @__PURE__ */ L(Dg.Provider, { value: { showConfirmation: l, updateMessage: c }, children: [
    e,
    /* @__PURE__ */ h(Tg, { open: t, onOpenChange: f, children: /* @__PURE__ */ L(wu, { onEscapeKeyDown: d, showCloseButton: i == null ? void 0 : i.showCloseButton, children: [
      /* @__PURE__ */ h(kg, { children: i == null ? void 0 : i.title }),
      r && /* @__PURE__ */ h(gr, { cover: !0 }),
      i == null ? void 0 : i.message,
      /* @__PURE__ */ L(Eg, { children: [
        !(i != null && i.hideCancelButton) && /* @__PURE__ */ h(ke, { onClick: d, variant: "outline", disabled: (i == null ? void 0 : i.isCancelDisabled) || r, children: (i == null ? void 0 : i.cancelText) || "Cancel" }),
        /* @__PURE__ */ h(
          ke,
          {
            onClick: u,
            variant: i == null ? void 0 : i.variant,
            autoFocus: !0,
            disabled: (i == null ? void 0 : i.isConfirmDisabled) || r,
            children: (i == null ? void 0 : i.confirmText) || "Confirm"
          }
        )
      ] })
    ] }) })
  ] });
};
var VC = Object.defineProperty, Rg = (e, t) => VC(e, "name", { value: t, configurable: !0 }), Of = "horizontal", BC = ["horizontal", "vertical"], Mg = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ Rg(function(t, n) {
    const { decorative: r, orientation: o = Of, ...i } = t, s = Ag(o) ? o : Of, l = r ? { role: "none" } : { "aria-orientation": s === "vertical" ? s : void 0, role: "separator" };
    return /* @__PURE__ */ h(
      me.div,
      {
        "data-orientation": s,
        ...l,
        ...i,
        ref: n
      }
    );
  }, "Separator")
);
function Ag(e) {
  return BC.includes(e);
}
Rg(Ag, "isValidOrientation");
const Qo = v.forwardRef(({ className: e, orientation: t = "horizontal", decorative: n = !0, ...r }, o) => /* @__PURE__ */ h(
  Mg,
  {
    ref: o,
    decorative: n,
    orientation: t,
    className: Q(
      "shrink-0 bg-neutral-borders",
      t === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
      e
    ),
    ...r
  }
));
Qo.displayName = Mg.displayName;
const La = "grow min-w-8", $a = "overflow-hidden text-ellipsis", WC = ({
  datatableHooks: e,
  expandAll: t,
  contractAll: n,
  filters: r,
  clearFilters: o,
  colapsableTable: i
}) => {
  const s = r ? Object.values(r).flat().length : 0, a = !!((s || !i) && o);
  return /* @__PURE__ */ L(
    "div",
    {
      className: He(
        "flex shrink flex-row  text-button-primary-outline-default space-x-1 text-sm justify-end ml-4 overflow-hidden",
        a ? "min-w-48" : "min-w-32"
      ),
      children: [
        i && /* @__PURE__ */ L(Oe, { children: [
          /* @__PURE__ */ h(ke, { variant: "ghost", onClick: t || (e == null ? void 0 : e.expandAllGroups), size: "sm", className: La, children: /* @__PURE__ */ h("span", { className: $a, children: "Expand all" }) }),
          /* @__PURE__ */ h(Qo, { orientation: "vertical", className: "h-auto" }),
          /* @__PURE__ */ h(ke, { variant: "ghost", onClick: n || (e == null ? void 0 : e.contractAllGroups), size: "sm", className: La, children: /* @__PURE__ */ h("span", { className: $a, children: "Collapse all" }) })
        ] }),
        a ? /* @__PURE__ */ L(Oe, { children: [
          i && /* @__PURE__ */ h(Qo, { orientation: "vertical", className: "h-auto" }),
          /* @__PURE__ */ h(ke, { variant: "ghost", onClick: o, size: "sm", className: La, disabled: !s, children: /* @__PURE__ */ h("span", { className: $a, children: " Clear filters" }) })
        ] }) : void 0
      ]
    }
  );
};
function Mr(e) {
  const { negativeFormat: t = "brackets" } = e.column;
  let n, r;
  return e.value === 1 / 0 || e.value === -1 / 0 ? n = "" : e.column.lookup ? e.value === null || e.value === void 0 || e.value === "" ? n = "-" : typeof e.column.lookup == "function" ? n = e.column.lookup(`${e.value}`, e.record) || `${e.value}` : n = e.column.lookup[`${e.value}`] || `${e.value}` : (n = e.value, r = e.column.dataType === "number" ? e.value && e.value < 0 : !1, e.value ? e.column.conditionalMask && (typeof e.value == "number" || typeof e.value == "string") && n !== "-" ? n = Al(
    Math.abs(+e.value),
    e.column.conditionalMask(e.column.key, e.column.name, e.record)
  ) : e.column.mask && (typeof e.value == "number" || typeof e.value == "string") && n !== "-" && (n = Al(Math.abs(+e.value), e.column.mask), n = `${e.column.prefix ?? ""}${n}${e.column.suffix ?? ""}`) : n = "-", t === "brackets" && r && n !== "-" && (n = `(${n})`), t === "minus" && r && n !== "-" && (n = `-${n}`)), /* @__PURE__ */ h("div", { className: He("overflow-x-hidden text-ellipsis grow w-0", r && "text-red-500"), children: n });
}
const zC = ["top", "right", "bottom", "left"], Qn = Math.min, Nn = Math.max, Ss = Math.round, Yi = Math.floor, _n = (e) => ({
  x: e,
  y: e
}), jC = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Og(e, t, n) {
  return Nn(e, Qn(t, n));
}
function $n(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Zn(e) {
  return e.split("-")[0];
}
function yo(e) {
  return e.split("-")[1];
}
function xu(e) {
  return e === "x" ? "y" : "x";
}
function Su(e) {
  return e === "y" ? "height" : "width";
}
function wn(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function Cu(e) {
  return xu(wn(e));
}
function HC(e, t, n) {
  n === void 0 && (n = !1);
  const r = yo(e), o = Cu(e), i = Su(o);
  let s = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (s = Cs(s)), [s, Cs(s)];
}
function UC(e) {
  const t = Cs(e);
  return [Ul(e), t, Ul(t)];
}
function Ul(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const Nf = ["left", "right"], _f = ["right", "left"], YC = ["top", "bottom"], GC = ["bottom", "top"];
function KC(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? _f : Nf : t ? Nf : _f;
    case "left":
    case "right":
      return t ? YC : GC;
    default:
      return [];
  }
}
function XC(e, t, n, r) {
  const o = yo(e);
  let i = KC(Zn(e), n === "start", r);
  return o && (i = i.map((s) => s + "-" + o), t && (i = i.concat(i.map(Ul)))), i;
}
function Cs(e) {
  const t = Zn(e);
  return jC[t] + e.slice(t.length);
}
function qC(e) {
  var t, n, r, o;
  return {
    top: (t = e.top) != null ? t : 0,
    right: (n = e.right) != null ? n : 0,
    bottom: (r = e.bottom) != null ? r : 0,
    left: (o = e.left) != null ? o : 0
  };
}
function Ng(e) {
  return typeof e != "number" ? qC(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Ts(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function If(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = wn(t), s = Cu(t), a = Su(s), l = Zn(t), c = i === "y", u = r.x + r.width / 2 - o.width / 2, d = r.y + r.height / 2 - o.height / 2, f = r[a] / 2 - o[a] / 2;
  let m;
  switch (l) {
    case "top":
      m = {
        x: u,
        y: r.y - o.height
      };
      break;
    case "bottom":
      m = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      m = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      m = {
        x: r.x - o.width,
        y: d
      };
      break;
    default:
      m = {
        x: r.x,
        y: r.y
      };
  }
  const p = yo(t);
  return p && (m[s] += f * (p === "end" ? 1 : -1) * (n && c ? -1 : 1)), m;
}
async function QC(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: s,
    elements: a,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: m = 0
  } = $n(t, e), p = Ng(m), y = a[f ? d === "floating" ? "reference" : "floating" : d], b = Ts(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(y))) == null || n ? y : y.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(a.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), x = d === "floating" ? {
    x: r,
    y: o,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, w = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(a.floating)), S = await (i.isElement == null ? void 0 : i.isElement(w)) && await (i.getScale == null ? void 0 : i.getScale(w)) || {
    x: 1,
    y: 1
  }, E = Ts(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: x,
    offsetParent: w,
    strategy: l
  }) : x);
  return {
    top: (b.top - E.top + p.top) / S.y,
    bottom: (E.bottom - b.bottom + p.bottom) / S.y,
    left: (b.left - E.left + p.left) / S.x,
    right: (E.right - b.right + p.right) / S.x
  };
}
const ZC = 50, JC = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: s
  } = n, a = s.detectOverflow ? s : {
    ...s,
    detectOverflow: QC
  }, l = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let c = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: u,
    y: d
  } = If(c, r, l), f = r, m = 0;
  const p = {};
  for (let g = 0; g < i.length; g++) {
    const y = i[g];
    if (!y)
      continue;
    const {
      name: b,
      fn: x
    } = y, {
      x: w,
      y: S,
      data: E,
      reset: C
    } = await x({
      x: u,
      y: d,
      initialPlacement: r,
      placement: f,
      strategy: o,
      middlewareData: p,
      rects: c,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = w ?? u, d = S ?? d, p[b] = {
      ...p[b],
      ...E
    }, C && m < ZC && (m++, typeof C == "object" && (C.placement && (f = C.placement), C.rects && (c = C.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : C.rects), {
      x: u,
      y: d
    } = If(c, f, l)), g = -1);
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: o,
    middlewareData: p
  };
}, eT = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: i,
      platform: s,
      elements: a,
      middlewareData: l
    } = t, {
      element: c,
      padding: u = 0
    } = $n(e, t) || {};
    if (c == null)
      return {};
    const d = Ng(u), f = {
      x: n,
      y: r
    }, m = Cu(o), p = Su(m), g = await s.getDimensions(c), y = m === "y", b = y ? "top" : "left", x = y ? "bottom" : "right", w = y ? "clientHeight" : "clientWidth", S = i.reference[p] + i.reference[m] - f[m] - i.floating[p], E = f[m] - i.reference[m], C = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(c));
    let T = C ? C[w] : 0;
    (!T || !await (s.isElement == null ? void 0 : s.isElement(C))) && (T = a.floating[w] || i.floating[p]);
    const P = S / 2 - E / 2, D = T / 2 - g[p] / 2 - 1, k = Qn(d[b], D), R = Qn(d[x], D), O = T - g[p] - R, _ = T / 2 - g[p] / 2 + P, $ = Og(k, _, O), z = !l.arrow && yo(o) != null && _ !== $ && i.reference[p] / 2 - (_ < k ? k : R) - g[p] / 2 < 0, I = z ? _ < k ? _ - k : _ - O : 0;
    return {
      [m]: f[m] + I,
      data: {
        [m]: $,
        centerOffset: _ - $ - I,
        ...z && {
          alignmentOffset: I
        }
      },
      reset: z
    };
  }
}), tT = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: i,
        rects: s,
        initialPlacement: a,
        platform: l,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: p = "none",
        flipAlignment: g = !0,
        ...y
      } = $n(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const b = Zn(o), x = wn(a), w = Zn(a) === a, S = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), E = f || (w || !g ? [Cs(a)] : UC(a)), C = p !== "none";
      !f && C && E.push(...XC(a, g, p, S));
      const T = [a, ...E], P = await l.detectOverflow(t, y), D = [];
      let k = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (u && D.push(P[b]), d) {
        const $ = HC(o, s, S);
        D.push(P[$[0]], P[$[1]]);
      }
      if (k = [...k, {
        placement: o,
        overflows: D
      }], !D.every(($) => $ <= 0)) {
        var R, O;
        const $ = (((R = i.flip) == null ? void 0 : R.index) || 0) + 1, z = T[$];
        if (z && (!(d === "alignment" ? x !== wn(z) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        k.every((M) => wn(M.placement) === x ? M.overflows[0] > 0 : !0)))
          return {
            data: {
              index: $,
              overflows: k
            },
            reset: {
              placement: z
            }
          };
        let I = (O = k.filter((A) => A.overflows[0] <= 0).sort((A, M) => A.overflows[1] - M.overflows[1])[0]) == null ? void 0 : O.placement;
        if (!I)
          switch (m) {
            case "bestFit": {
              var _;
              const A = (_ = k.filter((M) => {
                if (C) {
                  const F = wn(M.placement);
                  return F === x || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  F === "y";
                }
                return !0;
              }).map((M) => [M.placement, M.overflows.filter((F) => F > 0).reduce((F, W) => F + W, 0)]).sort((M, F) => M[1] - F[1])[0]) == null ? void 0 : _[0];
              A && (I = A);
              break;
            }
            case "initialPlacement":
              I = a;
              break;
          }
        if (o !== I)
          return {
            reset: {
              placement: I
            }
          };
      }
      return {};
    }
  };
};
function Lf(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function $f(e) {
  return zC.some((t) => e[t] >= 0);
}
const nT = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n,
        platform: r
      } = t, {
        strategy: o = "referenceHidden",
        ...i
      } = $n(e, t);
      switch (o) {
        case "referenceHidden": {
          const s = await r.detectOverflow(t, {
            ...i,
            elementContext: "reference"
          }), a = Lf(s, n.reference);
          return {
            data: {
              referenceHiddenOffsets: a,
              referenceHidden: $f(a)
            }
          };
        }
        case "escaped": {
          const s = await r.detectOverflow(t, {
            ...i,
            altBoundary: !0
          }), a = Lf(s, n.floating);
          return {
            data: {
              escapedOffsets: a,
              escaped: $f(a)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, _g = /* @__PURE__ */ new Set(["left", "top"]);
async function rT(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), s = Zn(n), a = yo(n), l = wn(n) === "y", c = _g.has(s) ? -1 : 1, u = i && l ? -1 : 1, d = $n(t, e);
  let {
    mainAxis: f,
    crossAxis: m,
    alignmentAxis: p
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return a && typeof p == "number" && (m = a === "end" ? p * -1 : p), l ? {
    x: m * u,
    y: f * c
  } : {
    x: f * c,
    y: m * u
  };
}
const oT = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: i,
        placement: s,
        middlewareData: a
      } = t, l = await rT(t, e);
      return s === ((n = a.offset) == null ? void 0 : n.placement) && (r = a.arrow) != null && r.alignmentOffset ? {} : {
        x: o + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: s
        }
      };
    }
  };
}, iT = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        platform: i
      } = t, {
        mainAxis: s = !0,
        crossAxis: a = !1,
        limiter: l = {
          fn: (x) => {
            let {
              x: w,
              y: S
            } = x;
            return {
              x: w,
              y: S
            };
          }
        },
        ...c
      } = $n(e, t), u = {
        x: n,
        y: r
      }, d = await i.detectOverflow(t, c), f = wn(o), m = xu(f);
      let p = u[m], g = u[f];
      const y = (x, w) => Og(w + d[x === "y" ? "top" : "left"], w, w - d[x === "y" ? "bottom" : "right"]);
      s && (p = y(m, p)), a && (g = y(f, g));
      const b = l.fn({
        ...t,
        [m]: p,
        [f]: g
      });
      return {
        ...b,
        data: {
          x: b.x - n,
          y: b.y - r,
          enabled: {
            [m]: s,
            [f]: a
          }
        }
      };
    }
  };
}, sT = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      var n, r;
      const {
        x: o,
        y: i,
        placement: s,
        rects: a,
        middlewareData: l
      } = t, {
        offset: c = 0,
        mainAxis: u = !0,
        crossAxis: d = !0
      } = $n(e, t), f = {
        x: o,
        y: i
      }, m = wn(s), p = xu(m);
      let g = f[p], y = f[m];
      const b = $n(c, t), x = typeof b == "number" ? {
        mainAxis: b,
        crossAxis: 0
      } : {
        mainAxis: (n = b.mainAxis) != null ? n : 0,
        crossAxis: (r = b.crossAxis) != null ? r : 0
      };
      if (u) {
        const E = p === "y" ? "height" : "width", C = a.reference[p] - a.floating[E] + x.mainAxis, T = a.reference[p] + a.reference[E] - x.mainAxis;
        g < C ? g = C : g > T && (g = T);
      }
      if (d) {
        var w, S;
        const E = p === "y" ? "width" : "height", C = _g.has(Zn(s)), T = a.reference[m] - a.floating[E] + (C && ((w = l.offset) == null ? void 0 : w[m]) || 0) + (C ? 0 : x.crossAxis), P = a.reference[m] + a.reference[E] + (C ? 0 : ((S = l.offset) == null ? void 0 : S[m]) || 0) - (C ? x.crossAxis : 0);
        y < T ? y = T : y > P && (y = P);
      }
      return {
        [p]: g,
        [m]: y
      };
    }
  };
}, aT = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: r,
        platform: o,
        elements: i
      } = t, {
        apply: s = () => {
        },
        ...a
      } = $n(e, t), l = await o.detectOverflow(t, a), c = Zn(n), u = yo(n), d = wn(n) === "y", {
        width: f,
        height: m
      } = r.floating;
      let p, g;
      c === "top" || c === "bottom" ? (p = c, g = u === (await (o.isRTL == null ? void 0 : o.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (g = c, p = u === "end" ? "top" : "bottom");
      const y = m - l.top - l.bottom, b = f - l.left - l.right, x = Qn(m - l[p], y), w = Qn(f - l[g], b), S = t.middlewareData.shift, E = !S;
      let C = x, T = w;
      S != null && S.enabled.x && (T = b), S != null && S.enabled.y && (C = y), E && !u && (d ? T = f - 2 * Nn(l.left, l.right) : C = m - 2 * Nn(l.top, l.bottom)), await s({
        ...t,
        availableWidth: T,
        availableHeight: C
      });
      const P = await o.getDimensions(i.floating);
      return f !== P.width || m !== P.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Xs() {
  return typeof window < "u";
}
function bo(e) {
  return Ig(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Ot(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Wn(e) {
  var t;
  return (t = (Ig(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Ig(e) {
  return Xs() ? e instanceof Node || e instanceof Ot(e).Node : !1;
}
function Tn(e) {
  return Xs() ? e instanceof Element || e instanceof Ot(e).Element : !1;
}
function er(e) {
  return Xs() ? e instanceof HTMLElement || e instanceof Ot(e).HTMLElement : !1;
}
function Ff(e) {
  return !Xs() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Ot(e).ShadowRoot;
}
function qs(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = Pn(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && o !== "inline" && o !== "contents";
}
function lT(e) {
  return /^(table|td|th)$/.test(bo(e));
}
function Qs(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const cT = /transform|translate|scale|rotate|perspective|filter/, uT = /paint|layout|strict|content/, or = (e) => !!e && e !== "none";
let Fa;
function Tu(e) {
  const t = Tn(e) ? Pn(e) : e;
  return or(t.transform) || or(t.translate) || or(t.scale) || or(t.rotate) || or(t.perspective) || !Pu() && (or(t.backdropFilter) || or(t.filter)) || cT.test(t.willChange || "") || uT.test(t.contain || "");
}
function dT(e) {
  let t = vr(e);
  for (; er(t) && !Zo(t); ) {
    if (Tu(t))
      return t;
    if (Qs(t))
      return null;
    t = vr(t);
  }
  return null;
}
function Pu() {
  return Fa == null && (Fa = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), Fa;
}
function Zo(e) {
  return /^(html|body|#document)$/.test(bo(e));
}
function Pn(e) {
  return Ot(e).getComputedStyle(e);
}
function Zs(e) {
  return Tn(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function vr(e) {
  if (bo(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Ff(e) && e.host || // Fallback.
    Wn(e)
  );
  return Ff(t) ? t.host : t;
}
function Lg(e) {
  const t = vr(e);
  return Zo(t) ? (e.ownerDocument || e).body : er(t) && qs(t) ? t : Lg(t);
}
function Jo(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = Lg(e), i = o === ((r = e.ownerDocument) == null ? void 0 : r.body), s = Ot(o);
  if (i) {
    const a = Yl(s);
    return t.concat(s, s.visualViewport || [], qs(o) ? o : [], a && n ? Jo(a) : []);
  } else
    return t.concat(o, Jo(o, [], n));
}
function Yl(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function $g(e) {
  const t = Pn(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = er(e), i = o ? e.offsetWidth : n, s = o ? e.offsetHeight : r, a = Ss(n) !== i || Ss(r) !== s;
  return a && (n = i, r = s), {
    width: n,
    height: r,
    $: a
  };
}
function Eu(e) {
  return Tn(e) ? e : e.contextElement;
}
function oo(e) {
  const t = Eu(e);
  if (!er(t))
    return _n(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = $g(t);
  let s = (i ? Ss(n.width) : n.width) / r, a = (i ? Ss(n.height) : n.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
const fT = /* @__PURE__ */ _n(0);
function Fg(e) {
  const t = Ot(e);
  return !Pu() || !t.visualViewport ? fT : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function hT(e, t, n) {
  return t === void 0 && (t = !1), !!n && t && n === Ot(e);
}
function yr(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = Eu(e);
  let s = _n(1);
  t && (r ? Tn(r) && (s = oo(r)) : s = oo(e));
  const a = hT(i, n, r) ? Fg(i) : _n(0);
  let l = (o.left + a.x) / s.x, c = (o.top + a.y) / s.y, u = o.width / s.x, d = o.height / s.y;
  if (i && r) {
    const f = Ot(i), m = Tn(r) ? Ot(r) : r;
    let p = f, g = Yl(p);
    for (; g && m !== p; ) {
      const y = oo(g), b = g.getBoundingClientRect(), x = Pn(g), w = b.left + (g.clientLeft + parseFloat(x.paddingLeft)) * y.x, S = b.top + (g.clientTop + parseFloat(x.paddingTop)) * y.y;
      l *= y.x, c *= y.y, u *= y.x, d *= y.y, l += w, c += S, p = Ot(g), g = Yl(p);
    }
  }
  return Ts({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function Js(e, t) {
  const n = Zs(e).scrollLeft;
  return t ? t.left + n : yr(Wn(e)).left + n;
}
function Vg(e, t) {
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - Js(e, n), o = n.top + t.scrollTop;
  return {
    x: r,
    y: o
  };
}
function mT(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const i = o === "fixed", s = Wn(r), a = t ? Qs(t.floating) : !1;
  if (r === s || a && i)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = _n(1);
  const u = _n(0), d = er(r);
  if ((d || !i) && ((bo(r) !== "body" || qs(s)) && (l = Zs(r)), d)) {
    const m = yr(r);
    c = oo(r), u.x = m.x + r.clientLeft, u.y = m.y + r.clientTop;
  }
  const f = s && !d && !i ? Vg(s, l) : _n(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + u.x + f.x,
    y: n.y * c.y - l.scrollTop * c.y + u.y + f.y
  };
}
function pT(e) {
  return e.getClientRects ? Array.from(e.getClientRects()) : [];
}
function gT(e) {
  const t = Zs(e), n = e.ownerDocument.body, r = Nn(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), o = Nn(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight);
  let i = -t.scrollLeft + Js(e);
  const s = -t.scrollTop;
  return Pn(n).direction === "rtl" && (i += Nn(e.clientWidth, n.clientWidth) - r), {
    width: r,
    height: o,
    x: i,
    y: s
  };
}
const vT = 25;
function yT(e, t, n) {
  n === void 0 && (n = "viewport");
  const r = n === "layoutViewport", o = Ot(e), i = Wn(e), s = o.visualViewport;
  let a = i.clientWidth, l = i.clientHeight, c = 0, u = 0;
  if (s) {
    const f = !Pu() || t === "fixed";
    r ? f || (c = -s.offsetLeft, u = -s.offsetTop) : (a = s.width, l = s.height, f && (c = s.offsetLeft, u = s.offsetTop));
  }
  if (Js(i) <= 0) {
    const f = i.ownerDocument, m = f.body, p = getComputedStyle(m), g = f.compatMode === "CSS1Compat" && parseFloat(p.marginLeft) + parseFloat(p.marginRight) || 0, y = Math.abs(i.clientWidth - m.clientWidth - g), b = getComputedStyle(i).scrollbarGutter === "stable both-edges" ? y / 2 : y;
    b <= vT && (a -= b);
  }
  return {
    width: a,
    height: l,
    x: c,
    y: u
  };
}
function bT(e, t) {
  const n = yr(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = oo(e), s = e.clientWidth * i.x, a = e.clientHeight * i.y, l = o * i.x, c = r * i.y;
  return {
    width: s,
    height: a,
    x: l,
    y: c
  };
}
function Vf(e, t, n) {
  let r;
  if (t === "viewport" || t === "layoutViewport")
    r = yT(e, n, t);
  else if (t === "document")
    r = gT(Wn(e));
  else if (Tn(t))
    r = bT(t, n);
  else {
    const o = Fg(e);
    r = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return Ts(r);
}
function wT(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Jo(e, [], !1).filter((a) => Tn(a) && bo(a) !== "body"), o = null;
  const i = Pn(e).position === "fixed";
  let s = i ? vr(e) : e;
  for (; Tn(s) && !Zo(s); ) {
    const a = Pn(s), l = Tu(s), c = o ? o.position : i ? "fixed" : "";
    !l && (c === "fixed" || c === "absolute" && a.position === "static") ? r = r.filter((d) => d !== s) : o = a, s = vr(s);
  }
  return t.set(e, r), r;
}
function xT(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const s = [...n === "clippingAncestors" ? Qs(t) ? [] : wT(t, this._c) : [].concat(n), r], a = Vf(t, s[0], o);
  let l = a.top, c = a.right, u = a.bottom, d = a.left;
  for (let f = 1; f < s.length; f++) {
    const m = Vf(t, s[f], o);
    l = Nn(m.top, l), c = Qn(m.right, c), u = Qn(m.bottom, u), d = Nn(m.left, d);
  }
  return {
    width: c - d,
    height: u - l,
    x: d,
    y: l
  };
}
function ST(e) {
  const {
    width: t,
    height: n
  } = $g(e);
  return {
    width: t,
    height: n
  };
}
function CT(e, t, n) {
  const r = er(t), o = Wn(t), i = n === "fixed", s = yr(e, !0, i, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = _n(0);
  if ((r || !i) && ((bo(t) !== "body" || qs(o)) && (a = Zs(t)), r)) {
    const f = yr(t, !0, i, t);
    l.x = f.x + t.clientLeft, l.y = f.y + t.clientTop;
  }
  !r && o && (l.x = Js(o));
  const c = o && !r && !i ? Vg(o, a) : _n(0), u = s.left + a.scrollLeft - l.x - c.x, d = s.top + a.scrollTop - l.y - c.y;
  return {
    x: u,
    y: d,
    width: s.width,
    height: s.height
  };
}
function Va(e) {
  return Pn(e).position === "static";
}
function Bf(e, t) {
  if (!er(e) || Pn(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Wn(e) === n && (n = n.ownerDocument.body), n;
}
function Bg(e, t) {
  const n = Ot(e);
  if (Qs(e))
    return n;
  if (!er(e)) {
    let o = vr(e);
    for (; o && !Zo(o); ) {
      if (Tn(o) && !Va(o))
        return o;
      o = vr(o);
    }
    return n;
  }
  let r = Bf(e, t);
  for (; r && lT(r) && Va(r); )
    r = Bf(r, t);
  return r && Zo(r) && Va(r) && !Tu(r) ? n : r || dT(e) || n;
}
const TT = async function(e) {
  const t = this.getOffsetParent || Bg, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: CT(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function PT(e) {
  return Pn(e).direction === "rtl";
}
const ET = {
  convertOffsetParentRelativeRectToViewportRelativeRect: mT,
  getDocumentElement: Wn,
  getClippingRect: xT,
  getOffsetParent: Bg,
  getElementRects: TT,
  getClientRects: pT,
  getDimensions: ST,
  getScale: oo,
  isElement: Tn,
  isRTL: PT
};
function Wg(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function kT(e, t, n) {
  let r = null, o;
  const i = Wn(e);
  function s() {
    var u;
    clearTimeout(o), (u = r) == null || u.disconnect(), r = null;
  }
  function a(u, d) {
    u === void 0 && (u = !1), d === void 0 && (d = 1), s();
    const f = e.getBoundingClientRect(), {
      left: m,
      top: p,
      width: g,
      height: y
    } = f;
    if (u || t(), !g || !y)
      return;
    const b = Yi(p), x = Yi(i.clientWidth - (m + g)), w = Yi(i.clientHeight - (p + y)), S = Yi(m), C = {
      rootMargin: -b + "px " + -x + "px " + -w + "px " + -S + "px",
      threshold: Nn(0, Qn(1, d)) || 1
    };
    let T = !0;
    function P(D) {
      const k = D[0].intersectionRatio;
      if (!Wg(f, e.getBoundingClientRect()))
        return a();
      if (k !== d) {
        if (!T)
          return a();
        k ? a(!1, k) : o = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      T = !1;
    }
    try {
      r = new IntersectionObserver(P, {
        ...C,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(P, C);
    }
    r.observe(e);
  }
  const l = Ot(e), c = () => a(n);
  return l.addEventListener("resize", c), a(!0), () => {
    l.removeEventListener("resize", c), s();
  };
}
function DT(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = Eu(e), u = o || i ? [...c ? Jo(c) : [], ...t ? Jo(t) : []] : [];
  u.forEach((b) => {
    o && b.addEventListener("scroll", n), i && b.addEventListener("resize", n);
  });
  const d = c && a ? kT(c, n, i) : null;
  let f = -1, m = null;
  s && (m = new ResizeObserver((b) => {
    let [x] = b;
    x && x.target === c && m && t && (m.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var w;
      (w = m) == null || w.observe(t);
    })), n();
  }), c && !l && m.observe(c), t && m.observe(t));
  let p, g = l ? yr(e) : null;
  l && y();
  function y() {
    const b = yr(e);
    g && !Wg(g, b) && n(), g = b, p = requestAnimationFrame(y);
  }
  return n(), () => {
    var b;
    u.forEach((x) => {
      o && x.removeEventListener("scroll", n), i && x.removeEventListener("resize", n);
    }), d == null || d(), (b = m) == null || b.disconnect(), m = null, l && cancelAnimationFrame(p);
  };
}
const RT = oT, MT = iT, AT = tT, OT = aT, NT = nT, Wf = eT, _T = sT, IT = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = n ?? {}, i = {
    ...ET,
    ...o.platform,
    _c: r
  };
  return JC(e, t, {
    ...o,
    platform: i
  });
};
var LT = typeof document < "u", $T = function() {
}, as = LT ? Dr : $T;
function Ps(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!Ps(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && e.$$typeof) && !Ps(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function zg(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function zf(e, t) {
  const n = zg(e);
  return Math.round(t * n) / n;
}
function Ba(e) {
  const t = v.useRef(e);
  return as(() => {
    t.current = e;
  }), t;
}
function FT(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: s
    } = {},
    transform: a = !0,
    whileElementsMounted: l,
    open: c
  } = e, [u, d] = v.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [f, m] = v.useState(r);
  Ps(f, r) || m(r);
  const [p, g] = v.useState(null), [y, b] = v.useState(null), x = v.useCallback((M) => {
    M !== C.current && (C.current = M, g(M));
  }, []), w = v.useCallback((M) => {
    M !== T.current && (T.current = M, b(M));
  }, []), S = i || p, E = s || y, C = v.useRef(null), T = v.useRef(null), P = v.useRef(u), D = l != null, k = Ba(l), R = Ba(o), O = Ba(c), _ = v.useCallback(() => {
    if (!C.current || !T.current)
      return;
    const M = {
      placement: t,
      strategy: n,
      middleware: f
    };
    R.current && (M.platform = R.current), IT(C.current, T.current, M).then((F) => {
      const W = {
        ...F,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: O.current !== !1
      };
      $.current && !Ps(P.current, W) && (P.current = W, po.flushSync(() => {
        d(W);
      }));
    });
  }, [f, t, n, R, O]);
  as(() => {
    c === !1 && P.current.isPositioned && (P.current.isPositioned = !1, d((M) => ({
      ...M,
      isPositioned: !1
    })));
  }, [c]);
  const $ = v.useRef(!1);
  as(() => ($.current = !0, () => {
    $.current = !1;
  }), []), as(() => {
    if (S && (C.current = S), E && (T.current = E), S && E) {
      if (k.current)
        return k.current(S, E, _);
      _();
    }
  }, [S, E, _, k, D]);
  const z = v.useMemo(() => ({
    reference: C,
    floating: T,
    setReference: x,
    setFloating: w
  }), [x, w]), I = v.useMemo(() => ({
    reference: S,
    floating: E
  }), [S, E]), A = v.useMemo(() => {
    const M = {
      position: n,
      left: 0,
      top: 0
    };
    if (!I.floating)
      return M;
    const F = zf(I.floating, u.x), W = zf(I.floating, u.y);
    return a ? {
      ...M,
      transform: "translate(" + F + "px, " + W + "px)",
      ...zg(I.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: F,
      top: W
    };
  }, [n, a, I.floating, u.x, u.y]);
  return v.useMemo(() => ({
    ...u,
    update: _,
    refs: z,
    elements: I,
    floatingStyles: A
  }), [u, _, z, I, A]);
}
const VT = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? Wf({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? Wf({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
}, BT = (e, t) => {
  const n = RT(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, WT = (e, t) => {
  const n = MT(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, zT = (e, t) => ({
  fn: _T(e).fn,
  options: [e, t]
}), jT = (e, t) => {
  const n = AT(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, HT = (e, t) => {
  const n = OT(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, UT = (e, t) => {
  const n = NT(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, YT = (e, t) => {
  const n = VT(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
};
var GT = Object.defineProperty, KT = (e, t) => GT(e, "name", { value: t, configurable: !0 });
function ku(e) {
  const [t, n] = v.useState(void 0);
  return qe(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let s, a;
        if ("borderBoxSize" in i) {
          const l = i.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          s = c.inlineSize, a = c.blockSize;
        } else
          s = e.offsetWidth, a = e.offsetHeight;
        n({ width: s, height: a });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
KT(ku, "useSize");
var XT = Object.defineProperty, Xn = (e, t) => XT(e, "name", { value: t, configurable: !0 }), jg = "Popper", [Hg, tr] = /* @__PURE__ */ It(jg), [qT, Ug] = Hg(jg), Du = /* @__PURE__ */ Xn((e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = v.useState(null), [i, s] = v.useState(void 0);
  return /* @__PURE__ */ h(
    qT,
    {
      scope: t,
      anchor: r,
      onAnchorChange: o,
      placementState: i,
      setPlacementState: s,
      children: n
    }
  );
}, "Popper"), QT = "PopperAnchor", ea = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ Xn(function(t, n) {
    const { __scopePopper: r, virtualRef: o, ...i } = t, s = Ug(QT, r), a = v.useRef(null), l = s.onAnchorChange, c = v.useCallback(
      (g) => {
        a.current = g, g && l(g);
      },
      [l]
    ), u = be(n, c), d = v.useRef(null);
    v.useEffect(() => {
      if (!o)
        return;
      const g = d.current;
      d.current = o.current, g !== d.current && l(d.current);
    });
    const f = s.placementState && ta(s.placementState), m = f == null ? void 0 : f[0], p = f == null ? void 0 : f[1];
    return o ? null : /* @__PURE__ */ h(
      me.div,
      {
        "data-radix-popper-side": m,
        "data-radix-popper-align": p,
        ...i,
        ref: u
      }
    );
  }, "PopperAnchor")
), Yg = "PopperContent", [ZT, yV] = Hg(Yg), Ru = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ Xn(function(t, n) {
    var se, ee, xe, ye, G, mt, ut;
    const {
      __scopePopper: r,
      side: o = "bottom",
      sideOffset: i = 0,
      align: s = "center",
      alignOffset: a = 0,
      arrowPadding: l = 0,
      avoidCollisions: c = !0,
      collisionBoundary: u = [],
      collisionPadding: d = 0,
      sticky: f = "partial",
      hideWhenDetached: m = !1,
      updatePositionStrategy: p = "optimized",
      onPlaced: g,
      ...y
    } = t, b = Ug(Yg, r), [x, w] = v.useState(null), S = be(n, w), [E, C] = v.useState(null), T = ku(E), P = (T == null ? void 0 : T.width) ?? 0, D = (T == null ? void 0 : T.height) ?? 0, k = o + (s !== "center" ? "-" + s : ""), R = typeof d == "number" ? d : { top: 0, right: 0, bottom: 0, left: 0, ...d }, O = Array.isArray(u) ? u : [u], _ = O.length > 0, $ = {
      padding: R,
      boundary: O.filter(Gg),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: _
    }, { refs: z, floatingStyles: I, placement: A, isPositioned: M, middlewareData: F } = FT({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: k,
      whileElementsMounted: /* @__PURE__ */ Xn((...Dt) => DT(...Dt, {
        animationFrame: p === "always"
      }), "whileElementsMounted"),
      elements: {
        reference: b.anchor
      },
      middleware: [
        BT({ mainAxis: i + D, alignmentAxis: a }),
        c && WT({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? zT() : void 0,
          ...$
        }),
        c && jT({ ...$ }),
        HT({
          ...$,
          apply: /* @__PURE__ */ Xn(({ elements: Dt, rects: Zt, availableWidth: dn, availableHeight: fn }) => {
            const { width: V, height: q } = Zt.reference, B = Dt.floating.style;
            B.setProperty("--radix-popper-available-width", `${dn}px`), B.setProperty("--radix-popper-available-height", `${fn}px`), B.setProperty("--radix-popper-anchor-width", `${V}px`), B.setProperty("--radix-popper-anchor-height", `${q}px`);
          }, "apply")
        }),
        E && YT({ element: E, padding: l }),
        JT({ arrowWidth: P, arrowHeight: D }),
        m && UT({
          strategy: "referenceHidden",
          ...$,
          // `hide` detects whether the anchor (reference) is clipped, so when
          // no explicit `collisionBoundary` is set we fall back to Floating
          // UI's default clipping ancestors (e.g. a scrollable menu). This
          // lets an occluded submenu hide once its anchor scrolls out of view
          // (#3237). The collision/size middlewares deliberately keep the
          // viewport-based default to avoid clamping content rendered inside
          // transformed or overflow-clipping portal containers.
          boundary: _ ? $.boundary : void 0
        })
      ]
    }), W = b.setPlacementState;
    qe(() => (W(A), () => {
      W(void 0);
    }), [A, W]);
    const [ne, N] = ta(A), Y = Je(g);
    qe(() => {
      M && (Y == null || Y());
    }, [M, Y]);
    const H = (se = F.arrow) == null ? void 0 : se.x, U = (ee = F.arrow) == null ? void 0 : ee.y, fe = ((xe = F.arrow) == null ? void 0 : xe.centerOffset) !== 0, [ge, X] = v.useState();
    return qe(() => {
      x && X(window.getComputedStyle(x).zIndex);
    }, [x]), /* @__PURE__ */ h(
      "div",
      {
        ref: z.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...I,
          transform: M ? I.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: ge,
          "--radix-popper-transform-origin": [
            (ye = F.transformOrigin) == null ? void 0 : ye.x,
            (G = F.transformOrigin) == null ? void 0 : G.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((mt = F.hide) == null ? void 0 : mt.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: t.dir,
        children: /* @__PURE__ */ h(
          ZT,
          {
            scope: r,
            placedSide: ne,
            placedAlign: N,
            onArrowChange: C,
            arrowX: H,
            arrowY: U,
            shouldHideArrow: fe,
            children: /* @__PURE__ */ h(
              me.div,
              {
                "data-side": ne,
                "data-align": N,
                ...y,
                ref: S,
                style: {
                  ...y.style,
                  // if the PopperContent hasn't been placed yet (not all
                  // measurements done) we prevent animations so that users'
                  // animations don't kick in too early from the wrong sides.
                  animation: M ? (ut = y.style) == null ? void 0 : ut.animation : "none"
                }
              }
            )
          }
        )
      }
    );
  }, "PopperContent")
);
function Gg(e) {
  return e !== null;
}
Xn(Gg, "isNotNull");
var JT = /* @__PURE__ */ Xn((e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var y, b, x;
    const { placement: n, rects: r, middlewareData: o } = t, s = ((y = o.arrow) == null ? void 0 : y.centerOffset) !== 0, a = s ? 0 : e.arrowWidth, l = s ? 0 : e.arrowHeight, [c, u] = ta(n), d = { start: "0%", center: "50%", end: "100%" }[u], f = (((b = o.arrow) == null ? void 0 : b.x) ?? 0) + a / 2, m = (((x = o.arrow) == null ? void 0 : x.y) ?? 0) + l / 2;
    let p = "", g = "";
    return c === "bottom" ? (p = s ? d : `${f}px`, g = `${-l}px`) : c === "top" ? (p = s ? d : `${f}px`, g = `${r.floating.height + l}px`) : c === "right" ? (p = `${-l}px`, g = s ? d : `${m}px`) : c === "left" && (p = `${r.floating.width + l}px`, g = s ? d : `${m}px`), { data: { x: p, y: g } };
  }
}), "transformOrigin");
function ta(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
Xn(ta, "getSideAndAlignFromPlacement");
var eP = Object.defineProperty, tP = (e, t) => eP(e, "name", { value: t, configurable: !0 }), Kg = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), Mu = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ tP(function(t, n) {
    return /* @__PURE__ */ h(
      me.span,
      {
        ...t,
        ref: n,
        style: { ...Kg, ...t.style }
      }
    );
  }, "VisuallyHidden")
), nP = Object.defineProperty, ct = (e, t) => nP(e, "name", { value: t, configurable: !0 }), [Au, bV] = /* @__PURE__ */ It("Tooltip", [
  tr
]), Ou = tr(), rP = "TooltipProvider", oP = 700, Gl = "tooltip.open", [iP, Nu] = Au(rP), sP = /* @__PURE__ */ ct((e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = oP,
    skipDelayDuration: r = 300,
    disableHoverableContent: o = !1,
    children: i
  } = e, s = v.useRef(!0), a = v.useRef(!1), l = v.useRef(0);
  return v.useEffect(() => {
    const c = l.current;
    return () => window.clearTimeout(c);
  }, []), /* @__PURE__ */ h(
    iP,
    {
      scope: t,
      isOpenDelayedRef: s,
      delayDuration: n,
      onOpen: v.useCallback(() => {
        r <= 0 || (window.clearTimeout(l.current), s.current = !1);
      }, [r]),
      onClose: v.useCallback(() => {
        r <= 0 || (window.clearTimeout(l.current), l.current = window.setTimeout(
          () => s.current = !0,
          r
        ));
      }, [r]),
      isPointerInTransitRef: a,
      onPointerInTransitChange: v.useCallback((c) => {
        a.current = c;
      }, []),
      disableHoverableContent: o,
      children: i
    }
  );
}, "TooltipProvider"), Kl = "Tooltip", [aP, yi] = Au(Kl), lP = /* @__PURE__ */ ct((e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    disableHoverableContent: s,
    delayDuration: a
  } = e, l = Nu(Kl, e.__scopeTooltip), c = Ou(t), [u, d] = v.useState(null), [f, m] = v.useState(void 0), p = rn(), g = v.useRef(0), y = s ?? l.disableHoverableContent, b = a ?? l.delayDuration, x = v.useRef(!1), [w, S] = qn({
    prop: r,
    defaultProp: o ?? !1,
    onChange: /* @__PURE__ */ ct((k) => {
      k ? (l.onOpen(), document.dispatchEvent(new CustomEvent(Gl))) : l.onClose(), i == null || i(k);
    }, "onChange"),
    caller: Kl
  }), E = v.useMemo(() => w ? x.current ? "delayed-open" : "instant-open" : "closed", [w]), C = v.useCallback(() => {
    window.clearTimeout(g.current), g.current = 0, x.current = !1, S(!0);
  }, [S]), T = v.useCallback(() => {
    window.clearTimeout(g.current), g.current = 0, S(!1);
  }, [S]), P = v.useCallback(() => {
    window.clearTimeout(g.current), g.current = window.setTimeout(() => {
      x.current = !0, S(!0), g.current = 0;
    }, b);
  }, [b, S]);
  return v.useEffect(() => () => {
    g.current && (window.clearTimeout(g.current), g.current = 0);
  }, []), /* @__PURE__ */ h(Du, { ...c, children: /* @__PURE__ */ h(
    aP,
    {
      scope: t,
      contentId: f ?? p,
      setContentId: m,
      open: w,
      stateAttribute: E,
      trigger: u,
      onTriggerChange: d,
      onTriggerEnter: v.useCallback(() => {
        l.isOpenDelayedRef.current ? P() : C();
      }, [l.isOpenDelayedRef, P, C]),
      onTriggerLeave: v.useCallback(() => {
        y ? T() : (window.clearTimeout(g.current), g.current = 0);
      }, [T, y]),
      onOpen: C,
      onClose: T,
      disableHoverableContent: y,
      children: n
    }
  ) });
}, "Tooltip"), jf = "TooltipTrigger", cP = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ ct(function(t, n) {
    const { __scopeTooltip: r, "aria-describedby": o, ...i } = t, s = yi(jf, r), a = Nu(jf, r), l = Ou(r), c = v.useRef(null), u = be(n, c, s.onTriggerChange), d = v.useRef(!1), f = v.useRef(!1), m = v.useCallback(() => d.current = !1, []);
    return v.useEffect(() => () => document.removeEventListener("pointerup", m), [m]), /* @__PURE__ */ h(ea, { asChild: !0, ...l, children: /* @__PURE__ */ h(
      me.button,
      {
        "aria-describedby": s.open ? iv(o, s.contentId) : o,
        "data-state": s.stateAttribute,
        ...i,
        ref: u,
        onPointerMove: re(t.onPointerMove, (p) => {
          p.pointerType !== "touch" && !f.current && !a.isPointerInTransitRef.current && (s.onTriggerEnter(), f.current = !0);
        }),
        onPointerLeave: re(t.onPointerLeave, () => {
          s.onTriggerLeave(), f.current = !1;
        }),
        onPointerDown: re(t.onPointerDown, () => {
          s.open && s.onClose(), d.current = !0, document.addEventListener("pointerup", m, { once: !0 });
        }),
        onFocus: re(t.onFocus, () => {
          d.current || s.onOpen();
        }),
        onBlur: re(t.onBlur, s.onClose),
        onClick: re(t.onClick, s.onClose)
      }
    ) });
  }, "TooltipTrigger")
), Xg = "TooltipPortal", [uP, dP] = Au(Xg, {
  forceMount: void 0
}), qg = /* @__PURE__ */ ct((e) => {
  const { __scopeTooltip: t, forceMount: n, children: r, container: o } = e, i = yi(Xg, t);
  return /* @__PURE__ */ h(uP, { scope: t, forceMount: n, children: /* @__PURE__ */ h(Lt, { present: n || i.open, children: /* @__PURE__ */ h(gi, { asChild: !0, container: o, children: r }) }) });
}, "TooltipPortal"), ei = "TooltipContent", Qg = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ ct(function(t, n) {
    const r = dP(ei, t.__scopeTooltip), { forceMount: o = r.forceMount, side: i = "top", ...s } = t, a = yi(ei, t.__scopeTooltip);
    return /* @__PURE__ */ h(Lt, { present: o || a.open, children: a.disableHoverableContent ? /* @__PURE__ */ h(Zg, { side: i, ...s, ref: n }) : /* @__PURE__ */ h(fP, { side: i, ...s, ref: n }) });
  }, "TooltipContent")
), fP = /* @__PURE__ */ v.forwardRef(/* @__PURE__ */ ct(function(t, n) {
  const r = yi(ei, t.__scopeTooltip), o = Nu(ei, t.__scopeTooltip), i = v.useRef(null), s = be(n, i), [a, l] = v.useState(null), { trigger: c, onClose: u } = r, d = i.current, { onPointerInTransitChange: f } = o, m = v.useCallback(() => {
    l(null), f(!1);
  }, [f]), p = v.useCallback(
    (g, y) => {
      const b = g.currentTarget, x = { x: g.clientX, y: g.clientY }, w = Jg(x, b.getBoundingClientRect()), S = ev(x, w), E = tv(y.getBoundingClientRect()), C = rv([...S, ...E]);
      l(C), f(!0);
    },
    [f]
  );
  return v.useEffect(() => () => m(), [m]), v.useEffect(() => {
    if (c && d) {
      const g = /* @__PURE__ */ ct((b) => p(b, d), "handleTriggerLeave"), y = /* @__PURE__ */ ct((b) => p(b, c), "handleContentLeave");
      return c.addEventListener("pointerleave", g), d.addEventListener("pointerleave", y), () => {
        c.removeEventListener("pointerleave", g), d.removeEventListener("pointerleave", y);
      };
    }
  }, [c, d, p, m]), v.useEffect(() => {
    if (a) {
      const g = /* @__PURE__ */ ct((y) => {
        const b = y.target, x = { x: y.clientX, y: y.clientY }, w = (c == null ? void 0 : c.contains(b)) || (d == null ? void 0 : d.contains(b)), S = !nv(x, a);
        w ? m() : S && (m(), u());
      }, "handleTrackPointerGrace");
      return document.addEventListener("pointermove", g), () => document.removeEventListener("pointermove", g);
    }
  }, [c, d, a, u, m]), /* @__PURE__ */ h(Zg, { ...t, ref: s });
}, "TooltipContentHoverable")), hP = /* @__PURE__ */ Ip("TooltipContent"), Zg = /* @__PURE__ */ v.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ ct(function(t, n) {
    const {
      __scopeTooltip: r,
      children: o,
      "aria-label": i,
      id: s,
      onEscapeKeyDown: a,
      onPointerDownOutside: l,
      ...c
    } = t, u = yi(ei, r), d = Ou(r), { onClose: f } = u;
    v.useEffect(() => (document.addEventListener(Gl, f), () => document.removeEventListener(Gl, f)), [f]), v.useEffect(() => {
      if (u.trigger) {
        const p = /* @__PURE__ */ ct((g) => {
          g.target instanceof Node && g.target.contains(u.trigger) && f();
        }, "handleScroll");
        return window.addEventListener("scroll", p, { capture: !0 }), () => window.removeEventListener("scroll", p, { capture: !0 });
      }
    }, [u.trigger, f]);
    const { setContentId: m } = u;
    return qe(() => (m(s), () => {
      m(void 0);
    }), [s, m]), /* @__PURE__ */ h(
      pi,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: a,
        onPointerDownOutside: l,
        onFocusOutside: (p) => p.preventDefault(),
        onDismiss: f,
        children: /* @__PURE__ */ L(
          Ru,
          {
            "data-state": u.stateAttribute,
            role: i ? void 0 : "tooltip",
            id: i ? void 0 : u.contentId,
            ...d,
            ...c,
            ref: n,
            style: {
              ...c.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ h(hP, { children: o }),
              i ? /* @__PURE__ */ h(Mu, { id: u.contentId, role: "tooltip", children: i }) : null
            ]
          }
        )
      }
    );
  }, "TooltipContentImpl")
);
function Jg(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), o = Math.abs(t.right - e.x), i = Math.abs(t.left - e.x);
  switch (Math.min(n, r, o, i)) {
    case i:
      return "left";
    case o:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
ct(Jg, "getExitSideFromRect");
function ev(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      r.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return r;
}
ct(ev, "getPaddedExitPoints");
function tv(e) {
  const { top: t, right: n, bottom: r, left: o } = e;
  return [
    { x: o, y: t },
    { x: n, y: t },
    { x: n, y: r },
    { x: o, y: r }
  ];
}
ct(tv, "getPointsFromRect");
function nv(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let i = 0, s = t.length - 1; i < t.length; s = i++) {
    const a = t[i], l = t[s], c = a.x, u = a.y, d = l.x, f = l.y;
    u > r != f > r && n < (d - c) * (r - u) / (f - u) + c && (o = !o);
  }
  return o;
}
ct(nv, "isPointInPolygon");
function rv(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), ov(t);
}
ct(rv, "getHull");
function ov(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const o = e[r];
    for (; t.length >= 2; ) {
      const i = t[t.length - 1], s = t[t.length - 2];
      if ((i.x - s.x) * (o.y - s.y) >= (i.y - s.y) * (o.x - s.x)) t.pop();
      else break;
    }
    t.push(o);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const o = e[r];
    for (; n.length >= 2; ) {
      const i = n[n.length - 1], s = n[n.length - 2];
      if ((i.x - s.x) * (o.y - s.y) >= (i.y - s.y) * (o.x - s.x)) n.pop();
      else break;
    }
    n.push(o);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
ct(ov, "getHullPresorted");
function iv(...e) {
  const t = /* @__PURE__ */ new Set();
  for (const n of e)
    if (typeof n == "string")
      for (const r of String(n).trim().split(/\s+/))
        r && t.add(r);
  return t.size > 0 ? Array.from(t).join(" ") : void 0;
}
ct(iv, "concatAriaDescribedby");
const _u = sP, na = lP, ra = cP, bi = v.forwardRef(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ h(qg, { children: /* @__PURE__ */ h(
  Qg,
  {
    ref: r,
    sideOffset: t,
    className: Q(
      "z-50 overflow-hidden rounded-lg border bg-neutral-bg px-2 py-0.5 text-xxs text-neutral-text-secondary shadow-sm animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...n
  }
) }));
bi.displayName = Qg.displayName;
function sv({ text: e, className: t = "" }) {
  const n = /* @__PURE__ */ h("span", { className: t, children: e });
  return e ? /* @__PURE__ */ L(na, { children: [
    /* @__PURE__ */ h(ra, { asChild: !0, children: n }),
    /* @__PURE__ */ h(qg, { children: /* @__PURE__ */ h(bi, { side: "top", className: "z-[9999] max-w-xs break-words text-xs dark:text-white", children: e }) })
  ] }) : n;
}
function mP(e, t, n) {
  return pP(e, { column: t, row: n });
}
function pP(e, t) {
  return !e || !t ? !1 : e.column === t.column && e.row === t.row;
}
const wV = () => ({
  split: !0
}), xV = (e) => ({
  split: !0,
  key: e,
  isLocked: !0
}), SV = (e) => ({
  split: !0,
  key: e,
  isLockedRight: !0
}), gP = (e, t) => {
  const n = `${e.map((r) => r.key).join("_").toLowerCase()}_${t}_group`;
  return {
    key: n,
    name: n,
    group: e,
    groupColumn: !0,
    _dfColIndex: -1
  };
};
function vP(e, t, n) {
  const r = new Array(e);
  return new Proxy(r, {
    get(o, i, s) {
      if (typeof i == "string") {
        const a = i.charCodeAt(0);
        if (a >= 48 && a <= 57) {
          const l = +i;
          if (Number.isInteger(l) && l >= 0 && l < e) {
            let c = o[l];
            if (!c) {
              const u = t[l * 2];
              c = o[l] = {
                index: l,
                key: n(l),
                start: u,
                size: t[l * 2 + 1],
                end: u + t[l * 2 + 1],
                lane: 0
              };
            }
            return c;
          }
        }
        if (i === "length") return e;
      }
      return Reflect.get(o, i, s);
    }
  });
}
function zr(e, t, n) {
  let r = n.initialDeps ?? [], o, i = !0;
  function s() {
    var a;
    const l = process.env.NODE_ENV !== "production" && !!n.key && !!((a = n.debug) != null && a.call(n));
    let c = 0;
    l && (c = Date.now());
    const u = e();
    if (!(u.length !== r.length || u.some((m, p) => r[p] !== m)))
      return o;
    r = u;
    let f = 0;
    if (l && (f = Date.now()), o = t(...u), l) {
      const m = Math.round((Date.now() - c) * 100) / 100, p = Math.round((Date.now() - f) * 100) / 100, g = p / 16, y = (b, x) => {
        for (b = String(b); b.length < x; )
          b = " " + b;
        return b;
      };
      console.info(
        `%c⏱ ${y(p, 5)} /${y(m, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * g, 120)
        )}deg 100% 31%);`,
        n == null ? void 0 : n.key
      );
    }
    return n != null && n.onChange && !(i && n.skipInitialOnChange) && n.onChange(o), i = !1, o;
  }
  return s.updateDeps = (a) => {
    r = a;
  }, s;
}
function Hf(e, t) {
  if (e === void 0)
    throw new Error("Unexpected undefined");
  return e;
}
const yP = (e, t) => Math.abs(e - t) < 1.01, bP = (e, t, n) => {
  let r;
  return function(...o) {
    e.clearTimeout(r), r = e.setTimeout(() => t.apply(this, o), n);
  };
};
let ko;
const Wa = () => {
  if (ko !== void 0) return ko;
  if (typeof navigator > "u") return ko = !1;
  if (/iP(hone|od|ad)/.test(navigator.userAgent)) return ko = !0;
  const e = navigator.maxTouchPoints;
  return ko = navigator.platform === "MacIntel" && e !== void 0 && e > 0;
}, Uf = (e) => {
  const { offsetWidth: t, offsetHeight: n } = e;
  return { width: t, height: n };
}, wP = (e) => e, xP = (e) => {
  const t = Math.max(e.startIndex - e.overscan, 0), r = Math.min(e.endIndex + e.overscan, e.count - 1) - t + 1, o = new Array(r);
  for (let i = 0; i < r; i++)
    o[i] = t + i;
  return o;
}, SP = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  const o = (s) => {
    const { width: a, height: l } = s;
    t({ width: Math.round(a), height: Math.round(l) });
  };
  if (o(Uf(n)), !r.ResizeObserver)
    return () => {
    };
  const i = new r.ResizeObserver((s) => {
    const a = () => {
      const l = s[0];
      if (l != null && l.borderBoxSize) {
        const c = l.borderBoxSize[0];
        if (c) {
          o({ width: c.inlineSize, height: c.blockSize });
          return;
        }
      }
      o(Uf(n));
    };
    e.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(a) : a();
  });
  return i.observe(n, { box: "border-box" }), () => {
    i.unobserve(n);
  };
}, Es = {
  passive: !0
}, CP = typeof window > "u" ? !0 : "onscrollend" in window, TP = (e, t, n) => {
  const r = e.scrollElement;
  if (!r)
    return;
  const o = e.targetWindow;
  if (!o)
    return;
  const i = e.options.useScrollendEvent && CP;
  let s = 0;
  const a = i ? null : bP(
    o,
    () => t(s, !1),
    e.options.isScrollingResetDelay
  ), l = (d) => () => {
    s = n(r), a == null || a(), t(s, d);
  }, c = l(!0), u = l(!1);
  return r.addEventListener("scroll", c, Es), i && r.addEventListener("scrollend", u, Es), () => {
    r.removeEventListener("scroll", c), i && r.removeEventListener("scrollend", u);
  };
}, PP = (e, t) => TP(e, t, (n) => {
  const { horizontal: r, isRtl: o } = e.options;
  return r ? n.scrollLeft * (o && -1 || 1) : n.scrollTop;
}), EP = (e, t, n) => {
  if (n.options.useCachedMeasurements) {
    const r = n.indexFromElement(e), o = n.options.getItemKey(r);
    return n.itemSizeCache.get(o) ?? n.options.estimateSize(r);
  }
  if (t != null && t.borderBoxSize) {
    const r = t.borderBoxSize[0];
    if (r)
      return Math.round(
        r[n.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  if (!t) {
    const r = n.indexFromElement(e), o = n.options.getItemKey(r), i = n.itemSizeCache.get(o);
    if (i !== void 0)
      return i;
  }
  return e[n.options.horizontal ? "offsetWidth" : "offsetHeight"];
}, kP = (e, {
  adjustments: t = 0,
  behavior: n
}, r) => {
  var o, i;
  (i = (o = r.scrollElement) == null ? void 0 : o.scrollTo) == null || i.call(o, {
    [r.options.horizontal ? "left" : "top"]: e + t,
    behavior: n
  });
}, DP = kP;
class RP {
  constructor(t) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollState = null, this.measurementsCache = [], this._flatMeasurements = null, this.itemSizeCache = /* @__PURE__ */ new Map(), this.itemSizeCacheVersion = 0, this.laneAssignments = /* @__PURE__ */ new Map(), this.pendingMin = null, this.prevLanes = void 0, this.lanesChangedFlag = !1, this.lanesSettling = !1, this.pendingScrollAnchor = null, this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this._iosDeferredAdjustment = 0, this._iosTouching = !1, this._iosJustTouchEnded = !1, this._iosTouchEndTimerId = null, this._intendedScrollOffset = null, this.elementsCache = /* @__PURE__ */ new Map(), this.now = () => {
      var n, r, o;
      return ((o = (r = (n = this.targetWindow) == null ? void 0 : n.performance) == null ? void 0 : r.now) == null ? void 0 : o.call(r)) ?? Date.now();
    }, this.observer = /* @__PURE__ */ (() => {
      let n = null;
      const r = () => n || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : n = new this.targetWindow.ResizeObserver((o) => {
        o.forEach((i) => {
          const s = () => {
            const a = i.target, l = this.indexFromElement(a);
            if (!a.isConnected) {
              this.observer.unobserve(a);
              for (const [c, u] of this.elementsCache)
                if (u === a) {
                  this.elementsCache.delete(c);
                  break;
                }
              return;
            }
            this.shouldMeasureDuringScroll(l) && this.resizeItem(
              l,
              this.options.measureElement(a, i, this)
            );
          };
          this.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(s) : s();
        });
      }));
      return {
        disconnect: () => {
          var o;
          (o = r()) == null || o.disconnect(), n = null;
        },
        observe: (o) => {
          var i;
          return (i = r()) == null ? void 0 : i.observe(o, { box: "border-box" });
        },
        unobserve: (o) => {
          var i;
          return (i = r()) == null ? void 0 : i.unobserve(o);
        }
      };
    })(), this.range = null, this.setOptions = (n) => {
      var r, o;
      const i = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: wP,
        rangeExtractor: xP,
        onChange: () => {
        },
        measureElement: EP,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        anchorTo: "start",
        followOnAppend: !1,
        scrollEndThreshold: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        useScrollendEvent: !1,
        useAnimationFrameWithResizeObserver: !1,
        laneAssignmentMode: "estimate",
        useCachedMeasurements: !1
      };
      for (const f in n) {
        const m = n[f];
        m !== void 0 && (i[f] = m);
      }
      const s = this.options;
      let a = null, l = null, c = !1;
      if (s !== void 0 && s.enabled && i.enabled && i.anchorTo === "end" && this.scrollElement !== null) {
        const f = s.count, m = i.count, p = this.getMeasurements(), g = f > 0 ? ((r = p[0]) == null ? void 0 : r.key) ?? s.getItemKey(0) : null, y = f > 0 ? ((o = p[f - 1]) == null ? void 0 : o.key) ?? s.getItemKey(f - 1) : null;
        if (m !== f || f > 0 && m > 0 && (i.getItemKey(0) !== g || i.getItemKey(m - 1) !== y)) {
          c = !0;
          const w = f > 0 ? this.getVirtualItemForOffset(this.getScrollOffset()) ?? p[0] : null;
          w && (a = [w.key, this.getScrollOffset() - w.start]);
          const S = i.followOnAppend === !0 ? "auto" : i.followOnAppend || null;
          S && m > f && this.isAtEnd(s.scrollEndThreshold) && (f === 0 || i.getItemKey(m - 1) !== y) && (l = S);
        }
      }
      this.options = i, c && (this.pendingMin = 0, this.itemSizeCacheVersion++);
      let u = !1, d = 0;
      if (a && this.scrollOffset !== null) {
        const [f, m] = a, p = this.getMeasurements(), { count: g, getItemKey: y } = this.options;
        let b = 0;
        for (; b < g && y(b) !== f; )
          b++;
        if (b < g) {
          const x = p[b];
          if (x) {
            const w = Math.max(0, x.start + m);
            w !== this.scrollOffset && (d = w - this.scrollOffset, this.scrollOffset = w, u = !0);
          }
        }
      }
      (u || l) && (this.pendingScrollAnchor = [
        u ? a[0] : null,
        u ? a[1] : 0,
        l,
        d
      ]);
    }, this.notify = (n) => {
      var r, o;
      (o = (r = this.options).onChange) == null || o.call(r, this, n);
    }, this.maybeNotify = zr(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (n) => {
        this.notify(n);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((n) => n()), this.unsubs = [], this.observer.disconnect(), this.rafId != null && this.targetWindow && (this.targetWindow.cancelAnimationFrame(this.rafId), this.rafId = null), this.scrollState = null, this._iosDeferredAdjustment = 0, this._iosTouching = !1, this._iosJustTouchEnded = !1, this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var n;
      const r = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== r) {
        if (this.cleanup(), !r) {
          this.maybeNotify();
          return;
        }
        if (this.scrollElement = r, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((n = this.scrollElement) == null ? void 0 : n.window) ?? null, this.elementsCache.forEach((i) => {
          this.observer.observe(i);
        }), this.unsubs.push(
          this.options.observeElementRect(this, (i) => {
            this.scrollRect = i, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (i, s) => {
            if (s && this._intendedScrollOffset === null && i === this.scrollOffset)
              return;
            this._intendedScrollOffset !== null && Math.abs(i - this._intendedScrollOffset) < 1.5 && (i = this._intendedScrollOffset), this._intendedScrollOffset = null, this.scrollAdjustments = 0;
            const a = this.getScrollOffset();
            this.scrollDirection = s ? a === i ? this.scrollDirection : a < i ? "forward" : "backward" : null, this.scrollOffset = i, this.isScrolling = s, this._flushIosDeferredIfReady(), this.scrollState && this.scheduleScrollReconcile(), this.maybeNotify();
          })
        ), "addEventListener" in this.scrollElement) {
          const i = this.scrollElement, s = () => {
            this._iosTouching = !0, this._iosJustTouchEnded = !1, this._iosTouchEndTimerId !== null && this.targetWindow != null && (this.targetWindow.clearTimeout(this._iosTouchEndTimerId), this._iosTouchEndTimerId = null);
          }, a = () => {
            this._iosTouching = !1, !(!Wa() || this.targetWindow == null) && (this._iosJustTouchEnded = !0, this._iosTouchEndTimerId = this.targetWindow.setTimeout(() => {
              this._iosJustTouchEnded = !1, this._iosTouchEndTimerId = null, this._flushIosDeferredIfReady();
            }, 150));
          };
          i.addEventListener(
            "touchstart",
            s,
            Es
          ), i.addEventListener(
            "touchend",
            a,
            Es
          ), this.unsubs.push(() => {
            i.removeEventListener("touchstart", s), i.removeEventListener("touchend", a), this._iosTouchEndTimerId !== null && this.targetWindow != null && (this.targetWindow.clearTimeout(this._iosTouchEndTimerId), this._iosTouchEndTimerId = null);
          });
        }
        this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        });
      }
      const o = this.pendingScrollAnchor;
      if (this.pendingScrollAnchor = null, o && this.scrollElement && this.options.enabled) {
        const [i, s, a, l] = o;
        i !== null && !a && (Wa() && (this.isScrolling || this._iosTouching || this._iosJustTouchEnded) ? l !== 0 && (this._iosDeferredAdjustment += l) : this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        })), a && this.scrollToEnd({ behavior: a });
      }
    }, this._flushIosDeferredIfReady = () => {
      if (this._iosDeferredAdjustment === 0 || this.isScrolling || this._iosTouching || this._iosJustTouchEnded) return;
      const n = this.getScrollOffset(), r = this.getMaxScrollOffset();
      if (n < 0 || n > r) return;
      if (this._iosDeferredAdjustment < 0 && n >= r - 1) {
        this._iosDeferredAdjustment = 0;
        return;
      }
      const o = this._iosDeferredAdjustment;
      this._iosDeferredAdjustment = 0, this._scrollToOffset(n, {
        adjustments: this.scrollAdjustments += o,
        behavior: void 0
      });
    }, this.rafId = null, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getMeasurementOptions = zr(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled,
        this.options.lanes,
        this.options.laneAssignmentMode,
        this.options.gap
      ],
      (n, r, o, i, s, a, l, c) => (this.prevLanes !== void 0 && this.prevLanes !== a && (this.lanesChangedFlag = !0), this.prevLanes = a, this.pendingMin = null, {
        count: n,
        paddingStart: r,
        scrollMargin: o,
        getItemKey: i,
        enabled: s,
        lanes: a,
        laneAssignmentMode: l,
        gap: c
      }),
      {
        key: !1
      }
    ), this.getMeasurements = zr(
      () => [this.getMeasurementOptions(), this.itemSizeCacheVersion],
      ({
        count: n,
        paddingStart: r,
        scrollMargin: o,
        getItemKey: i,
        enabled: s,
        lanes: a,
        laneAssignmentMode: l,
        gap: c
      }, u) => {
        const d = this.itemSizeCache;
        if (!s)
          return this.measurementsCache = [], this.itemSizeCache.clear(), this.laneAssignments.clear(), [];
        if (this.laneAssignments.size > n)
          for (const b of this.laneAssignments.keys())
            b >= n && this.laneAssignments.delete(b);
        this.lanesChangedFlag && (this.lanesChangedFlag = !1, this.lanesSettling = !0, this.measurementsCache = [], this.itemSizeCache.clear(), this.laneAssignments.clear(), this.pendingMin = null), this.measurementsCache.length === 0 && !this.lanesSettling && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((b) => {
          this.itemSizeCache.set(b.key, b.size);
        }));
        const f = this.lanesSettling ? 0 : this.pendingMin ?? 0;
        if (this.pendingMin = null, this.lanesSettling && this.measurementsCache.length === n && (this.lanesSettling = !1), a === 1) {
          const b = n * 2;
          let x = this._flatMeasurements;
          if (!x || x.length < b) {
            const E = new Float64Array(b);
            x && f > 0 && E.set(x.subarray(0, f * 2)), x = E, this._flatMeasurements = x;
          }
          let w;
          if (f === 0)
            w = r + o;
          else {
            const E = f - 1;
            w = x[E * 2] + x[E * 2 + 1] + c;
          }
          for (let E = f; E < n; E++) {
            const C = i(E), T = d.get(C), P = typeof T == "number" ? T : this.options.estimateSize(E);
            x[E * 2] = w, x[E * 2 + 1] = P, w += P + c;
          }
          const S = vP(n, x, i);
          return this.measurementsCache = S, S;
        }
        const m = this.measurementsCache.slice(0, f), p = new Array(a).fill(
          void 0
        ), g = new Float64Array(a);
        let y = 0;
        for (let b = 0; b < f; b++) {
          const x = m[b];
          x && (p[x.lane] === void 0 && y++, p[x.lane] = b, g[x.lane] = x.end);
        }
        for (let b = f; b < n; b++) {
          const x = i(b), w = this.laneAssignments.get(b);
          let S, E;
          const C = l === "estimate" || d.has(x);
          if (w !== void 0 && this.options.lanes > 1) {
            S = w;
            const k = p[S], R = k !== void 0 ? m[k] : void 0;
            E = R ? R.end + c : r + o;
          } else if (y === a) {
            let k = 0, R = g[0], O = p[0];
            for (let _ = 1; _ < a; _++) {
              const $ = g[_];
              ($ < R || $ === R && p[_] < O) && (k = _, R = $, O = p[_]);
            }
            S = k, E = R + c, C && this.laneAssignments.set(b, S);
          } else
            S = b % this.options.lanes, E = r + o, C && this.laneAssignments.set(b, S);
          const T = d.get(x), P = typeof T == "number" ? T : this.options.estimateSize(b), D = E + P;
          m[b] = {
            index: b,
            start: E,
            size: P,
            end: D,
            key: x,
            lane: S
          }, p[S] === void 0 && y++, p[S] = b, g[S] = D;
        }
        return this.measurementsCache = m, m;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = zr(
      () => [
        this.getMeasurements(),
        this.getSize(),
        this.getScrollOffset(),
        this.options.lanes
      ],
      (n, r, o, i) => n.length === 0 || r === 0 ? (this.range = null, null) : (this.range = AP(
        n,
        r,
        o,
        i,
        // Pass the typed array so binary search + forward-walk can read
        // start/end directly from Float64Array, skipping the Proxy traps.
        i === 1 && this._flatMeasurements != null ? this._flatMeasurements : null
      ), this.range),
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getVirtualIndexes = zr(
      () => {
        let n = null, r = null;
        const o = this.calculateRange();
        return o && (n = o.startIndex, r = o.endIndex), this.maybeNotify.updateDeps([this.isScrolling, n, r]), [
          this.options.rangeExtractor,
          this.options.overscan,
          this.options.count,
          n,
          r
        ];
      },
      (n, r, o, i, s) => i === null || s === null ? [] : n({
        startIndex: i,
        endIndex: s,
        overscan: r,
        count: o
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (n) => {
      const r = this.options.indexAttribute, o = n.getAttribute(r);
      return o ? parseInt(o, 10) : (console.warn(
        `Missing attribute name '${r}={index}' on measured element.`
      ), -1);
    }, this.shouldMeasureDuringScroll = (n) => {
      var r;
      if (!this.scrollState || this.scrollState.behavior !== "smooth")
        return !0;
      const o = this.scrollState.index ?? ((r = this.getVirtualItemForOffset(this.scrollState.lastTargetOffset)) == null ? void 0 : r.index);
      if (o !== void 0 && this.range) {
        const i = Math.max(
          this.options.overscan,
          Math.ceil((this.range.endIndex - this.range.startIndex) / 2)
        ), s = Math.max(0, o - i), a = Math.min(
          this.options.count - 1,
          o + i
        );
        return n >= s && n <= a;
      }
      return !0;
    }, this.measureElement = (n) => {
      if (!n) {
        this.elementsCache.forEach((s, a) => {
          s.isConnected || (this.observer.unobserve(s), this.elementsCache.delete(a));
        });
        return;
      }
      const r = this.indexFromElement(n), o = this.options.getItemKey(r), i = this.elementsCache.get(o);
      i !== n && (i && this.observer.unobserve(i), this.observer.observe(n), this.elementsCache.set(o, n)), (!this.isScrolling || this.scrollState) && this.shouldMeasureDuringScroll(r) && this.resizeItem(r, this.options.measureElement(n, void 0, this));
    }, this.resizeItem = (n, r) => {
      var o, i;
      if (n < 0 || n >= this.options.count) return;
      let s, a, l;
      const c = this._flatMeasurements;
      if (this.options.lanes === 1 && c !== null)
        l = this.options.getItemKey(n), a = c[n * 2], s = c[n * 2 + 1];
      else {
        const f = this.measurementsCache[n];
        if (!f) return;
        l = f.key, a = f.start, s = f.size;
      }
      const u = this.itemSizeCache.get(l) ?? s, d = r - u;
      if (d !== 0) {
        const f = this.options.anchorTo === "end" && ((o = this.scrollState) == null ? void 0 : o.behavior) !== "smooth" && this.getVirtualDistanceFromEnd() <= this.options.scrollEndThreshold, m = f ? this.getTotalSize() : 0, p = this.getScrollOffset() + this.scrollAdjustments, y = !this.itemSizeCache.has(l) ? (
          // First measurement: compensate any item whose top sits above the
          // fold — the estimate→actual delta must be corrected regardless of
          // scroll direction, since the whole estimated block was above it.
          a < p
        ) : (
          // Re-measurement: only compensate an item that is ENTIRELY above the
          // fold. An item that merely *spans* the fold (top above, bottom
          // below — e.g. a streaming chat message growing at its bottom)
          // changes size *below* the anchor point, so shifting scrollTop by the
          // delta would drag the viewport downward on every growth (#1218).
          // Also skip during backward scroll to avoid the "items jump while
          // scrolling up" cascade.
          a + u <= p && this.scrollDirection !== "backward"
        ), b = ((i = this.scrollState) == null ? void 0 : i.behavior) !== "smooth" && (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(
          // The callback expects a VirtualItem; build one lazily only
          // when the consumer actually supplied a custom predicate.
          this.measurementsCache[n] ?? {
            index: n,
            key: l,
            start: a,
            size: s,
            end: a + s,
            lane: 0
          },
          d,
          this
        ) : y);
        (this.pendingMin === null || n < this.pendingMin) && (this.pendingMin = n), this.itemSizeCache.set(l, r), this.itemSizeCacheVersion++, f ? this.applyScrollAdjustment(this.getTotalSize() - m) : b && this.applyScrollAdjustment(d), this.notify(!1);
      }
    }, this.getVirtualItems = zr(
      () => [this.getVirtualIndexes(), this.getMeasurements()],
      (n, r) => {
        const o = [];
        for (let i = 0, s = n.length; i < s; i++) {
          const a = n[i], l = r[a];
          o.push(l);
        }
        return o;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (n) => {
      const r = this.getMeasurements();
      if (r.length === 0)
        return;
      const o = this._flatMeasurements, i = this.options.lanes === 1 && o != null, s = av(
        0,
        r.length - 1,
        i ? (a) => o[a * 2] : (a) => Hf(r[a]).start,
        n
      );
      return Hf(r[s]);
    }, this.getMaxScrollOffset = () => {
      if (!this.scrollElement) return 0;
      if ("scrollHeight" in this.scrollElement)
        return this.options.horizontal ? this.scrollElement.scrollWidth - this.scrollElement.clientWidth : this.scrollElement.scrollHeight - this.scrollElement.clientHeight;
      {
        const n = this.scrollElement.document.documentElement;
        return this.options.horizontal ? n.scrollWidth - this.scrollElement.innerWidth : n.scrollHeight - this.scrollElement.innerHeight;
      }
    }, this.getVirtualDistanceFromEnd = () => Math.max(
      this.getTotalSize() - this.getSize() - this.getScrollOffset(),
      0
    ), this.getDistanceFromEnd = () => Math.max(this.getMaxScrollOffset() - this.getScrollOffset(), 0), this.isAtEnd = (n = this.options.scrollEndThreshold) => this.getDistanceFromEnd() <= n, this.getOffsetForAlignment = (n, r, o = 0) => {
      if (!this.scrollElement) return 0;
      const i = this.getSize(), s = this.getScrollOffset();
      r === "auto" && (r = n >= s + i ? "end" : "start"), r === "center" ? n += (o - i) / 2 : r === "end" && (n -= i);
      const a = this.getMaxScrollOffset();
      return Math.max(Math.min(a, n), 0);
    }, this.getOffsetForIndex = (n, r = "auto") => {
      n = Math.max(0, Math.min(n, this.options.count - 1));
      const o = this.getSize(), i = this.getScrollOffset(), s = this.measurementsCache[n];
      if (!s) return;
      if (r === "auto")
        if (s.end >= i + o - this.options.scrollPaddingEnd)
          r = "end";
        else if (s.start <= i + this.options.scrollPaddingStart)
          r = "start";
        else
          return [i, r];
      if (r === "end" && n === this.options.count - 1)
        return [this.getMaxScrollOffset(), r];
      const a = r === "end" ? s.end + this.options.scrollPaddingEnd : s.start - this.options.scrollPaddingStart;
      return [
        this.getOffsetForAlignment(a, r, s.size),
        r
      ];
    }, this.scrollToOffset = (n, { align: r = "start", behavior: o = "auto" } = {}) => {
      this._iosDeferredAdjustment = 0;
      const i = this.getOffsetForAlignment(n, r), s = this.now();
      this.scrollState = {
        index: null,
        align: r,
        behavior: o,
        startedAt: s,
        lastTargetOffset: i,
        stableFrames: 0
      }, this._scrollToOffset(i, { adjustments: void 0, behavior: o }), this.scheduleScrollReconcile();
    }, this.scrollToIndex = (n, {
      align: r = "auto",
      behavior: o = "auto"
    } = {}) => {
      this._iosDeferredAdjustment = 0, n = Math.max(0, Math.min(n, this.options.count - 1));
      const i = this.getOffsetForIndex(n, r);
      if (!i)
        return;
      const [s, a] = i, l = this.now();
      this.scrollState = {
        index: n,
        align: a,
        behavior: o,
        startedAt: l,
        lastTargetOffset: s,
        stableFrames: 0
      }, this._scrollToOffset(s, { adjustments: void 0, behavior: o }), this.scheduleScrollReconcile();
    }, this.scrollBy = (n, { behavior: r = "auto" } = {}) => {
      const o = this.getScrollOffset() + n, i = this.now();
      this.scrollState = {
        index: null,
        align: "start",
        behavior: r,
        startedAt: i,
        lastTargetOffset: o,
        stableFrames: 0
      }, this._scrollToOffset(o, { adjustments: void 0, behavior: r }), this.scheduleScrollReconcile();
    }, this.scrollToEnd = ({ behavior: n = "auto" } = {}) => {
      if (this.options.count > 0) {
        this.scrollToIndex(this.options.count - 1, {
          align: "end",
          behavior: n
        });
        return;
      }
      this.scrollToOffset(Math.max(this.getTotalSize() - this.getSize(), 0), {
        behavior: n
      });
    }, this.getTotalSize = () => {
      var n;
      const r = this.getMeasurements();
      let o;
      if (r.length === 0)
        o = this.options.paddingStart;
      else if (this.options.lanes === 1) {
        const i = r.length - 1, s = this._flatMeasurements;
        s != null ? o = s[i * 2] + s[i * 2 + 1] : o = ((n = r[i]) == null ? void 0 : n.end) ?? 0;
      } else {
        const i = Array(this.options.lanes).fill(null);
        let s = r.length - 1;
        for (; s >= 0 && i.some((a) => a === null); ) {
          const a = r[s];
          i[a.lane] === null && (i[a.lane] = a.end), s--;
        }
        o = Math.max(...i.filter((a) => a !== null));
      }
      return Math.max(
        o - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this.takeSnapshot = () => {
      const n = [];
      if (this.itemSizeCache.size === 0) return n;
      const r = this.getMeasurements();
      for (const o of r)
        o && this.itemSizeCache.has(o.key) && n.push({
          index: o.index,
          key: o.key,
          start: o.start,
          size: o.size,
          end: o.end,
          lane: o.lane
        });
      return n;
    }, this._scrollToOffset = (n, {
      adjustments: r,
      behavior: o
    }) => {
      this._intendedScrollOffset = n + (r ?? 0), this.options.scrollToFn(n, { behavior: o, adjustments: r }, this);
    }, this.measure = () => {
      this.pendingMin = null, this.itemSizeCache.clear(), this.laneAssignments.clear(), this.itemSizeCacheVersion++, this.notify(!1);
    }, this.setOptions(t);
  }
  applyScrollAdjustment(t, n) {
    t !== 0 && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", t), Wa() && (this.isScrolling || this._iosTouching || this._iosJustTouchEnded) ? this._iosDeferredAdjustment += t : (this._scrollToOffset(this.getScrollOffset(), {
      adjustments: this.scrollAdjustments += t,
      behavior: n
    }), this.scrollOffset !== null && (this.scrollOffset += this.scrollAdjustments, this.scrollOffset < 0 && (this.scrollOffset = 0), this.scrollAdjustments = 0)));
  }
  scheduleScrollReconcile() {
    if (!this.targetWindow) {
      this.scrollState = null;
      return;
    }
    this.rafId == null && (this.rafId = this.targetWindow.requestAnimationFrame(() => {
      this.rafId = null, this.reconcileScroll();
    }));
  }
  reconcileScroll() {
    if (!this.scrollState || !this.scrollElement) return;
    if (this.now() - this.scrollState.startedAt > 5e3) {
      this.scrollState = null;
      return;
    }
    const r = this.scrollState.index != null ? this.getOffsetForIndex(this.scrollState.index, this.scrollState.align) : void 0, o = r ? r[0] : this.scrollState.lastTargetOffset, i = 1, s = o !== this.scrollState.lastTargetOffset;
    if (!s && yP(o, this.getScrollOffset())) {
      if (this.scrollState.stableFrames++, this.scrollState.stableFrames >= i) {
        this.getScrollOffset() !== o && this._scrollToOffset(o, {
          adjustments: void 0,
          behavior: "auto"
        }), this.scrollState = null;
        return;
      }
    } else if (this.scrollState.stableFrames = 0, s) {
      const a = this.getSize() || 600, l = Math.abs(o - this.getScrollOffset()), c = this.scrollState.behavior === "smooth" && l > a;
      this.scrollState.lastTargetOffset = o, c || (this.scrollState.behavior = "auto"), this._scrollToOffset(o, {
        adjustments: void 0,
        behavior: c ? "smooth" : "auto"
      });
    }
    this.scheduleScrollReconcile();
  }
}
const av = (e, t, n, r) => {
  for (; e <= t; ) {
    const o = (e + t) / 2 | 0, i = n(o);
    if (i < r)
      e = o + 1;
    else if (i > r)
      t = o - 1;
    else
      return o;
  }
  return e > 0 ? e - 1 : 0;
};
function MP(e, t, n) {
  let r = 0;
  for (; r <= t; ) {
    const o = (r + t) / 2 | 0, i = e[o * 2];
    if (i < n)
      r = o + 1;
    else if (i > n)
      t = o - 1;
    else
      return o;
  }
  return r > 0 ? r - 1 : 0;
}
function AP(e, t, n, r, o) {
  const i = e.length - 1;
  if (e.length <= r)
    return { startIndex: 0, endIndex: i };
  if (r === 1 && o !== null) {
    const c = MP(
      o,
      i,
      n
    );
    let u = c;
    const d = n + t;
    for (; u < i && o[u * 2] + o[u * 2 + 1] < d; )
      u++;
    return { startIndex: c, endIndex: u };
  }
  let a = av(0, i, (c) => e[c].start, n), l = a;
  if (r === 1)
    for (; l < i && e[l].end < n + t; )
      l++;
  else if (r > 1) {
    const c = Array(r).fill(0);
    for (; l < i && c.some((d) => d < n + t); ) {
      const d = e[l];
      c[d.lane] = d.end, l++;
    }
    const u = Array(r).fill(n + t);
    for (; a >= 0 && u.some((d) => d >= n); ) {
      const d = e[a];
      u[d.lane] = d.start, a--;
    }
    a = Math.max(0, a - a % r), l = Math.min(i, l + (r - 1 - l % r));
  }
  return { startIndex: a, endIndex: l };
}
const za = typeof document < "u" ? v.useLayoutEffect : v.useEffect;
function OP({
  useFlushSync: e = !0,
  directDomUpdates: t = !1,
  directDomUpdatesMode: n = "transform",
  ...r
}) {
  const o = v.useReducer((u) => u + 1, 0)[1], i = v.useRef({
    enabled: t,
    mode: n,
    container: null,
    lastSize: null,
    // Keyed by the element itself so a remounted node (same key, new DOM
    // node — e.g. when `enabled` is toggled off then on) is treated as fresh
    // and gets its style written.
    lastPositions: /* @__PURE__ */ new WeakMap(),
    prevRange: null
  });
  i.current.enabled = t, i.current.mode = n;
  const s = (u) => {
    const d = i.current;
    if (!d.enabled || !d.container) return;
    const f = u.getTotalSize();
    if (f !== d.lastSize) {
      d.lastSize = f;
      const m = u.options.horizontal ? "width" : "height";
      d.container.style[m] = `${f}px`;
    }
  }, a = (u) => {
    const d = i.current;
    if (!d.enabled || !d.container) return;
    s(u);
    const f = !!u.options.horizontal, m = d.mode === "transform", p = f ? "left" : "top", g = u.options.scrollMargin, y = u.getVirtualItems();
    for (const b of y) {
      const x = b.start - g, w = u.elementsCache.get(b.key);
      w && d.lastPositions.get(w) !== x && (d.lastPositions.set(w, x), m ? w.style.transform = f ? `translate3d(${x}px, 0, 0)` : `translate3d(0, ${x}px, 0)` : w.style[p] = `${x}px`);
    }
  }, l = {
    ...r,
    onChange: (u, d) => {
      var f;
      const m = i.current;
      let p = !0;
      if (m.enabled) {
        a(u);
        const g = u.range, y = m.prevRange;
        p = !y || y.isScrolling !== u.isScrolling || y.startIndex !== (g == null ? void 0 : g.startIndex) || y.endIndex !== (g == null ? void 0 : g.endIndex), p && (m.prevRange = g ? {
          startIndex: g.startIndex,
          endIndex: g.endIndex,
          isScrolling: u.isScrolling
        } : null);
      }
      p && (e && d ? ru(o) : o()), (f = r.onChange) == null || f.call(r, u, d);
    }
  }, [c] = v.useState(() => {
    const u = new RP(l);
    return Object.assign(u, {
      containerRef: (d) => {
        const f = i.current;
        if (f.container = d, f.lastSize = null, d && f.enabled) {
          const m = u.getTotalSize();
          f.lastSize = m;
          const p = u.options.horizontal ? "width" : "height";
          d.style[p] = `${m}px`;
        }
      }
    });
  });
  return c.setOptions(l), za(() => c._didMount(), []), za(() => (s(c), c._willUpdate())), za(() => {
    a(c);
  }), c;
}
function NP(e) {
  return OP({
    observeElementRect: SP,
    observeElementOffset: PP,
    scrollToFn: DP,
    ...e
  });
}
function _P({
  column: e,
  columns: t,
  id: n,
  children: r,
  state: o,
  hooks: i,
  aditionalClasses: s,
  topPosition: a,
  leftSection: l,
  rightSection: c,
  infoRow: u,
  showInfoRow: d,
  cfg: f,
  disableResize: m,
  hasActiveFilter: p
}) {
  const g = (w) => {
    if (m)
      return;
    const E = w.target.parentElement.getBoundingClientRect().x;
    w.preventDefault();
    const C = (P) => {
      const D = P.x - E + 6;
      i.changeColumnSize({ key: e.key, width: D });
    }, T = () => {
      document.removeEventListener("mouseup", T), document.removeEventListener("mousemove", C);
    };
    document.addEventListener("mouseup", T), document.addEventListener("mousemove", C);
  }, y = !!e.isLocked, b = !y && !!e.isLockedRight, x = {
    position: "sticky",
    top: `${a}px`,
    zIndex: 20,
    borderLeftWidth: "0px"
  };
  return y ? (x.left = `${f.stickyOffsets[e.key]}px`, x.zIndex = 30, x.borderLeftWidth = "0px") : b && (x.right = `${f.stickyRightOffsets[e.key] ?? 0}px`, x.zIndex = 999999), /* @__PURE__ */ h(
    "th",
    {
      className: He("relative", b && "border-l border-table-borders-header"),
      style: x,
      "attr-column-key": e.key,
      children: /* @__PURE__ */ L("div", { className: He(s, p && "!bg-blue-100 dark:!bg-blue-900"), children: [
        /* @__PURE__ */ L("div", { className: "flex flex-col grow", children: [
          /* @__PURE__ */ h("div", { className: "flex grow", children: /* @__PURE__ */ L("div", { className: "overlay flex flex-row grow px-2 py-1 w-0 items-center justify-center", children: [
            l && /* @__PURE__ */ h("div", { children: l }),
            e.headerComponent ? /* @__PURE__ */ h("div", { className: "flex grow min-w-0", children: /* @__PURE__ */ h(e.headerComponent, { column: e, ...e.headerComponentProps || {} }) }) : /* @__PURE__ */ h(
              sv,
              {
                text: e.name,
                className: "overflow-hidden text-ellipsis whitespace-nowrap text-xs font-medium min-w-0"
              }
            ),
            c && /* @__PURE__ */ h("div", { children: c }),
            /* @__PURE__ */ h("div", { className: "th-controls", children: r })
          ] }) }),
          d && /* @__PURE__ */ h(
            "div",
            {
              className: He(
                "bg-neutral-container border-y border-table-borders-header",
                " px-1 h-5 flex items-center whitespace-nowrap bg-table-bg-fixed font-bold text-neutral-text-secondary",
                e.dataType === "number" && "is-numeric"
              ),
              children: /* @__PURE__ */ h(Mr, { column: e, record: {}, state: {}, value: u })
            }
          )
        ] }),
        !m && /* @__PURE__ */ h(
          "div",
          {
            className: "hover-handle",
            title: "Double-click to fit all columns",
            onMouseDown: (w) => g(w),
            onDoubleClick: (w) => i.autoSizeAllColumns(w.currentTarget)
          }
        )
      ] })
    },
    `${n}-column`
  );
}
var IP = Object.defineProperty, LP = (e, t) => IP(e, "name", { value: t, configurable: !0 });
function ks(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
LP(ks, "clamp");
var $P = Object.defineProperty, ft = (e, t) => $P(e, "name", { value: t, configurable: !0 });
// @__NO_SIDE_EFFECTS__
function wi(e) {
  const t = e + "CollectionProvider", [n, r] = /* @__PURE__ */ It(t), [o, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = /* @__PURE__ */ ft((g) => {
    const { scope: y, children: b } = g, x = v.useRef(null), w = v.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ h(o, { scope: y, itemMap: w, collectionRef: x, children: b });
  }, "CollectionProvider");
  s.displayName = t;
  const a = e + "CollectionSlot", l = /* @__PURE__ */ Cn(a), c = v.forwardRef(
    (g, y) => {
      const { scope: b, children: x } = g, w = i(a, b), S = be(y, w.collectionRef);
      return /* @__PURE__ */ h(l, { ref: S, children: x });
    }
  );
  c.displayName = a;
  const u = e + "CollectionItemSlot", d = "data-radix-collection-item", f = /* @__PURE__ */ Cn(u), m = v.forwardRef(
    (g, y) => {
      const { scope: b, children: x, ...w } = g, S = v.useRef(null), E = be(y, S), C = i(u, b);
      return v.useEffect(() => (C.itemMap.set(S, { ref: S, ...w }), () => void C.itemMap.delete(S))), /* @__PURE__ */ h(f, { [d]: "", ref: E, children: x });
    }
  );
  m.displayName = u;
  function p(g) {
    const y = i(e + "CollectionConsumer", g);
    return v.useCallback(() => {
      const x = y.collectionRef.current;
      if (!x) return [];
      const w = Array.from(x.querySelectorAll(`[${d}]`));
      return Array.from(y.itemMap.values()).sort(
        (C, T) => w.indexOf(C.ref.current) - w.indexOf(T.ref.current)
      );
    }, [y.collectionRef, y.itemMap]);
  }
  return ft(p, "useCollection"), [
    { Provider: s, Slot: c, ItemSlot: m },
    p,
    r
  ];
}
ft(wi, "createCollection");
var Yf = /* @__PURE__ */ new WeakMap(), nt, Vt, ja = (Vt = class extends Map {
  constructor(n) {
    super(n);
    pf(this, nt);
    Da(this, nt, [...super.keys()]), Yf.set(this, !0);
  }
  set(n, r) {
    return Yf.get(this) && (this.has(n) ? wt(this, nt)[wt(this, nt).indexOf(n)] = n : wt(this, nt).push(n)), super.set(n, r), this;
  }
  insert(n, r, o) {
    const i = this.has(r), s = wt(this, nt).length, a = Iu(n);
    let l = a >= 0 ? a : s + a;
    const c = l < 0 || l >= s ? -1 : l;
    if (c === this.size || i && c === this.size - 1 || c === -1)
      return this.set(r, o), this;
    const u = this.size + (i ? 0 : 1);
    a < 0 && l++;
    const d = [...wt(this, nt)];
    let f, m = !1;
    for (let p = l; p < u; p++)
      if (l === p) {
        let g = d[p];
        d[p] === r && (g = d[p + 1]), i && this.delete(r), f = this.get(g), this.set(r, o);
      } else {
        !m && d[p - 1] === r && (m = !0);
        const g = d[m ? p : p - 1], y = f;
        f = this.get(g), this.delete(g), this.set(g, y);
      }
    return this;
  }
  with(n, r, o) {
    const i = new Vt(this);
    return i.insert(n, r, o), i;
  }
  before(n) {
    const r = wt(this, nt).indexOf(n) - 1;
    if (!(r < 0))
      return this.entryAt(r);
  }
  /**
   * Sets a new key-value pair at the position before the given key.
   */
  setBefore(n, r, o) {
    const i = wt(this, nt).indexOf(n);
    return i === -1 ? this : this.insert(i, r, o);
  }
  after(n) {
    let r = wt(this, nt).indexOf(n);
    if (r = r === -1 || r === this.size - 1 ? -1 : r + 1, r !== -1)
      return this.entryAt(r);
  }
  /**
   * Sets a new key-value pair at the position after the given key.
   */
  setAfter(n, r, o) {
    const i = wt(this, nt).indexOf(n);
    return i === -1 ? this : this.insert(i + 1, r, o);
  }
  first() {
    return this.entryAt(0);
  }
  last() {
    return this.entryAt(-1);
  }
  clear() {
    return Da(this, nt, []), super.clear();
  }
  delete(n) {
    const r = super.delete(n);
    return r && wt(this, nt).splice(wt(this, nt).indexOf(n), 1), r;
  }
  deleteAt(n) {
    const r = this.keyAt(n);
    return r !== void 0 ? this.delete(r) : !1;
  }
  at(n) {
    const r = ls(wt(this, nt), n);
    if (r !== void 0)
      return this.get(r);
  }
  entryAt(n) {
    const r = ls(wt(this, nt), n);
    if (r !== void 0)
      return [r, this.get(r)];
  }
  indexOf(n) {
    return wt(this, nt).indexOf(n);
  }
  keyAt(n) {
    return ls(wt(this, nt), n);
  }
  from(n, r) {
    const o = this.indexOf(n);
    if (o === -1)
      return;
    let i = o + r;
    return i < 0 && (i = 0), i >= this.size && (i = this.size - 1), this.at(i);
  }
  keyFrom(n, r) {
    const o = this.indexOf(n);
    if (o === -1)
      return;
    let i = o + r;
    return i < 0 && (i = 0), i >= this.size && (i = this.size - 1), this.keyAt(i);
  }
  find(n, r) {
    let o = 0;
    for (const i of this) {
      if (Reflect.apply(n, r, [i, o, this]))
        return i;
      o++;
    }
  }
  findIndex(n, r) {
    let o = 0;
    for (const i of this) {
      if (Reflect.apply(n, r, [i, o, this]))
        return o;
      o++;
    }
    return -1;
  }
  filter(n, r) {
    const o = [];
    let i = 0;
    for (const s of this)
      Reflect.apply(n, r, [s, i, this]) && o.push(s), i++;
    return new Vt(o);
  }
  map(n, r) {
    const o = [];
    let i = 0;
    for (const s of this)
      o.push([s[0], Reflect.apply(n, r, [s, i, this])]), i++;
    return new Vt(o);
  }
  reduce(...n) {
    const [r, o] = n;
    let i = 0, s = o ?? this.at(0);
    for (const a of this)
      i === 0 && n.length === 1 ? s = a : s = Reflect.apply(r, this, [s, a, i, this]), i++;
    return s;
  }
  reduceRight(...n) {
    const [r, o] = n;
    let i = o ?? this.at(-1);
    for (let s = this.size - 1; s >= 0; s--) {
      const a = this.at(s);
      s === this.size - 1 && n.length === 1 ? i = a : i = Reflect.apply(r, this, [i, a, s, this]);
    }
    return i;
  }
  toSorted(n) {
    const r = [...this.entries()].sort(n);
    return new Vt(r);
  }
  toReversed() {
    const n = new Vt();
    for (let r = this.size - 1; r >= 0; r--) {
      const o = this.keyAt(r), i = this.get(o);
      n.set(o, i);
    }
    return n;
  }
  toSpliced(...n) {
    const r = [...this.entries()];
    return r.splice(...n), new Vt(r);
  }
  slice(n, r) {
    const o = new Vt();
    let i = this.size - 1;
    if (n === void 0)
      return o;
    n < 0 && (n = n + this.size), r !== void 0 && r > 0 && (i = r - 1);
    for (let s = n; s <= i; s++) {
      const a = this.keyAt(s), l = this.get(a);
      o.set(a, l);
    }
    return o;
  }
  every(n, r) {
    let o = 0;
    for (const i of this) {
      if (!Reflect.apply(n, r, [i, o, this]))
        return !1;
      o++;
    }
    return !0;
  }
  some(n, r) {
    let o = 0;
    for (const i of this) {
      if (Reflect.apply(n, r, [i, o, this]))
        return !0;
      o++;
    }
    return !1;
  }
}, nt = new WeakMap(), ft(Vt, "OrderedDict"), Vt);
function ls(e, t) {
  if ("at" in Array.prototype)
    return Array.prototype.at.call(e, t);
  const n = lv(e, t);
  return n === -1 ? void 0 : e[n];
}
ft(ls, "at");
function lv(e, t) {
  const n = e.length, r = Iu(t), o = r >= 0 ? r : n + r;
  return o < 0 || o >= n ? -1 : o;
}
ft(lv, "toSafeIndex");
function Iu(e) {
  return e !== e || e === 0 ? 0 : Math.trunc(e);
}
ft(Iu, "toSafeInteger");
// @__NO_SIDE_EFFECTS__
function FP(e) {
  const t = e + "CollectionProvider", [n, r] = /* @__PURE__ */ It(t), [o, i] = n(
    t,
    {
      collectionElement: null,
      collectionRef: { current: null },
      collectionRefObject: { current: null },
      itemMap: new ja(),
      setItemMap: /* @__PURE__ */ ft(() => {
      }, "setItemMap")
    }
  ), s = /* @__PURE__ */ ft(({ state: w, ...S }) => w ? /* @__PURE__ */ h(l, { ...S, state: w }) : /* @__PURE__ */ h(a, { ...S }), "CollectionProvider");
  s.displayName = t;
  const a = /* @__PURE__ */ ft((w) => {
    const S = y();
    return /* @__PURE__ */ h(l, { ...w, state: S });
  }, "CollectionInit");
  a.displayName = t + "Init";
  const l = /* @__PURE__ */ ft((w) => {
    const { scope: S, children: E, state: C } = w, T = v.useRef(null), [P, D] = v.useState(
      null
    ), k = be(T, D), [R, O] = C;
    return v.useEffect(() => {
      if (!P) return;
      const _ = dv(() => {
      });
      return _.observe(P, {
        childList: !0,
        subtree: !0
      }), () => {
        _.disconnect();
      };
    }, [P]), /* @__PURE__ */ h(
      o,
      {
        scope: S,
        itemMap: R,
        setItemMap: O,
        collectionRef: k,
        collectionRefObject: T,
        collectionElement: P,
        children: E
      }
    );
  }, "CollectionProviderImpl");
  l.displayName = t + "Impl";
  const c = e + "CollectionSlot", u = /* @__PURE__ */ Cn(c), d = v.forwardRef(
    (w, S) => {
      const { scope: E, children: C } = w, T = i(c, E), P = be(S, T.collectionRef);
      return /* @__PURE__ */ h(u, { ref: P, children: C });
    }
  );
  d.displayName = c;
  const f = e + "CollectionItemSlot", m = "data-radix-collection-item", p = /* @__PURE__ */ Cn(f), g = v.forwardRef(
    (w, S) => {
      const { scope: E, children: C, ...T } = w, P = v.useRef(null), [D, k] = v.useState(null), R = be(S, P, k), O = i(f, E), { setItemMap: _ } = O, $ = v.useRef(T);
      cv($.current, T) || ($.current = T);
      const z = $.current;
      return v.useEffect(() => {
        const I = z;
        return _((A) => D ? A.has(D) ? A.set(D, { ...I, element: D }).toSorted(Xl) : (A.set(D, { ...I, element: D }), A.toSorted(Xl)) : A), () => {
          _((A) => !D || !A.has(D) ? A : (A.delete(D), new ja(A)));
        };
      }, [D, z, _]), /* @__PURE__ */ h(p, { [m]: "", ref: R, children: C });
    }
  );
  g.displayName = f;
  function y() {
    return v.useState(new ja());
  }
  ft(y, "useInitCollection");
  function b(w) {
    const { itemMap: S } = i(e + "CollectionConsumer", w);
    return S;
  }
  return ft(b, "useCollection"), [
    { Provider: s, Slot: d, ItemSlot: g },
    {
      createCollectionScope: r,
      useCollection: b,
      useInitCollection: y
    }
  ];
}
ft(FP, "createCollection");
function cv(e, t) {
  if (e === t) return !0;
  if (typeof e != "object" || typeof t != "object" || e == null || t == null) return !1;
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length) return !1;
  for (const o of n)
    if (!Object.prototype.hasOwnProperty.call(t, o) || e[o] !== t[o]) return !1;
  return !0;
}
ft(cv, "shallowEqual");
function uv(e, t) {
  return !!(t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_PRECEDING);
}
ft(uv, "isElementPreceding");
function Xl(e, t) {
  return !e[1].element || !t[1].element ? 0 : uv(e[1].element, t[1].element) ? -1 : 1;
}
ft(Xl, "sortByDocumentPosition");
function dv(e) {
  return new MutationObserver((n) => {
    for (const r of n)
      if (r.type === "childList") {
        e();
        return;
      }
  });
}
ft(dv, "getChildListObserver");
var VP = Object.defineProperty, BP = (e, t) => VP(e, "name", { value: t, configurable: !0 }), WP = v.createContext(void 0);
function Lu(e) {
  const t = v.useContext(WP);
  return e || t || "ltr";
}
BP(Lu, "useDirection");
var zP = Object.defineProperty, jP = (e, t) => zP(e, "name", { value: t, configurable: !0 });
function fv(e) {
  const t = v.useRef({ value: e, previous: e });
  return v.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
jP(fv, "usePrevious");
var HP = Object.defineProperty, Te = (e, t) => HP(e, "name", { value: t, configurable: !0 }), UP = [" ", "Enter", "ArrowUp", "ArrowDown"], YP = [" ", "Enter"], ao = "Select", [oa, ia, GP] = /* @__PURE__ */ wi(ao), [Ar, CV] = /* @__PURE__ */ It(ao, [
  GP,
  tr
]), $u = tr(), [KP, nr] = Ar(ao), [XP, qP] = Ar(ao);
function hv(e) {
  const {
    __scopeSelect: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    value: s,
    defaultValue: a,
    onValueChange: l,
    dir: c,
    name: u,
    autoComplete: d,
    disabled: f,
    required: m,
    form: p,
    // @ts-expect-error internal render prop used by `Select` to compose its default parts
    internal_do_not_use_render: g
  } = e, y = $u(t), [b, x] = v.useState(null), [w, S] = v.useState(null), [E, C] = v.useState(!1), T = Lu(c), [P, D] = qn({
    prop: r,
    defaultProp: o ?? !1,
    onChange: i,
    caller: ao
  }), [k, R] = qn({
    prop: s,
    defaultProp: a,
    onChange: l,
    caller: ao
  }), O = v.useRef(null), _ = v.useRef(k);
  v.useEffect(() => {
    const N = p ? b == null ? void 0 : b.ownerDocument.getElementById(p) : b == null ? void 0 : b.form;
    if (N instanceof HTMLFormElement) {
      const Y = /* @__PURE__ */ Te(() => R(_.current), "reset");
      return N.addEventListener("reset", Y), () => N.removeEventListener("reset", Y);
    }
  }, [p, b, R]);
  const $ = b ? !!p || !!b.closest("form") : !0, [z, I] = v.useState(/* @__PURE__ */ new Set()), A = rn(), M = Array.from(z).map((N) => N.props.value).join(";"), F = v.useCallback((N) => {
    I((Y) => new Set(Y).add(N));
  }, []), W = v.useCallback((N) => {
    I((Y) => {
      const H = new Set(Y);
      return H.delete(N), H;
    });
  }, []), ne = {
    required: m,
    trigger: b,
    onTriggerChange: x,
    valueNode: w,
    onValueNodeChange: S,
    valueNodeHasChildren: E,
    onValueNodeHasChildrenChange: C,
    contentId: A,
    value: k,
    onValueChange: R,
    open: P,
    onOpenChange: D,
    dir: T,
    triggerPointerDownPosRef: O,
    disabled: f,
    name: u,
    autoComplete: d,
    form: p,
    nativeOptions: z,
    nativeSelectKey: M,
    isFormControl: $
  };
  return /* @__PURE__ */ h(Du, { ...y, children: /* @__PURE__ */ h(KP, { scope: t, ...ne, children: /* @__PURE__ */ h(oa.Provider, { scope: t, children: /* @__PURE__ */ h(
    XP,
    {
      scope: t,
      onNativeOptionAdd: F,
      onNativeOptionRemove: W,
      children: xv(g) ? g(ne) : n
    }
  ) }) }) });
}
Te(hv, "SelectProvider");
var QP = /* @__PURE__ */ Te((e) => {
  const { __scopeSelect: t, children: n, ...r } = e;
  return /* @__PURE__ */ h(
    hv,
    {
      __scopeSelect: t,
      ...r,
      internal_do_not_use_render: ({ isFormControl: o }) => /* @__PURE__ */ L(Oe, { children: [
        n,
        o ? /* @__PURE__ */ h(
          wE,
          {
            __scopeSelect: t
          }
        ) : null
      ] })
    }
  );
}, "Select"), ZP = "SelectTrigger", Fu = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ Te(function(t, n) {
    const { __scopeSelect: r, disabled: o = !1, ...i } = t, s = $u(r), a = nr(ZP, r), l = a.disabled || o, c = be(n, a.onTriggerChange), u = ia(r), d = v.useRef("touch"), [f, m, p] = zu((y) => {
      const b = u().filter((S) => !S.disabled), x = b.find((S) => S.value === a.value), w = ju(b, y, x);
      w !== void 0 && a.onValueChange(w.value);
    }), g = /* @__PURE__ */ Te((y) => {
      l || (a.onOpenChange(!0), p()), y && (a.triggerPointerDownPosRef.current = {
        x: Math.round(y.pageX),
        y: Math.round(y.pageY)
      });
    }, "handleOpen");
    return /* @__PURE__ */ h(ea, { asChild: !0, ...s, children: /* @__PURE__ */ h(
      me.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": a.open ? a.contentId : void 0,
        "aria-expanded": a.open,
        "aria-required": a.required,
        "aria-autocomplete": "none",
        dir: a.dir,
        "data-state": a.open ? "open" : "closed",
        disabled: l,
        "data-disabled": l ? "" : void 0,
        "data-placeholder": xi(a.value) ? "" : void 0,
        ...i,
        ref: c,
        onClick: re(i.onClick, (y) => {
          y.currentTarget.focus(), d.current !== "mouse" && g(y);
        }),
        onPointerDown: re(i.onPointerDown, (y) => {
          d.current = y.pointerType;
          const b = y.target;
          b.hasPointerCapture(y.pointerId) && b.releasePointerCapture(y.pointerId), y.button === 0 && y.ctrlKey === !1 && y.pointerType === "mouse" && (g(y), y.preventDefault());
        }),
        onKeyDown: re(i.onKeyDown, (y) => {
          const b = f.current !== "";
          !(y.ctrlKey || y.altKey || y.metaKey) && y.key.length === 1 && m(y.key), !(b && y.key === " ") && UP.includes(y.key) && (g(), y.preventDefault());
        })
      }
    ) });
  }, "SelectTrigger")
), JP = "SelectValue", mv = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ Te(function(t, n) {
    const { __scopeSelect: r, className: o, style: i, children: s, placeholder: a = "", ...l } = t, c = nr(JP, r), { onValueNodeHasChildrenChange: u } = c, d = s !== void 0, f = be(n, c.onValueNodeChange);
    qe(() => {
      u(d);
    }, [u, d]);
    const m = xi(c.value);
    return /* @__PURE__ */ h(
      me.span,
      {
        ...l,
        asChild: m ? !1 : l.asChild,
        ref: f,
        style: { pointerEvents: "none" },
        children: /* @__PURE__ */ h(v.Fragment, { children: m ? a : s }, m ? "placeholder" : "value")
      }
    );
  }, "SelectValue")
), eE = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ Te(function(t, n) {
    const { __scopeSelect: r, children: o, ...i } = t;
    return /* @__PURE__ */ h(me.span, { "aria-hidden": !0, ...i, ref: n, children: o || "▼" });
  }, "SelectIcon")
), tE = "SelectPortal", [nE, rE] = Ar(tE, {
  forceMount: void 0
}), oE = /* @__PURE__ */ Te((e) => {
  const { __scopeSelect: t, forceMount: n, ...r } = e;
  return /* @__PURE__ */ h(nE, { scope: e.__scopeSelect, forceMount: n, children: /* @__PURE__ */ h(gi, { asChild: !0, ...r }) });
}, "SelectPortal"), br = "SelectContent", Vu = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ Te(function(t, n) {
    const r = rE(br, t.__scopeSelect), { forceMount: o = r.forceMount, ...i } = t, s = nr(br, t.__scopeSelect), [a, l] = v.useState();
    return qe(() => {
      l(new DocumentFragment());
    }, []), /* @__PURE__ */ h(Lt, { present: o || s.open, children: ({ present: c }) => c ? /* @__PURE__ */ h(aE, { ...i, ref: n }) : /* @__PURE__ */ h(iE, { ...i, fragment: a }) });
  }, "SelectContent")
), iE = /* @__PURE__ */ v.forwardRef(/* @__PURE__ */ Te(function(t, n) {
  const { __scopeSelect: r, children: o, fragment: i } = t;
  return i ? po.createPortal(
    /* @__PURE__ */ h(pv, { scope: r, children: /* @__PURE__ */ h(oa.Slot, { scope: r, children: /* @__PURE__ */ h("div", { ref: n, children: o }) }) }),
    i
  ) : null;
}, "SelectContentFragment")), tn = 10, [pv, Or] = Ar(br), sE = /* @__PURE__ */ Cn("SelectContent.RemoveScroll"), aE = /* @__PURE__ */ v.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ Te(function(t, n) {
    const { __scopeSelect: r } = t, {
      position: o = "item-aligned",
      onCloseAutoFocus: i,
      onEscapeKeyDown: s,
      onPointerDownOutside: a,
      //
      // PopperContent props
      side: l,
      sideOffset: c,
      align: u,
      alignOffset: d,
      arrowPadding: f,
      collisionBoundary: m,
      collisionPadding: p,
      sticky: g,
      hideWhenDetached: y,
      avoidCollisions: b,
      //
      ...x
    } = t, w = nr(br, r), [S, E] = v.useState(null), [C, T] = v.useState(null), P = be(n, E), [D, k] = v.useState(null), [R, O] = v.useState(
      null
    ), _ = ia(r), [$, z] = v.useState(!1), I = v.useRef(!1);
    v.useEffect(() => {
      if (S) return Gs(S);
    }, [S]), vi();
    const A = v.useCallback(
      (X) => {
        const [se, ...ee] = _().map((G) => G.ref.current), [xe] = ee.slice(-1), ye = document.activeElement;
        for (const G of X)
          if (G === ye || (G == null || G.scrollIntoView({ block: "nearest" }), G === se && C && (C.scrollTop = 0), G === xe && C && (C.scrollTop = C.scrollHeight), G == null || G.focus(), document.activeElement !== ye)) return;
      },
      [_, C]
    ), M = v.useCallback(
      () => A([D, S]),
      [A, D, S]
    );
    v.useEffect(() => {
      $ && M();
    }, [$, M]);
    const { onOpenChange: F, triggerPointerDownPosRef: W } = w;
    v.useEffect(() => {
      if (S) {
        let X = { x: 0, y: 0 };
        const se = /* @__PURE__ */ Te((xe) => {
          var ye, G;
          X = {
            x: Math.abs(Math.round(xe.pageX) - (((ye = W.current) == null ? void 0 : ye.x) ?? 0)),
            y: Math.abs(Math.round(xe.pageY) - (((G = W.current) == null ? void 0 : G.y) ?? 0))
          };
        }, "handlePointerMove"), ee = /* @__PURE__ */ Te((xe) => {
          X.x <= 10 && X.y <= 10 ? xe.preventDefault() : xe.composedPath().includes(S) || F(!1), document.removeEventListener("pointermove", se), W.current = null;
        }, "handlePointerUp");
        return W.current !== null && (document.addEventListener("pointermove", se), document.addEventListener("pointerup", ee, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", se), document.removeEventListener("pointerup", ee, { capture: !0 });
        };
      }
    }, [S, F, W]), v.useEffect(() => {
      const X = /* @__PURE__ */ Te(() => F(!1), "close");
      return window.addEventListener("blur", X), window.addEventListener("resize", X), () => {
        window.removeEventListener("blur", X), window.removeEventListener("resize", X);
      };
    }, [F]);
    const [ne, N] = zu((X) => {
      const se = _().filter((ye) => !ye.disabled), ee = se.find((ye) => ye.ref.current === document.activeElement), xe = ju(se, X, ee);
      xe && setTimeout(() => {
        var ye;
        return (ye = xe.ref.current) == null ? void 0 : ye.focus();
      });
    }), Y = v.useCallback(
      (X, se, ee) => {
        const xe = !I.current && !ee;
        (w.value !== void 0 && w.value === se || xe) && (k(X), xe && (I.current = !0));
      },
      [w.value]
    ), H = v.useCallback(() => S == null ? void 0 : S.focus(), [S]), U = v.useCallback(
      (X, se, ee) => {
        const xe = !I.current && !ee;
        (w.value !== void 0 && w.value === se || xe) && O(X);
      },
      [w.value]
    ), fe = o === "popper" ? Gf : lE, ge = fe === Gf ? {
      side: l,
      sideOffset: c,
      align: u,
      alignOffset: d,
      arrowPadding: f,
      collisionBoundary: m,
      collisionPadding: p,
      sticky: g,
      hideWhenDetached: y,
      avoidCollisions: b
    } : {};
    return /* @__PURE__ */ h(
      pv,
      {
        scope: r,
        content: S,
        viewport: C,
        onViewportChange: T,
        itemRefCallback: Y,
        selectedItem: D,
        onItemLeave: H,
        itemTextRefCallback: U,
        focusSelectedItem: M,
        selectedItemText: R,
        position: o,
        isPositioned: $,
        searchRef: ne,
        children: /* @__PURE__ */ h(Ys, { as: sE, allowPinchZoom: !0, children: /* @__PURE__ */ h(
          cu,
          {
            asChild: !0,
            trapped: w.open,
            onMountAutoFocus: (X) => {
              X.preventDefault();
            },
            onUnmountAutoFocus: re(i, (X) => {
              var se;
              (se = w.trigger) == null || se.focus({ preventScroll: !0 }), X.preventDefault();
            }),
            children: /* @__PURE__ */ h(
              pi,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: s,
                onPointerDownOutside: a,
                onFocusOutside: (X) => X.preventDefault(),
                onDismiss: () => w.onOpenChange(!1),
                children: /* @__PURE__ */ h(
                  fe,
                  {
                    role: "listbox",
                    id: w.contentId,
                    "data-state": w.open ? "open" : "closed",
                    dir: w.dir,
                    onContextMenu: (X) => X.preventDefault(),
                    ...x,
                    ...ge,
                    onPlaced: () => z(!0),
                    ref: P,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...x.style
                    },
                    onKeyDown: re(x.onKeyDown, (X) => {
                      const se = X.ctrlKey || X.altKey || X.metaKey;
                      if (X.key === "Tab" && X.preventDefault(), !se && X.key.length === 1 && N(X.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(X.key)) {
                        let xe = _().filter((ye) => !ye.disabled).map((ye) => ye.ref.current);
                        if (["ArrowUp", "End"].includes(X.key) && (xe = xe.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(X.key)) {
                          const ye = X.target, G = xe.indexOf(ye);
                          xe = xe.slice(G + 1);
                        }
                        setTimeout(() => A(xe)), X.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }, "SelectContentImpl")
), lE = /* @__PURE__ */ v.forwardRef(/* @__PURE__ */ Te(function(t, n) {
  const { __scopeSelect: r, onPlaced: o, ...i } = t, s = nr(br, r), a = Or(br, r), [l, c] = v.useState(null), [u, d] = v.useState(null), f = be(n, d), m = ia(r), p = v.useRef(!1), g = v.useRef(!0), { viewport: y, selectedItem: b, selectedItemText: x, focusSelectedItem: w } = a, S = v.useCallback(() => {
    if (s.trigger && s.valueNode && l && u && y && b && x) {
      const P = s.trigger.getBoundingClientRect(), D = u.getBoundingClientRect(), k = s.valueNode.getBoundingClientRect(), R = x.getBoundingClientRect();
      if (s.dir !== "rtl") {
        const ye = R.left - D.left, G = k.left - ye, mt = P.left - G, ut = P.width + mt, Dt = Math.max(ut, D.width), Zt = window.innerWidth - tn, dn = ks(G, [
          tn,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(tn, Zt - Dt)
        ]);
        l.style.minWidth = ut + "px", l.style.left = dn + "px";
      } else {
        const ye = D.right - R.right, G = window.innerWidth - k.right - ye, mt = window.innerWidth - P.right - G, ut = P.width + mt, Dt = Math.max(ut, D.width), Zt = window.innerWidth - tn, dn = ks(G, [
          tn,
          Math.max(tn, Zt - Dt)
        ]);
        l.style.minWidth = ut + "px", l.style.right = dn + "px";
      }
      const O = m(), _ = window.innerHeight - tn * 2, $ = y.scrollHeight, z = window.getComputedStyle(u), I = parseInt(z.borderTopWidth, 10), A = parseInt(z.paddingTop, 10), M = parseInt(z.borderBottomWidth, 10), F = parseInt(z.paddingBottom, 10), W = I + A + $ + F + M, ne = Math.min(b.offsetHeight * 5, W), N = window.getComputedStyle(y), Y = parseInt(N.paddingTop, 10), H = parseInt(N.paddingBottom, 10), U = P.top + P.height / 2 - tn, fe = _ - U, ge = b.offsetHeight / 2, X = b.offsetTop + ge, se = I + A + X, ee = W - se;
      if (se <= U) {
        const ye = O.length > 0 && b === O[O.length - 1].ref.current;
        l.style.bottom = "0px";
        const G = u.clientHeight - y.offsetTop - y.offsetHeight, mt = Math.max(
          fe,
          ge + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (ye ? H : 0) + G + M
        ), ut = se + mt;
        l.style.height = ut + "px";
      } else {
        const ye = O.length > 0 && b === O[0].ref.current;
        l.style.top = "0px";
        const mt = Math.max(
          U,
          I + y.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (ye ? Y : 0) + ge
        ) + ee;
        l.style.height = mt + "px", y.scrollTop = se - U + y.offsetTop;
      }
      l.style.margin = `${tn}px 0`, l.style.minHeight = ne + "px", l.style.maxHeight = _ + "px", o == null || o(), requestAnimationFrame(() => p.current = !0);
    }
  }, [
    m,
    s.trigger,
    s.valueNode,
    l,
    u,
    y,
    b,
    x,
    s.dir,
    o
  ]);
  qe(() => S(), [S]);
  const [E, C] = v.useState();
  qe(() => {
    u && C(window.getComputedStyle(u).zIndex);
  }, [u]);
  const T = v.useCallback(
    (P) => {
      P && g.current === !0 && (S(), w == null || w(), g.current = !1);
    },
    [S, w]
  );
  return /* @__PURE__ */ h(
    cE,
    {
      scope: r,
      contentWrapper: l,
      shouldExpandOnScrollRef: p,
      onScrollButtonChange: T,
      children: /* @__PURE__ */ h(
        "div",
        {
          ref: c,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: E
          },
          children: /* @__PURE__ */ h(
            me.div,
            {
              ...i,
              ref: f,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...i.style
              }
            }
          )
        }
      )
    }
  );
}, "SelectItemAlignedPosition")), Gf = /* @__PURE__ */ v.forwardRef(/* @__PURE__ */ Te(function(t, n) {
  const {
    __scopeSelect: r,
    align: o = "start",
    collisionPadding: i = tn,
    ...s
  } = t, a = $u(r);
  return /* @__PURE__ */ h(
    Ru,
    {
      ...a,
      ...s,
      ref: n,
      align: o,
      collisionPadding: i,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...s.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
}, "SelectPopperPosition")), [cE, Bu] = Ar(br, {}), Kf = "SelectViewport", uE = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ Te(function(t, n) {
    const { __scopeSelect: r, nonce: o, ...i } = t, s = Or(Kf, r), a = Bu(Kf, r), l = be(n, s.onViewportChange), c = v.useRef(0);
    return /* @__PURE__ */ L(Oe, { children: [
      /* @__PURE__ */ h(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: o
        }
      ),
      /* @__PURE__ */ h(oa.Slot, { scope: r, children: /* @__PURE__ */ h(
        me.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...i,
          ref: l,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...i.style
          },
          onScroll: re(i.onScroll, (u) => {
            const d = u.currentTarget, { contentWrapper: f, shouldExpandOnScrollRef: m } = a;
            if (m != null && m.current && f) {
              const p = Math.abs(c.current - d.scrollTop);
              if (p > 0) {
                const g = window.innerHeight - tn * 2, y = parseFloat(f.style.minHeight), b = parseFloat(f.style.height), x = Math.max(y, b);
                if (x < g) {
                  const w = x + p, S = Math.min(g, w), E = w - S;
                  f.style.height = S + "px", f.style.bottom === "0px" && (d.scrollTop = E > 0 ? E : 0, f.style.justifyContent = "flex-end");
                }
              }
            }
            c.current = d.scrollTop;
          })
        }
      ) })
    ] });
  }, "SelectViewport")
), dE = "SelectGroup", [fE, hE] = Ar(dE), mE = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ Te(function(t, n) {
    const { __scopeSelect: r, ...o } = t, i = rn();
    return /* @__PURE__ */ h(fE, { scope: r, id: i, children: /* @__PURE__ */ h(me.div, { role: "group", "aria-labelledby": i, ...o, ref: n }) });
  }, "SelectGroup")
), pE = "SelectLabel", gv = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ Te(function(t, n) {
    const { __scopeSelect: r, ...o } = t, i = hE(pE, r);
    return /* @__PURE__ */ h(me.div, { id: i.id, ...o, ref: n });
  }, "SelectLabel")
), ql = "SelectItem", [gE, vE] = Ar(ql), Wu = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ Te(function(t, n) {
    const {
      __scopeSelect: r,
      value: o,
      disabled: i = !1,
      textValue: s,
      ...a
    } = t, l = nr(ql, r), c = Or(ql, r), u = l.value === o, [d, f] = v.useState(s ?? ""), [m, p] = v.useState(!1), g = Je(
      (S) => {
        var E;
        return (E = c.itemRefCallback) == null ? void 0 : E.call(c, S, o, i);
      }
    ), y = be(n, g), b = rn(), x = v.useRef("touch"), w = /* @__PURE__ */ Te(() => {
      i || (l.onValueChange(o), l.onOpenChange(!1));
    }, "handleSelect");
    return /* @__PURE__ */ h(
      gE,
      {
        scope: r,
        value: o,
        disabled: i,
        textId: b,
        isSelected: u,
        onItemTextChange: v.useCallback((S) => {
          f((E) => E || ((S == null ? void 0 : S.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ h(
          oa.ItemSlot,
          {
            scope: r,
            value: o,
            disabled: i,
            textValue: d,
            children: /* @__PURE__ */ h(
              me.div,
              {
                role: "option",
                "aria-labelledby": b,
                "data-highlighted": m ? "" : void 0,
                "aria-selected": u && m,
                "data-state": u ? "checked" : "unchecked",
                "aria-disabled": i || void 0,
                "data-disabled": i ? "" : void 0,
                tabIndex: i ? void 0 : -1,
                ...a,
                ref: y,
                onFocus: re(a.onFocus, () => p(!0)),
                onBlur: re(a.onBlur, () => p(!1)),
                onClick: re(a.onClick, () => {
                  x.current !== "mouse" && w();
                }),
                onPointerUp: re(a.onPointerUp, () => {
                  x.current === "mouse" && w();
                }),
                onPointerDown: re(a.onPointerDown, (S) => {
                  x.current = S.pointerType;
                }),
                onPointerMove: re(a.onPointerMove, (S) => {
                  var E;
                  x.current = S.pointerType, i ? (E = c.onItemLeave) == null || E.call(c) : x.current === "mouse" && S.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: re(a.onPointerLeave, (S) => {
                  var E;
                  S.currentTarget === document.activeElement && ((E = c.onItemLeave) == null || E.call(c));
                }),
                onKeyDown: re(a.onKeyDown, (S) => {
                  var C;
                  i || S.target !== S.currentTarget || ((C = c.searchRef) == null ? void 0 : C.current) !== "" && S.key === " " || (YP.includes(S.key) && w(), S.key === " " && S.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }, "SelectItem")
), Gi = "SelectItemText", yE = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ Te(function(t, n) {
    const { __scopeSelect: r, className: o, style: i, ...s } = t, a = nr(Gi, r), l = Or(Gi, r), c = vE(Gi, r), u = qP(Gi, r), [d, f] = v.useState(null), m = Je(
      (w) => {
        var S;
        return (S = l.itemTextRefCallback) == null ? void 0 : S.call(l, w, c.value, c.disabled);
      }
    ), p = be(
      n,
      f,
      c.onItemTextChange,
      m
    ), g = d == null ? void 0 : d.textContent, y = v.useMemo(
      () => /* @__PURE__ */ h("option", { value: c.value, disabled: c.disabled, children: g }, c.value),
      [c.disabled, c.value, g]
    ), { onNativeOptionAdd: b, onNativeOptionRemove: x } = u;
    return qe(() => (b(y), () => x(y)), [b, x, y]), /* @__PURE__ */ L(Oe, { children: [
      /* @__PURE__ */ h(me.span, { id: c.textId, ...s, ref: p }),
      c.isSelected && a.valueNode && !a.valueNodeHasChildren && !xi(a.value) ? po.createPortal(s.children, a.valueNode) : null
    ] });
  }, "SelectItemText")
), Xf = "SelectScrollUpButton", vv = /* @__PURE__ */ v.forwardRef(/* @__PURE__ */ Te(function(t, n) {
  const r = Or(Xf, t.__scopeSelect), o = Bu(Xf, t.__scopeSelect), [i, s] = v.useState(!1), a = be(n, o.onScrollButtonChange);
  return qe(() => {
    if (r.viewport && r.isPositioned) {
      let l = function() {
        const u = c.scrollTop > 0;
        s(u);
      };
      Te(l, "handleScroll");
      const c = r.viewport;
      return l(), c.addEventListener("scroll", l), () => c.removeEventListener("scroll", l);
    }
  }, [r.viewport, r.isPositioned]), i ? /* @__PURE__ */ h(
    bv,
    {
      ...t,
      ref: a,
      onAutoScroll: () => {
        const { viewport: l, selectedItem: c } = r;
        l && c && (l.scrollTop = l.scrollTop - c.offsetHeight);
      }
    }
  ) : null;
}, "SelectScrollUpButton")), qf = "SelectScrollDownButton", yv = /* @__PURE__ */ v.forwardRef(/* @__PURE__ */ Te(function(t, n) {
  const r = Or(qf, t.__scopeSelect), o = Bu(qf, t.__scopeSelect), [i, s] = v.useState(!1), a = be(n, o.onScrollButtonChange);
  return qe(() => {
    if (r.viewport && r.isPositioned) {
      let l = function() {
        const u = c.scrollHeight - c.clientHeight, d = Math.ceil(c.scrollTop) < u;
        s(d);
      };
      Te(l, "handleScroll");
      const c = r.viewport;
      return l(), c.addEventListener("scroll", l), () => c.removeEventListener("scroll", l);
    }
  }, [r.viewport, r.isPositioned]), i ? /* @__PURE__ */ h(
    bv,
    {
      ...t,
      ref: a,
      onAutoScroll: () => {
        const { viewport: l, selectedItem: c } = r;
        l && c && (l.scrollTop = l.scrollTop + c.offsetHeight);
      }
    }
  ) : null;
}, "SelectScrollDownButton")), bv = /* @__PURE__ */ v.forwardRef(/* @__PURE__ */ Te(function(t, n) {
  const { __scopeSelect: r, onAutoScroll: o, ...i } = t, s = Or("SelectScrollButton", r), a = v.useRef(null), l = ia(r), c = v.useCallback(() => {
    a.current !== null && (window.clearInterval(a.current), a.current = null);
  }, []);
  return v.useEffect(() => () => c(), [c]), qe(() => {
    var d;
    const u = l().find((f) => f.ref.current === document.activeElement);
    (d = u == null ? void 0 : u.ref.current) == null || d.scrollIntoView({ block: "nearest" });
  }, [l]), /* @__PURE__ */ h(
    me.div,
    {
      "aria-hidden": !0,
      ...i,
      ref: n,
      style: { flexShrink: 0, ...i.style },
      onPointerDown: re(i.onPointerDown, () => {
        a.current === null && (a.current = window.setInterval(o, 50));
      }),
      onPointerMove: re(i.onPointerMove, () => {
        var u;
        (u = s.onItemLeave) == null || u.call(s), a.current === null && (a.current = window.setInterval(o, 50));
      }),
      onPointerLeave: re(i.onPointerLeave, () => {
        c();
      })
    }
  );
}, "SelectScrollButtonImpl")), wv = /* @__PURE__ */ v.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ Te(function(t, n) {
    const { __scopeSelect: r, ...o } = t;
    return /* @__PURE__ */ h(me.div, { "aria-hidden": !0, ...o, ref: n });
  }, "SelectSeparator")
), bE = "SelectBubbleInput", wE = /* @__PURE__ */ v.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ Te(function({ __scopeSelect: t, ...n }, r) {
    const o = nr(bE, t), { value: i, onValueChange: s, required: a, disabled: l, name: c, autoComplete: u, form: d } = o, { nativeOptions: f, nativeSelectKey: m } = o, p = v.useRef(null), g = be(r, p), y = i ?? "", b = fv(y), x = Array.from(f).some(
      (w) => (w.props.value ?? "") === ""
    );
    return v.useEffect(() => {
      const w = p.current;
      if (!w) return;
      const S = window.HTMLSelectElement.prototype, C = Object.getOwnPropertyDescriptor(
        S,
        "value"
      ).set;
      if (b !== y && C) {
        const T = new Event("change", { bubbles: !0 });
        C.call(w, y), w.dispatchEvent(T);
      }
    }, [b, y]), /* @__PURE__ */ L(
      me.select,
      {
        "aria-hidden": !0,
        required: a,
        tabIndex: -1,
        name: c,
        autoComplete: u,
        disabled: l,
        form: d,
        onChange: (w) => s(w.target.value),
        ...n,
        style: { ...Kg, ...n.style },
        ref: g,
        defaultValue: y,
        children: [
          xi(i) && !x ? /* @__PURE__ */ h("option", { value: "" }) : null,
          Array.from(f)
        ]
      },
      m
    );
  }, "SelectBubbleInput")
);
function xv(e) {
  return typeof e == "function";
}
Te(xv, "isFunction");
function xi(e) {
  return e === "" || e === void 0;
}
Te(xi, "shouldShowPlaceholder");
function zu(e) {
  const t = Je(e), n = v.useRef(""), r = v.useRef(0), o = v.useCallback(
    (s) => {
      const a = n.current + s;
      t(a), (/* @__PURE__ */ Te(function l(c) {
        n.current = c, window.clearTimeout(r.current), c !== "" && (r.current = window.setTimeout(() => l(""), 1e3));
      }, "updateSearch"))(a);
    },
    [t]
  ), i = v.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return v.useEffect(() => () => window.clearTimeout(r.current), []), [n, o, i];
}
Te(zu, "useTypeaheadSearch");
function ju(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((c) => c === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let s = Sv(e, Math.max(i, 0));
  o.length === 1 && (s = s.filter((c) => c !== n));
  const l = s.find(
    (c) => c.textValue.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
Te(ju, "findNextItem");
function Sv(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
Te(Sv, "wrapArray");
const sa = QP, Cv = mE, Hu = mv, aa = v.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ L(
  Fu,
  {
    ref: r,
    className: Q(
      "group input flex w-full items-center justify-between rounded-md border border-neutral-borders ring-offset-background data-[placeholder]:text-input-text-secondary focus:outline-none focus:ring-2 focus:ring-input-active focus:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1 text-left",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ h(eE, { asChild: !0, children: /* @__PURE__ */ h(Cp, { className: "h-4 w-4 text-input-active group-data-[state=open]:rotate-180 shrink-0" }) })
    ]
  }
));
aa.displayName = Fu.displayName;
const Tv = v.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  vv,
  {
    ref: n,
    className: Q("flex cursor-default items-center justify-center py-1", e),
    ...t,
    children: /* @__PURE__ */ h(ix, { className: "h-4 w-4" })
  }
));
Tv.displayName = vv.displayName;
const Pv = v.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  yv,
  {
    ref: n,
    className: Q("flex cursor-default items-center justify-center py-1", e),
    ...t,
    children: /* @__PURE__ */ h(Cp, { className: "h-4 w-4" })
  }
));
Pv.displayName = yv.displayName;
const la = v.forwardRef(({ className: e, children: t, position: n = "popper", ...r }, o) => /* @__PURE__ */ h(oE, { children: /* @__PURE__ */ L(
  Vu,
  {
    ref: o,
    align: "start",
    side: "bottom",
    className: Q(
      "relative z-50 max-h-96 overflow-hidden rounded-md border bg-input-bg popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      e
    ),
    position: n,
    ...r,
    children: [
      /* @__PURE__ */ h(Tv, { className: "text-input-active" }),
      /* @__PURE__ */ h(
        uE,
        {
          className: Q(
            "p-0",
            n === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
          ),
          children: t
        }
      ),
      /* @__PURE__ */ h(Pv, { className: "text-input-active" })
    ]
  }
) }));
la.displayName = Vu.displayName;
const xE = v.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(gv, { ref: n, className: Q("py-1.5 px-2 text-sm font-semibold", e), ...t }));
xE.displayName = gv.displayName;
const ca = v.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ h(
  Wu,
  {
    ref: r,
    className: Q(
      "relative flex w-full cursor-default select-none border-b items-center control text-sm outline-none focus:bg-input-hover data-[state=checked]:bg-input-active data-[state=checked]:text-input-bg data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: /* @__PURE__ */ h(yE, { children: t })
  }
));
ca.displayName = Wu.displayName;
const SE = v.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(wv, { ref: n, className: Q("-mx-1 my-1 h-px bg-muted", e), ...t }));
SE.displayName = wv.displayName;
function Ds(e) {
  var i;
  const t = oe(null), n = typeof e.options == "function" ? e.options(e.record.key, e.column.key, e.record) : e.options, r = e.value ? (i = n.find((s) => s.key === e.value)) == null ? void 0 : i.label : "-", o = e.column.isLocked || !1;
  return de(() => (e.isEditing && t.current && t.current.click(), () => {
    var s;
    e.isEditing && ((s = e.stopEditing) == null || s.call(e));
  }), [e.isEditing]), e.isEditing ? /* @__PURE__ */ h("div", { className: "overflow-x-hidden text-ellipsis relative w-full flex", children: /* @__PURE__ */ L(
    sa,
    {
      onValueChange: (s) => {
        e.onChange && e.onChange(s);
      },
      value: e.value || "",
      children: [
        /* @__PURE__ */ h(
          aa,
          {
            ref: t,
            className: He(
              "text-xs min-h-0 h-4 w-full p-0 w-0 bg-transparent flex-1 rounded-none border-0 data-[state=open]:[&>svg]:text-red-500"
            ),
            children: /* @__PURE__ */ h(Hu, { placeholder: r })
          }
        ),
        /* @__PURE__ */ h(la, { className: He(o && "z-[100]"), children: /* @__PURE__ */ h(Cv, { children: n.map((s) => /* @__PURE__ */ h(ca, { value: s.key, children: s.label }, s.key)) }) })
      ]
    }
  ) }) : /* @__PURE__ */ h(Mr, { ...e, value: r });
}
function CE(e, t, n, r, o) {
  switch (!0) {
    case (!e && r === "error"):
      return "bg-red-200 dark:bg-red-900 !outline-red-500";
    case (!e && r === "warning"):
      return "bg-yellow-200 dark:bg-yellow-900 !outline-yellow-400";
    case (!e && r === "neutral" && !n):
      return "bg-gray-300 dark:bg-gray-800 !outline-gray-500";
    case (!e && r === "neutral" && n):
      return "bg-gray-400 dark:bg-gray-900 !outline-gray-600";
    case (!e && !t && n):
      return "bg-neutral-container";
    case (!e && !t && !n):
      return "bg-[#F2F2F2] dark:bg-[#312E2F]";
    case (!e && t):
      return "bg-violet-200 dark:bg-stone-700";
    case (e && t):
      return "bg-violet-200 dark:bg-stone-500";
    case (e && !t && n):
      return "bg-color-greys-100 dark:bg-color-greys-800";
    case (e && !t && !n):
      return "bg-table-bg-fixed";
    default:
      return "bg-table-bg-editable";
  }
}
function TE({
  rowIndex: e,
  columns: t,
  record: n,
  rowSize: r,
  state: o,
  visibleColumns: i,
  // onRowChange,
  onRowsCommit: s,
  onToggleEdit: a,
  onCellSelect: l,
  hooks: c,
  cellValidations: u,
  onDrag: d,
  editingCell: f,
  onChangeEditCellValue: m,
  selectedCells: p,
  dragBlock: g,
  cfg: y
}) {
  function b(C, T, P, D, k) {
    mP(o.editCellRef, D, k) || a(void 0);
    const R = C.currentTarget.getBoundingClientRect();
    d("start", R.x, R.y, R.width, R.height, {
      column: T.key,
      row: n.key,
      rowIndex: e
    });
  }
  function x(C, T, P, D, k) {
    const R = C.currentTarget.getBoundingClientRect();
    d("end", R.x, R.y, R.width, R.height, {
      column: T.key,
      row: n.key,
      rowIndex: e
    });
  }
  function w(C, T, P, D, k) {
    if (C.buttons === 1) {
      const R = C.currentTarget.getBoundingClientRect();
      d("drag", R.x, R.y, R.width, R.height, {
        column: T.key,
        row: n.key,
        rowIndex: e
      });
    }
  }
  function S(C, T, P, D, k) {
    T.readOnly || a({
      column: D,
      row: k,
      rowIndex: e,
      value: P[D]
    });
  }
  const E = (C, T) => {
    let P;
    (C.ctrlKey || C.metaKey) && (P = "ctrl"), l(
      {
        column: T,
        row: n.key,
        value: n[T],
        rowIndex: e
      },
      P
    );
  };
  return /* @__PURE__ */ h(
    "tr",
    {
      style: {
        height: `${r}px`
      },
      children: t.map((C, T) => {
        if (!y.disableColumnVirtualization) {
          if (i[T] >= 1)
            return /* @__PURE__ */ h("td", { colSpan: i[T] }, C.key);
          if (i[T] === 0)
            return;
        }
        const P = `${n.key}${C.key}`;
        if (C.groupColumn)
          return /* @__PURE__ */ h("td", { className: "td-group-path" }, P);
        const D = !!C.isLocked, k = !D && !!C.isLockedRight, R = D ? {
          position: "sticky",
          left: `${y.stickyOffsets[C.key]}px`,
          zIndex: 20
        } : k ? {
          position: "sticky",
          right: `${y.stickyRightOffsets[C.key] ?? 0}px`,
          zIndex: 20
        } : {}, O = C._dfColIndex, _ = (f == null ? void 0 : f.column) === C.key && (f == null ? void 0 : f.row) === n.key, $ = n[C.key], z = p.some((ee) => ee.column === C.key && ee.row === n.key), I = !!g && !C.split && !C.groupColumn && T >= g.minCol && T <= g.maxCol && e >= g.minRow && e <= g.maxRow, A = z || I, M = p.length > 0 && p.filter((ee) => ee.row === n.key).length === p.length, F = { ...C.componentProps || {} };
        F.nullable = C.nullable;
        let W = T > 0 ? !!t[T - 1].readOnly && !C.split : !1, ne = !1;
        T > 0 && t[T - 1].groupColumn && (W = !0);
        const N = u[`${T - 1}-${e}`], Y = u[`${T}-${e - 1}`];
        (N == null ? void 0 : N.type) === "disable" && (W = !0), (Y == null ? void 0 : Y.type) === "disable" && (ne = !0);
        const H = u[`${T}-${e}`];
        let U = C.readOnly, fe = !1;
        H && H.type === "disable" && (U = !0, fe = !0);
        let ge = C.component, X = {};
        if (C.conditionalComponent) {
          const ee = C.conditionalComponent(C.key, n);
          ee && (ge = ee.component, X = ee.props);
        }
        const se = /* @__PURE__ */ h("div", { className: "flex w-full", children: /* @__PURE__ */ h(
          ge,
          {
            cellRef: { column: O, row: e },
            record: n,
            column: C,
            value: _ ? f.newValue : $,
            state: o,
            stopEditing: () => a(void 0),
            onChange: _ ? (ee) => m == null ? void 0 : m(ee, ge === Ds) : void 0,
            ...F,
            ...X,
            isEditing: _
          }
        ) });
        return /* @__PURE__ */ L(
          "td",
          {
            className: He(
              "overflow-hidden text-ellipsis whitespace-nowrap ",
              // Prevent native text selection while drag-selecting cells; otherwise
              // the browser highlights text and the drag breaks crossing the
              // sticky (fixed) <-> scrollable column boundary. Editing cells keep
              // normal text selection so the input works.
              !_ && "select-none",
              C.split && (C.isLockedRight ? (
                // right splitter mirrors the left one: fades from transparent into the frozen net block.
                "td-new-splitter bg-gradient-to-l from-neutral-container to-transparent"
              ) : "td-new-splitter bg-gradient-to-r from-neutral-container to-transparent"),
              _ && "is-editing",
              D || k ? "z-20 dark:text-white" : "relative",
              k && "border-l border-l-table-borders-header",
              W && "!border-l-table-borders-header",
              ne && "!border-t-table-borders-header",
              U ? "read-only" : "cursor-cell",
              fe && (H == null ? void 0 : H.message) && "cursor-not-allowed",
              C.dataType === "number" && "is-numeric",
              !C.split && CE(
                !!U,
                M,
                e % 2 === 0,
                H == null ? void 0 : H.type
              ),
              A && "outline outline-2 outline-blue-400 outline-offset-[-1px]",
              C.conditionalFormatter && C.conditionalFormatter(n.key, $, C.key, n, e)
            ),
            onMouseDown: (ee) => !_ && b(ee, C, n, C.key, n.key),
            onMouseUp: (ee) => !_ && x(ee, C, n, C.key, n.key),
            onMouseMove: (ee) => w(ee, C, n, C.key, n.key),
            onDoubleClick: (ee) => !U && S(ee, C, n, C.key, n.key),
            onClick: (ee) => {
              E(ee, C.key), !U && !_ && ge === Ds && S(ee, C, n, C.key, n.key);
            },
            style: R,
            "data-row-key": n.key,
            "data-col-key": C.key,
            children: [
              (H == null ? void 0 : H.type) === "note" && /* @__PURE__ */ h(
                "div",
                {
                  className: `absolute left-0 top-0 w-2 h-2 pointer-events-none ${H.colorClass ?? "text-button-secondary-bg"}`,
                  children: /* @__PURE__ */ h("svg", { viewBox: "0 0 1 1", fill: "currentColor", children: /* @__PURE__ */ h("path", { d: "M0 0 L1 0 L0 1 Z" }) })
                }
              ),
              H != null && H.message ? /* @__PURE__ */ L(na, { children: [
                /* @__PURE__ */ h(ra, { asChild: !0, children: se }),
                /* @__PURE__ */ h(bi, { children: /* @__PURE__ */ h("div", { className: "font-medium text-xs text-neutral-text-primary whitespace-pre-line text-left", children: H == null ? void 0 : H.message }) })
              ] }) : se
            ]
          },
          P
        );
      })
    }
  );
}
function PE(e) {
  return e.children;
}
var Ev = Symbol.for("immer-nothing"), Qf = Symbol.for("immer-draftable"), Wt = Symbol.for("immer-state"), EE = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(e) {
    return `The plugin for '${e}' has not been loaded into Immer. To enable the plugin, import and call \`enable${e}()\` when initializing your application.`;
  },
  function(e) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${e}'`;
  },
  "This object has been frozen and should not be mutated",
  function(e) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(e) {
    return `'current' expects a draft, got: ${e}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(e) {
    return `'original' expects a draft, got: ${e}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function Mt(e, ...t) {
  if (process.env.NODE_ENV !== "production") {
    const n = EE[e], r = typeof n == "function" ? n.apply(null, t) : n;
    throw new Error(`[Immer] ${r}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var ti = Object.getPrototypeOf;
function lo(e) {
  return !!e && !!e[Wt];
}
function wr(e) {
  var t;
  return e ? kv(e) || Array.isArray(e) || !!e[Qf] || !!((t = e.constructor) != null && t[Qf]) || Si(e) || da(e) : !1;
}
var kE = Object.prototype.constructor.toString(), Zf = /* @__PURE__ */ new WeakMap();
function kv(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = Object.getPrototypeOf(e);
  if (t === null || t === Object.prototype)
    return !0;
  const n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  if (n === Object)
    return !0;
  if (typeof n != "function")
    return !1;
  let r = Zf.get(n);
  return r === void 0 && (r = Function.toString.call(n), Zf.set(n, r)), r === kE;
}
function Rs(e, t, n = !0) {
  ua(e) === 0 ? (n ? Reflect.ownKeys(e) : Object.keys(e)).forEach((o) => {
    t(o, e[o], e);
  }) : e.forEach((r, o) => t(o, r, e));
}
function ua(e) {
  const t = e[Wt];
  return t ? t.type_ : Array.isArray(e) ? 1 : Si(e) ? 2 : da(e) ? 3 : 0;
}
function Ql(e, t) {
  return ua(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function Dv(e, t, n) {
  const r = ua(e);
  r === 2 ? e.set(t, n) : r === 3 ? e.add(n) : e[t] = n;
}
function DE(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function Si(e) {
  return e instanceof Map;
}
function da(e) {
  return e instanceof Set;
}
function ar(e) {
  return e.copy_ || e.base_;
}
function Zl(e, t) {
  if (Si(e))
    return new Map(e);
  if (da(e))
    return new Set(e);
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  const n = kv(e);
  if (t === !0 || t === "class_only" && !n) {
    const r = Object.getOwnPropertyDescriptors(e);
    delete r[Wt];
    let o = Reflect.ownKeys(r);
    for (let i = 0; i < o.length; i++) {
      const s = o[i], a = r[s];
      a.writable === !1 && (a.writable = !0, a.configurable = !0), (a.get || a.set) && (r[s] = {
        configurable: !0,
        writable: !0,
        // could live with !!desc.set as well here...
        enumerable: a.enumerable,
        value: e[s]
      });
    }
    return Object.create(ti(e), r);
  } else {
    const r = ti(e);
    if (r !== null && n)
      return { ...e };
    const o = Object.create(r);
    return Object.assign(o, e);
  }
}
function Uu(e, t = !1) {
  return fa(e) || lo(e) || !wr(e) || (ua(e) > 1 && Object.defineProperties(e, {
    set: Ki,
    add: Ki,
    clear: Ki,
    delete: Ki
  }), Object.freeze(e), t && Object.values(e).forEach((n) => Uu(n, !0))), e;
}
function RE() {
  Mt(2);
}
var Ki = {
  value: RE
};
function fa(e) {
  return e === null || typeof e != "object" ? !0 : Object.isFrozen(e);
}
var ME = {};
function xr(e) {
  const t = ME[e];
  return t || Mt(0, e), t;
}
var ni;
function Rv() {
  return ni;
}
function AE(e, t) {
  return {
    drafts_: [],
    parent_: e,
    immer_: t,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function Jf(e, t) {
  t && (xr("Patches"), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function Jl(e) {
  ec(e), e.drafts_.forEach(OE), e.drafts_ = null;
}
function ec(e) {
  e === ni && (ni = e.parent_);
}
function eh(e) {
  return ni = AE(ni, e);
}
function OE(e) {
  const t = e[Wt];
  t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function th(e, t) {
  t.unfinalizedDrafts_ = t.drafts_.length;
  const n = t.drafts_[0];
  return e !== void 0 && e !== n ? (n[Wt].modified_ && (Jl(t), Mt(4)), wr(e) && (e = Ms(t, e), t.parent_ || As(t, e)), t.patches_ && xr("Patches").generateReplacementPatches_(
    n[Wt].base_,
    e,
    t.patches_,
    t.inversePatches_
  )) : e = Ms(t, n, []), Jl(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e !== Ev ? e : void 0;
}
function Ms(e, t, n) {
  if (fa(t))
    return t;
  const r = e.immer_.shouldUseStrictIteration(), o = t[Wt];
  if (!o)
    return Rs(
      t,
      (i, s) => nh(e, o, t, i, s, n),
      r
    ), t;
  if (o.scope_ !== e)
    return t;
  if (!o.modified_)
    return As(e, o.base_, !0), o.base_;
  if (!o.finalized_) {
    o.finalized_ = !0, o.scope_.unfinalizedDrafts_--;
    const i = o.copy_;
    let s = i, a = !1;
    o.type_ === 3 && (s = new Set(i), i.clear(), a = !0), Rs(
      s,
      (l, c) => nh(
        e,
        o,
        i,
        l,
        c,
        n,
        a
      ),
      r
    ), As(e, i, !1), n && e.patches_ && xr("Patches").generatePatches_(
      o,
      n,
      e.patches_,
      e.inversePatches_
    );
  }
  return o.copy_;
}
function nh(e, t, n, r, o, i, s) {
  if (o == null || typeof o != "object" && !s)
    return;
  const a = fa(o);
  if (!(a && !s)) {
    if (process.env.NODE_ENV !== "production" && o === n && Mt(5), lo(o)) {
      const l = i && t && t.type_ !== 3 && // Set objects are atomic since they have no keys.
      !Ql(t.assigned_, r) ? i.concat(r) : void 0, c = Ms(e, o, l);
      if (Dv(n, r, c), lo(c))
        e.canAutoFreeze_ = !1;
      else
        return;
    } else s && n.add(o);
    if (wr(o) && !a) {
      if (!e.immer_.autoFreeze_ && e.unfinalizedDrafts_ < 1 || t && t.base_ && t.base_[r] === o && a)
        return;
      Ms(e, o), (!t || !t.scope_.parent_) && typeof r != "symbol" && (Si(n) ? n.has(r) : Object.prototype.propertyIsEnumerable.call(n, r)) && As(e, o);
    }
  }
}
function As(e, t, n = !1) {
  !e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && Uu(t, n);
}
function NE(e, t) {
  const n = Array.isArray(e), r = {
    type_: n ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: t ? t.scope_ : Rv(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: t,
    // The base state.
    base_: e,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let o = r, i = Yu;
  n && (o = [r], i = ri);
  const { revoke: s, proxy: a } = Proxy.revocable(o, i);
  return r.draft_ = a, r.revoke_ = s, a;
}
var Yu = {
  get(e, t) {
    if (t === Wt)
      return e;
    const n = ar(e);
    if (!Ql(n, t))
      return _E(e, n, t);
    const r = n[t];
    return e.finalized_ || !wr(r) ? r : r === Ha(e.base_, t) ? (Ua(e), e.copy_[t] = nc(r, e)) : r;
  },
  has(e, t) {
    return t in ar(e);
  },
  ownKeys(e) {
    return Reflect.ownKeys(ar(e));
  },
  set(e, t, n) {
    const r = Mv(ar(e), t);
    if (r != null && r.set)
      return r.set.call(e.draft_, n), !0;
    if (!e.modified_) {
      const o = Ha(ar(e), t), i = o == null ? void 0 : o[Wt];
      if (i && i.base_ === n)
        return e.copy_[t] = n, e.assigned_[t] = !1, !0;
      if (DE(n, o) && (n !== void 0 || Ql(e.base_, t)))
        return !0;
      Ua(e), tc(e);
    }
    return e.copy_[t] === n && // special case: handle new props with value 'undefined'
    (n !== void 0 || t in e.copy_) || // special case: NaN
    Number.isNaN(n) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = n, e.assigned_[t] = !0), !0;
  },
  deleteProperty(e, t) {
    return Ha(e.base_, t) !== void 0 || t in e.base_ ? (e.assigned_[t] = !1, Ua(e), tc(e)) : delete e.assigned_[t], e.copy_ && delete e.copy_[t], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(e, t) {
    const n = ar(e), r = Reflect.getOwnPropertyDescriptor(n, t);
    return r && {
      writable: !0,
      configurable: e.type_ !== 1 || t !== "length",
      enumerable: r.enumerable,
      value: n[t]
    };
  },
  defineProperty() {
    Mt(11);
  },
  getPrototypeOf(e) {
    return ti(e.base_);
  },
  setPrototypeOf() {
    Mt(12);
  }
}, ri = {};
Rs(Yu, (e, t) => {
  ri[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
});
ri.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && Mt(13), ri.set.call(this, e, t, void 0);
};
ri.set = function(e, t, n) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && Mt(14), Yu.set.call(this, e[0], t, n, e[0]);
};
function Ha(e, t) {
  const n = e[Wt];
  return (n ? ar(n) : e)[t];
}
function _E(e, t, n) {
  var o;
  const r = Mv(t, n);
  return r ? "value" in r ? r.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (o = r.get) == null ? void 0 : o.call(e.draft_)
  ) : void 0;
}
function Mv(e, t) {
  if (!(t in e))
    return;
  let n = ti(e);
  for (; n; ) {
    const r = Object.getOwnPropertyDescriptor(n, t);
    if (r)
      return r;
    n = ti(n);
  }
}
function tc(e) {
  e.modified_ || (e.modified_ = !0, e.parent_ && tc(e.parent_));
}
function Ua(e) {
  e.copy_ || (e.copy_ = Zl(
    e.base_,
    e.scope_.immer_.useStrictShallowCopy_
  ));
}
var IE = class {
  constructor(e) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.useStrictIteration_ = !0, this.produce = (t, n, r) => {
      if (typeof t == "function" && typeof n != "function") {
        const i = n;
        n = t;
        const s = this;
        return function(l = i, ...c) {
          return s.produce(l, (u) => n.call(this, u, ...c));
        };
      }
      typeof n != "function" && Mt(6), r !== void 0 && typeof r != "function" && Mt(7);
      let o;
      if (wr(t)) {
        const i = eh(this), s = nc(t, void 0);
        let a = !0;
        try {
          o = n(s), a = !1;
        } finally {
          a ? Jl(i) : ec(i);
        }
        return Jf(i, r), th(o, i);
      } else if (!t || typeof t != "object") {
        if (o = n(t), o === void 0 && (o = t), o === Ev && (o = void 0), this.autoFreeze_ && Uu(o, !0), r) {
          const i = [], s = [];
          xr("Patches").generateReplacementPatches_(t, o, i, s), r(i, s);
        }
        return o;
      } else
        Mt(1, t);
    }, this.produceWithPatches = (t, n) => {
      if (typeof t == "function")
        return (s, ...a) => this.produceWithPatches(s, (l) => t(l, ...a));
      let r, o;
      return [this.produce(t, n, (s, a) => {
        r = s, o = a;
      }), r, o];
    }, typeof (e == null ? void 0 : e.autoFreeze) == "boolean" && this.setAutoFreeze(e.autoFreeze), typeof (e == null ? void 0 : e.useStrictShallowCopy) == "boolean" && this.setUseStrictShallowCopy(e.useStrictShallowCopy), typeof (e == null ? void 0 : e.useStrictIteration) == "boolean" && this.setUseStrictIteration(e.useStrictIteration);
  }
  createDraft(e) {
    wr(e) || Mt(8), lo(e) && (e = LE(e));
    const t = eh(this), n = nc(e, void 0);
    return n[Wt].isManual_ = !0, ec(t), n;
  }
  finishDraft(e, t) {
    const n = e && e[Wt];
    (!n || !n.isManual_) && Mt(9);
    const { scope_: r } = n;
    return Jf(r, t), th(void 0, r);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(e) {
    this.autoFreeze_ = e;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(e) {
    this.useStrictShallowCopy_ = e;
  }
  /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */
  setUseStrictIteration(e) {
    this.useStrictIteration_ = e;
  }
  shouldUseStrictIteration() {
    return this.useStrictIteration_;
  }
  applyPatches(e, t) {
    let n;
    for (n = t.length - 1; n >= 0; n--) {
      const o = t[n];
      if (o.path.length === 0 && o.op === "replace") {
        e = o.value;
        break;
      }
    }
    n > -1 && (t = t.slice(n + 1));
    const r = xr("Patches").applyPatches_;
    return lo(e) ? r(e, t) : this.produce(
      e,
      (o) => r(o, t)
    );
  }
};
function nc(e, t) {
  const n = Si(e) ? xr("MapSet").proxyMap_(e, t) : da(e) ? xr("MapSet").proxySet_(e, t) : NE(e, t);
  return (t ? t.scope_ : Rv()).drafts_.push(n), n;
}
function LE(e) {
  return lo(e) || Mt(10, e), Av(e);
}
function Av(e) {
  if (!wr(e) || fa(e))
    return e;
  const t = e[Wt];
  let n, r = !0;
  if (t) {
    if (!t.modified_)
      return t.base_;
    t.finalized_ = !0, n = Zl(e, t.scope_.immer_.useStrictShallowCopy_), r = t.scope_.immer_.shouldUseStrictIteration();
  } else
    n = Zl(e, !0);
  return Rs(
    n,
    (o, i) => {
      Dv(n, o, Av(i));
    },
    r
  ), t && (t.finalized_ = !1), n;
}
var $E = new IE(), Bt = $E.produce, rh = function() {
}, Ov = typeof window < "u";
function FE(e, t) {
  var n = oe(!1), r = oe(), o = oe(e), i = Fe(function() {
    return n.current;
  }, []), s = Fe(function() {
    n.current = !1, r.current && clearTimeout(r.current), r.current = setTimeout(function() {
      n.current = !0, o.current();
    }, t);
  }, [t]), a = Fe(function() {
    n.current = null, r.current && clearTimeout(r.current);
  }, []);
  return de(function() {
    o.current = e;
  }, [e]), de(function() {
    return s(), a;
  }, [t]), [i, a, s];
}
function VE(e, t, n) {
  n === void 0 && (n = []);
  var r = FE(e, t), o = r[0], i = r[1], s = r[2];
  return de(s, n), [o, i];
}
var oh = function(e, t, n) {
  if (!Ov)
    return [t, rh, rh];
  if (!e)
    throw new Error("useLocalStorage key may not be falsy");
  var r = JSON.parse, o = oe(function(u) {
    try {
      var d = n ? n.raw ? String : n.serializer : JSON.stringify, f = localStorage.getItem(u);
      return f !== null ? r(f) : (t && localStorage.setItem(u, d(t)), t);
    } catch {
      return t;
    }
  }), i = ue(function() {
    return o.current(e);
  }), s = i[0], a = i[1];
  Dr(function() {
    return a(o.current(e));
  }, [e]);
  var l = Fe(function(u) {
    try {
      var d = typeof u == "function" ? u(s) : u;
      if (typeof d > "u")
        return;
      var f = void 0;
      n || (f = JSON.stringify(d)), localStorage.setItem(e, f), a(r(f));
    } catch {
    }
  }, [e, a]), c = Fe(function() {
    try {
      localStorage.removeItem(e), a(void 0);
    } catch {
    }
  }, [e, a]);
  return [s, l, c];
}, Gu = function(e, t, n) {
  if (!Ov)
    return [t, function() {
    }];
  var r = ue(function() {
    try {
      var s = sessionStorage.getItem(e);
      return typeof s != "string" ? (sessionStorage.setItem(e, n ? String(t) : JSON.stringify(t)), t) : n ? s : JSON.parse(s || "null");
    } catch {
      return t;
    }
  }), o = r[0], i = r[1];
  return de(function() {
    try {
      var s = n ? String(o) : JSON.stringify(o);
      sessionStorage.setItem(e, s);
    } catch {
    }
  }), [o, i];
};
const BE = 70, WE = 1;
var zE = /* @__PURE__ */ ((e) => (e.Move = "move", e.Escape = "escape", e.Enter = "enter", e))(zE || {});
function TV(e = {}) {
  const [t, n] = ue(e);
  function r(o, i) {
    n(
      Bt((s) => {
        s[o.name] = i;
      })
    );
  }
  return [t, r];
}
const jE = (e, t) => {
  var r;
  const n = [];
  for (const o of e)
    if ((r = o.group) != null && r.length)
      for (let i = 1; i <= o.group.length; i++) {
        const s = o.group.slice(0, i);
        t && s[s.length - 1].uncollapsable || s[s.length - 1].label && n.push(s);
      }
  return n;
}, ih = (e, t) => {
  const n = {}, r = jE(e, t);
  for (const o of r) {
    const i = o.map((s) => s.key).join("_");
    n[i] = !1;
  }
  return n;
}, rc = (e, t) => {
  var o;
  if (!((o = e.group) != null && o.length)) return;
  const n = [...e.group], r = [n.shift()];
  for (; r.length <= e.group.length; ) {
    const i = r.map((s) => s.key).join("_");
    if (t.groupCollapsedStatus[i])
      return r;
    r.push(n.shift());
  }
}, HE = (e, t) => !e || !t || e.length !== t.length ? !1 : e.every((n, r) => n.key === t[r].key), UE = (e, t, n) => {
  for (const r of t)
    if (r.group && r.group.length > e.length && e.every((o, i) => o.key === r.group[i].key)) {
      const o = r.group.slice(0, e.length + 1).map((i) => i.key).join("_");
      if (!n.groupCollapsedStatus[o])
        return !1;
    }
  return !0;
}, YE = 6, GE = (e) => {
  const t = {};
  return typeof document > "u" || !e || e.querySelectorAll("th[attr-column-key]").forEach((r) => {
    const o = r.getAttribute("attr-column-key"), i = r.querySelector('[class*="text-ellipsis"]') || r.querySelector("span");
    !o || !i || (t[o] = Math.max(0, Math.ceil(i.scrollWidth - i.clientWidth)));
  }), t;
}, Nv = (e, t, n) => {
  var i;
  const r = ((i = e == null ? void 0 : e.name) == null ? void 0 : i.split(/[\s_]/).sort((s, a) => a.length - s.length)[0].length) || 0;
  let o = Math.max(12 + r * 12, t);
  return e.filterable && (o += 28), e.sortable && (o += 24), n !== void 0 && (o = Math.min(o, n)), o;
}, KE = (e, t, n) => {
  const r = {};
  return e.forEach((o, i) => {
    if (!("split" in o)) {
      const s = n ? `column-${i}` : o.key;
      r[s] = Nv(o, o.minWidth || t, o.maxWidth);
    }
  }), r;
};
function PV(e, t, n) {
  const r = {
    minColumnWidth: (n == null ? void 0 : n.minColumnWidth) || BE,
    usePositionalColumnSizing: (n == null ? void 0 : n.usePositionalColumnSizing) || !1,
    disableColumnVirtualization: (n == null ? void 0 : n.disableColumnVirtualization) || !1
  }, [o, i] = oh(
    `${e}-column-position-v2`,
    {}
  ), [s, a] = oh(`${e}-group-status`, {}), [l, c] = ue({
    tableKey: e,
    columnPositions: o && Object.keys(o).length ? o : KE(t, r.minColumnWidth, r.usePositionalColumnSizing),
    // columnStickyOffset: {},
    editCellRef: null,
    lockedColumns: [],
    groupCollapsedStatus: s ?? ih(t)
  });
  de(() => {
    const C = t.reduce(
      (T, P) => {
        const D = t.findIndex((R) => R.key === P.key), k = r.usePositionalColumnSizing ? `column-${D}` : P.key;
        return o && k in o ? T[k] = o[k] : T[k] = Nv(P, P.minWidth || r.minColumnWidth, P.maxWidth), T;
      },
      {}
    );
    c({
      ...l,
      columnPositions: C
    });
  }, [t]);
  function u(C) {
    c((T) => {
      var R;
      const P = (R = t.find((O) => O.key === C.key)) == null ? void 0 : R.minWidth, D = r.usePositionalColumnSizing ? `column-${t.findIndex((O) => O.key === C.key)}` : C.key, k = {
        ...T.columnPositions,
        [D]: Math.max(C.width, P || r.minColumnWidth)
      };
      return i(k), {
        ...T,
        columnPositions: k
      };
    });
  }
  function d(C) {
    const T = (C == null ? void 0 : C.closest("table")) ?? null, P = GE(T);
    c((D) => {
      const k = { ...D.columnPositions };
      return t.forEach((R, O) => {
        if ("split" in R) return;
        const _ = P[R.key];
        if (!_) return;
        const $ = r.usePositionalColumnSizing ? `column-${O}` : R.key;
        let I = Math.max(D.columnPositions[$] || 0, R.minWidth || r.minColumnWidth) + _ + YE;
        R.maxWidth !== void 0 && (I = Math.min(I, R.maxWidth)), k[$] = I;
      }), i(k), {
        ...D,
        columnPositions: k
      };
    });
  }
  function f(C, T) {
    let P = null;
    C !== null && T !== null && (P = { column: C, row: T }), c({
      ...l,
      editCellRef: P
    });
  }
  function m(C) {
    c(
      Bt(l, (T) => {
        C.forEach((P) => !T.lockedColumns.includes(P) && T.lockedColumns.push(P));
      })
    );
  }
  function p(C) {
    c(
      Bt(l, (T) => {
        T.lockedColumns = T.lockedColumns.filter((P) => !C.includes(P));
      })
    );
  }
  function g(C, T) {
    const P = C.map((R) => R.key).join("_"), D = T ?? (l.groupCollapsedStatus[P] || !1), k = {
      ...l,
      groupCollapsedStatus: {
        ...l.groupCollapsedStatus,
        [P]: !D
      }
    };
    c(k), a(k.groupCollapsedStatus);
  }
  const y = pe(() => {
    let C = 0;
    const T = {};
    return t.forEach((P, D) => {
      const k = !!rc(P, l);
      if ((l.lockedColumns.includes(P.key) || P.isLocked) && !k) {
        const R = r.usePositionalColumnSizing ? `column-${D}` : P.key;
        T[P.key] = C, "split" in P ? C += 28 : C += Math.max(P.minWidth || r.minColumnWidth, l.columnPositions[R] || 0);
      }
    }), T;
  }, [l.lockedColumns, l.columnPositions]), b = pe(() => {
    let C = 0;
    const T = {};
    for (let P = t.length - 1; P >= 0; P--) {
      const D = t[P], k = !!rc(D, l);
      if (D.isLockedRight && !D.isLocked && !k) {
        const R = r.usePositionalColumnSizing ? `column-${P}` : D.key;
        T[D.key] = C, "split" in D ? C += 28 : C += Math.max(D.minWidth || r.minColumnWidth, l.columnPositions[R] || 0);
      }
    }
    return T;
  }, [l.columnPositions]), x = (C) => {
    const T = ih(t, !0);
    Object.entries(T).forEach(([P]) => {
      T[P] = C;
    }), c({
      ...l,
      groupCollapsedStatus: T
    }), a(T);
  };
  function w() {
    return {
      ...r,
      stickyOffsets: y,
      stickyRightOffsets: b
    };
  }
  function S(C) {
    var P;
    const T = [];
    for (let D = 0; D < C.size; D++) {
      const k = C.object(D);
      for (const R of t) {
        if (!R.validate) continue;
        const O = Array.isArray(R.validate) ? (P = R.validate.map((_) => _(k[R.key], k))) == null ? void 0 : P.find((_) => _) : R.validate(k[R.key], k);
        O && T.push(O);
      }
    }
    return T.length ? T : void 0;
  }
  return [l, {
    validate: S,
    getDatatableConfig: w,
    expandAllGroups: () => x(!1),
    contractAllGroups: () => x(!0),
    onMouseDown: () => {
    },
    // noop
    onToggleEdit: f,
    changeColumnSize: u,
    autoSizeAllColumns: d,
    lockColumns: m,
    unlockColumns: p,
    // showColumns,
    // hideColumns,
    // reorderColumns,
    _setStateToBeRemoved: c,
    // changeColumnsStickyOffset,
    // hideGroups,
    // showGroups,
    toggleGroupCollapse: g
  }];
}
function XE({
  group: e,
  hooks: t,
  hidding: n = !0
}) {
  return /* @__PURE__ */ h(
    ke,
    {
      variant: "ghost",
      size: "sm",
      className: "icon text-button-secondary-bg hover:bg-transparent align-middle shrink-0",
      onClick: () => t.toggleGroupCollapse(e),
      children: n ? /* @__PURE__ */ h(sx, {}) : /* @__PURE__ */ h(ax, {})
    }
  );
}
var qE = Object.defineProperty, kn = (e, t) => qE(e, "name", { value: t, configurable: !0 }), Ku = "Popover", [_v, EV] = /* @__PURE__ */ It(Ku, [
  tr
]), ha = tr(), [QE, Nr] = _v(Ku), ZE = /* @__PURE__ */ kn((e) => {
  const {
    __scopePopover: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    modal: s = !1
  } = e, a = ha(t), l = v.useRef(null), [c, u] = v.useState(!1), [d, f] = v.useState(0), [m, p] = v.useState(0), [g, y] = qn({
    prop: r,
    defaultProp: o ?? !1,
    onChange: i,
    caller: Ku
  });
  return /* @__PURE__ */ h(Du, { ...a, children: /* @__PURE__ */ h(
    QE,
    {
      scope: t,
      contentId: rn(),
      titleId: rn(),
      descriptionId: rn(),
      titlePresent: d > 0,
      descriptionPresent: m > 0,
      setTitleCount: f,
      setDescriptionCount: p,
      triggerRef: l,
      open: g,
      onOpenChange: y,
      onOpenToggle: v.useCallback(() => y((b) => !b), [y]),
      hasCustomAnchor: c,
      onCustomAnchorAdd: v.useCallback(() => u(!0), []),
      onCustomAnchorRemove: v.useCallback(() => u(!1), []),
      modal: s,
      children: n
    }
  ) });
}, "Popover"), JE = "PopoverAnchor", Ci = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ kn(function(t, n) {
    const { __scopePopover: r, ...o } = t, i = Nr(JE, r), s = ha(r), { onCustomAnchorAdd: a, onCustomAnchorRemove: l } = i;
    return v.useEffect(() => (a(), () => l()), [a, l]), /* @__PURE__ */ h(ea, { ...s, ...o, ref: n });
  }, "PopoverAnchor")
), e1 = "PopoverTrigger", t1 = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ kn(function(t, n) {
    const { __scopePopover: r, ...o } = t, i = Nr(e1, r), s = ha(r), a = be(n, i.triggerRef), l = /* @__PURE__ */ h(
      me.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.open ? i.contentId : void 0,
        "data-state": Xu(i.open),
        ...o,
        ref: a,
        onClick: re(t.onClick, i.onOpenToggle)
      }
    );
    return i.hasCustomAnchor ? l : /* @__PURE__ */ h(ea, { asChild: !0, ...s, children: l });
  }, "PopoverTrigger")
), Iv = "PopoverPortal", [n1, r1] = _v(Iv, {
  forceMount: void 0
}), o1 = /* @__PURE__ */ kn((e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: o } = e, i = Nr(Iv, t);
  return /* @__PURE__ */ h(n1, { scope: t, forceMount: n, children: /* @__PURE__ */ h(Lt, { present: n || i.open, children: /* @__PURE__ */ h(gi, { asChild: !0, container: o, children: r }) }) });
}, "PopoverPortal"), oi = "PopoverContent", Lv = /* @__PURE__ */ v.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ kn(function(t, n) {
    const r = r1(oi, t.__scopePopover), { forceMount: o = r.forceMount, ...i } = t, s = Nr(oi, t.__scopePopover);
    return /* @__PURE__ */ h(Lt, { present: o || s.open, children: s.modal ? /* @__PURE__ */ h(s1, { ...i, ref: n }) : /* @__PURE__ */ h(a1, { ...i, ref: n }) });
  }, "PopoverContent")
), i1 = /* @__PURE__ */ Cn("PopoverContent.RemoveScroll"), s1 = /* @__PURE__ */ v.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ kn(function(t, n) {
    const r = Nr(oi, t.__scopePopover), o = v.useRef(null), i = be(n, o), s = v.useRef(!1);
    return v.useEffect(() => {
      const a = o.current;
      if (a) return Gs(a);
    }, []), /* @__PURE__ */ h(Ys, { as: i1, allowPinchZoom: !0, children: /* @__PURE__ */ h(
      $v,
      {
        ...t,
        ref: i,
        trapFocus: r.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: re(t.onCloseAutoFocus, (a) => {
          var l;
          a.preventDefault(), s.current || (l = r.triggerRef.current) == null || l.focus();
        }),
        onPointerDownOutside: re(
          t.onPointerDownOutside,
          (a) => {
            const l = a.detail.originalEvent, c = l.button === 0 && l.ctrlKey === !0, u = l.button === 2 || c;
            s.current = u;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: re(
          t.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }, "PopoverContentModal")
), a1 = /* @__PURE__ */ v.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ kn(function(t, n) {
    const r = Nr(oi, t.__scopePopover), o = v.useRef(!1), i = v.useRef(!1);
    return /* @__PURE__ */ h(
      $v,
      {
        ...t,
        ref: n,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (s) => {
          var a, l;
          (a = t.onCloseAutoFocus) == null || a.call(t, s), s.defaultPrevented || (o.current || (l = r.triggerRef.current) == null || l.focus(), s.preventDefault()), o.current = !1, i.current = !1;
        },
        onInteractOutside: (s) => {
          var c, u;
          (c = t.onInteractOutside) == null || c.call(t, s), s.defaultPrevented || (o.current = !0, s.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const a = s.target;
          ((u = r.triggerRef.current) == null ? void 0 : u.contains(a)) && s.preventDefault(), s.detail.originalEvent.type === "focusin" && i.current && s.preventDefault();
        }
      }
    );
  }, "PopoverContentNonModal")
), $v = /* @__PURE__ */ v.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ kn(function(t, n) {
    const {
      __scopePopover: r,
      trapFocus: o,
      onOpenAutoFocus: i,
      onCloseAutoFocus: s,
      disableOutsidePointerEvents: a,
      onEscapeKeyDown: l,
      onPointerDownOutside: c,
      onFocusOutside: u,
      onInteractOutside: d,
      "aria-describedby": f,
      ...m
    } = t, p = Nr(oi, r), g = ha(r);
    return vi(), /* @__PURE__ */ h(
      cu,
      {
        asChild: !0,
        loop: !0,
        trapped: o,
        onMountAutoFocus: i,
        onUnmountAutoFocus: s,
        children: /* @__PURE__ */ h(
          pi,
          {
            asChild: !0,
            disableOutsidePointerEvents: a,
            onInteractOutside: d,
            onEscapeKeyDown: l,
            onPointerDownOutside: c,
            onFocusOutside: u,
            onDismiss: () => p.onOpenChange(!1),
            deferPointerDownOutside: !0,
            children: /* @__PURE__ */ h(
              Ru,
              {
                "data-state": Xu(p.open),
                role: "dialog",
                id: p.contentId,
                "aria-labelledby": p.titlePresent ? p.titleId : void 0,
                "aria-describedby": p.descriptionPresent ? Fv(f, p.descriptionId) : f,
                ...g,
                ...m,
                ref: n,
                style: {
                  ...m.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }, "PopoverContentImpl")
);
function Xu(e) {
  return e ? "open" : "closed";
}
kn(Xu, "getState");
function Fv(...e) {
  const t = /* @__PURE__ */ new Set();
  for (const n of e)
    if (typeof n == "string")
      for (const r of String(n).trim().split(/\s+/))
        r && t.add(r);
  return t.size > 0 ? Array.from(t).join(" ") : void 0;
}
kn(Fv, "concatAriaDescribedby");
const Sr = ZE, wo = t1, _r = v.forwardRef(({ className: e, align: t = "center", sideOffset: n = 4, renderOnBody: r = !0, ...o }, i) => {
  const s = r ? o1 : v.Fragment;
  return /* @__PURE__ */ h(s, { children: /* @__PURE__ */ h(
    Lv,
    {
      ref: i,
      align: t,
      sideOffset: n,
      className: Q(
        "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        e
      ),
      ...o
    }
  ) });
});
_r.displayName = Lv.displayName;
const l1 = Rr(
  "flex w-full rounded-md border-neutral-borders text-base ring-offset-background file:border-0 file:bg-transparent file:text-base font-normal placeholder:text-input-text-secondary text-input-text focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 aria-[errormessage]:border-red-500 aria-[errormessage]:ring-red-500",
  {
    variants: {
      variant: {
        default: "input-md",
        sm: "input-sm"
      },
      borderless: {
        true: "border-0",
        false: "border"
      }
    },
    defaultVariants: {
      variant: "default",
      borderless: !1
    }
  }
), Ti = v.forwardRef(
  ({ className: e, variant: t, borderless: n, type: r, ...o }, i) => /* @__PURE__ */ h("input", { type: r, className: Q(l1({ variant: t, borderless: n, className: e })), ref: i, ...o })
);
Ti.displayName = "Input";
var c1 = Object.defineProperty, u1 = (e, t) => c1(e, "name", { value: t, configurable: !0 }), Vv = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ u1(function(t, n) {
    return /* @__PURE__ */ h(
      me.label,
      {
        ...t,
        ref: n,
        onMouseDown: (r) => {
          var i;
          r.target.closest("button, input, select, textarea") || ((i = t.onMouseDown) == null || i.call(t, r), !r.defaultPrevented && r.detail > 1 && r.preventDefault());
        }
      }
    );
  }, "Label")
);
const d1 = Rr("text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"), Bv = v.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(Vv, { ref: n, className: Q(d1(), e), ...t }));
Bv.displayName = Vv.displayName;
const Gt = ({
  label: e,
  children: t,
  error: n,
  disabled: r,
  className: o,
  hideOverflow: i = !0
}) => /* @__PURE__ */ L("div", { className: o, children: [
  /* @__PURE__ */ L(
    "fieldset",
    {
      "aria-errormessage": n,
      "aria-disabled": r,
      className: Q(
        i && "overflow-hidden",
        "labeled-container relative bg-input-bg rounded-md border border-neutral-borders ring-offset-background focus-within:outline-none  aria-[errormessage]:border-red-500 focus-within:ring-offset-2 aria-[disabled]:cursor-not-allowed aria-[disabled]:border-neutral-borders/50 aria-[errormessage]:aria-[disabled]:border-red-500/50 focus-within:!border-input-active"
      ),
      children: [
        e && /* @__PURE__ */ h(
          "legend",
          {
            "aria-errormessage": n,
            "aria-disabled": r,
            className: "relative z-10 px-0.5 ml-2 h-0 text-xs text-neutral-text-secondary aria-disabled:text-neutral-text-secondary/50 aria-[errormessage]:text-red-500 aria-[errormessage]:aria-disabled:text-red-500/50",
            children: /* @__PURE__ */ h("span", { className: "block -mt-2", children: e })
          }
        ),
        t
      ]
    }
  ),
  n && /* @__PURE__ */ h(
    Bv,
    {
      "aria-errormessage": n,
      "aria-disabled": r,
      className: "block z-10 text-xs text-red-500 aria-disabled:text-red-500/50",
      children: n
    }
  )
] }), f1 = ({ content: e, children: t, tooltipContentProps: n, hide: r = !1 }) => r ? t : /* @__PURE__ */ h(_u, { children: /* @__PURE__ */ L(na, { children: [
  /* @__PURE__ */ h(ra, { asChild: !0, children: t }),
  /* @__PURE__ */ h(bi, { ...n, children: e })
] }) }), qu = ({ className: e, ...t }) => {
  var s;
  const n = { ...t };
  delete n.endIcon, delete n.starticon;
  const [r, o] = ue(
    Number(t.maxLength) - ((s = t.value) == null ? void 0 : s.length)
  ), i = (a) => {
    console.log("handleOnChange");
    const l = a.target.value;
    t.maxLength && o(t.maxLength - l.length), t.onKeyUp && t.onKeyUp(a);
  };
  return /* @__PURE__ */ h(
    Gt,
    {
      label: t.label,
      error: t.error,
      disabled: t.disabled,
      className: Q("-m-px", e),
      children: /* @__PURE__ */ L("div", { className: "flex items-center", children: [
        t.starticon && /* @__PURE__ */ h("div", { className: "pl-3", children: t.starticon }),
        /* @__PURE__ */ h(Ti, { onKeyUp: i, type: "text", ...n, className: "w-full", borderless: !0 }),
        t.maxLength && /* @__PURE__ */ h(f1, { content: "Remaining Characters", children: /* @__PURE__ */ h("div", { className: Q("pr-3 text-sm", r < 0 && "text-red-500"), children: r }) }),
        t.endIcon && /* @__PURE__ */ h("div", { className: "pr-3", children: t.endIcon })
      ] })
    }
  );
};
var h1 = Object.defineProperty, Fn = (e, t) => h1(e, "name", { value: t, configurable: !0 }), Qu = "Checkbox", [m1, kV] = /* @__PURE__ */ It(Qu), [p1, Zu] = m1(Qu);
function Wv(e) {
  const {
    __scopeCheckbox: t,
    checked: n,
    children: r,
    defaultChecked: o,
    disabled: i,
    form: s,
    name: a,
    onCheckedChange: l,
    required: c,
    value: u = "on",
    // @ts-expect-error
    internal_do_not_use_render: d
  } = e, [f, m] = qn({
    prop: n,
    defaultProp: o ?? !1,
    onChange: l,
    caller: Qu
  }), [p, g] = v.useState(null), [y, b] = v.useState(null), x = v.useRef(!1), [w, S] = v.useReducer(
    (T) => T + 1,
    0
  ), E = p ? !!s || !!p.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), C = {
    checked: f,
    disabled: i,
    setChecked: m,
    control: p,
    setControl: g,
    name: a,
    form: s,
    value: u,
    hasConsumerStoppedPropagationRef: x,
    userInteractionCount: w,
    onUserInteraction: S,
    required: c,
    defaultChecked: In(o) ? !1 : o,
    isFormControl: E,
    bubbleInput: y,
    setBubbleInput: b
  };
  return /* @__PURE__ */ h(
    p1,
    {
      scope: t,
      ...C,
      children: jv(d) ? d(C) : r
    }
  );
}
Fn(Wv, "CheckboxProvider");
var g1 = "CheckboxTrigger", v1 = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ Fn(function({ __scopeCheckbox: t, onKeyDown: n, onClick: r, ...o }, i) {
    const {
      control: s,
      value: a,
      disabled: l,
      checked: c,
      required: u,
      setControl: d,
      setChecked: f,
      hasConsumerStoppedPropagationRef: m,
      onUserInteraction: p,
      isFormControl: g,
      bubbleInput: y
    } = Zu(g1, t), b = be(i, d), x = v.useRef(c);
    return v.useEffect(() => {
      const w = s == null ? void 0 : s.form;
      if (w) {
        const S = /* @__PURE__ */ Fn(() => f(x.current), "reset");
        return w.addEventListener("reset", S), () => w.removeEventListener("reset", S);
      }
    }, [s, f]), /* @__PURE__ */ h(
      me.button,
      {
        type: "button",
        role: "checkbox",
        "aria-checked": In(c) ? "mixed" : c,
        "aria-required": u,
        "data-state": ed(c),
        "data-disabled": l ? "" : void 0,
        disabled: l,
        value: a,
        ...o,
        ref: b,
        onKeyDown: re(n, (w) => {
          w.key === "Enter" && w.preventDefault();
        }),
        onClick: re(r, (w) => {
          p(), f((S) => In(S) ? !0 : !S), y && g && (m.current = w.isPropagationStopped(), m.current || w.stopPropagation());
        })
      }
    );
  }, "CheckboxTrigger")
), Ju = /* @__PURE__ */ v.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ Fn(function(t, n) {
    const {
      __scopeCheckbox: r,
      name: o,
      checked: i,
      defaultChecked: s,
      required: a,
      disabled: l,
      value: c,
      onCheckedChange: u,
      form: d,
      ...f
    } = t;
    return /* @__PURE__ */ h(
      Wv,
      {
        __scopeCheckbox: r,
        checked: i,
        defaultChecked: s,
        disabled: l,
        required: a,
        onCheckedChange: u,
        name: o,
        form: d,
        value: c,
        internal_do_not_use_render: ({ isFormControl: m }) => /* @__PURE__ */ L(Oe, { children: [
          /* @__PURE__ */ h(
            v1,
            {
              ...f,
              ref: n,
              __scopeCheckbox: r
            }
          ),
          m && /* @__PURE__ */ h(
            w1,
            {
              __scopeCheckbox: r
            }
          )
        ] })
      }
    );
  }, "Checkbox")
), y1 = "CheckboxIndicator", zv = /* @__PURE__ */ v.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ Fn(function(t, n) {
    const { __scopeCheckbox: r, forceMount: o, ...i } = t, s = Zu(y1, r);
    return /* @__PURE__ */ h(
      Lt,
      {
        present: o || In(s.checked) || s.checked === !0,
        children: /* @__PURE__ */ h(
          me.span,
          {
            "data-state": ed(s.checked),
            "data-disabled": s.disabled ? "" : void 0,
            ...i,
            ref: n,
            style: { pointerEvents: "none", ...t.style }
          }
        )
      }
    );
  }, "CheckboxIndicator")
), b1 = "CheckboxBubbleInput", w1 = /* @__PURE__ */ v.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ Fn(function({ __scopeCheckbox: t, onClick: n, ...r }, o) {
    const {
      control: i,
      hasConsumerStoppedPropagationRef: s,
      userInteractionCount: a,
      checked: l,
      defaultChecked: c,
      required: u,
      disabled: d,
      name: f,
      value: m,
      form: p,
      bubbleInput: g,
      setBubbleInput: y
    } = Zu(b1, t), b = be(o, y), x = ku(i), w = v.useRef(!1), S = v.useRef(l), E = v.useRef(a);
    v.useEffect(() => {
      const T = g;
      if (!T) return;
      const P = window.HTMLInputElement.prototype, k = Object.getOwnPropertyDescriptor(
        P,
        "checked"
      ).set, R = a !== E.current;
      E.current = a;
      const O = S.current !== l;
      S.current = l;
      const _ = !(R && s.current);
      if (O && k) {
        w.current = !R;
        const $ = new Event("click", { bubbles: _ });
        T.indeterminate = In(l), k.call(T, In(l) ? !1 : l), T.dispatchEvent($), w.current = !1;
      }
    }, [g, l, s, a]);
    const C = v.useRef(In(l) ? !1 : l);
    return /* @__PURE__ */ h(
      me.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: c ?? C.current,
        required: u,
        disabled: d,
        name: f,
        value: m,
        form: p,
        ...r,
        tabIndex: -1,
        ref: b,
        onClick: re(n, (T) => {
          w.current && T.stopPropagation();
        }),
        style: {
          ...r.style,
          ...x,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }, "CheckboxBubbleInput")
);
function jv(e) {
  return typeof e == "function";
}
Fn(jv, "isFunction");
function In(e) {
  return e === "indeterminate";
}
Fn(In, "isIndeterminate");
function ed(e) {
  return In(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
Fn(ed, "getState");
const td = v.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  Ju,
  {
    ref: n,
    className: Q(
      "peer h-4 w-4 shrink-0 rounded border border-checkbox-border bg-checkbox-bg ring-offset-checkbox-bg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 group-hover:bg-checkbox-hover group-hover:border-checkbox-hover-border disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-checkbox-active data-[state=checked]:border-checkbox-active data-[state=checked]:text-checkbox-icon data-[state=indeterminate]:bg-checkbox-active data-[state=indeterminate]:border-checkbox-active  data-[state=indeterminate]:text-checkbox-icon",
      e
    ),
    ...t,
    children: /* @__PURE__ */ L(zv, { className: Q("flex items-center justify-center text-current"), children: [
      t.checked === "indeterminate" && /* @__PURE__ */ h(lx, { className: "h-4 w-4 pb-[1px]" }),
      t.checked === !0 && /* @__PURE__ */ h(tu, { className: "h-4 w-4" })
    ] })
  }
));
td.displayName = "TriStateCheckbox";
const co = (e, t, n) => t ? (typeof t == "function" ? t(e) : t[e]) || e : e ? n ? Al(e, n) : e : "-", DV = (e, t, n) => {
  const r = t.field;
  console.log("[onSortColumn] field:", r, "| order:", t.order, "| columnExists:", e.columnNames().includes(r), "| tableSize:", e.size);
  const o = n == null ? void 0 : n.find((u) => u.key === r), i = o == null ? void 0 : o.lookup, s = (u) => u == null || !i ? u : typeof i == "function" ? i(String(u)) || u : i[String(u)] || u, a = [];
  for (let u = 0; u < e.size; u++)
    a.push(e.object(u));
  const l = t.order === "asc" ? 1 : -1;
  a.sort((u, d) => {
    const f = s(u[r]), m = s(d[r]);
    return f == null && m == null ? 0 : f == null ? 1 : m == null ? -1 : typeof f == "number" && typeof m == "number" ? (f - m) * l : String(f).localeCompare(String(m)) * l;
  });
  const c = Tp(a);
  return console.log("[onSortColumn] result first 3:", a.slice(0, 3).map((u) => ({ [r]: u[r] }))), c;
}, x1 = async (e, t, n, r = "", o, i, s, a) => {
  if (!(e != null && e.columnNames().includes(n))) return [];
  r = r.toLowerCase();
  let l = e;
  if (a != null && a[n]) {
    const f = a[n];
    l = e.orderby(
      to((m) => {
        const p = f.indexOf(m[n]);
        return p === -1 ? 999999 : p;
      })
    );
  }
  const c = l.select(n).params({ textToFilter: r, columnKey: n }).derive({
    textToMatch: to((f, m) => f[m.columnKey] + "|" + co(f[m.columnKey], o, i))
  }).filter(
    (f, m) => (
      // @ts-expect-error aq likes overloads :)
      xs.includes(xs.lower(f.textToMatch), m.textToFilter, 0)
    )
  ).array(n), u = /* @__PURE__ */ new Set(), d = [];
  for (const f of c) {
    const m = co(f, o, i);
    if (!u.has(m) && (u.add(m), d.push(f), d.length >= t))
      break;
  }
  return d;
}, S1 = (e, t, n) => {
  for (const [r, o] of Object.entries(e)) {
    if (!o.length || !t.columnNames().includes(r))
      continue;
    const i = n == null ? void 0 : n[r];
    t = t.params({ filters: e, rowKey: r }).filter(
      to((s, a) => {
        const l = co(s[a.rowKey], i == null ? void 0 : i.lookup, i == null ? void 0 : i.mask), c = a.filters[a.rowKey].map((d) => d.label), u = a.filters[a.rowKey].map((d) => d.key);
        return xs.includes(c, l, 0) || xs.includes(u, s[a.rowKey], 0);
      })
    );
  }
  return t;
}, sh = (e, t, n, r) => {
  const [o, i] = [
    n.findIndex((c) => c.key === e.column),
    n.findIndex((c) => c.key === t.column)
  ].sort((c, u) => c - u), [s, a] = [e.rowIndex, t.rowIndex].sort((c, u) => c - u), l = [];
  for (let c = s; c <= a; c++) {
    const u = r.object(c);
    for (let d = o; d <= i; d++) {
      const f = n[d];
      f.split || f.groupColumn || l.push({
        column: f.key,
        row: u.key,
        rowIndex: c,
        value: u[f.key]
      });
    }
  }
  return l;
}, Hv = (e, t) => {
  var o;
  if (!t.validate) return !1;
  const n = e, r = Array.isArray(t.validate) ? (o = t.validate.map((i) => i(n[t.key], n))) == null ? void 0 : o.find((i) => i) : t.validate(n[t.key], n);
  return (r == null ? void 0 : r.type) === "disable";
}, Do = (e, t, n) => {
  if (!n.validate) return !1;
  const r = t.object(e.rowIndex);
  return Hv(r, n);
}, jr = (e, t, n, r) => {
  const o = C1(r), i = t === "arrowdown" ? 1 : t === "arrowup" ? -1 : 0, s = t === "arrowright" ? 1 : t === "arrowleft" ? -1 : 0;
  if (i !== 0) {
    const a = e.rowIndex + i;
    if (a >= 0 && a < o) {
      const l = oc(r, a);
      return {
        column: e.column,
        row: l.key,
        rowIndex: a,
        value: l[e.column]
      };
    } else
      return e;
  }
  if (s !== 0) {
    let a = n.findIndex((c) => c.key === e.column) + s, l;
    for (; !l && a >= 0 && a < n.length; ) {
      const c = n[a];
      !c.split && !c.groupColumn && (l = c), a += s;
    }
    if (l) {
      const c = oc(r, e.rowIndex);
      return {
        column: l.key,
        row: e.row,
        rowIndex: e.rowIndex,
        value: c[l.key]
      };
    } else
      return e;
  }
}, Ro = (e, t, n) => {
  const r = oc(t, e.rowIndex), o = n.find((l) => l.key === e.column), i = (o == null ? void 0 : o.dataType) || "string", s = (e.newValue ?? null) === null;
  if (e.newValue === e.value)
    return [];
  if (s && !(o != null && o.nullable))
    return [];
  const a = i === "number" && !s ? Number(e.newValue) : e.newValue;
  return [
    {
      cells: [
        {
          ...e,
          value: a
        }
      ],
      oldRecord: r,
      newRecord: { ...r, [e.column]: a }
    }
  ];
}, oc = (e, t) => "length" in e ? e[t] : e.object(t), C1 = (e) => "length" in e ? e.length : e.size, T1 = (e) => e >= "0" && e <= "9" || e >= "a" && e <= "z" || e === "-" || e === ".";
function P1(e, t) {
  const n = e.findIndex((r) => r.rowspan && r.rowspan > 1);
  if (n >= 0 && t !== n) {
    const r = e[n].rowspan;
    return t < n + r;
  }
  return !1;
}
function RV(e, t) {
  return (n) => {
    if (n > e)
      return {
        type: "error",
        message: t || `Max allowed value is ${e}`
      };
  };
}
function MV(e, t) {
  return (n) => {
    if (n < e)
      return {
        type: "error",
        message: t || `Min allowed value is ${e}`
      };
  };
}
function AV(e) {
  return e.reduce((t, n) => (t[n.key] = {
    lookup: n.lookup,
    mask: n.mask
  }, t), {});
}
function OV(e, t, n) {
  return (r, o, i, s) => {
    const a = t == null ? void 0 : t[r];
    return x1(
      e,
      100,
      r,
      o,
      i,
      s,
      !!a,
      n
    );
  };
}
const Xi = (e, t) => [...e].sort((n, r) => {
  const o = t ? t(n.keyText) : n.keyText, i = t ? t(r.keyText) : r.keyText;
  return o.localeCompare(i, void 0, { sensitivity: "base" });
}), Uv = ({
  onApply: e,
  onLoadFilters: t,
  activeFilters: n,
  showApplyCancel: r,
  column: o,
  onOpenPopover: i,
  openedPopover: s,
  trigger: a,
  lookup: l,
  onClose: c,
  renderOnBody: u = !0,
  disabled: d = !1
}) => {
  const [f, m] = ue([]), [p, g] = ue([]), [y, b] = ue(""), [x, w] = ue(!1), [S, E] = ue(!1), C = Fe(
    (A) => o != null && o.mask ? co(A, l, o.mask) : `${(l ? typeof l == "function" ? l(A) : l[A] : void 0) || A}`,
    [l, o]
  );
  VE(
    async () => {
      const A = f.filter((N) => N.checked), F = [...p.filter((N) => N.checked), ...A];
      let W = await T(y);
      const ne = new Set(F.map((N) => C(N.keyText)));
      W = W.filter((N) => !ne.has(C(N))), m(
        Xi(
          W.map((N) => ({ keyText: N, checked: !1 })),
          C
        )
      ), g(Xi(F, C));
    },
    500,
    [y, l]
  );
  const T = async (A) => {
    E(!0);
    const M = await t(A || y);
    return E(!1), M;
  }, P = (A) => {
    if (d) return;
    const M = Bt(f, (F) => {
      F[A].checked = !F[A].checked;
    });
    m(M), r || R(void 0, M);
  }, D = (A) => {
    if (d) return;
    const M = Bt(p, (F) => {
      F[A].checked = !F[A].checked;
    });
    g(M), r || R(M, void 0);
  }, k = (A) => {
    if (d) return;
    const M = Bt(f, (W) => {
      W.forEach((ne) => ne.checked = A);
    }), F = Bt(p, (W) => {
      W.forEach((ne) => ne.checked = A);
    });
    m(M), g(F), r || R(F, M);
  }, R = (A, M) => {
    if (d) return;
    const F = [
      ...(A || p).filter((W) => W.checked).map((W) => W.keyText),
      ...(M || f).filter((W) => W.checked).map((W) => W.keyText)
    ];
    w(F.length > 0), e(F.map((W) => ({ key: W, label: C(W) })));
  }, O = async () => {
    let A = await T();
    A = A.filter(
      (M) => !(n || []).some((F) => F.label === C(M) || F.key === M)
    ), g(
      Xi(
        (n || []).map((M) => ({ keyText: M.key, checked: !0 })),
        C
      )
    ), m(
      Xi(
        A.map((M) => ({ keyText: M, checked: !1 })),
        C
      )
    );
  }, _ = a ? /* @__PURE__ */ h("div", { onClick: O, children: a }) : /* @__PURE__ */ h(ke, { onClick: O, variant: "ghost", className: "icon hover:bg-transparent text-input-icons", size: "sm", children: n != null && n.length ? /* @__PURE__ */ h(cx, {}) : /* @__PURE__ */ h(Ml, {}) }), $ = (A, M, F) => /* @__PURE__ */ h(
    "div",
    {
      className: "flex items-center px-3 py-1.5 rounded-sm hover:bg-neutral-100 dark:hover:bg-neutral-800 transition-colors",
      children: /* @__PURE__ */ L("label", { className: "flex items-center gap-2.5 cursor-pointer w-full", children: [
        /* @__PURE__ */ h(
          td,
          {
            className: "shrink-0",
            onCheckedChange: F,
            checked: !!A.checked,
            disabled: d
          }
        ),
        /* @__PURE__ */ h("span", { className: "text-xs font-normal leading-normal text-neutral-text-primary truncate", children: C(A.keyText) })
      ] })
    },
    M
  ), z = /* @__PURE__ */ L(Oe, { children: [
    /* @__PURE__ */ h(wo, { asChild: !0, children: _ }),
    /* @__PURE__ */ h(_r, { renderOnBody: u, align: "start", className: "w-72 p-0 pointer-events-auto", children: /* @__PURE__ */ L("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ h("div", { className: "px-3 pt-3 pb-2", children: /* @__PURE__ */ h(
        qu,
        {
          label: "",
          placeholder: "Search",
          value: y,
          onChange: (A) => b(A.currentTarget.value),
          starticon: /* @__PURE__ */ h(Ml, { size: 14, className: "text-neutral-400" }),
          disabled: d
        }
      ) }),
      /* @__PURE__ */ L("div", { className: "flex items-center gap-3 px-3 py-2 border-b border-neutral-200 dark:border-neutral-700", children: [
        /* @__PURE__ */ h(
          "span",
          {
            className: `text-xs font-medium ${d ? "text-neutral-400" : "text-button-primary-bg hover:text-button-primary-bg/80 cursor-pointer"}`,
            onClick: () => k(!0),
            children: "Select All"
          }
        ),
        /* @__PURE__ */ h("span", { className: "text-neutral-300 dark:text-neutral-600 text-xs", children: "|" }),
        /* @__PURE__ */ h(
          "span",
          {
            className: `text-xs font-medium ${d ? "text-neutral-400" : "text-button-primary-bg hover:text-button-primary-bg/80 cursor-pointer"}`,
            onClick: () => k(!1),
            children: "Deselect All"
          }
        )
      ] }),
      /* @__PURE__ */ h("div", { className: "flex flex-col py-1 h-64 overflow-y-auto overflow-x-hidden pretty-scrollbar", children: S ? /* @__PURE__ */ h("div", { className: "w-full flex justify-center py-4", children: /* @__PURE__ */ h("span", { className: "loading loading-spinner loading-sm" }) }) : /* @__PURE__ */ L(Oe, { children: [
        p.map((A, M) => $(A, M, () => D(M))),
        p.length > 0 && f.length > 0 && /* @__PURE__ */ h("div", { className: "border-t border-neutral-200 dark:border-neutral-700 mx-3 my-1" }),
        f.map((A, M) => $(A, M, () => P(M)))
      ] }) }),
      r && /* @__PURE__ */ h("div", { className: "flex flex-row-reverse p-2", children: /* @__PURE__ */ h(ke, { onClick: () => R(), variant: "ghost", size: "sm", color: "primary", disabled: d, children: "Apply" }) })
    ] }) })
  ] }), I = (A) => {
    A ? document.body.classList.add("filter-popover-open") : document.body.classList.remove("filter-popover-open"), o && i ? i(A ? o.key : null) : !A && c && c();
  };
  return o && i ? /* @__PURE__ */ h(Sr, { open: o.key === s, onOpenChange: I, children: z }) : /* @__PURE__ */ h(Sr, { onOpenChange: I, children: z });
};
function E1(e) {
  const t = e.column.filterable && e.onFilterChange, n = (r) => e.onFilterChange && e.onFilterChange(e.column, r);
  return t && e.onLoadFilters ? /* @__PURE__ */ h(
    Uv,
    {
      activeFilters: e.filters,
      onApply: n,
      onLoadFilters: e.onLoadFilters,
      column: e.column,
      lookup: e.column.lookup,
      onOpenPopover: e.onOpenPopover,
      openedPopover: e.openedPopover
    }
  ) : void 0;
}
function k1({ id: e, topPosition: t }) {
  return /* @__PURE__ */ h("th", { className: "th-group-path sticky", style: { top: `${t}px` }, children: /* @__PURE__ */ h("div", {}) }, `${e}-column`);
}
function D1({ id: e, column: t, state: n, topPosition: r, cfg: o }) {
  const i = t.isLockedRight ? {
    right: `${o.stickyRightOffsets[t.key] ?? 0}px`,
    top: `${r}px`,
    zIndex: 25,
    position: "sticky"
  } : t.isLocked ? {
    left: `${o.stickyOffsets[t.key]}px`,
    top: `${r}px`,
    zIndex: 25,
    position: "sticky"
  } : void 0;
  return /* @__PURE__ */ h(
    "th",
    {
      className: t.isLockedRight ? (
        // right splitter mirrors the left one: fades from transparent into the frozen net block.
        "th-new-splitter !bg-gradient-to-l !from-neutral-container !to-transparent"
      ) : "th-new-splitter !bg-gradient-to-r !from-neutral-container !to-transparent",
      style: i
    },
    `${e}-column`
  );
}
function R1(e, t) {
  var n = oe(null), r = oe(null);
  r.current = t;
  var o = oe(null);
  de(function() {
    i();
  });
  var i = Fe(function() {
    var s = o.current, a = r.current, l = s || (a ? a instanceof Element ? a : a.current : null);
    n.current && n.current.element === l && n.current.subscriber === e || (n.current && n.current.cleanup && n.current.cleanup(), n.current = {
      element: l,
      subscriber: e,
      // Only calling the subscriber, if there's an actual element to report.
      // Setting cleanup to undefined unless a subscriber returns one, as an existing cleanup function would've been just called.
      cleanup: l ? e(l) : void 0
    });
  }, [e]);
  return de(function() {
    return function() {
      n.current && n.current.cleanup && (n.current.cleanup(), n.current = null);
    };
  }, []), Fe(function(s) {
    o.current = s, i();
  }, [i]);
}
function ah(e, t, n) {
  return e[t] ? e[t][0] ? e[t][0][n] : (
    // TS complains about this, because the RO entry type follows the spec and does not reflect Firefox's current
    // behaviour of returning objects instead of arrays for `borderBoxSize` and `contentBoxSize`.
    // @ts-ignore
    e[t][n]
  ) : t === "contentBoxSize" ? e.contentRect[n === "inlineSize" ? "width" : "height"] : void 0;
}
function M1(e) {
  e === void 0 && (e = {});
  var t = e.onResize, n = oe(void 0);
  n.current = t;
  var r = e.round || Math.round, o = oe(), i = ue({
    width: void 0,
    height: void 0
  }), s = i[0], a = i[1], l = oe(!1);
  de(function() {
    return l.current = !1, function() {
      l.current = !0;
    };
  }, []);
  var c = oe({
    width: void 0,
    height: void 0
  }), u = R1(Fe(function(d) {
    return (!o.current || o.current.box !== e.box || o.current.round !== r) && (o.current = {
      box: e.box,
      round: r,
      instance: new ResizeObserver(function(f) {
        var m = f[0], p = e.box === "border-box" ? "borderBoxSize" : e.box === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize", g = ah(m, p, "inlineSize"), y = ah(m, p, "blockSize"), b = g ? r(g) : void 0, x = y ? r(y) : void 0;
        if (c.current.width !== b || c.current.height !== x) {
          var w = {
            width: b,
            height: x
          };
          c.current.width = b, c.current.height = x, n.current ? n.current(w) : l.current || a(w);
        }
      })
    }), o.current.instance.observe(d, {
      box: e.box
    }), function() {
      o.current && o.current.instance.unobserve(d);
    };
  }, [e.box, r]), e.ref);
  return pe(function() {
    return {
      ref: u,
      width: s.width,
      height: s.height
    };
  }, [u, s.width, s.height]);
}
const lh = ({ children: e, onChangeHeight: t }) => {
  const n = oe(null);
  return M1({
    ref: n,
    onResize: (r) => {
      r.height && t && t && t(r.height);
    }
  }), /* @__PURE__ */ h("tr", { ref: n, children: e });
};
var Yv = /* @__PURE__ */ ((e) => (e.LOADING = "LOADING", e.ERROR = "ERROR", e))(Yv || {});
const A1 = ({ scroll: e, rowVirtualizer: t, columns: n, visibleColumns: r, table: o }) => pe(() => {
  const s = {}, a = t.getVirtualItems();
  return !o || "length" in o ? {} : (n.forEach((l, c) => {
    var u;
    if (r[c] === -1)
      for (const d of a) {
        const f = d.index, m = o.object(f);
        let p;
        l.validate && (p = Array.isArray(l.validate) ? (u = l.validate.map((g) => g(m[l.key], m))) == null ? void 0 : u.find(Boolean) : l.validate(m[l.key], m)), p && (s[`${c}-${f}`] = p);
      }
  }), s);
}, [e, o, n, r]), O1 = {
  includeHeaders: !1,
  includeContextColumns: !1,
  semicolonSeparated: !1,
  includeCurrencySymbol: !0
}, N1 = (e) => {
  if (!(e != null && e.length)) return [];
  const t = [...new Set(e.map((o) => o.rowIndex))].sort((o, i) => o - i), n = [...new Set(e.map((o) => o.colIndex))].sort((o, i) => o - i), r = new Map(e.map((o) => [`${o.rowIndex}-${o.colIndex}`, o]));
  return t.map((o) => n.map((i) => r.get(`${o}-${i}`)));
}, _1 = (e, t) => e.map((r) => ({
  ...r,
  colIndex: t.findIndex((o) => o.key === r.column)
})), Gv = (e, t, n) => {
  var s;
  const r = e.filter((a) => {
    const l = n.find((u) => u.key === a.column);
    let c = (l == null ? void 0 : l.readOnly) || (l == null ? void 0 : l.split) || a.pasteValue === null && (l == null ? void 0 : l.nullable) === !1 || (l == null ? void 0 : l.dataType) === "number" && isNaN(Number(a.pasteValue));
    if (!c && (l != null && l.validate)) {
      const u = t.object(a.rowIndex);
      c = Hv(u, l);
    }
    return !c;
  }), o = [...new Set(r.map((a) => a.rowIndex))], i = [];
  for (const a of o) {
    const l = t == null ? void 0 : t.object(a);
    if (l && "key" in l) {
      const c = r.filter((f) => f.row === l.key), u = { ...l }, d = [];
      for (const f of c) {
        const m = ((s = n.find((p) => p.key === f.column)) == null ? void 0 : s.dataType) || (typeof u[f.column] == "number" ? "number" : "string");
        u[f.column] = m === "number" && f.pasteValue !== null ? Number(f.pasteValue) : f.pasteValue, d.push({
          ...f,
          value: u[f.column]
        });
      }
      i.push({
        newRecord: u,
        oldRecord: l,
        cells: d
      });
    }
  }
  return i;
}, I1 = (e, t, n, r, o) => {
  const { includeHeaders: i, includeContextColumns: s, semicolonSeparated: a, includeCurrencySymbol: l } = {
    ...O1,
    ...o
  }, c = a ? ";" : "	";
  return {
    copy: async () => {
      if (!n || !(t != null && t.end) && !e.length)
        return;
      const f = (P) => r.find((D) => D.key === P), m = (P) => {
        if (P != null && P.prefix) return P.prefix;
        const D = P == null ? void 0 : P.mask;
        return typeof D == "string" && D[0] === "$" ? "$" : "";
      }, p = (P, D) => D != null && D.lookup ? co(P, D.lookup) : P == null || P === "" ? "-" : `${l ? m(D) : ""}${P}`, g = t != null && t.end ? sh(t.start.cell, t.end.cell, r, n) : e;
      if (!g.length) return;
      if (g.length === 1) {
        const P = g[0];
        await navigator.clipboard.writeText(String(p(P.value, f(P.column)) ?? ""));
        return;
      }
      const y = new Set(g.map((P) => P.column)), b = r.filter((P) => !P.split && !P.groupColumn && y.has(P.key));
      if (!b.length) return;
      let x = [];
      if (s && (x = r.filter((P) => P.isLocked && !P.split && !P.groupColumn && !y.has(P.key)), !x.length)) {
        const P = r.find((D) => !D.split && !D.groupColumn);
        P && !y.has(P.key) && (x = [P]);
      }
      const w = [...x, ...b], E = [...new Set(g.map((P) => P.rowIndex))].sort((P, D) => P - D).map((P) => {
        const D = n.object(P);
        return w.map((k) => p(D == null ? void 0 : D[k.key], k));
      }), T = (i ? [w.map((P) => P.name), ...E] : E).map((P) => P.join(c)).join(`
`);
      await navigator.clipboard.writeText(T);
    },
    paste: async (f) => {
      if (!n || !(t != null && t.end) && !e.length)
        return [];
      const p = (await navigator.clipboard.readText()).trim().split(`
`).map((C) => C.split("	")), [g, y] = [p.length, p[0].length], b = !!(t != null && t.end), x = t != null && t.end ? sh(t.start.cell, t.end.cell, r, n) : e, w = _1(x, r), S = N1(w).map(
        (C) => C.map((T) => ({ ...T, pasteValue: null }))
      );
      for (let C = 0; C < S.length; C++) {
        const T = S[C];
        for (let P = 0; P < T.length; P++) {
          const D = T[P];
          f ? D.pasteValue = null : b ? D.pasteValue = f ? null : p[C % g][P % y] : D.pasteValue = p[0][0];
        }
      }
      return Gv(S.flat(), n, r);
    }
  };
}, L1 = (e) => {
  const [t, n] = Gu(
    `selection-status-${e}`,
    []
  );
  return {
    selectedCells: t,
    setSelectedCells: n,
    clearSelectedCells: () => {
      n([]);
    },
    cellClicked: (i, s) => {
      !s || s === "replace" ? n(
        Bt(t, () => [i])
      ) : s === "add" && n(
        Bt(t, (a) => {
          a.some((c) => c.column === i.column && c.row === i.row) || a.push(i);
        })
      );
    }
  };
};
function $1({ columns: e, height: t, cfg: n }) {
  const r = 20 * t;
  return /* @__PURE__ */ h("tr", { children: e.map((o, i) => {
    var p, g;
    const s = `row-spacer-${o.key}`;
    if (o.groupColumn)
      return /* @__PURE__ */ h("td", { className: "td-group-path !border-b-table-borders-header !border-b" }, s);
    let a = !1;
    const l = i < e.length - 1 ? (p = e[i + 1]) == null ? void 0 : p.split : !0, c = i > 0 ? (g = e[i - 1]) == null ? void 0 : g.split : !0, u = !!(i > 0 && e[i - 1].groupColumn);
    (i > 0 && u && !o.split || i === 0 || c) && (a = !0);
    const d = !!o.isLocked, f = !d && !!o.isLockedRight, m = d ? {
      position: "sticky",
      left: `${n.stickyOffsets[o.key]}px`,
      zIndex: 20
    } : f ? {
      position: "sticky",
      overflow: "auto",
      right: `${n.stickyRightOffsets[o.key] ?? 0}px`,
      zIndex: 20
    } : {};
    return /* @__PURE__ */ h(
      "td",
      {
        className: He(
          o.split ? "td-new-splitter bg-gradient-to-r from-neutral-container to-transparent" : "bg-color-greys-100 dark:bg-color-greys-800",
          a ? "!border-l-table-borders-header !border-l" : "!border-l-0",
          f && "!border-l-table-borders-header !border-l",
          "!border-t-table-borders-header",
          "!border-b-table-borders-header",
          l && "!border-r-table-borders-header !border-r"
        ),
        style: {
          ...m,
          height: `${r}px`
        }
      },
      s
    );
  }) });
}
const F1 = ({ sortState: e }) => {
  switch (e) {
    case "asc":
      return /* @__PURE__ */ h(fx, { size: 16 });
    case "desc":
      return /* @__PURE__ */ h(dx, { size: 16 });
    default:
      return /* @__PURE__ */ h(ux, { size: 16 });
  }
};
function V1({ column: e, sort: t, onSort: n }) {
  const r = t && e.key === t.field ? t.order : null;
  return /* @__PURE__ */ h(ke, { onClick: () => {
    const i = (t == null ? void 0 : t.order) === "asc" ? "desc" : "asc";
    n({ field: e.key, order: i });
  }, variant: "ghost", className: "icon hover:bg-transparent text-input-icons", size: "sm", children: /* @__PURE__ */ h(F1, { sortState: r }) });
}
const Kv = Ye(void 0), NV = ({ children: e, lookups: t = {} }) => {
  const n = Fe(
    (o) => o.map((i) => i.lookup ? i : t[i.key] ? { ...i, lookup: t[i.key] } : i),
    [t]
  ), r = pe(
    () => ({
      lookups: t,
      applyLookups: n
    }),
    [t, n]
  );
  return /* @__PURE__ */ h(Kv.Provider, { value: r, children: e });
}, nd = () => Pe(Kv), _V = (e) => {
  var ut, Dt, Zt, dn, fn;
  const t = nd(), n = pe(() => {
    if (Array.isArray(e.table)) {
      const V = e.table.length ? Object.keys(e.table[0]) : [], q = e.columns.map((ie) => ie.key), B = [.../* @__PURE__ */ new Set([...V, ...q])];
      return Tp(e.table, B);
    }
    return e.table;
  }, [e.table]), r = pe(() => {
    const V = e.columns.some((B) => B.fixedPercentageWidth), q = e.columns.every((B) => B.fixedPercentageWidth);
    if (V && !q)
      throw new Error("Either all columns must have fixedPercentageWidth set or none of them should have it");
    return V;
  }, [e.columns]), o = e.hooks.getDatatableConfig(), i = oe(null), { state: s, hooks: a } = e, [l, c] = ue([]), [u, d] = ue(null), [f, m] = Gu(`scroll-position-${e.tablekey}`, { x: 0, y: 0 }), [p, g] = ue(!1), y = (V) => {
    p && m(V);
  };
  de(() => {
    i != null && i.current && n && (i.current.scrollLeft = f.x, i.current.scrollTop = f.y, g(!0));
  }, [n, e.columns]);
  const [b, x] = ue(), [w, S] = ue(), E = (V, q) => {
    c((B) => Bt(B, (ie) => {
      ie[V] = q;
    }));
  }, [C, T, P] = pe(() => {
    var dt;
    const V = [];
    let q = 0;
    const ie = [...(t == null ? void 0 : t.applyLookups(e.columns)) ?? e.columns];
    let he = ie.map((ae, Me) => {
      var St, Ve;
      if ("split" in ae)
        return {
          name: "",
          key: ae.key || `sep-${Me}`,
          component: () => /* @__PURE__ */ h(PE, {}),
          _dfColIndex: -1,
          sourceColIndex: -1,
          split: !0,
          isLocked: ae.isLocked
        };
      let Ee = "";
      const K = ae.isLocked || s.lockedColumns.includes(ae.key);
      ((St = ae.group) != null && St.length && !ae.group[ae.group.length - 1].label || !((Ve = ae.group) != null && Ve.length)) && ((Me === 0 || "split" in ie[Me - 1]) && (Ee += "rounded-tl "), (Me === ie.length - 1 || "split" in ie[Me + 1]) && (Ee += "rounded-tr "));
      const j = {
        ...ae,
        component: ae.component || Mr,
        _dfColIndex: -1,
        sourceColIndex: Me,
        isLocked: K,
        aditionalClasses: Ee
      };
      return !ae.onLoadFilters && ae.filterable && e.onLoadFiltersByColumn && (j.onLoadFilters = (hn) => e.onLoadFiltersByColumn(ae.key, hn, j.lookup, j.mask)), j;
    });
    const Ue = [];
    let pt = 0;
    for (const ae of he) {
      const Me = rc(ae, s);
      if (!Me)
        !ae.split && !ae.groupColumn && (ae._dfColIndex = pt++), Ue.push(ae);
      else {
        const Ee = Ue.length ? Ue[Ue.length - 1] : void 0;
        (!Ee || !HE(Ee.group, Me)) && Ue.push(gP(Me, ae.key));
      }
    }
    he = Ue;
    for (const ae of he)
      ae.group && ae.group.length > q && (q = ae.group.length);
    for (let ae = 0; ae < q; ae++) {
      const Me = [];
      for (let Ee = 0; Ee < he.length; Ee++) {
        const K = he[Ee], j = K.group && K.group[ae];
        if (K.group && P1(K.group, ae))
          continue;
        const St = Ee < he.length - 1 ? he[Ee + 1] : void 0, Ve = K.group && ae > 0 ? K.group[ae - 1] : void 0, hn = ae === 0 || (Ve == null ? void 0 : Ve.label) === void 0 || (Ve == null ? void 0 : Ve.component), Fr = K.group && K.groupColumn ? ae > ((dt = K.group) == null ? void 0 : dt.length) - 2 : void 0, Fi = (St == null ? void 0 : St.split) || Ee === he.length - 1, le = K.group ? ae === K.group.length - 1 || ae === 0 : !1, Se = Ee > 0 ? Me[Me.length - 1] : void 0, Ie = (j == null ? void 0 : j.label) === void 0 && !Fr || !1, Le = j == null ? void 0 : j.label;
        if (Se && Se.key === (j == null ? void 0 : j.key))
          Me[Me.length - 1].colspan += 1, Fi && hn && (Me[Me.length - 1].aditionalClasses += "rounded-tr ");
        else {
          let De, gt = "";
          const ot = (K.group || []).filter((Jt, Rt) => Rt <= ae);
          if (Le && !(j != null && j.uncollapsable)) {
            const Jt = ot.map((Rt) => Rt.key).join("_");
            De = /* @__PURE__ */ h(
              XE,
              {
                hooks: a,
                group: ot,
                hidding: !s.groupCollapsedStatus[Jt]
              }
            );
          }
          Ie && (gt += Se != null && Se.name && !K.split ? "empty-cell-left-border " : "empty-cell "), (Se != null && Se.split || Ee === 0) && hn && (gt += "rounded-tl "), Fi && hn && (gt += "rounded-tr ");
          let vt = ot;
          j && j.rowspan && (vt = (K.group || []).filter((Jt, Rt) => Rt <= ae + j.rowspan - 1));
          const Ft = vt.length ? UE(vt, ie, s) : !1;
          Me.push({
            rowspan: j == null ? void 0 : j.rowspan,
            areSubgroupsCollapsed: Ft,
            aditionalClasses: gt,
            viewComponent: j == null ? void 0 : j.component,
            key: (j == null ? void 0 : j.key) || `no-group-${ae}`,
            name: Le || "",
            colspan: 1,
            split: K.split,
            // Left-frozen columns (incl. their group-header spacer) must stay pinned so the
            // scrolling scenario group headers slide UNDER them — mirrors the right-locked
            // handling below. Without this the group header overwrites the left frozen block.
            leftStickyOffset: j != null && j.isLocked || K.split && !K.isLockedRight || K.isLocked && !K.isLockedRight ? o.stickyOffsets[K.key] : void 0,
            rightStickyOffset: !K.isLocked && K.isLockedRight ? o.stickyRightOffsets[K.key] ?? 0 : void 0,
            component: De,
            isPartOfGroup: Fr,
            isHeadOfGroup: le
          });
        }
      }
      V.push(Me);
    }
    return [he, V, q];
  }, [
    n,
    e.columns,
    s.lockedColumns,
    s.groupCollapsedStatus,
    s.columnPositions,
    o.stickyOffsets,
    o.stickyRightOffsets,
    t
  ]);
  de(() => {
    x(void 0);
  }, [s.lockedColumns, s.groupCollapsedStatus, s.columnPositions, e.columns]);
  const D = pe(() => {
    const V = [];
    let q = WE;
    for (let B = 0; B < P + 2; B++)
      V[B] = q, q += l[B] || 25;
    return V;
  }, [l, P]), { rowSize: k, cssClass: R } = pe(() => {
    let V = 32, q = e.className ?? "";
    return e.isCompressed && (V = 20, q += " is-compressed"), e.rowHeight != null && (V = e.rowHeight), {
      rowSize: V,
      cssClass: q
    };
  }, [e.isCompressed, e.className, e.rowHeight]), O = (n == null ? void 0 : n.size) || 0, _ = NP({
    count: O,
    getScrollElement: () => i.current,
    estimateSize: () => k
  }), $ = _.getVirtualItems().find((V) => V !== void 0) || { size: k, start: 0 }, z = _.getTotalSize() - ($.start + _.getVirtualItems().length * $.size), I = ((ut = i.current) == null ? void 0 : ut.getBoundingClientRect().width) || 1, A = pe(() => {
    if (o.disableColumnVirtualization || r)
      return [];
    const V = [];
    let q = 0, B = 0;
    for (let ie = 0; ie < C.length; ie++) {
      const he = C[ie], Ue = o.usePositionalColumnSizing ? `column-${he.sourceColIndex}` : he.key;
      let pt = Math.max(s.columnPositions[Ue] || 0, he.minWidth || o.minColumnWidth);
      he.groupColumn && (pt = 24), he.split && (pt = 12), q >= f.x - 200 && q <= f.x + I + 200 || he.isLocked || he.isLockedRight ? (V.push(-1), B = ie + 1) : (V.push(0), V[B]++), q += pt;
    }
    return V;
  }, [f, s, I, o.disableColumnVirtualization]), M = (V) => {
    const B = i.current;
    if (B) {
      const ie = B.querySelector(`td[data-row-key="${V.row}"][data-col-key="${V.column}"]`);
      if (!ie) return;
      const he = ie.getBoundingClientRect(), Ue = B.getBoundingClientRect(), pt = B.scrollTop, dt = B.scrollLeft, ae = D[D.length - 1], Me = Object.keys(o.stickyOffsets).length ? Math.max(...Object.values(o.stickyOffsets)) : 0, Ee = {
        top: Ue.top + ae,
        bottom: Ue.bottom,
        left: Ue.left + Me,
        right: Ue.right
      };
      let K = he.top < Ee.top + 150 ? pt - (Ee.top + 150 - he.top) : void 0, j = he.left < Ee.left + 150 ? dt - (Ee.left + 150 - he.left) : void 0;
      K = he.bottom > Ee.bottom - 150 ? pt + (he.bottom - (Ee.bottom - 150)) : K, j = he.right > Ee.right - 150 ? dt + (he.right - (Ee.right - 150)) : j, B.scrollTo({
        top: K,
        left: j,
        behavior: "instant"
      });
    }
  }, {
    selectedCells: F,
    clearSelectedCells: W,
    cellClicked: ne
  } = L1(e.tablekey), N = e.disableCellSelection ? () => {
  } : ne, { copy: Y, paste: H } = I1(F, b, n, C, e.copyOptions), U = (V, q) => {
    const B = document.querySelector(`td[data-row-key="${V}"][data-col-key="${q}"]`);
    if (B) {
      const ie = B.querySelector("input");
      ie && ie.type === "number" && (ie.focus(), ie.type = "text", ie.setSelectionRange(0, ie.value.length), ie.type = "number");
    }
  }, fe = async (V) => {
    var Ue, pt, dt, ae, Me, Ee;
    if (!n || u) return;
    let q = V.key.toLocaleLowerCase();
    q === "backspace" && w === void 0 && (q = "delete");
    const B = V.ctrlKey || V.metaKey, ie = F.length ? F[0] : void 0, he = ie ? C.find((K) => K.key === ie.column) : void 0;
    switch (!0) {
      case (q.length === 1 && T1(q) && !B && !w && !!ie):
        he && !he.readOnly && !he.split && !Do(ie, n, he) && S({
          ...F[0],
          newValue: "",
          editMode: "express"
        });
        break;
      case q === "escape":
        w ? S(void 0) : (W(), x(void 0)), (Ue = i.current) == null || Ue.focus();
        break;
      case q === "enter":
        if (w && e.onRowsCommit) {
          e.onRowsCommit(Ro(w, n, C));
          const K = jr(w, "arrowdown", C, n);
          K && K.rowIndex !== w.rowIndex && !Do(K, n, C.find((j) => j.key === K.column)) ? (N(K, "replace"), S({
            ...K,
            newValue: K == null ? void 0 : K.value,
            editMode: "normal"
          }), M(K)) : S(void 0), (pt = i.current) == null || pt.focus();
        } else if (!w && F.length) {
          const K = F[0], j = C.find((St) => St.key === K.column);
          j && !j.readOnly && !Do(K, n, j) && S({
            ...F[0],
            newValue: F[0].value,
            editMode: "normal"
          });
        }
        break;
      case (q === "v" && B):
        {
          const K = await H();
          K != null && K.length && e.onRowsCommit && e.onRowsCommit(K), V.preventDefault();
        }
        break;
      case q === "delete":
        if (n && e.onRowsCommit) {
          const K = await H(!0);
          K != null && K.length && e.onRowsCommit(K), V.preventDefault();
        }
        break;
      case (q === "c" && B):
        await Y();
        break;
      case (q === "tab" && !w && !!(F != null && F.length)):
        {
          const K = F[0], j = jr(K, "arrowright", C, n);
          j && N(j, "replace");
        }
        V.preventDefault();
        break;
      case (q === "tab" && !!w):
        {
          const K = Ro(w, n, C);
          K.length && e.onRowsCommit && e.onRowsCommit(K);
          const j = jr(w, "arrowright", C, n);
          if (j && j.column !== w.column) {
            const St = C.find((Ve) => Ve.key === j.column);
            (dt = C.find((Ve) => Ve.key === j.column)) != null && dt.readOnly || Do(j, n, St) ? S(void 0) : S({
              ...j,
              newValue: j == null ? void 0 : j.value,
              editMode: "normal"
            }), N(j, "replace"), M(j);
          } else
            S(void 0);
          V.preventDefault(), (ae = i.current) == null || ae.focus();
        }
        break;
      case ((w == null ? void 0 : w.editMode) === "express" && ["arrowleft", "arrowup", "arrowright", "arrowdown"].includes(q)):
        if (e.onRowsCommit) {
          const K = Ro(w, n, C);
          K.length && e.onRowsCommit(K);
          let j = jr(w, q, C, n), St = !1;
          for (; j && ((Me = C.find((Ve) => Ve.key === (j == null ? void 0 : j.column))) != null && Me.readOnly) && !St; ) {
            const Ve = jr(j, q, C, n);
            (Ve == null ? void 0 : Ve.column) !== j.column || Ve.row !== j.row ? j = Ve : St = !0;
          }
          if (j && (j.row !== w.row || j.column !== w.column)) {
            const Ve = C.find((Fr) => Fr.key === j.column), hn = Ve.readOnly || Do(j, n, Ve);
            N(j, "replace"), S(
              hn ? void 0 : { ...j, newValue: j.value, editMode: "express" }
            ), setTimeout(() => {
              j && U(j.row, j.column);
            }, 0);
          } else
            S(void 0);
        }
        break;
      case ["arrowup", "arrowdown"].includes(q):
      case (!w && ["arrowleft", "arrowright"].includes(q)):
        {
          const K = (b == null ? void 0 : b.start.cell) || F.length && F[0];
          if (K && n) {
            const j = jr(K, q, C, n);
            j && (x(void 0), N(j, "replace"), M(j), V.preventDefault());
          }
          ["arrowup", "arrowdown"].includes(q) && (S(void 0), (Ee = i.current) == null || Ee.focus());
        }
        break;
    }
  }, ge = (V, q) => {
    N(V, q === "ctrl" ? "add" : "replace"), e.onCellSelect && e.onCellSelect(V, n.object(V.rowIndex));
  }, X = (V) => {
    w && w.value !== w.newValue && e.onRowsCommit && n && e.onRowsCommit(Ro(w, n, C)), S(
      V ? {
        ...V,
        newValue: V.value,
        editMode: "normal"
      } : void 0
    );
  }, se = (V, q) => {
    if (w) {
      const B = { ...w, newValue: V };
      S(B), q && e.onRowsCommit && n && (e.onRowsCommit(Ro(B, n, C)), S(void 0));
    }
  }, ee = (V, q, B, ie, he, Ue) => {
    var ae, Me, Ee, K;
    const pt = -(((ae = i.current) == null ? void 0 : ae.getBoundingClientRect().x) || 0) + q + (((Me = i.current) == null ? void 0 : Me.scrollLeft) || 0), dt = -(((Ee = i.current) == null ? void 0 : Ee.getBoundingClientRect().y) || 0) + B + (((K = i == null ? void 0 : i.current) == null ? void 0 : K.scrollTop) || 0);
    V === "start" && x({
      start: {
        absX: pt,
        absY: dt,
        width: ie,
        height: he,
        cell: Ue
      }
    }), V === "drag" && b && x({
      ...b,
      end: {
        absX: pt,
        absY: dt,
        width: ie,
        height: he,
        cell: Ue
      }
    }), V === "end" && b && (b.start.cell.row !== Ue.row || b.start.cell.column !== Ue.column ? (S(void 0), W(), x({
      ...b,
      end: {
        absX: pt,
        absY: dt,
        width: ie,
        height: he,
        cell: Ue
      }
    })) : x(void 0));
  }, xe = pe(() => {
    const V = b;
    if (!(V != null && V.end)) return;
    const q = C.findIndex((ie) => ie.key === V.start.cell.column), B = C.findIndex((ie) => ie.key === V.end.cell.column);
    if (!(q < 0 || B < 0))
      return {
        minCol: Math.min(q, B),
        maxCol: Math.max(q, B),
        minRow: Math.min(V.start.cell.rowIndex, V.end.cell.rowIndex),
        maxRow: Math.max(V.start.cell.rowIndex, V.end.cell.rowIndex)
      };
  }, [b, C]), ye = (V) => {
    if (e.infoHeader)
      return e.infoHeader.columnNames().includes(V.key) ? e.infoHeader.get(V.key, 0) : " ";
  }, G = A1({
    scroll: f,
    rowVirtualizer: _,
    columns: C,
    visibleColumns: A,
    table: n
  }), mt = pe(() => {
    const V = Math.max((e.bottomRowsPaddingAmount ?? 6) - ((n == null ? void 0 : n.size) || 0), 0);
    return V ? /* @__PURE__ */ h($1, { cfg: o, columns: C, height: V }) : void 0;
  }, [e.bottomRowsPaddingAmount, n == null ? void 0 : n.size, o, C]);
  return e.error ? /* @__PURE__ */ h(
    "div",
    {
      className: He(
        "w-full relative bg-red-200 text-red-800 text-sm text-center border rounded-md p-2",
        "border-red-700"
      ),
      children: "There was an error loading data. Please try again."
    }
  ) : !(n != null && n.size) && !(C != null && C.length) ? /* @__PURE__ */ h("div", { className: "h-32 w-full relative", children: /* @__PURE__ */ h(gr, { cover: !0 }) }) : /* @__PURE__ */ h(_u, { children: /* @__PURE__ */ h("div", { className: "flex overflow-hidden", children: /* @__PURE__ */ L(
    "div",
    {
      ref: i,
      onScroll: (V) => y({
        x: V.currentTarget.scrollLeft,
        y: V.currentTarget.scrollTop
      }),
      onKeyDownCapture: fe,
      tabIndex: 0,
      className: He(" pretty-scrollbar w-0 grow outline-none relative", [
        e.disableScrolling ? "" : "overflow-y-auto overflow-x-auto"
      ]),
      children: [
        /* @__PURE__ */ L(
          "table",
          {
            className: He(`supertable ${R}`, r && "w-full"),
            style: { minHeight: e.minHeight ?? void 0 },
            children: [
              /* @__PURE__ */ h("colgroup", { children: C.map((V) => {
                const q = o.usePositionalColumnSizing ? `column-${V.sourceColIndex}` : V.key, B = Math.max(
                  s.columnPositions[q] || 0,
                  V.minWidth || o.minColumnWidth
                ), ie = r ? `${V.fixedPercentageWidth}%` : `${B}px`;
                return /* @__PURE__ */ h(
                  "col",
                  {
                    style: V.split ? {
                      // keep in sync with the 28px splitter width in DatatableState offsets and .td-new-splitter (w-7)
                      width: "28px",
                      minWidth: "28px",
                      maxWidth: "28px"
                    } : {
                      minWidth: V.groupColumn ? "24px" : B ? ie : "50px",
                      maxWidth: V.groupColumn ? "24px" : void 0,
                      width: V.groupColumn ? "24px" : ie
                    }
                  },
                  V.key
                );
              }) }),
              /* @__PURE__ */ L("thead", { className: e.theadClassName ?? "", children: [
                T.map((V, q) => /* @__PURE__ */ h(
                  lh,
                  {
                    "attr-key": `${q}-grp-row`,
                    onChangeHeight: (B) => E(q, B),
                    children: V.map((B, ie) => {
                      const he = !!(ie === V.length - 1 || V[ie + 1].split);
                      return /* @__PURE__ */ h(
                        "th",
                        {
                          "attr-key": `${ie}-th`,
                          rowSpan: B.rowspan,
                          className: He(
                            "sticky",
                            B.split && (B.rightStickyOffset !== void 0 ? (
                              // right splitter mirrors the left: gradient over the content sliding beneath the net block
                              "th-new-splitter !bg-gradient-to-l !from-neutral-container !to-transparent"
                            ) : "th-new-splitter bg-gradient-to-r from-neutral-container to-transparent"),
                            B.isPartOfGroup ? B.name ? "th-is-group" : "th-group-path" : void 0,
                            // Frozen (sticky) spacer cells must be opaque, else the scrolling
                            // group headers show through them. empty-cell is bg-transparent.
                            !B.split && (B.leftStickyOffset !== void 0 || B.rightStickyOffset !== void 0) && "bg-table-bg-header",
                            "font-medium"
                          ),
                          style: {
                            top: `${D[q]}px`,
                            left: B.leftStickyOffset !== void 0 ? `${B.leftStickyOffset}px` : void 0,
                            right: B.rightStickyOffset !== void 0 ? `${B.rightStickyOffset}px` : void 0,
                            // isHeadOfGroup should be on top of other groups (vertical text)
                            // and if the group is sticky, it should be on top of every other group
                            zIndex: B.leftStickyOffset !== void 0 || B.rightStickyOffset !== void 0 ? 25 : B.isHeadOfGroup ? 18 : 15
                          },
                          colSpan: B.colspan,
                          children: /* @__PURE__ */ h("div", { className: B.aditionalClasses, children: B.isPartOfGroup && B.name ? /* @__PURE__ */ L(
                            "div",
                            {
                              className: He(
                                "text-xs bg-table-bg-header vertical-group",
                                he && "border-r",
                                B.aditionalClasses
                              ),
                              style: {
                                minHeight: `${100 + T.length * 32}px`
                              },
                              children: [
                                B.component ? B.component : "",
                                B.viewComponent ? /* @__PURE__ */ h(B.viewComponent, { isCollapsed: B.areSubgroupsCollapsed }) : B.name
                              ]
                            }
                          ) : /* @__PURE__ */ h(Oe, { children: B.viewComponent ? /* @__PURE__ */ L("div", { className: "grow relative", style: { display: "flex", justifyContent: "center", alignItems: "center" }, children: [
                            B.component ? /* @__PURE__ */ h("div", { className: "absolute bottom-0.8 left-0.5 z-10", children: B.component }) : "",
                            /* @__PURE__ */ h(B.viewComponent, { isCollapsed: B.areSubgroupsCollapsed })
                          ] }) : /* @__PURE__ */ L("div", { className: "grow w-0 text-xs flex justify-center items-center px-2 whitespace-nowrap min-w-0", children: [
                            B.component ? B.component : "",
                            /* @__PURE__ */ h(
                              sv,
                              {
                                text: B.name,
                                className: "align-middle text-ellipsis overflow-hidden whitespace-nowrap min-w-0"
                              }
                            )
                          ] }) }) })
                        },
                        `${ie}-th`
                      );
                    })
                  },
                  `${q}-grp-row`
                )),
                /* @__PURE__ */ h(lh, { children: C.map(
                  (V, q) => {
                    var B;
                    return V.groupColumn ? /* @__PURE__ */ h(k1, { id: q, topPosition: D[D.length - 1] }, V.key) : V.split ? /* @__PURE__ */ h(
                      D1,
                      {
                        id: q,
                        column: V,
                        state: s,
                        topPosition: D[T.length],
                        cfg: o
                      },
                      V.key
                    ) : /* @__PURE__ */ h(
                      _P,
                      {
                        columns: C,
                        column: V,
                        id: q,
                        state: s,
                        hooks: a,
                        cfg: o,
                        aditionalClasses: V.aditionalClasses,
                        leftSection: V.filterable && e.onFilterChange && /* @__PURE__ */ h(
                          E1,
                          {
                            column: V,
                            filters: e.filters ? e.filters[V.key] : [],
                            onLoadFilters: V.onLoadFilters,
                            onFilterChange: e.onFilterChange,
                            onOpenPopover: d,
                            openedPopover: u
                          }
                        ),
                        rightSection: V.sortable && e.onSort && /* @__PURE__ */ h(
                          V1,
                          {
                            column: V,
                            sort: e.sort ? e.sort : null,
                            onSort: e.onSort
                          }
                        ),
                        topPosition: D[T.length],
                        showInfoRow: !!e.infoHeader,
                        infoRow: e.infoHeader ? ye(V) : void 0,
                        disableResize: r,
                        hasActiveFilter: !!(e.filters && ((B = e.filters[V.key]) != null && B.length))
                      },
                      V.key
                    );
                  }
                ) }, "column-row")
              ] }),
              /* @__PURE__ */ L("tbody", { children: [
                /* @__PURE__ */ h(
                  "tr",
                  {
                    style: {
                      height: `${$.start + k}px`,
                      display: `${$.start ? "table-row" : "none"}`
                    }
                  }
                ),
                _.getVirtualItems().map((V) => {
                  const q = V.index, B = n.object(q);
                  return /* @__PURE__ */ h(
                    TE,
                    {
                      onDrag: ee,
                      hooks: a,
                      visibleColumns: A,
                      rowIndex: q,
                      rowSize: V.size,
                      columns: C,
                      record: B,
                      state: s,
                      selectedCells: F,
                      dragBlock: xe,
                      cellValidations: G,
                      onRowsCommit: (ie) => {
                        var he;
                        e.onRowsCommit && e.onRowsCommit(ie), (he = i.current) == null || he.focus();
                      },
                      editingCell: w,
                      onToggleEdit: X,
                      onChangeEditCellValue: se,
                      onCellSelect: ge,
                      cfg: o
                    },
                    B.key
                  );
                }),
                mt,
                /* @__PURE__ */ h(
                  "tr",
                  {
                    className: "bottom-virtual-row",
                    style: {
                      height: `${z}px`,
                      display: `${z ? "table-row" : "none"}`
                    },
                    children: /* @__PURE__ */ h("td", { children: " " })
                  }
                )
              ] })
            ]
          }
        ),
        !n || e.status ? /* @__PURE__ */ h(
          "div",
          {
            className: "z-50 absolute bg-neutral-container/50  place-content-center place-items-center",
            style: {
              left: `${(Dt = i.current) == null ? void 0 : Dt.scrollLeft}px`,
              top: `${(Zt = i.current) == null ? void 0 : Zt.scrollTop}px`,
              width: `${(dn = i.current) == null ? void 0 : dn.clientWidth}px`,
              height: `${(fn = i.current) == null ? void 0 : fn.clientHeight}px`
            },
            children: e.status === Yv.ERROR ? /* @__PURE__ */ h("div", { className: "text-red-500", children: /* @__PURE__ */ h(hx, {}) }) : /* @__PURE__ */ h(gr, { cover: !0, transparent: !0 })
          }
        ) : void 0
      ]
    }
  ) }) });
};
function IV() {
  return /* @__PURE__ */ h("div", { className: "w-full relative h-32", children: /* @__PURE__ */ h(gr, { cover: !0 }) });
}
function LV(e) {
  const { trueLabel: t = "Yes", falseLabel: n = "No" } = e, r = e.value === !0 ? t : e.value === !1 ? n : "-", o = [
    {
      key: "true",
      label: t
    },
    {
      key: "false",
      label: n
    },
    e.nullable ? {
      key: "undefined",
      label: "Not defined"
    } : void 0
  ].filter(Boolean), i = (a) => a === "undefined" ? void 0 : a === "true", s = e.value === void 0 || e.value === null ? "undefined" : e.value ? "true" : "false";
  return e.isEditing ? /* @__PURE__ */ L("div", { className: "overflow-x-hidden text-ellipsis relative w-full", children: [
    /* @__PURE__ */ h(
      "select",
      {
        value: s,
        className: "bg-transparent outline-none absolute top-0 right-0 bottom-0 left-0",
        onChange: (a) => e.onChange && e.onChange(i(a.currentTarget.value)),
        autoFocus: !0,
        children: o.map((a) => /* @__PURE__ */ h("option", { value: a.key, children: a.label }, a.key))
      }
    ),
    " "
  ] }) : /* @__PURE__ */ h(Mr, { ...e, value: r });
}
function $V(e) {
  return /* @__PURE__ */ h("div", { className: "datatable-header-left flex items-center gap-2", children: e.children });
}
function FV(e) {
  return /* @__PURE__ */ h("div", { className: "datatable-header-left flex items-center gap-2", children: e.children });
}
function VV({
  search: e,
  onSearch: t,
  heading: n,
  hooks: r,
  children: o,
  filters: i,
  clearFilters: s,
  colapsableTable: a = !0
}) {
  return /* @__PURE__ */ L("div", { className: He("flex items-center justify-between mb-4"), children: [
    n && /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h("h2", { className: "text-xl font-semibold", children: n }) }),
    /* @__PURE__ */ h("div", { className: "flex items-center grow gap-2", children: o }),
    /* @__PURE__ */ L("div", { className: "flex items-center overflow-hidden", children: [
      t && /* @__PURE__ */ L("div", { className: "flex items-center py-4", children: [
        /* @__PURE__ */ h(
          Ti,
          {
            type: "search",
            placeholder: "Search",
            onInput: (l) => {
              t && t(l.target.value), l.preventDefault();
            },
            value: e,
            className: "max-w-sm pr-10"
          }
        ),
        /* @__PURE__ */ h(Ml, { className: "relative right-7 top-3 transform -translate-y-1/2" })
      ] }),
      /* @__PURE__ */ h(
        WC,
        {
          datatableHooks: r,
          filters: i,
          clearFilters: s,
          colapsableTable: a
        }
      )
    ] })
  ] });
}
function BV(e) {
  let { value: t } = e;
  return e.isEditing ? /* @__PURE__ */ L("div", { className: "overflow-x-hidden text-ellipsis relative w-full", children: [
    /* @__PURE__ */ h(
      "input",
      {
        value: t ?? "",
        className: "bg-transparent outline-none absolute top-0 right-0 bottom-0 left-0 disable-stepper",
        autoFocus: !0,
        onInput: (n) => e.onChange && e.onChange(n.currentTarget.value)
      }
    ),
    " "
  ] }) : /* @__PURE__ */ h(Mr, { ...e });
}
function B1(e) {
  var r, o;
  const { mask: t } = e.column;
  let { value: n } = e;
  if (t) {
    const i = ((o = (r = t == null ? void 0 : t.split(".")) == null ? void 0 : r[1]) == null ? void 0 : o.length) || 0;
    n = n || n === 0 ? Ax(n, i) : void 0;
  }
  return e.isEditing ? /* @__PURE__ */ L("div", { className: "overflow-x-hidden text-ellipsis relative w-full", children: [
    /* @__PURE__ */ h(
      "input",
      {
        value: n ?? "",
        type: "number",
        className: "bg-transparent outline-none absolute top-0 right-0 bottom-0 left-0 disable-stepper",
        step: 0.01,
        autoFocus: !0,
        onInput: (i) => e.onChange && e.onChange(i.currentTarget.value)
      }
    ),
    " "
  ] }) : /* @__PURE__ */ h(Mr, { ...e });
}
function W1(e) {
  const [t, n] = ue(""), r = e.numDecimals ?? 2;
  de(() => {
    e.isEditing ? n(e.value ? `${(+e.value * 100).toFixed(r)}` : "") : n("");
  }, [e.isEditing]);
  const o = (i) => {
    n(i), e.onChange && e.onChange(+i / 100);
  };
  return e.isEditing ? /* @__PURE__ */ L("div", { className: "overflow-x-hidden text-ellipsis relative w-full", children: [
    /* @__PURE__ */ L("div", { className: "flex gap-2 absolute inset-0", children: [
      /* @__PURE__ */ h(
        "input",
        {
          value: t,
          type: "number",
          className: "bg-transparent outline-none disable-stepper shrink min-w-0",
          step: 0.01,
          autoFocus: !0,
          onInput: (i) => o(i.currentTarget.value)
        }
      ),
      /* @__PURE__ */ h("div", { className: "grow", children: "%" })
    ] }),
    " "
  ] }) : /* @__PURE__ */ h(Mr, { ...e });
}
function WV(e) {
  return /* @__PURE__ */ h(Oe, { children: /* @__PURE__ */ h("td", { ...e, className: `${e.className ?? ""} overflow-hidden text-ellipsis whitespace-nowrap`, children: e.children }) });
}
function zV(e) {
  return e.value;
}
function jV(e) {
  const t = (n) => {
  };
  return /* @__PURE__ */ h("div", { role: "button", className: "p-1", onClick: () => t(e.column), children: /* @__PURE__ */ h(mx, { className: "size-3" }) });
}
function HV({
  direction: e,
  column: t,
  hooks: n,
  state: r
}) {
  return /* @__PURE__ */ h("div", { role: "button", className: "p-1", onClick: () => {
  }, children: /* @__PURE__ */ h(e === 1 ? px : gx, { className: "size-3", color: "gray" }) });
}
function UV({ column: e, sort: t, onSort: n }) {
  const r = e.key === (t == null ? void 0 : t.field), o = (t == null ? void 0 : t.order) === "asc";
  return /* @__PURE__ */ h(Oe, { children: n && /* @__PURE__ */ h("div", { role: "button", className: "p-1", onClick: () => {
    n && n(r && !o ? void 0 : { field: e.key, order: r && o ? "desc" : "asc" });
  }, children: /* @__PURE__ */ h(t ? r ? o ? vx : yx : gf : gf, { className: "size-3", color: r ? "black" : "gray" }) }) });
}
function YV(e) {
  const t = e.state.lockedColumns.includes(e.column.key), n = (r) => {
    t ? e.hooks.unlockColumns([r.key]) : e.hooks.lockColumns([r.key]);
  };
  return /* @__PURE__ */ h("div", { role: "button", className: "p-1", onClick: () => n(e.column), children: t ? /* @__PURE__ */ h(bx, { className: "size-3" }) : /* @__PURE__ */ h(wx, { className: "size-3" }) });
}
const z1 = ({ checkboxProps: e, labelProps: t, hasChildren: n }) => {
  const r = () => {
    if (n)
      return /* @__PURE__ */ h(so, { className: "text-input-active -mr-2 peer-disabled:text-input-active/50" });
  };
  return /* @__PURE__ */ L(
    "div",
    {
      "aria-checked": !!e.checked || void 0,
      onClick: t.onOpenChange,
      className: "flex z-10 justify-between group w-full p-2 bg-table-bg border-b border-neutral-borders hover:bg-filters-hover items-center gap-2 has-[:disabled]:border-neutral-borders/50 aria-[checked]:bg-table-primary-highlight",
      children: [
        /* @__PURE__ */ L("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ h(td, { ...e }),
          /* @__PURE__ */ h("label", { className: "text-md text-input-text font-medium leading-6 peer-disabled:cursor-not-allowed peer-disabled:opacity-50", children: t.label })
        ] }),
        r()
      ]
    }
  );
}, Xv = ({
  nodes: e,
  ancestors: t,
  handleCheckboxChange: n,
  depth: r,
  useAutoWidth: o
}) => {
  var u;
  const [i, s] = ue(), a = e.find(({ id: d }) => d === i), l = o ? {
    width: `${100 / r}%`
  } : {}, c = r !== t.length + 1;
  return /* @__PURE__ */ L(Oe, { children: [
    /* @__PURE__ */ h("div", { className: He("flex flex-col border-neutral-borders h-full", { "border-r": c }), style: l, children: /* @__PURE__ */ h("div", { className: "overflow-y-auto pretty-scrollbar grow h-0", children: e.map((d, f) => {
      const { id: m, label: p, checked: g, childrenNodes: y, disabled: b } = d;
      return /* @__PURE__ */ h(
        z1,
        {
          checkboxProps: { checked: g, onClick: (w) => {
            w.stopPropagation(), n({ node: d, ancestors: t });
          }, disabled: b },
          labelProps: { id: m, label: p, onOpenChange: () => s(m) },
          hasChildren: !!(y != null && y.length)
        },
        f
      );
    }) }) }),
    !!((u = a == null ? void 0 : a.childrenNodes) != null && u.length) && /* @__PURE__ */ h(
      Xv,
      {
        depth: r,
        useAutoWidth: o,
        nodes: a.childrenNodes,
        handleCheckboxChange: n,
        ancestors: [...t, a.id]
      }
    )
  ] });
};
var j1 = Object.defineProperty, ma = (e, t) => j1(e, "name", { value: t, configurable: !0 }), rd = "RovingFocusGroup", [GV, KV, H1] = /* @__PURE__ */ wi(rd), [U1, qv] = /* @__PURE__ */ It(
  rd,
  [H1]
), [XV, qV] = U1(rd), Y1 = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Qv(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
ma(Qv, "getDirectionAwareKey");
function G1(e, t, n) {
  const r = Qv(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return Y1[r];
}
ma(G1, "getFocusIntent");
function K1(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
ma(K1, "focusFirst");
function X1(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
ma(X1, "wrapArray");
var q1 = Object.defineProperty, cn = (e, t) => q1(e, "name", { value: t, configurable: !0 }), pa = "Menu", [QV, ZV, Q1] = /* @__PURE__ */ wi(pa), [Ir, Zv] = /* @__PURE__ */ It(pa, [
  Q1,
  tr,
  qv
]);
tr();
qv();
var [JV, eB] = Ir(pa), [tB, nB] = Ir(pa), Z1 = "MenuPortal", [rB, oB] = Ir(Z1, {
  forceMount: void 0
}), J1 = "MenuContent", [iB, sB] = Ir(J1), ek = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ cn(function(t, n) {
    const { __scopeMenu: r, ...o } = t;
    return /* @__PURE__ */ h(me.div, { ...o, ref: n });
  }, "MenuLabel")
), tk = "MenuRadioGroup", [aB, lB] = Ir(
  tk,
  { value: void 0, onValueChange: /* @__PURE__ */ cn(() => {
  }, "onValueChange") }
), nk = "MenuItemIndicator", [cB, uB] = Ir(
  nk,
  { checked: !1 }
), rk = "MenuSub", [dB, fB] = Ir(rk);
function ok(e) {
  return e ? "open" : "closed";
}
cn(ok, "getOpenState");
function Jv(e) {
  return e === "indeterminate";
}
cn(Jv, "isIndeterminate");
function ik(e) {
  return Jv(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
cn(ik, "getCheckedState");
function sk(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
cn(sk, "focusFirst");
function ey(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
cn(ey, "wrapArray");
function ak(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((c) => c === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let s = ey(e, Math.max(i, 0));
  o.length === 1 && (s = s.filter((c) => c !== n));
  const l = s.find(
    (c) => c.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
cn(ak, "getNextMatch");
function ty(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let i = 0, s = t.length - 1; i < t.length; s = i++) {
    const a = t[i], l = t[s], c = a.x, u = a.y, d = l.x, f = l.y;
    u > r != f > r && n < (d - c) * (r - u) / (f - u) + c && (o = !o);
  }
  return o;
}
cn(ty, "isPointInPolygon");
function lk(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return ty(n, t);
}
cn(lk, "isPointerInGraceArea");
function ck(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
cn(ck, "whenMouse");
var uk = Object.defineProperty, dk = (e, t) => uk(e, "name", { value: t, configurable: !0 }), ny = "DropdownMenu", [fk, hB] = /* @__PURE__ */ It(
  ny,
  [Zv]
), hk = Zv(), [mB, pB] = fk(ny), mk = /* @__PURE__ */ v.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ dk(function(t, n) {
    const { __scopeDropdownMenu: r, ...o } = t, i = hk(r);
    return /* @__PURE__ */ h(ek, { ...i, ...o, ref: n });
  }, "DropdownMenuLabel")
);
const pk = (e, t) => {
  const n = oe();
  return Fe(
    (...r) => {
      const o = () => {
        clearTimeout(n.current), e(...r);
      };
      clearTimeout(n.current), n.current = setTimeout(o, t);
    },
    [e, t]
  );
}, ry = (e) => !e || e.length === 0 ? 0 : 1 + Math.max(...e.map(({ childrenNodes: t }) => ry(t))), gk = ({ value: e, id: t, ancestors: n }) => {
  if (!n.length)
    return e.find((o) => o.id === t);
  let r;
  return n.forEach((o) => {
    r && r.childrenNodes ? r = r.childrenNodes.find((i) => i.id === o) : r = e.find((i) => i.id === o);
  }), r.childrenNodes.find((o) => o.id === t);
}, vk = ({ value: e, ancestors: t }) => {
  if (!t.length)
    return;
  const n = [];
  t.forEach((r) => {
    const o = n.length ? n[0].childrenNodes : e;
    if (o) {
      const i = o.find((s) => s.id === r);
      i && n.unshift(i);
    }
  }), n.forEach((r) => {
    var o, i;
    (o = r == null ? void 0 : r.childrenNodes) != null && o.every((s) => s.checked === !0) ? r.checked = !0 : (i = r == null ? void 0 : r.childrenNodes) != null && i.every((s) => !s.checked) ? r.checked = !1 : r.checked = "indeterminate";
  });
}, oy = (e) => {
  const t = e.checked;
  e.childrenNodes && e.childrenNodes.forEach((n) => {
    n.disabled || (n.checked = t, oy(n));
  });
}, iy = ({ node: e, search: t }) => {
  var r;
  if (!((r = e.childrenNodes) != null && r.length))
    return e.label.toLowerCase().includes(t.toLowerCase()) ? e : void 0;
  const n = e.childrenNodes.map((o) => iy({ node: o, search: t })).filter(Boolean);
  return n.length ? { ...e, childrenNodes: n } : void 0;
}, yk = (e) => ["indeterminate", !1].includes(e) || !1, bk = (e) => {
  var t, n;
  e.checked = ((t = e.childrenNodes) == null ? void 0 : t.every(({ checked: r }) => r === !0)) || !1, !e.checked && ((n = e.childrenNodes) != null && n.some(({ checked: r }) => [!0, "indeterminate"].includes(r))) && (e.checked = "indeterminate");
}, sy = ({
  filteredNodes: e,
  fullNodes: t,
  checked: n
}) => {
  e.forEach(({ id: r, childrenNodes: o }) => {
    var s;
    const i = t.find((a) => a.id === r);
    i && (o != null && o.length && ((s = i.childrenNodes) != null && s.length) ? (sy({
      filteredNodes: o,
      fullNodes: i.childrenNodes,
      checked: n
    }), bk(i)) : i.disabled || (i.checked = n));
  });
}, ay = ({ value: e = [], onChange: t, error: n, useAutoWidth: r }) => {
  const [o, i] = ue(""), s = pe(() => o ? Bt(e, (u) => (u = u.map((f) => iy({ node: f, search: o })).filter(Boolean), u)) : e, [e, o]), a = ({ node: { id: u, disabled: d }, ancestors: f }) => {
    if (!d) {
      const m = Bt(e, (p) => {
        const g = gk({
          value: p,
          id: u,
          ancestors: f
        });
        g.checked = yk(g.checked), oy(g), vk({ value: p, ancestors: f });
      });
      t(m);
    }
  }, l = (u) => {
    const d = Bt(e, (f) => {
      sy({
        filteredNodes: s,
        fullNodes: f,
        checked: u
      });
    });
    t(d);
  }, c = pk(({ target: { value: u } }) => {
    i(u);
  }, 500);
  return /* @__PURE__ */ L("div", { className: "flex flex-col h-full mb-4", children: [
    /* @__PURE__ */ L("div", { className: "flex align-end items-center justify-between mb-2", children: [
      /* @__PURE__ */ h(qu, { label: "Search", onChange: c }),
      /* @__PURE__ */ L("div", { className: "grow flex flex-row text-button-primary-outline-default space-x-2 text-sm justify-end", children: [
        /* @__PURE__ */ h(ke, { onClick: () => l(!0), variant: "ghost", children: "Select all" }),
        /* @__PURE__ */ h(Qo, { orientation: "vertical", className: "h-auto" }),
        /* @__PURE__ */ h(ke, { onClick: () => l(!1), variant: "ghost", children: "Deselect all" })
      ] })
    ] }),
    /* @__PURE__ */ h(
      "div",
      {
        "aria-errormessage": n || void 0,
        className: "grow flex flex-col border border-neutral-border rounded-md overflow-hidden aria-[errormessage]:border-red-500",
        children: /* @__PURE__ */ h("div", { className: "flex grow", children: /* @__PURE__ */ h(
          Xv,
          {
            depth: ry(e),
            useAutoWidth: r,
            nodes: s,
            ancestors: [],
            handleCheckboxChange: a
          }
        ) })
      }
    ),
    n && /* @__PURE__ */ h(
      mk,
      {
        "aria-errormessage": n,
        className: "block z-10 text-xs aria-disabled:text-neutral-text-secondary/50 text-red-500 aria-disabled:text-red-500/50",
        children: n
      }
    )
  ] });
}, ly = (e) => {
  switch (e) {
    case "large":
      return "min-h-[32rem]";
    case "medium":
      return "min-h-[24rem]";
    case "small":
    default:
      return "min-h-[16rem]";
  }
}, wk = [B1, W1, Ds], xk = (e) => {
  var t;
  return [(t = e.group) == null ? void 0 : t.map((n) => n.label), e.name].filter(Boolean).join(" > ");
}, Sk = ({ columns: e, value: t, onChange: n, size: r }) => {
  const o = pe(() => e.filter((a) => !a.readOnly && wk.includes(a.component)).map((a) => ({
    id: a.key,
    label: xk(a)
  })), [e]), i = pe(() => o.map((a) => ({
    ...a,
    checked: t.includes(a.id)
  })), [o, t]), s = (a) => {
    const l = a.filter((c) => c.checked === !0).map((c) => c.id);
    n(l);
  };
  return /* @__PURE__ */ L("div", { className: `p-2 py-4 ${ly(r)}`, children: [
    /* @__PURE__ */ h("div", { className: "text-neutral-text-primary font-bold text-xl pb-2", children: "Columns" }),
    /* @__PURE__ */ h(ay, { value: i, onChange: s, useAutoWidth: !0 })
  ] });
}, Ck = ({
  column: e,
  value: t,
  onChange: n,
  table: r,
  size: o,
  sortValuesByLookupLabel: i = !1,
  customOrder: s
}) => {
  const a = pe(() => {
    if (!r) return [];
    const d = r.select([e.key]).dedupe().array(e.key).map((f) => ({
      id: f,
      label: co(f, e.lookup, e.mask)
    }));
    return s && s.length ? [...d].sort((f, m) => {
      const p = s.indexOf(f.id), g = s.indexOf(m.id);
      return (p === -1 ? Number.MAX_SAFE_INTEGER : p) - (g === -1 ? Number.MAX_SAFE_INTEGER : g);
    }) : i ? [...d].sort(
      (f, m) => f.label.localeCompare(m.label, void 0, { sensitivity: "base", numeric: !0 })
    ) : d;
  }, [r, e.key, e.lookup, e.mask, i, s]), l = pe(() => a.map((u) => ({
    ...u,
    checked: t.includes(u.id)
  })), [a, t]), c = (u) => {
    const d = u.filter((f) => f.checked === !0).map((f) => f.id);
    n(d);
  };
  return /* @__PURE__ */ L("div", { className: `p-2 py-4 ${ly(o)}`, children: [
    /* @__PURE__ */ h("div", { className: "text-neutral-text-primary font-bold text-xl pb-2", children: e.name }),
    /* @__PURE__ */ h(ay, { value: l, onChange: c, useAutoWidth: !0 })
  ] });
}, ch = (e) => {
  const t = e.size ? `input-${e.size}` : "input-md";
  return /* @__PURE__ */ h(Gt, { label: e.label, error: e.error, disabled: e.disabled, className: e.className, children: /* @__PURE__ */ L(sa, { ...e, children: [
    /* @__PURE__ */ h(
      aa,
      {
        "aria-errormessage": e.error,
        className: He("w-full0 border-0 data-[state=open]:[&>svg]:text-red-500", t),
        children: /* @__PURE__ */ h(Hu, { placeholder: e.placeholder || "" })
      }
    ),
    /* @__PURE__ */ h(la, { children: /* @__PURE__ */ h(Cv, { children: e.options.map(({ value: n, label: r }) => /* @__PURE__ */ h(ca, { value: n, children: r }, n)) }) })
  ] }) });
};
function Tk(e) {
  if (typeof document > "u") return;
  let t = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
  n.type = "text/css", t.appendChild(n), n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e));
}
const cy = Z.createContext({
  drawerRef: {
    current: null
  },
  overlayRef: {
    current: null
  },
  onPress: () => {
  },
  onRelease: () => {
  },
  onDrag: () => {
  },
  onNestedDrag: () => {
  },
  onNestedOpenChange: () => {
  },
  onNestedRelease: () => {
  },
  openProp: void 0,
  dismissible: !1,
  isOpen: !1,
  isDragging: !1,
  keyboardIsOpen: {
    current: !1
  },
  snapPointsOffset: null,
  snapPoints: null,
  handleOnly: !1,
  modal: !1,
  shouldFade: !1,
  activeSnapPoint: null,
  onOpenChange: () => {
  },
  setActiveSnapPoint: () => {
  },
  closeDrawer: () => {
  },
  direction: "bottom",
  shouldScaleBackground: !1,
  setBackgroundColorOnScale: !0,
  noBodyStyles: !1,
  container: null,
  autoFocus: !1
}), Pi = () => {
  const e = Z.useContext(cy);
  if (!e)
    throw new Error("useDrawerContext must be used within a Drawer.Root");
  return e;
};
Tk(`[data-vaul-drawer]{touch-action:none;will-change:transform;transition:transform .5s cubic-bezier(.32, .72, 0, 1);animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=open]{animation-name:slideFromBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=closed]{animation-name:slideToBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=open]{animation-name:slideFromTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=closed]{animation-name:slideToTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=open]{animation-name:slideFromLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=closed]{animation-name:slideToLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=open]{animation-name:slideFromRight}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=closed]{animation-name:slideToRight}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,100%,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,-100%,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(-100%,0,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(100%,0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-overlay][data-vaul-snap-points=false]{animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-overlay][data-vaul-snap-points=false][data-state=open]{animation-name:fadeIn}[data-vaul-overlay][data-state=closed]{animation-name:fadeOut}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:0;transition:opacity .5s cubic-bezier(.32, .72, 0, 1)}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:1}[data-vaul-drawer]:not([data-vaul-custom-container=true])::after{content:'';position:absolute;background:inherit;background-color:inherit}[data-vaul-drawer][data-vaul-drawer-direction=top]::after{top:initial;bottom:100%;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=bottom]::after{top:100%;bottom:initial;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=left]::after{left:initial;right:100%;top:0;bottom:0;width:200%}[data-vaul-drawer][data-vaul-drawer-direction=right]::after{left:100%;right:initial;top:0;bottom:0;width:200%}[data-vaul-overlay][data-vaul-snap-points=true]:not([data-vaul-snap-points-overlay=true]):not(
[data-state=closed]
){opacity:0}[data-vaul-overlay][data-vaul-snap-points-overlay=true]{opacity:1}[data-vaul-handle]{display:block;position:relative;opacity:.7;background:#e2e2e4;margin-left:auto;margin-right:auto;height:5px;width:32px;border-radius:1rem;touch-action:pan-y}[data-vaul-handle]:active,[data-vaul-handle]:hover{opacity:1}[data-vaul-handle-hitarea]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:max(100%,2.75rem);height:max(100%,2.75rem);touch-action:inherit}@media (hover:hover) and (pointer:fine){[data-vaul-drawer]{user-select:none}}@media (pointer:fine){[data-vaul-handle-hitarea]:{width:100%;height:100%}}@keyframes fadeIn{from{opacity:0}to{opacity:1}}@keyframes fadeOut{to{opacity:0}}@keyframes slideFromBottom{from{transform:translate3d(0,100%,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToBottom{to{transform:translate3d(0,100%,0)}}@keyframes slideFromTop{from{transform:translate3d(0,-100%,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToTop{to{transform:translate3d(0,-100%,0)}}@keyframes slideFromLeft{from{transform:translate3d(-100%,0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToLeft{to{transform:translate3d(-100%,0,0)}}@keyframes slideFromRight{from{transform:translate3d(100%,0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToRight{to{transform:translate3d(100%,0,0)}}`);
const Pk = 24, Ek = typeof window < "u" ? Dr : de;
function uh(...e) {
  return (...t) => {
    for (let n of e)
      typeof n == "function" && n(...t);
  };
}
function kk() {
  return od(/^Mac/);
}
function Dk() {
  return od(/^iPhone/);
}
function dh() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function Rk() {
  return od(/^iPad/) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  kk() && navigator.maxTouchPoints > 1;
}
function uy() {
  return Dk() || Rk();
}
function od(e) {
  return typeof window < "u" && window.navigator != null ? e.test(window.navigator.platform) : void 0;
}
const Ya = typeof document < "u" && window.visualViewport;
function fh(e) {
  let t = window.getComputedStyle(e);
  return /(auto|scroll)/.test(t.overflow + t.overflowX + t.overflowY);
}
function dy(e) {
  for (fh(e) && (e = e.parentElement); e && !fh(e); )
    e = e.parentElement;
  return e || document.scrollingElement || document.documentElement;
}
const Mk = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
let qi = 0, Ga;
function Ak(e = {}) {
  let { isDisabled: t } = e;
  Ek(() => {
    if (!t)
      return qi++, qi === 1 && uy() && (Ga = Ok()), () => {
        qi--, qi === 0 && (Ga == null || Ga());
      };
  }, [
    t
  ]);
}
function Ok() {
  let e, t = 0, n = (d) => {
    e = dy(d.target), !(e === document.documentElement && e === document.body) && (t = d.changedTouches[0].pageY);
  }, r = (d) => {
    if (!e || e === document.documentElement || e === document.body) {
      d.preventDefault();
      return;
    }
    let f = d.changedTouches[0].pageY, m = e.scrollTop, p = e.scrollHeight - e.clientHeight;
    p !== 0 && ((m <= 0 && f > t || m >= p && f < t) && d.preventDefault(), t = f);
  }, o = (d) => {
    let f = d.target;
    ic(f) && f !== document.activeElement && (d.preventDefault(), f.style.transform = "translateY(-2000px)", f.focus(), requestAnimationFrame(() => {
      f.style.transform = "";
    }));
  }, i = (d) => {
    let f = d.target;
    ic(f) && (f.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      f.style.transform = "", Ya && (Ya.height < window.innerHeight ? requestAnimationFrame(() => {
        hh(f);
      }) : Ya.addEventListener("resize", () => hh(f), {
        once: !0
      }));
    }));
  }, s = () => {
    window.scrollTo(0, 0);
  }, a = window.pageXOffset, l = window.pageYOffset, c = uh(Nk(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`));
  window.scrollTo(0, 0);
  let u = uh(Mo(document, "touchstart", n, {
    passive: !1,
    capture: !0
  }), Mo(document, "touchmove", r, {
    passive: !1,
    capture: !0
  }), Mo(document, "touchend", o, {
    passive: !1,
    capture: !0
  }), Mo(document, "focus", i, !0), Mo(window, "scroll", s));
  return () => {
    c(), u(), window.scrollTo(a, l);
  };
}
function Nk(e, t, n) {
  let r = e.style[t];
  return e.style[t] = n, () => {
    e.style[t] = r;
  };
}
function Mo(e, t, n, r) {
  return e.addEventListener(t, n, r), () => {
    e.removeEventListener(t, n, r);
  };
}
function hh(e) {
  let t = document.scrollingElement || document.documentElement;
  for (; e && e !== t; ) {
    let n = dy(e);
    if (n !== document.documentElement && n !== document.body && n !== e) {
      let r = n.getBoundingClientRect().top, o = e.getBoundingClientRect().top, i = e.getBoundingClientRect().bottom;
      const s = n.getBoundingClientRect().bottom + Pk;
      i > s && (n.scrollTop += o - r);
    }
    e = n.parentElement;
  }
}
function ic(e) {
  return e instanceof HTMLInputElement && !Mk.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
}
function _k(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Ik(...e) {
  return (t) => e.forEach((n) => _k(n, t));
}
function fy(...e) {
  return v.useCallback(Ik(...e), e);
}
const hy = /* @__PURE__ */ new WeakMap();
function it(e, t, n = !1) {
  if (!e || !(e instanceof HTMLElement)) return;
  let r = {};
  Object.entries(t).forEach(([o, i]) => {
    if (o.startsWith("--")) {
      e.style.setProperty(o, i);
      return;
    }
    r[o] = e.style[o], e.style[o] = i;
  }), !n && hy.set(e, r);
}
function Lk(e, t) {
  if (!e || !(e instanceof HTMLElement)) return;
  let n = hy.get(e);
  n && (e.style[t] = n[t]);
}
const at = (e) => {
  switch (e) {
    case "top":
    case "bottom":
      return !0;
    case "left":
    case "right":
      return !1;
    default:
      return e;
  }
};
function Qi(e, t) {
  if (!e)
    return null;
  const n = window.getComputedStyle(e), r = (
    // @ts-ignore
    n.transform || n.webkitTransform || n.mozTransform
  );
  let o = r.match(/^matrix3d\((.+)\)$/);
  return o ? parseFloat(o[1].split(", ")[at(t) ? 13 : 12]) : (o = r.match(/^matrix\((.+)\)$/), o ? parseFloat(o[1].split(", ")[at(t) ? 5 : 4]) : null);
}
function $k(e) {
  return 8 * (Math.log(e + 1) - 2);
}
function Ka(e, t) {
  if (!e) return () => {
  };
  const n = e.style.cssText;
  return Object.assign(e.style, t), () => {
    e.style.cssText = n;
  };
}
function Fk(...e) {
  return (...t) => {
    for (const n of e)
      typeof n == "function" && n(...t);
  };
}
const Ge = {
  DURATION: 0.5,
  EASE: [
    0.32,
    0.72,
    0,
    1
  ]
}, my = 0.4, Vk = 0.25, Bk = 100, py = 8, ir = 16, sc = 26, Xa = "vaul-dragging";
function gy(e) {
  const t = Z.useRef(e);
  return Z.useEffect(() => {
    t.current = e;
  }), Z.useMemo(() => (...n) => t.current == null ? void 0 : t.current.call(t, ...n), []);
}
function Wk({ defaultProp: e, onChange: t }) {
  const n = Z.useState(e), [r] = n, o = Z.useRef(r), i = gy(t);
  return Z.useEffect(() => {
    o.current !== r && (i(r), o.current = r);
  }, [
    r,
    o,
    i
  ]), n;
}
function vy({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = Wk({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, s = i ? e : r, a = gy(n), l = Z.useCallback((c) => {
    if (i) {
      const d = typeof c == "function" ? c(e) : c;
      d !== e && a(d);
    } else
      o(c);
  }, [
    i,
    e,
    o,
    a
  ]);
  return [
    s,
    l
  ];
}
function zk({ activeSnapPointProp: e, setActiveSnapPointProp: t, snapPoints: n, drawerRef: r, overlayRef: o, fadeFromIndex: i, onSnapPointChange: s, direction: a = "bottom", container: l, snapToSequentialPoint: c }) {
  const [u, d] = vy({
    prop: e,
    defaultProp: n == null ? void 0 : n[0],
    onChange: t
  }), [f, m] = Z.useState(typeof window < "u" ? {
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight
  } : void 0);
  Z.useEffect(() => {
    function T() {
      m({
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
      });
    }
    return window.addEventListener("resize", T), () => window.removeEventListener("resize", T);
  }, []);
  const p = Z.useMemo(() => u === (n == null ? void 0 : n[n.length - 1]) || null, [
    n,
    u
  ]), g = Z.useMemo(() => n == null ? void 0 : n.findIndex((T) => T === u), [
    n,
    u
  ]), y = n && n.length > 0 && (i || i === 0) && !Number.isNaN(i) && n[i] === u || !n, b = Z.useMemo(() => {
    const T = l ? {
      width: l.getBoundingClientRect().width,
      height: l.getBoundingClientRect().height
    } : typeof window < "u" ? {
      width: window.innerWidth,
      height: window.innerHeight
    } : {
      width: 0,
      height: 0
    };
    var P;
    return (P = n == null ? void 0 : n.map((D) => {
      const k = typeof D == "string";
      let R = 0;
      if (k && (R = parseInt(D, 10)), at(a)) {
        const _ = k ? R : f ? D * T.height : 0;
        return f ? a === "bottom" ? T.height - _ : -T.height + _ : _;
      }
      const O = k ? R : f ? D * T.width : 0;
      return f ? a === "right" ? T.width - O : -T.width + O : O;
    })) != null ? P : [];
  }, [
    n,
    f,
    l
  ]), x = Z.useMemo(() => g !== null ? b == null ? void 0 : b[g] : null, [
    b,
    g
  ]), w = Z.useCallback((T) => {
    var P;
    const D = (P = b == null ? void 0 : b.findIndex((k) => k === T)) != null ? P : null;
    s(D), it(r.current, {
      transition: `transform ${Ge.DURATION}s cubic-bezier(${Ge.EASE.join(",")})`,
      transform: at(a) ? `translate3d(0, ${T}px, 0)` : `translate3d(${T}px, 0, 0)`
    }), b && D !== b.length - 1 && D !== i && D < i ? it(o.current, {
      transition: `opacity ${Ge.DURATION}s cubic-bezier(${Ge.EASE.join(",")})`,
      opacity: "0"
    }) : it(o.current, {
      transition: `opacity ${Ge.DURATION}s cubic-bezier(${Ge.EASE.join(",")})`,
      opacity: "1"
    }), d(n == null ? void 0 : n[Math.max(D, 0)]);
  }, [
    r.current,
    n,
    b,
    i,
    o,
    d
  ]);
  Z.useEffect(() => {
    if (u || e) {
      var T;
      const P = (T = n == null ? void 0 : n.findIndex((D) => D === e || D === u)) != null ? T : -1;
      b && P !== -1 && typeof b[P] == "number" && w(b[P]);
    }
  }, [
    u,
    e,
    n,
    b,
    w
  ]);
  function S({ draggedDistance: T, closeDrawer: P, velocity: D, dismissible: k }) {
    if (i === void 0) return;
    const R = a === "bottom" || a === "right" ? (x ?? 0) - T : (x ?? 0) + T, O = g === i - 1, _ = g === 0, $ = T > 0;
    if (O && it(o.current, {
      transition: `opacity ${Ge.DURATION}s cubic-bezier(${Ge.EASE.join(",")})`
    }), !c && D > 2 && !$) {
      k ? P() : w(b[0]);
      return;
    }
    if (!c && D > 2 && $ && b && n) {
      w(b[n.length - 1]);
      return;
    }
    const z = b == null ? void 0 : b.reduce((A, M) => typeof A != "number" || typeof M != "number" ? A : Math.abs(M - R) < Math.abs(A - R) ? M : A), I = at(a) ? window.innerHeight : window.innerWidth;
    if (D > my && Math.abs(T) < I * 0.4) {
      const A = $ ? 1 : -1;
      if (A > 0 && p) {
        w(b[n.length - 1]);
        return;
      }
      if (_ && A < 0 && k && P(), g === null) return;
      w(b[g + A]);
      return;
    }
    w(z);
  }
  function E({ draggedDistance: T }) {
    if (x === null) return;
    const P = a === "bottom" || a === "right" ? x - T : x + T;
    (a === "bottom" || a === "right") && P < b[b.length - 1] || (a === "top" || a === "left") && P > b[b.length - 1] || it(r.current, {
      transform: at(a) ? `translate3d(0, ${P}px, 0)` : `translate3d(${P}px, 0, 0)`
    });
  }
  function C(T, P) {
    if (!n || typeof g != "number" || !b || i === void 0) return null;
    const D = g === i - 1;
    if (g >= i && P)
      return 0;
    if (D && !P) return 1;
    if (!y && !D) return null;
    const R = D ? g + 1 : g - 1, O = D ? b[R] - b[R - 1] : b[R + 1] - b[R], _ = T / Math.abs(O);
    return D ? 1 - _ : _;
  }
  return {
    isLastSnapPoint: p,
    activeSnapPoint: u,
    shouldFade: y,
    getPercentageDragged: C,
    setActiveSnapPoint: d,
    activeSnapPointIndex: g,
    onRelease: S,
    onDrag: E,
    snapPointsOffset: b
  };
}
const jk = () => () => {
};
function Hk() {
  const { direction: e, isOpen: t, shouldScaleBackground: n, setBackgroundColorOnScale: r, noBodyStyles: o } = Pi(), i = Z.useRef(null), s = pe(() => document.body.style.backgroundColor, []);
  function a() {
    return (window.innerWidth - sc) / window.innerWidth;
  }
  Z.useEffect(() => {
    if (t && n) {
      i.current && clearTimeout(i.current);
      const l = document.querySelector("[data-vaul-drawer-wrapper]") || document.querySelector("[vaul-drawer-wrapper]");
      if (!l) return;
      Fk(r && !o ? Ka(document.body, {
        background: "black"
      }) : jk, Ka(l, {
        transformOrigin: at(e) ? "top" : "left",
        transitionProperty: "transform, border-radius",
        transitionDuration: `${Ge.DURATION}s`,
        transitionTimingFunction: `cubic-bezier(${Ge.EASE.join(",")})`
      }));
      const c = Ka(l, {
        borderRadius: `${py}px`,
        overflow: "hidden",
        ...at(e) ? {
          transform: `scale(${a()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`
        } : {
          transform: `scale(${a()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`
        }
      });
      return () => {
        c(), i.current = window.setTimeout(() => {
          s ? document.body.style.background = s : document.body.style.removeProperty("background");
        }, Ge.DURATION * 1e3);
      };
    }
  }, [
    t,
    n,
    s
  ]);
}
let Ao = null;
function Uk({ isOpen: e, modal: t, nested: n, hasBeenOpened: r, preventScrollRestoration: o, noBodyStyles: i }) {
  const [s, a] = Z.useState(() => typeof window < "u" ? window.location.href : ""), l = Z.useRef(0), c = Z.useCallback(() => {
    if (dh() && Ao === null && e && !i) {
      Ao = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        height: document.body.style.height,
        right: "unset"
      };
      const { scrollX: d, innerHeight: f } = window;
      document.body.style.setProperty("position", "fixed", "important"), Object.assign(document.body.style, {
        top: `${-l.current}px`,
        left: `${-d}px`,
        right: "0px",
        height: "auto"
      }), window.setTimeout(() => window.requestAnimationFrame(() => {
        const m = f - window.innerHeight;
        m && l.current >= f && (document.body.style.top = `${-(l.current + m)}px`);
      }), 300);
    }
  }, [
    e
  ]), u = Z.useCallback(() => {
    if (dh() && Ao !== null && !i) {
      const d = -parseInt(document.body.style.top, 10), f = -parseInt(document.body.style.left, 10);
      Object.assign(document.body.style, Ao), window.requestAnimationFrame(() => {
        if (o && s !== window.location.href) {
          a(window.location.href);
          return;
        }
        window.scrollTo(f, d);
      }), Ao = null;
    }
  }, [
    s
  ]);
  return Z.useEffect(() => {
    function d() {
      l.current = window.scrollY;
    }
    return d(), window.addEventListener("scroll", d), () => {
      window.removeEventListener("scroll", d);
    };
  }, []), Z.useEffect(() => {
    n || !r || (e ? (!window.matchMedia("(display-mode: standalone)").matches && c(), t || window.setTimeout(() => {
      u();
    }, 500)) : u());
  }, [
    e,
    r,
    s,
    t,
    n,
    c,
    u
  ]), {
    restorePositionSetting: u
  };
}
function Yk({ open: e, onOpenChange: t, children: n, onDrag: r, onRelease: o, snapPoints: i, shouldScaleBackground: s = !1, setBackgroundColorOnScale: a = !0, closeThreshold: l = Vk, scrollLockTimeout: c = Bk, dismissible: u = !0, handleOnly: d = !1, fadeFromIndex: f = i && i.length - 1, activeSnapPoint: m, setActiveSnapPoint: p, fixed: g, modal: y = !0, onClose: b, nested: x, noBodyStyles: w, direction: S = "bottom", defaultOpen: E = !1, disablePreventScroll: C = !0, snapToSequentialPoint: T = !1, preventScrollRestoration: P = !1, repositionInputs: D = !0, onAnimationEnd: k, container: R, autoFocus: O = !1 }) {
  var _, $;
  const [z = !1, I] = vy({
    defaultProp: E,
    prop: e,
    onChange: (le) => {
      t == null || t(le), !le && !x && pt(), setTimeout(() => {
        k == null || k(le);
      }, Ge.DURATION * 1e3), le && !y && typeof window < "u" && window.requestAnimationFrame(() => {
        document.body.style.pointerEvents = "auto";
      }), le || (document.body.style.pointerEvents = "auto");
    }
  }), [A, M] = Z.useState(!1), [F, W] = Z.useState(!1), [ne, N] = Z.useState(!1), Y = Z.useRef(null), H = Z.useRef(null), U = Z.useRef(null), fe = Z.useRef(null), ge = Z.useRef(null), X = Z.useRef(!1), se = Z.useRef(null), ee = Z.useRef(0), xe = Z.useRef(!1), ye = Z.useRef(0), G = Z.useRef(null), mt = Z.useRef(((_ = G.current) == null ? void 0 : _.getBoundingClientRect().height) || 0), ut = Z.useRef((($ = G.current) == null ? void 0 : $.getBoundingClientRect().width) || 0), Dt = Z.useRef(0), Zt = Z.useCallback((le) => {
    i && le === B.length - 1 && (H.current = /* @__PURE__ */ new Date());
  }, []), { activeSnapPoint: dn, activeSnapPointIndex: fn, setActiveSnapPoint: V, onRelease: q, snapPointsOffset: B, onDrag: ie, shouldFade: he, getPercentageDragged: Ue } = zk({
    snapPoints: i,
    activeSnapPointProp: m,
    setActiveSnapPointProp: p,
    drawerRef: G,
    fadeFromIndex: f,
    overlayRef: Y,
    onSnapPointChange: Zt,
    direction: S,
    container: R,
    snapToSequentialPoint: T
  });
  Ak({
    isDisabled: !z || F || !y || ne || !A || !D || !C
  });
  const { restorePositionSetting: pt } = Uk({
    isOpen: z,
    modal: y,
    nested: x,
    hasBeenOpened: A,
    preventScrollRestoration: P,
    noBodyStyles: w
  });
  function dt() {
    return (window.innerWidth - sc) / window.innerWidth;
  }
  function ae(le) {
    var Se, Ie;
    !u && !i || G.current && !G.current.contains(le.target) || (mt.current = ((Se = G.current) == null ? void 0 : Se.getBoundingClientRect().height) || 0, ut.current = ((Ie = G.current) == null ? void 0 : Ie.getBoundingClientRect().width) || 0, W(!0), U.current = /* @__PURE__ */ new Date(), uy() && window.addEventListener("touchend", () => X.current = !1, {
      once: !0
    }), le.target.setPointerCapture(le.pointerId), ee.current = at(S) ? le.pageY : le.pageX);
  }
  function Me(le, Se) {
    var Ie, Le;
    let De = le;
    const gt = (Ie = window.getSelection()) == null ? void 0 : Ie.toString(), ot = G.current ? Qi(G.current, S) : null, vt = /* @__PURE__ */ new Date();
    if (De.hasAttribute("data-vaul-no-drag") || De.closest("[data-vaul-no-drag]"))
      return !1;
    if (S === "right" || S === "left")
      return !0;
    if (H.current && vt.getTime() - H.current.getTime() < 500)
      return !1;
    if (ot !== null && (S === "bottom" ? ot > 0 : ot < 0))
      return !0;
    if (gt && gt.length > 0)
      return !1;
    if (vt.getTime() - ((Le = ge.current) == null ? void 0 : Le.getTime()) < c && ot === 0 || Se)
      return ge.current = vt, !1;
    for (; De; ) {
      if (De.scrollHeight > De.clientHeight) {
        if (De.scrollTop !== 0)
          return ge.current = /* @__PURE__ */ new Date(), !1;
        if (De.getAttribute("role") === "dialog")
          return !0;
      }
      De = De.parentNode;
    }
    return !0;
  }
  function Ee(le) {
    if (G.current && F) {
      const Se = S === "bottom" || S === "right" ? 1 : -1, Ie = (ee.current - (at(S) ? le.pageY : le.pageX)) * Se, Le = Ie > 0, De = i && !u && !Le;
      if (De && fn === 0) return;
      const gt = Math.abs(Ie), ot = document.querySelector("[data-vaul-drawer-wrapper]"), vt = S === "bottom" || S === "top" ? mt.current : ut.current;
      let Ft = gt / vt;
      const Jt = Ue(gt, Le);
      if (Jt !== null && (Ft = Jt), De && Ft >= 1 || !X.current && !Me(le.target, Le)) return;
      if (G.current.classList.add(Xa), X.current = !0, it(G.current, {
        transition: "none"
      }), it(Y.current, {
        transition: "none"
      }), i && ie({
        draggedDistance: Ie
      }), Le && !i) {
        const mn = $k(Ie), Vi = Math.min(mn * -1, 0) * Se;
        it(G.current, {
          transform: at(S) ? `translate3d(0, ${Vi}px, 0)` : `translate3d(${Vi}px, 0, 0)`
        });
        return;
      }
      const Rt = 1 - Ft;
      if ((he || f && fn === f - 1) && (r == null || r(le, Ft), it(Y.current, {
        opacity: `${Rt}`,
        transition: "none"
      }, !0)), ot && Y.current && s) {
        const mn = Math.min(dt() + Ft * (1 - dt()), 1), Vi = 8 - Ft * 8, ff = Math.max(0, 14 - Ft * 14);
        it(ot, {
          borderRadius: `${Vi}px`,
          transform: at(S) ? `scale(${mn}) translate3d(0, ${ff}px, 0)` : `scale(${mn}) translate3d(${ff}px, 0, 0)`,
          transition: "none"
        }, !0);
      }
      if (!i) {
        const mn = gt * Se;
        it(G.current, {
          transform: at(S) ? `translate3d(0, ${mn}px, 0)` : `translate3d(${mn}px, 0, 0)`
        });
      }
    }
  }
  Z.useEffect(() => {
    var le;
    function Se() {
      if (!G.current || !D) return;
      const Ie = document.activeElement;
      if (ic(Ie) || xe.current) {
        var Le;
        const De = ((Le = window.visualViewport) == null ? void 0 : Le.height) || 0, gt = window.innerHeight;
        let ot = gt - De;
        const vt = G.current.getBoundingClientRect().height || 0, Ft = vt > gt * 0.8;
        Dt.current || (Dt.current = vt);
        const Jt = G.current.getBoundingClientRect().top;
        if (Math.abs(ye.current - ot) > 60 && (xe.current = !xe.current), i && i.length > 0 && B && fn) {
          const Rt = B[fn] || 0;
          ot += Rt;
        }
        if (ye.current = ot, vt > De || xe.current) {
          const Rt = G.current.getBoundingClientRect().height;
          let mn = Rt;
          Rt > De && (mn = De - (Ft ? Jt : sc)), g ? G.current.style.height = `${Rt - Math.max(ot, 0)}px` : G.current.style.height = `${Math.max(mn, De - Jt)}px`;
        } else
          G.current.style.height = `${Dt.current}px`;
        i && i.length > 0 && !xe.current ? G.current.style.bottom = "0px" : G.current.style.bottom = `${Math.max(ot, 0)}px`;
      }
    }
    return (le = window.visualViewport) == null || le.addEventListener("resize", Se), () => {
      var Ie;
      return (Ie = window.visualViewport) == null ? void 0 : Ie.removeEventListener("resize", Se);
    };
  }, [
    fn,
    i,
    B
  ]);
  function K(le) {
    St(), b == null || b(), le || I(!1), setTimeout(() => {
      i && V(i[0]);
    }, Ge.DURATION * 1e3);
  }
  function j() {
    if (!G.current) return;
    const le = document.querySelector("[data-vaul-drawer-wrapper]"), Se = Qi(G.current, S);
    it(G.current, {
      transform: "translate3d(0, 0, 0)",
      transition: `transform ${Ge.DURATION}s cubic-bezier(${Ge.EASE.join(",")})`
    }), it(Y.current, {
      transition: `opacity ${Ge.DURATION}s cubic-bezier(${Ge.EASE.join(",")})`,
      opacity: "1"
    }), s && Se && Se > 0 && z && it(le, {
      borderRadius: `${py}px`,
      overflow: "hidden",
      ...at(S) ? {
        transform: `scale(${dt()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`,
        transformOrigin: "top"
      } : {
        transform: `scale(${dt()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`,
        transformOrigin: "left"
      },
      transitionProperty: "transform, border-radius",
      transitionDuration: `${Ge.DURATION}s`,
      transitionTimingFunction: `cubic-bezier(${Ge.EASE.join(",")})`
    }, !0);
  }
  function St() {
    !F || !G.current || (G.current.classList.remove(Xa), X.current = !1, W(!1), fe.current = /* @__PURE__ */ new Date());
  }
  function Ve(le) {
    if (!F || !G.current) return;
    G.current.classList.remove(Xa), X.current = !1, W(!1), fe.current = /* @__PURE__ */ new Date();
    const Se = Qi(G.current, S);
    if (!Me(le.target, !1) || !Se || Number.isNaN(Se) || U.current === null) return;
    const Ie = fe.current.getTime() - U.current.getTime(), Le = ee.current - (at(S) ? le.pageY : le.pageX), De = Math.abs(Le) / Ie;
    if (De > 0.05 && (N(!0), setTimeout(() => {
      N(!1);
    }, 200)), i) {
      q({
        draggedDistance: Le * (S === "bottom" || S === "right" ? 1 : -1),
        closeDrawer: K,
        velocity: De,
        dismissible: u
      }), o == null || o(le, !0);
      return;
    }
    if (S === "bottom" || S === "right" ? Le > 0 : Le < 0) {
      j(), o == null || o(le, !0);
      return;
    }
    if (De > my) {
      K(), o == null || o(le, !1);
      return;
    }
    var gt;
    const ot = Math.min((gt = G.current.getBoundingClientRect().height) != null ? gt : 0, window.innerHeight);
    var vt;
    const Ft = Math.min((vt = G.current.getBoundingClientRect().width) != null ? vt : 0, window.innerWidth), Jt = S === "left" || S === "right";
    if (Math.abs(Se) >= (Jt ? Ft : ot) * l) {
      K(), o == null || o(le, !1);
      return;
    }
    o == null || o(le, !0), j();
  }
  Z.useEffect(() => (z && (it(document.documentElement, {
    scrollBehavior: "auto"
  }), H.current = /* @__PURE__ */ new Date()), () => {
    Lk(document.documentElement, "scrollBehavior");
  }), [
    z
  ]);
  function hn(le) {
    const Se = le ? (window.innerWidth - ir) / window.innerWidth : 1, Ie = le ? -ir : 0;
    se.current && window.clearTimeout(se.current), it(G.current, {
      transition: `transform ${Ge.DURATION}s cubic-bezier(${Ge.EASE.join(",")})`,
      transform: `scale(${Se}) translate3d(0, ${Ie}px, 0)`
    }), !le && G.current && (se.current = setTimeout(() => {
      const Le = Qi(G.current, S);
      it(G.current, {
        transition: "none",
        transform: at(S) ? `translate3d(0, ${Le}px, 0)` : `translate3d(${Le}px, 0, 0)`
      });
    }, 500));
  }
  function Fr(le, Se) {
    if (Se < 0) return;
    const Ie = (window.innerWidth - ir) / window.innerWidth, Le = Ie + Se * (1 - Ie), De = -ir + Se * ir;
    it(G.current, {
      transform: at(S) ? `scale(${Le}) translate3d(0, ${De}px, 0)` : `scale(${Le}) translate3d(${De}px, 0, 0)`,
      transition: "none"
    });
  }
  function Fi(le, Se) {
    const Ie = at(S) ? window.innerHeight : window.innerWidth, Le = Se ? (Ie - ir) / Ie : 1, De = Se ? -ir : 0;
    Se && it(G.current, {
      transition: `transform ${Ge.DURATION}s cubic-bezier(${Ge.EASE.join(",")})`,
      transform: at(S) ? `scale(${Le}) translate3d(0, ${De}px, 0)` : `scale(${Le}) translate3d(${De}px, 0, 0)`
    });
  }
  return /* @__PURE__ */ Z.createElement(vg, {
    defaultOpen: E,
    onOpenChange: (le) => {
      !u && !le || (le ? M(!0) : K(!0), I(le));
    },
    open: z
  }, /* @__PURE__ */ Z.createElement(cy.Provider, {
    value: {
      activeSnapPoint: dn,
      snapPoints: i,
      setActiveSnapPoint: V,
      drawerRef: G,
      overlayRef: Y,
      onOpenChange: t,
      onPress: ae,
      onRelease: Ve,
      onDrag: Ee,
      dismissible: u,
      handleOnly: d,
      isOpen: z,
      isDragging: F,
      shouldFade: he,
      closeDrawer: K,
      onNestedDrag: Fr,
      onNestedOpenChange: hn,
      onNestedRelease: Fi,
      keyboardIsOpen: xe,
      modal: y,
      snapPointsOffset: B,
      direction: S,
      shouldScaleBackground: s,
      setBackgroundColorOnScale: a,
      noBodyStyles: w,
      container: R,
      autoFocus: O
    }
  }, n));
}
const yy = /* @__PURE__ */ Z.forwardRef(function({ ...e }, t) {
  const { overlayRef: n, snapPoints: r, onRelease: o, shouldFade: i, isOpen: s, modal: a } = Pi(), l = fy(t, n), c = r && r.length > 0;
  return a ? /* @__PURE__ */ Z.createElement(pu, {
    onMouseUp: o,
    ref: l,
    "data-vaul-overlay": "",
    "data-vaul-snap-points": s && c ? "true" : "false",
    "data-vaul-snap-points-overlay": s && i ? "true" : "false",
    ...e
  }) : (typeof window < "u" && window.requestAnimationFrame(() => {
    document.body.style.pointerEvents = "auto";
  }), null);
});
yy.displayName = "Drawer.Overlay";
const by = /* @__PURE__ */ Z.forwardRef(function({ onPointerDownOutside: e, style: t, onOpenAutoFocus: n, ...r }, o) {
  const { drawerRef: i, onPress: s, onRelease: a, onDrag: l, keyboardIsOpen: c, snapPointsOffset: u, modal: d, isOpen: f, direction: m, snapPoints: p, container: g, handleOnly: y, autoFocus: b } = Pi(), [x, w] = Z.useState(!1), S = fy(o, i), E = Z.useRef(null), C = Z.useRef(null), T = Z.useRef(!1), P = p && p.length > 0;
  Hk();
  const D = (R, O, _ = 0) => {
    if (T.current) return !0;
    const $ = Math.abs(R.y), z = Math.abs(R.x), I = z > $, A = [
      "bottom",
      "right"
    ].includes(O) ? 1 : -1;
    if (O === "left" || O === "right") {
      if (!(R.x * A < 0) && z >= 0 && z <= _)
        return I;
    } else if (!(R.y * A < 0) && $ >= 0 && $ <= _)
      return !I;
    return T.current = !0, !0;
  };
  Z.useEffect(() => {
    P && window.requestAnimationFrame(() => {
      w(!0);
    });
  }, []);
  function k(R) {
    E.current = null, T.current = !1, a(R);
  }
  return /* @__PURE__ */ Z.createElement(gu, {
    "data-vaul-drawer-direction": m,
    "data-vaul-drawer": "",
    "data-vaul-delayed-snap-points": x ? "true" : "false",
    "data-vaul-snap-points": f && P ? "true" : "false",
    "data-vaul-custom-container": g ? "true" : "false",
    ...r,
    ref: S,
    style: u && u.length > 0 ? {
      "--snap-point-height": `${u[0]}px`,
      ...t
    } : t,
    onPointerDown: (R) => {
      y || (r.onPointerDown == null || r.onPointerDown.call(r, R), E.current = {
        x: R.pageX,
        y: R.pageY
      }, s(R));
    },
    onOpenAutoFocus: (R) => {
      n == null || n(R), b || R.preventDefault();
    },
    onPointerDownOutside: (R) => {
      if (e == null || e(R), !d || R.defaultPrevented) {
        R.preventDefault();
        return;
      }
      c.current && (c.current = !1);
    },
    onFocusOutside: (R) => {
      if (!d) {
        R.preventDefault();
        return;
      }
    },
    onPointerMove: (R) => {
      if (C.current = R, y || (r.onPointerMove == null || r.onPointerMove.call(r, R), !E.current)) return;
      const O = R.pageY - E.current.y, _ = R.pageX - E.current.x, $ = R.pointerType === "touch" ? 10 : 2;
      D({
        x: _,
        y: O
      }, m, $) ? l(R) : (Math.abs(_) > $ || Math.abs(O) > $) && (E.current = null);
    },
    onPointerUp: (R) => {
      r.onPointerUp == null || r.onPointerUp.call(r, R), E.current = null, T.current = !1, a(R);
    },
    onPointerOut: (R) => {
      r.onPointerOut == null || r.onPointerOut.call(r, R), k(C.current);
    },
    onContextMenu: (R) => {
      r.onContextMenu == null || r.onContextMenu.call(r, R), k(C.current);
    }
  });
});
by.displayName = "Drawer.Content";
const Gk = 250, Kk = 120, Xk = /* @__PURE__ */ Z.forwardRef(function({ preventCycle: e = !1, children: t, ...n }, r) {
  const { closeDrawer: o, isDragging: i, snapPoints: s, activeSnapPoint: a, setActiveSnapPoint: l, dismissible: c, handleOnly: u, isOpen: d, onPress: f, onDrag: m } = Pi(), p = Z.useRef(null), g = Z.useRef(!1);
  function y() {
    if (g.current) {
      w();
      return;
    }
    window.setTimeout(() => {
      b();
    }, Kk);
  }
  function b() {
    if (i || e || g.current) {
      w();
      return;
    }
    if (w(), (!s || s.length === 0) && c) {
      o();
      return;
    }
    if (a === s[s.length - 1] && c) {
      o();
      return;
    }
    const E = s.findIndex((T) => T === a);
    if (E === -1) return;
    const C = s[E + 1];
    l(C);
  }
  function x() {
    p.current = window.setTimeout(() => {
      g.current = !0;
    }, Gk);
  }
  function w() {
    window.clearTimeout(p.current), g.current = !1;
  }
  return /* @__PURE__ */ Z.createElement("div", {
    onClick: y,
    onPointerCancel: w,
    onPointerDown: (S) => {
      u && f(S), x();
    },
    onPointerMove: (S) => {
      u && m(S);
    },
    // onPointerUp is already handled by the content component
    ref: r,
    "data-vaul-drawer-visible": d ? "true" : "false",
    "data-vaul-handle": "",
    "aria-hidden": "true",
    ...n
  }, /* @__PURE__ */ Z.createElement("span", {
    "data-vaul-handle-hitarea": "",
    "aria-hidden": "true"
  }, t));
});
Xk.displayName = "Drawer.Handle";
function qk(e) {
  const t = Pi(), { container: n = t.container, ...r } = e;
  return /* @__PURE__ */ Z.createElement(xg, {
    container: n,
    ...r
  });
}
const un = {
  Root: Yk,
  Content: by,
  Overlay: yy,
  Trigger: yg,
  Portal: qk,
  Close: bu,
  Title: vu,
  Description: yu
}, wy = ({ shouldScaleBackground: e = !0, ...t }) => /* @__PURE__ */ h(un.Root, { shouldScaleBackground: e, ...t });
wy.displayName = "Drawer";
const gB = un.Trigger, Qk = un.Portal, vB = un.Close, xy = v.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(un.Overlay, { ref: n, className: Q("fixed inset-0 z-50 bg-black/80", e), ...t }));
xy.displayName = un.Overlay.displayName;
const Sy = v.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ L(Qk, { children: [
  /* @__PURE__ */ h(xy, {}),
  /* @__PURE__ */ h(
    un.Content,
    {
      ref: r,
      className: Q(
        "fixed inset-x-0 bottom-0 z-50 mt-24 flex h-auto flex-col rounded-l-2xl border bg-background",
        e
      ),
      ...n,
      children: t
    }
  )
] }));
Sy.displayName = "DrawerContent";
const Zk = ({ className: e, ...t }) => /* @__PURE__ */ h("div", { className: Q("grid gap-1.5 p-4 text-center sm:text-left", e), ...t });
Zk.displayName = "DrawerHeader";
const Jk = ({ className: e, ...t }) => /* @__PURE__ */ h("div", { className: Q("mt-auto flex flex-col gap-2 p-4", e), ...t });
Jk.displayName = "DrawerFooter";
const Cy = v.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  un.Title,
  {
    ref: n,
    className: Q("text-lg font-semibold leading-none tracking-tight", e),
    ...t
  }
));
Cy.displayName = un.Title.displayName;
const eD = v.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(un.Description, { ref: n, className: Q("text-sm text-muted-foreground", e), ...t }));
eD.displayName = un.Description.displayName;
const tD = Rr(
  "relative w-full rounded-lg border p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground",
  {
    variants: {
      variant: {
        default: "bg-background text-foreground",
        destructive: "border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), Ty = v.forwardRef(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ h("div", { ref: r, role: "alert", className: Q(tD({ variant: t }), e), ...n }));
Ty.displayName = "Alert";
const Py = v.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ h("h5", { ref: n, className: Q("mb-1 font-medium leading-none tracking-tight", e), ...t })
);
Py.displayName = "AlertTitle";
const Ey = v.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ h("div", { ref: n, className: Q("text-sm [&_p]:leading-relaxed", e), ...t })
);
Ey.displayName = "AlertDescription";
const nD = ({
  isOpen: e,
  close: t,
  columns: n,
  onRowsCommit: r,
  onRowsSkipped: o,
  table: i,
  valueFormatter: s,
  size: a,
  columnsToHide: l = [],
  maxLength: c = 20,
  sortUsingLookup: u,
  sortUsingCustomOrder: d
}) => {
  const [f, m] = ue({}), [p, g] = ue([]), [y, b] = ue("delta"), [x, w] = ue("0"), S = nd(), E = pe(() => {
    let k = n.filter((R) => R.filterable && !(l != null && l.includes(R.key)));
    return S && (k = S.applyLookups(k)), k;
  }, [n, l]), C = Fe(
    (k) => {
      var _;
      const R = n.find(($) => $.key === k);
      if (!R) return [];
      const O = (_ = R.componentProps) == null ? void 0 : _.options;
      if (!O) return [];
      if (Array.isArray(O))
        return O.map(($) => ({ key: $.key, label: $.label }));
      if (typeof O == "function" && i) {
        const $ = /* @__PURE__ */ new Map();
        for (const z of i.objects())
          try {
            const I = O(z.key, k, z);
            Array.isArray(I) && I.forEach((A) => {
              $.has(A.key) || $.set(A.key, { key: A.key, label: A.label });
            });
          } catch (I) {
            console.warn(`Error getting options for row ${z.key}:`, I);
          }
        return Array.from($.values());
      }
      return [];
    },
    [n, i]
  ), T = pe(() => {
    const k = p.filter((O) => {
      var _;
      return ((_ = n.find(($) => $.key === O)) == null ? void 0 : _.component) === Ds;
    }).map((O) => {
      const _ = C(O);
      return {
        key: O,
        optStr: _.map(($) => $.key).sort().join(",")
      };
    }), R = p.filter(
      (O) => {
        var _;
        return ((_ = n.find(($) => $.key === O)) == null ? void 0 : _.dataType) === "number";
      }
    );
    return k.length && R.length ? "error_mixed" : k.length ? k.every((_) => _.optStr === k[0].optStr) ? "select" : "error_mixed" : R.length ? "number" : "none";
  }, [p, n, C]);
  de(() => {
    w("");
  }, [T]), de(() => {
    e || (m({}), g([]), w("0"));
  }, [e]);
  const P = pe(() => !(!i || T === "error_mixed" || !p.length || !Object.values(f).some((k) => k.length) || T === "number" && isNaN(Number(x)) || T === "select" && !x || x.length > c), [i, p, f, T, x]), D = () => {
    var $;
    if (!P) return;
    const k = S1(f, i), R = [];
    let O = 0;
    for (const z of p) {
      const I = n.find((M) => M.key === z);
      let A = 0;
      for (const M of k.objects()) {
        const F = M[z];
        let W;
        if (T === "select") {
          W = x;
          const ne = ($ = I == null ? void 0 : I.componentProps) == null ? void 0 : $.options;
          if (typeof ne == "function")
            try {
              const N = ne(M.key, z, M);
              if (Array.isArray(N) && !N.some((H) => H.key === W)) {
                O++, A++;
                continue;
              }
            } catch (N) {
              console.warn(`Error validating option for row ${M.key}:`, N), O++, A++;
              continue;
            }
        } else
          I && I.dataType === "number" && I.mask === "100#.##%" ? W = Number(x) / 100 : W = x, W = s ? s(Number(W)) : Number(W);
        R.push({
          value: W,
          column: z,
          pasteValue: T === "select" ? W : y === "delta" ? (F || 0) + W : W,
          row: M.key,
          rowIndex: A
        }), A++;
      }
    }
    const _ = Gv(R, k, n);
    _.length && r(_), O > 0 && o && o(O), t();
  };
  return /* @__PURE__ */ L(wy, { open: e, onOpenChange: (k) => !k && t(), direction: "right", children: [
    /* @__PURE__ */ h(Cy, {}),
    /* @__PURE__ */ h(
      Sy,
      {
        className: Q("h-screen top-0 right-0 left-auto mt-0 p-4 xl:p-8 min-w-150 focus-visible:outline-0"),
        "data-vaul-no-drag": !0,
        style: {
          width: "60vw",
          borderTopRightRadius: "0",
          borderBottomRightRadius: "0"
        },
        children: /* @__PURE__ */ L("div", { className: "flex flex-col gap-4 grow", children: [
          /* @__PURE__ */ L("div", { className: "flex flex-col gap-2 grow pretty-scrollbar h-0 overflow-y-scroll", children: [
            E.map((k) => {
              var R;
              return /* @__PURE__ */ h(
                Ck,
                {
                  column: k,
                  table: i,
                  value: ((R = f == null ? void 0 : f[k.key]) == null ? void 0 : R.map((O) => O.key)) || [],
                  onChange: (O) => {
                    m({
                      ...f,
                      [k.key]: O.map((_) => ({ key: _, label: _ }))
                    });
                  },
                  size: a,
                  sortValuesByLookupLabel: u != null && u.includes(k.key),
                  customOrder: d == null ? void 0 : d[k.key]
                },
                k.key
              );
            }),
            /* @__PURE__ */ h(
              Sk,
              {
                columns: n,
                value: p,
                onChange: (k) => {
                  g(k);
                },
                size: a
              }
            )
          ] }),
          /* @__PURE__ */ L("div", { className: "flex gap-2", children: [
            /* @__PURE__ */ L("div", { className: "grow flex gap-2", children: [
              T === "error_mixed" && /* @__PURE__ */ L(
                Ty,
                {
                  variant: "destructive",
                  className: "p-1 pl-2 text-sm bg-red-100 dark:bg-red-900 dark:text-white mb-2",
                  children: [
                    /* @__PURE__ */ h(Py, { children: "Mixed Input Types" }),
                    /* @__PURE__ */ h(Ey, { children: "Mixed input types are not allowed. Please select only one type of input." })
                  ]
                }
              ),
              T === "select" && /* @__PURE__ */ h(
                ch,
                {
                  label: "Value",
                  className: "w-full",
                  options: C(p[0]).map((k) => ({
                    label: k.label,
                    value: k.key
                  })) || [],
                  value: x,
                  onValueChange: (k) => w(k || "")
                }
              ),
              T === "number" && /* @__PURE__ */ L(Oe, { children: [
                /* @__PURE__ */ h(
                  ch,
                  {
                    label: "Mode",
                    className: "w-full",
                    options: [
                      {
                        label: "Delta",
                        value: "delta"
                      },
                      {
                        label: "Absolute",
                        value: "absolute"
                      }
                    ],
                    value: y,
                    onValueChange: (k) => b(k || "delta")
                  }
                ),
                /* @__PURE__ */ h(
                  qu,
                  {
                    className: "w-full",
                    maxLength: c,
                    label: "Value",
                    value: x,
                    onChange: (k) => w(k.currentTarget.value)
                  }
                )
              ] })
            ] }),
            T !== "error_mixed" && /* @__PURE__ */ h(ke, { disabled: !P, onClick: D, children: "Apply" })
          ] })
        ] })
      }
    )
  ] });
}, yB = ({
  trigger: e,
  columns: t,
  onRowsCommit: n,
  onRowsSkipped: r,
  table: o,
  valueFormatter: i,
  size: s,
  columnsToHide: a,
  sortUsingLookup: l,
  sortUsingCustomOrder: c
}) => {
  const [u, d] = ue(!1);
  return /* @__PURE__ */ L(Oe, { children: [
    e ? /* @__PURE__ */ h("div", { onClick: () => d(!0), children: e }) : /* @__PURE__ */ L(ke, { className: "icon-left", variant: "outline", disabled: !o, onClick: () => d(!0), children: [
      /* @__PURE__ */ h(xx, {}),
      "Bulk Update"
    ] }),
    /* @__PURE__ */ h(
      nD,
      {
        isOpen: u,
        close: () => d(!1),
        columns: t,
        onRowsCommit: n,
        onRowsSkipped: r,
        table: o,
        valueFormatter: i,
        size: s,
        columnsToHide: a,
        sortUsingLookup: l,
        sortUsingCustomOrder: c
      }
    )
  ] });
}, bB = (e) => {
  const [t, n] = Gu(e, {});
  return {
    filters: t,
    setFilters: (i, s) => {
      n({
        ...t,
        [i.key]: s
      });
    },
    clearFilters: () => {
      n({});
    }
  };
};
function rD() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return pe(
    () => (r) => {
      t.forEach((o) => o(r));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  );
}
const oD = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
function iD(e) {
  const t = Object.prototype.toString.call(e);
  return t === "[object Window]" || // In Electron context the Window object serializes to [object global]
  t === "[object global]";
}
function sD(e) {
  return "nodeType" in e;
}
function ky(e) {
  var t, n;
  return e ? iD(e) ? e : sD(e) && (t = (n = e.ownerDocument) == null ? void 0 : n.defaultView) != null ? t : window : window;
}
const ga = oD ? Dr : de;
function Dy(e) {
  const t = oe(e);
  return ga(() => {
    t.current = e;
  }), Fe(function() {
    for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
      r[o] = arguments[o];
    return t.current == null ? void 0 : t.current(...r);
  }, []);
}
function ac(e, t) {
  t === void 0 && (t = [e]);
  const n = oe(e);
  return ga(() => {
    n.current !== e && (n.current = e);
  }, t), n;
}
function lc(e) {
  const t = Dy(e), n = oe(null), r = Fe(
    (o) => {
      o !== n.current && (t == null || t(o, n.current)), n.current = o;
    },
    //eslint-disable-next-line
    []
  );
  return [n, r];
}
let qa = {};
function Ry(e, t) {
  return pe(() => {
    const n = qa[e] == null ? 0 : qa[e] + 1;
    return qa[e] = n, e + "-" + n;
  }, [e, t]);
}
function aD(e) {
  if (!e)
    return !1;
  const {
    KeyboardEvent: t
  } = ky(e.target);
  return t && e instanceof t;
}
const ii = /* @__PURE__ */ Object.freeze({
  Translate: {
    toString(e) {
      if (!e)
        return;
      const {
        x: t,
        y: n
      } = e;
      return "translate3d(" + (t ? Math.round(t) : 0) + "px, " + (n ? Math.round(n) : 0) + "px, 0)";
    }
  },
  Scale: {
    toString(e) {
      if (!e)
        return;
      const {
        scaleX: t,
        scaleY: n
      } = e;
      return "scaleX(" + t + ") scaleY(" + n + ")";
    }
  },
  Transform: {
    toString(e) {
      if (e)
        return [ii.Translate.toString(e), ii.Scale.toString(e)].join(" ");
    }
  },
  Transition: {
    toString(e) {
      let {
        property: t,
        duration: n,
        easing: r
      } = e;
      return t + " " + n + "ms " + r;
    }
  }
});
var Wo;
(function(e) {
  e.DragStart = "dragStart", e.DragMove = "dragMove", e.DragEnd = "dragEnd", e.DragCancel = "dragCancel", e.DragOver = "dragOver", e.RegisterDroppable = "registerDroppable", e.SetDroppableDisabled = "setDroppableDisabled", e.UnregisterDroppable = "unregisterDroppable";
})(Wo || (Wo = {}));
function mh() {
}
const lD = /* @__PURE__ */ Object.freeze({
  x: 0,
  y: 0
});
function cD(e) {
  if (e.startsWith("matrix3d(")) {
    const t = e.slice(9, -1).split(/, /);
    return {
      x: +t[12],
      y: +t[13],
      scaleX: +t[0],
      scaleY: +t[5]
    };
  } else if (e.startsWith("matrix(")) {
    const t = e.slice(7, -1).split(/, /);
    return {
      x: +t[4],
      y: +t[5],
      scaleX: +t[0],
      scaleY: +t[3]
    };
  }
  return null;
}
function uD(e, t, n) {
  const r = cD(t);
  if (!r)
    return e;
  const {
    scaleX: o,
    scaleY: i,
    x: s,
    y: a
  } = r, l = e.left - s - (1 - o) * parseFloat(n), c = e.top - a - (1 - i) * parseFloat(n.slice(n.indexOf(" ") + 1)), u = o ? e.width / o : e.width, d = i ? e.height / i : e.height;
  return {
    width: u,
    height: d,
    top: c,
    right: l + u,
    bottom: c + d,
    left: l
  };
}
const dD = {
  ignoreTransform: !1
};
function fD(e, t) {
  t === void 0 && (t = dD);
  let n = e.getBoundingClientRect();
  if (t.ignoreTransform) {
    const {
      transform: c,
      transformOrigin: u
    } = ky(e).getComputedStyle(e);
    c && (n = uD(n, c, u));
  }
  const {
    top: r,
    left: o,
    width: i,
    height: s,
    bottom: a,
    right: l
  } = n;
  return {
    top: r,
    left: o,
    width: i,
    height: s,
    bottom: a,
    right: l
  };
}
var qr;
(function(e) {
  e[e.Forward = 1] = "Forward", e[e.Backward = -1] = "Backward";
})(qr || (qr = {}));
var ph;
(function(e) {
  e.Click = "click", e.DragStart = "dragstart", e.Keydown = "keydown", e.ContextMenu = "contextmenu", e.Resize = "resize", e.SelectionChange = "selectionchange", e.VisibilityChange = "visibilitychange";
})(ph || (ph = {}));
var jt;
(function(e) {
  e.Space = "Space", e.Down = "ArrowDown", e.Right = "ArrowRight", e.Left = "ArrowLeft", e.Up = "ArrowUp", e.Esc = "Escape", e.Enter = "Enter", e.Tab = "Tab";
})(jt || (jt = {}));
jt.Space, jt.Enter, jt.Esc, jt.Space, jt.Enter, jt.Tab;
var gh;
(function(e) {
  e[e.RightClick = 2] = "RightClick";
})(gh || (gh = {}));
var vh;
(function(e) {
  e[e.Pointer = 0] = "Pointer", e[e.DraggableRect = 1] = "DraggableRect";
})(vh || (vh = {}));
var yh;
(function(e) {
  e[e.TreeOrder = 0] = "TreeOrder", e[e.ReversedTreeOrder = 1] = "ReversedTreeOrder";
})(yh || (yh = {}));
qr.Backward + "", qr.Forward + "", qr.Backward + "", qr.Forward + "";
var cc;
(function(e) {
  e[e.Always = 0] = "Always", e[e.BeforeDragging = 1] = "BeforeDragging", e[e.WhileDragging = 2] = "WhileDragging";
})(cc || (cc = {}));
var uc;
(function(e) {
  e.Optimized = "optimized";
})(uc || (uc = {}));
function hD(e) {
  let {
    callback: t,
    disabled: n
  } = e;
  const r = Dy(t), o = pe(
    () => {
      if (n || typeof window > "u" || typeof window.ResizeObserver > "u")
        return;
      const {
        ResizeObserver: i
      } = window;
      return new i(r);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n]
  );
  return de(() => () => o == null ? void 0 : o.disconnect(), [o]), o;
}
function mD(e, t) {
  return pe(() => e.reduce((n, r) => {
    let {
      eventName: o,
      handler: i
    } = r;
    return n[o] = (s) => {
      i(s, t);
    }, n;
  }, {}), [e, t]);
}
cc.WhileDragging, uc.Optimized;
const pD = {
  activatorEvent: null,
  activators: [],
  active: null,
  activeNodeRect: null,
  ariaDescribedById: {
    draggable: ""
  },
  dispatch: mh,
  draggableNodes: /* @__PURE__ */ new Map(),
  over: null,
  measureDroppableContainers: mh
}, My = /* @__PURE__ */ Ye(pD), gD = /* @__PURE__ */ Ye({
  ...lD,
  scaleX: 1,
  scaleY: 1
});
var bh;
(function(e) {
  e[e.Uninitialized = 0] = "Uninitialized", e[e.Initializing = 1] = "Initializing", e[e.Initialized = 2] = "Initialized";
})(bh || (bh = {}));
const vD = /* @__PURE__ */ Ye(null), wh = "button", yD = "Draggable";
function bD(e) {
  let {
    id: t,
    data: n,
    disabled: r = !1,
    attributes: o
  } = e;
  const i = Ry(yD), {
    activators: s,
    activatorEvent: a,
    active: l,
    activeNodeRect: c,
    ariaDescribedById: u,
    draggableNodes: d,
    over: f
  } = Pe(My), {
    role: m = wh,
    roleDescription: p = "draggable",
    tabIndex: g = 0
  } = o ?? {}, y = (l == null ? void 0 : l.id) === t, b = Pe(y ? gD : vD), [x, w] = lc(), [S, E] = lc(), C = mD(s, t), T = ac(n);
  ga(
    () => (d.set(t, {
      id: t,
      key: i,
      node: x,
      activatorNode: S,
      data: T
    }), () => {
      const D = d.get(t);
      D && D.key === i && d.delete(t);
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [d, t]
  );
  const P = pe(() => ({
    role: m,
    tabIndex: g,
    "aria-disabled": r,
    "aria-pressed": y && m === wh ? !0 : void 0,
    "aria-roledescription": p,
    "aria-describedby": u.draggable
  }), [r, m, g, y, p, u.draggable]);
  return {
    active: l,
    activatorEvent: a,
    activeNodeRect: c,
    attributes: P,
    isDragging: y,
    listeners: r ? void 0 : C,
    node: x,
    over: f,
    setNodeRef: w,
    setActivatorNodeRef: E,
    transform: b
  };
}
const wD = "Droppable", xD = {
  timeout: 25
};
function SD(e) {
  let {
    data: t,
    disabled: n = !1,
    id: r,
    resizeObserverConfig: o
  } = e;
  const i = Ry(wD), {
    active: s,
    dispatch: a,
    over: l,
    measureDroppableContainers: c
  } = Pe(My), u = oe({
    disabled: n
  }), d = oe(!1), f = oe(null), m = oe(null), {
    disabled: p,
    updateMeasurementsFor: g,
    timeout: y
  } = {
    ...xD,
    ...o
  }, b = ac(g ?? r), x = Fe(
    () => {
      if (!d.current) {
        d.current = !0;
        return;
      }
      m.current != null && clearTimeout(m.current), m.current = setTimeout(() => {
        c(Array.isArray(b.current) ? b.current : [b.current]), m.current = null;
      }, y);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [y]
  ), w = hD({
    callback: x,
    disabled: p || !s
  }), S = Fe((P, D) => {
    w && (D && (w.unobserve(D), d.current = !1), P && w.observe(P));
  }, [w]), [E, C] = lc(S), T = ac(t);
  return de(() => {
    !w || !E.current || (w.disconnect(), d.current = !1, w.observe(E.current));
  }, [E, w]), de(
    () => (a({
      type: Wo.RegisterDroppable,
      element: {
        id: r,
        key: i,
        disabled: n,
        node: E,
        rect: f,
        data: T
      }
    }), () => a({
      type: Wo.UnregisterDroppable,
      key: i,
      id: r
    })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r]
  ), de(() => {
    n !== u.current.disabled && (a({
      type: Wo.SetDroppableDisabled,
      id: r,
      key: i,
      disabled: n
    }), u.current.disabled = n);
  }, [r, i, n, a]), {
    active: s,
    rect: f,
    isOver: (l == null ? void 0 : l.id) === r,
    node: E,
    over: l,
    setNodeRef: C
  };
}
function Ay(e, t, n) {
  const r = e.slice();
  return r.splice(n < 0 ? r.length + n : n, 0, r.splice(t, 1)[0]), r;
}
function Zi(e) {
  return e !== null && e >= 0;
}
const CD = (e) => {
  let {
    rects: t,
    activeIndex: n,
    overIndex: r,
    index: o
  } = e;
  const i = Ay(t, r, n), s = t[o], a = i[o];
  return !a || !s ? null : {
    x: a.left - s.left,
    y: a.top - s.top,
    scaleX: a.width / s.width,
    scaleY: a.height / s.height
  };
}, TD = "Sortable", PD = /* @__PURE__ */ Z.createContext({
  activeIndex: -1,
  containerId: TD,
  disableTransforms: !1,
  items: [],
  overIndex: -1,
  useDragOverlay: !1,
  sortedRects: [],
  strategy: CD,
  disabled: {
    draggable: !1,
    droppable: !1
  }
}), ED = (e) => {
  let {
    id: t,
    items: n,
    activeIndex: r,
    overIndex: o
  } = e;
  return Ay(n, r, o).indexOf(t);
}, kD = (e) => {
  let {
    containerId: t,
    isSorting: n,
    wasDragging: r,
    index: o,
    items: i,
    newIndex: s,
    previousItems: a,
    previousContainerId: l,
    transition: c
  } = e;
  return !c || !r || a !== i && o === s ? !1 : n ? !0 : s !== o && t === l;
}, DD = {
  duration: 200,
  easing: "ease"
}, Oy = "transform", RD = /* @__PURE__ */ ii.Transition.toString({
  property: Oy,
  duration: 0,
  easing: "linear"
}), MD = {
  roleDescription: "sortable"
};
function AD(e) {
  let {
    disabled: t,
    index: n,
    node: r,
    rect: o
  } = e;
  const [i, s] = ue(null), a = oe(n);
  return ga(() => {
    if (!t && n !== a.current && r.current) {
      const l = o.current;
      if (l) {
        const c = fD(r.current, {
          ignoreTransform: !0
        }), u = {
          x: l.left - c.left,
          y: l.top - c.top,
          scaleX: l.width / c.width,
          scaleY: l.height / c.height
        };
        (u.x || u.y) && s(u);
      }
    }
    n !== a.current && (a.current = n);
  }, [t, n, r, o]), de(() => {
    i && s(null);
  }, [i]), i;
}
function OD(e) {
  let {
    animateLayoutChanges: t = kD,
    attributes: n,
    disabled: r,
    data: o,
    getNewIndex: i = ED,
    id: s,
    strategy: a,
    resizeObserverConfig: l,
    transition: c = DD
  } = e;
  const {
    items: u,
    containerId: d,
    activeIndex: f,
    disabled: m,
    disableTransforms: p,
    sortedRects: g,
    overIndex: y,
    useDragOverlay: b,
    strategy: x
  } = Pe(PD), w = ND(r, m), S = u.indexOf(s), E = pe(() => ({
    sortable: {
      containerId: d,
      index: S,
      items: u
    },
    ...o
  }), [d, o, S, u]), C = pe(() => u.slice(u.indexOf(s)), [u, s]), {
    rect: T,
    node: P,
    isOver: D,
    setNodeRef: k
  } = SD({
    id: s,
    data: E,
    disabled: w.droppable,
    resizeObserverConfig: {
      updateMeasurementsFor: C,
      ...l
    }
  }), {
    active: R,
    activatorEvent: O,
    activeNodeRect: _,
    attributes: $,
    setNodeRef: z,
    listeners: I,
    isDragging: A,
    over: M,
    setActivatorNodeRef: F,
    transform: W
  } = bD({
    id: s,
    data: E,
    attributes: {
      ...MD,
      ...n
    },
    disabled: w.draggable
  }), ne = rD(k, z), N = !!R, Y = N && !p && Zi(f) && Zi(y), H = !b && A, U = H && Y ? W : null, ge = Y ? U ?? (a ?? x)({
    rects: g,
    activeNodeRect: _,
    activeIndex: f,
    overIndex: y,
    index: S
  }) : null, X = Zi(f) && Zi(y) ? i({
    id: s,
    items: u,
    activeIndex: f,
    overIndex: y
  }) : S, se = R == null ? void 0 : R.id, ee = oe({
    activeId: se,
    items: u,
    newIndex: X,
    containerId: d
  }), xe = u !== ee.current.items, ye = t({
    active: R,
    containerId: d,
    isDragging: A,
    isSorting: N,
    id: s,
    index: S,
    items: u,
    newIndex: ee.current.newIndex,
    previousItems: ee.current.items,
    previousContainerId: ee.current.containerId,
    transition: c,
    wasDragging: ee.current.activeId != null
  }), G = AD({
    disabled: !ye,
    index: S,
    node: P,
    rect: T
  });
  return de(() => {
    N && ee.current.newIndex !== X && (ee.current.newIndex = X), d !== ee.current.containerId && (ee.current.containerId = d), u !== ee.current.items && (ee.current.items = u);
  }, [N, X, d, u]), de(() => {
    if (se === ee.current.activeId)
      return;
    if (se != null && ee.current.activeId == null) {
      ee.current.activeId = se;
      return;
    }
    const ut = setTimeout(() => {
      ee.current.activeId = se;
    }, 50);
    return () => clearTimeout(ut);
  }, [se]), {
    active: R,
    activeIndex: f,
    attributes: $,
    data: E,
    rect: T,
    index: S,
    newIndex: X,
    items: u,
    isOver: D,
    isSorting: N,
    isDragging: A,
    listeners: I,
    node: P,
    overIndex: y,
    over: M,
    setNodeRef: ne,
    setActivatorNodeRef: F,
    setDroppableNodeRef: k,
    setDraggableNodeRef: z,
    transform: G ?? ge,
    transition: mt()
  };
  function mt() {
    if (
      // Temporarily disable transitions for a single frame to set up derived transforms
      G || // Or to prevent items jumping to back to their "new" position when items change
      xe && ee.current.newIndex === S
    )
      return RD;
    if (!(H && !aD(O) || !c) && (N || ye))
      return ii.Transition.toString({
        ...c,
        property: Oy
      });
  }
}
function ND(e, t) {
  var n, r;
  return typeof e == "boolean" ? {
    draggable: e,
    // Backwards compatibility
    droppable: !1
  } : {
    draggable: (n = e == null ? void 0 : e.draggable) != null ? n : t.draggable,
    droppable: (r = e == null ? void 0 : e.droppable) != null ? r : t.droppable
  };
}
jt.Down, jt.Right, jt.Up, jt.Left;
const Ny = Ye({});
function Ei(e) {
  const t = oe(null);
  return t.current === null && (t.current = e()), t.current;
}
const _D = typeof window < "u", _y = _D ? Dr : de, id = /* @__PURE__ */ Ye(null);
function sd(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function Os(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
function ID([...e], t, n) {
  const r = t < 0 ? e.length + t : t;
  if (r >= 0 && r < e.length) {
    const o = n < 0 ? e.length + n : n, [i] = e.splice(t, 1);
    e.splice(o, 0, i);
  }
  return e;
}
const En = (e, t, n) => n > t ? t : n < e ? e : n;
function dc(e, t) {
  return t ? `${e}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${t}` : e;
}
let xo = () => {
}, sn = () => {
};
var wp;
typeof process < "u" && ((wp = process.env) == null ? void 0 : wp.NODE_ENV) !== "production" && (xo = (e, t, n) => {
  !e && typeof console < "u" && console.warn(dc(t, n));
}, sn = (e, t, n) => {
  if (!e)
    throw new Error(dc(t, n));
});
const Jn = {}, Iy = (e) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e), Ly = (e) => typeof e == "object" && e !== null, $y = (e) => /^0[^.\s]+$/u.test(e);
// @__NO_SIDE_EFFECTS__
function Fy(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
const Yt = /* @__NO_SIDE_EFFECTS__ */ (e) => e, ki = (...e) => e.reduce((t, n) => (r) => n(t(r))), si = /* @__NO_SIDE_EFFECTS__ */ (e, t, n) => {
  const r = t - e;
  return r ? (n - e) / r : 1;
};
class ad {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return sd(this.subscriptions, t), () => Os(this.subscriptions, t);
  }
  notify(t, n, r) {
    const o = this.subscriptions.length;
    if (o)
      if (o === 1)
        this.subscriptions[0](t, n, r);
      else
        for (let i = 0; i < o; i++) {
          const s = this.subscriptions[i];
          s && s(t, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const Nt = /* @__NO_SIDE_EFFECTS__ */ (e) => e * 1e3, Ut = /* @__NO_SIDE_EFFECTS__ */ (e) => e / 1e3, Vy = /* @__NO_SIDE_EFFECTS__ */ (e, t) => t ? e * (1e3 / t) : 0, xh = /* @__PURE__ */ new Set();
function ld(e, t, n) {
  e || xh.has(t) || (console.warn(dc(t, n)), xh.add(t));
}
const By = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, LD = 1e-7, $D = 12;
function FD(e, t, n, r, o) {
  let i, s, a = 0;
  do
    s = t + (n - t) / 2, i = By(s, r, o) - e, i > 0 ? n = s : t = s;
  while (Math.abs(i) > LD && ++a < $D);
  return s;
}
// @__NO_SIDE_EFFECTS__
function Di(e, t, n, r) {
  if (e === t && n === r)
    return Yt;
  const o = (i) => FD(i, 0, 1, e, n);
  return (i) => i === 0 || i === 1 ? i : By(o(i), t, r);
}
const Wy = /* @__NO_SIDE_EFFECTS__ */ (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, zy = /* @__NO_SIDE_EFFECTS__ */ (e) => (t) => 1 - e(1 - t), jy = /* @__PURE__ */ Di(0.33, 1.53, 0.69, 0.99), cd = /* @__PURE__ */ zy(jy), Hy = /* @__PURE__ */ Wy(cd), Uy = (e) => e >= 1 ? 1 : (e *= 2) < 1 ? 0.5 * cd(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), ud = (e) => 1 - Math.sin(Math.acos(e)), Yy = /* @__PURE__ */ zy(ud), Gy = /* @__PURE__ */ Wy(ud), VD = /* @__PURE__ */ Di(0.42, 0, 1, 1), BD = /* @__PURE__ */ Di(0, 0, 0.58, 1), Ky = /* @__PURE__ */ Di(0.42, 0, 0.58, 1), WD = /* @__NO_SIDE_EFFECTS__ */ (e) => Array.isArray(e) && typeof e[0] != "number", Xy = /* @__NO_SIDE_EFFECTS__ */ (e) => Array.isArray(e) && typeof e[0] == "number", Sh = {
  linear: Yt,
  easeIn: VD,
  easeInOut: Ky,
  easeOut: BD,
  circIn: ud,
  circInOut: Gy,
  circOut: Yy,
  backIn: cd,
  backInOut: Hy,
  backOut: jy,
  anticipate: Uy
}, zD = (e) => typeof e == "string", Ch = (e) => {
  if (/* @__PURE__ */ Xy(e)) {
    sn(e.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
    const [t, n, r, o] = e;
    return /* @__PURE__ */ Di(t, n, r, o);
  } else if (zD(e))
    return sn(Sh[e] !== void 0, `Invalid easing type '${e}'`, "invalid-easing-type"), Sh[e];
  return e;
}, Ji = [
  "setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
];
function jD(e) {
  let t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), r = !1, o = !1;
  const i = /* @__PURE__ */ new WeakSet();
  let s = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function a(c) {
    i.has(c) && (l.schedule(c), e()), c(s);
  }
  const l = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (c, u = !1, d = !1) => {
      const m = d && r ? t : n;
      return u && i.add(c), m.add(c), c;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (c) => {
      n.delete(c), i.delete(c);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (c) => {
      if (s = c, r) {
        o = !0;
        return;
      }
      r = !0;
      const u = t;
      t = n, n = u, t.forEach(a), t.clear(), r = !1, o && (o = !1, l.process(c));
    }
  };
  return l;
}
const HD = 40;
function qy(e, t) {
  let n = !1, r = !0;
  const o = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, i = () => n = !0, s = Ji.reduce((w, S) => (w[S] = jD(i), w), {}), { setup: a, read: l, resolveKeyframes: c, preUpdate: u, update: d, preRender: f, render: m, postRender: p } = s, g = () => {
    const w = Jn.useManualTiming, S = w ? o.timestamp : performance.now();
    n = !1, w || (o.delta = r ? 1e3 / 60 : Math.max(Math.min(S - o.timestamp, HD), 1)), o.timestamp = S, o.isProcessing = !0, a.process(o), l.process(o), c.process(o), u.process(o), d.process(o), f.process(o), m.process(o), p.process(o), o.isProcessing = !1, n && t && (r = !1, e(g));
  }, y = () => {
    n = !0, r = !0, o.isProcessing || e(g);
  };
  return { schedule: Ji.reduce((w, S) => {
    const E = s[S];
    return w[S] = (C, T = !1, P = !1) => (n || y(), E.schedule(C, T, P)), w;
  }, {}), cancel: (w) => {
    for (let S = 0; S < Ji.length; S++)
      s[Ji[S]].cancel(w);
  }, state: o, steps: s };
}
const { schedule: _e, cancel: Vn, state: yt, steps: Qa } = /* @__PURE__ */ qy(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Yt, !0);
let cs;
function UD() {
  cs = void 0;
}
const Tt = {
  now: () => (cs === void 0 && Tt.set(yt.isProcessing || Jn.useManualTiming ? yt.timestamp : performance.now()), cs),
  set: (e) => {
    cs = e, queueMicrotask(UD);
  }
}, Qy = (e) => (t) => typeof t == "string" && t.startsWith(e), Zy = /* @__PURE__ */ Qy("--"), YD = /* @__PURE__ */ Qy("var(--"), dd = (e) => YD(e) ? GD.test(e.split("/*")[0].trim()) : !1, GD = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;
function Th(e) {
  return typeof e != "string" ? !1 : e.split("/*")[0].includes("var(--");
}
const So = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, ai = {
  ...So,
  transform: (e) => En(0, 1, e)
}, es = {
  ...So,
  default: 1
}, zo = (e) => Math.round(e * 1e5) / 1e5, fd = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function KD(e) {
  return e == null;
}
const XD = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, hd = (e, t) => (n) => !!(typeof n == "string" && XD.test(n) && n.startsWith(e) || t && !KD(n) && Object.prototype.hasOwnProperty.call(n, t)), Jy = (e, t, n) => (r) => {
  if (typeof r != "string")
    return r;
  const [o, i, s, a] = r.match(fd);
  return {
    [e]: parseFloat(o),
    [t]: parseFloat(i),
    [n]: parseFloat(s),
    alpha: a !== void 0 ? parseFloat(a) : 1
  };
}, qD = (e) => En(0, 255, e), Za = {
  ...So,
  transform: (e) => Math.round(qD(e))
}, dr = {
  test: /* @__PURE__ */ hd("rgb", "red"),
  parse: /* @__PURE__ */ Jy("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + Za.transform(e) + ", " + Za.transform(t) + ", " + Za.transform(n) + ", " + zo(ai.transform(r)) + ")"
};
function QD(e) {
  let t = "", n = "", r = "", o = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), r = e.substring(5, 7), o = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), r = e.substring(3, 4), o = e.substring(4, 5), t += t, n += n, r += r, o += o), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: o ? parseInt(o, 16) / 255 : 1
  };
}
const fc = {
  test: /* @__PURE__ */ hd("#"),
  parse: QD,
  transform: dr.transform
}, Ri = /* @__NO_SIDE_EFFECTS__ */ (e) => ({
  test: (t) => typeof t == "string" && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), An = /* @__PURE__ */ Ri("deg"), Sn = /* @__PURE__ */ Ri("%"), te = /* @__PURE__ */ Ri("px"), ZD = /* @__PURE__ */ Ri("vh"), JD = /* @__PURE__ */ Ri("vw"), Ph = {
  ...Sn,
  parse: (e) => Sn.parse(e) / 100,
  transform: (e) => Sn.transform(e * 100)
}, Qr = {
  test: /* @__PURE__ */ hd("hsl", "hue"),
  parse: /* @__PURE__ */ Jy("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + Sn.transform(zo(t)) + ", " + Sn.transform(zo(n)) + ", " + zo(ai.transform(r)) + ")"
}, rt = {
  test: (e) => dr.test(e) || fc.test(e) || Qr.test(e),
  parse: (e) => dr.test(e) ? dr.parse(e) : Qr.test(e) ? Qr.parse(e) : fc.parse(e),
  transform: (e) => typeof e == "string" ? e : e.hasOwnProperty("red") ? dr.transform(e) : Qr.transform(e),
  getAnimatableNone: (e) => {
    const t = rt.parse(e);
    return t.alpha = 0, rt.transform(t);
  }
}, eR = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function tR(e) {
  var t, n;
  return isNaN(e) && typeof e == "string" && (((t = e.match(fd)) == null ? void 0 : t.length) || 0) + (((n = e.match(eR)) == null ? void 0 : n.length) || 0) > 0;
}
const eb = "number", tb = "color", nR = "var", rR = "var(", Eh = "${}", oR = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function uo(e) {
  const t = e.toString(), n = [], r = {
    color: [],
    number: [],
    var: []
  }, o = [];
  let i = 0;
  const a = t.replace(oR, (l) => (rt.test(l) ? (r.color.push(i), o.push(tb), n.push(rt.parse(l))) : l.startsWith(rR) ? (r.var.push(i), o.push(nR), n.push(l)) : (r.number.push(i), o.push(eb), n.push(parseFloat(l))), ++i, Eh)).split(Eh);
  return { values: n, split: a, indexes: r, types: o };
}
function iR(e) {
  return uo(e).values;
}
function nb({ split: e, types: t }) {
  const n = e.length;
  return (r) => {
    let o = "";
    for (let i = 0; i < n; i++)
      if (o += e[i], r[i] !== void 0) {
        const s = t[i];
        s === eb ? o += zo(r[i]) : s === tb ? o += rt.transform(r[i]) : o += r[i];
      }
    return o;
  };
}
function sR(e) {
  return nb(uo(e));
}
const aR = (e) => typeof e == "number" ? 0 : rt.test(e) ? rt.getAnimatableNone(e) : e, lR = (e, t) => typeof e == "number" ? t != null && t.trim().endsWith("/") ? e : 0 : aR(e);
function cR(e) {
  const t = uo(e);
  return nb(t)(t.values.map((r, o) => lR(r, t.split[o])));
}
const on = {
  test: tR,
  parse: iR,
  createTransformer: sR,
  getAnimatableNone: cR
};
function Ja(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function uR({ hue: e, saturation: t, lightness: n, alpha: r }) {
  e /= 360, t /= 100, n /= 100;
  let o = 0, i = 0, s = 0;
  if (!t)
    o = i = s = n;
  else {
    const a = n < 0.5 ? n * (1 + t) : n + t - n * t, l = 2 * n - a;
    o = Ja(l, a, e + 1 / 3), i = Ja(l, a, e), s = Ja(l, a, e - 1 / 3);
  }
  return {
    red: Math.round(o * 255),
    green: Math.round(i * 255),
    blue: Math.round(s * 255),
    alpha: r
  };
}
function Ns(e, t) {
  return (n) => n > 0 ? t : e;
}
const Ne = (e, t, n) => e + (t - e) * n, el = (e, t, n) => {
  const r = e * e, o = n * (t * t - r) + r;
  return o < 0 ? 0 : Math.sqrt(o);
}, dR = [fc, dr, Qr], fR = (e) => dR.find((t) => t.test(e));
function kh(e) {
  const t = fR(e);
  if (xo(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable"), !t)
    return !1;
  let n = t.parse(e);
  return t === Qr && (n = uR(n)), n;
}
const Dh = (e, t) => {
  const n = kh(e), r = kh(t);
  if (!n || !r)
    return Ns(e, t);
  const o = { ...n };
  return (i) => (o.red = el(n.red, r.red, i), o.green = el(n.green, r.green, i), o.blue = el(n.blue, r.blue, i), o.alpha = Ne(n.alpha, r.alpha, i), dr.transform(o));
}, hc = /* @__PURE__ */ new Set(["none", "hidden"]);
function hR(e, t) {
  return hc.has(e) ? (n) => n <= 0 ? e : t : (n) => n >= 1 ? t : e;
}
function mR(e, t) {
  return (n) => Ne(e, t, n);
}
function md(e) {
  return typeof e == "number" ? mR : typeof e == "string" ? dd(e) ? Ns : rt.test(e) ? Dh : vR : Array.isArray(e) ? rb : typeof e == "object" ? rt.test(e) ? Dh : pR : Ns;
}
function rb(e, t) {
  const n = [...e], r = n.length, o = e.map((i, s) => md(i)(i, t[s]));
  return (i) => {
    for (let s = 0; s < r; s++)
      n[s] = o[s](i);
    return n;
  };
}
function pR(e, t) {
  const n = { ...e, ...t }, r = {};
  for (const o in n)
    e[o] !== void 0 && t[o] !== void 0 && (r[o] = md(e[o])(e[o], t[o]));
  return (o) => {
    for (const i in r)
      n[i] = r[i](o);
    return n;
  };
}
function gR(e, t) {
  const n = [], r = { color: 0, var: 0, number: 0 };
  for (let o = 0; o < t.values.length; o++) {
    const i = t.types[o], s = e.indexes[i][r[i]], a = e.values[s] ?? 0;
    n[o] = a, r[i]++;
  }
  return n;
}
const vR = (e, t) => {
  const n = on.createTransformer(t), r = uo(e), o = uo(t);
  return r.indexes.var.length === o.indexes.var.length && r.indexes.color.length === o.indexes.color.length && r.indexes.number.length >= o.indexes.number.length ? hc.has(e) && !o.values.length || hc.has(t) && !r.values.length ? hR(e, t) : ki(rb(gR(r, o), o.values), n) : (xo(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different"), Ns(e, t));
};
function ob(e, t, n) {
  return typeof e == "number" && typeof t == "number" && typeof n == "number" ? Ne(e, t, n) : md(e)(e, t);
}
const yR = (e) => {
  const t = ({ timestamp: n }) => e(n);
  return {
    start: (n = !0) => _e.update(t, n),
    stop: () => Vn(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => yt.isProcessing ? yt.timestamp : Tt.now()
  };
}, ib = (e, t, n = 10) => {
  let r = "";
  const o = Math.max(Math.round(t / n), 2);
  for (let i = 0; i < o; i++)
    r += Math.round(e(i / (o - 1)) * 1e4) / 1e4 + ", ";
  return `linear(${r.substring(0, r.length - 2)})`;
}, _s = 2e4;
function pd(e) {
  let t = 0;
  const n = 50;
  let r = e.next(t);
  for (; !r.done && t < _s; )
    t += n, r = e.next(t);
  return t >= _s ? 1 / 0 : t;
}
function bR(e, t = 100, n) {
  const r = n({ ...e, keyframes: [0, t] }), o = Math.min(pd(r), _s);
  return {
    type: "keyframes",
    ease: (i) => r.next(o * i).value / t,
    duration: /* @__PURE__ */ Ut(o)
  };
}
const Ke = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
};
function mc(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const wR = 12;
function xR(e, t, n) {
  let r = n;
  for (let o = 1; o < wR; o++)
    r = r - e(r) / t(r);
  return r;
}
const tl = 1e-3;
function SR({ duration: e = Ke.duration, bounce: t = Ke.bounce, velocity: n = Ke.velocity, mass: r = Ke.mass }) {
  let o, i;
  xo(e <= /* @__PURE__ */ Nt(Ke.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
  let s = 1 - t;
  s = En(Ke.minDamping, Ke.maxDamping, s), e = En(Ke.minDuration, Ke.maxDuration, /* @__PURE__ */ Ut(e)), s < 1 ? (o = (c) => {
    const u = c * s, d = u * e, f = u - n, m = mc(c, s), p = Math.exp(-d);
    return tl - f / m * p;
  }, i = (c) => {
    const d = c * s * e, f = d * n + n, m = Math.pow(s, 2) * Math.pow(c, 2) * e, p = Math.exp(-d), g = mc(Math.pow(c, 2), s);
    return (-o(c) + tl > 0 ? -1 : 1) * ((f - m) * p) / g;
  }) : (o = (c) => {
    const u = Math.exp(-c * e), d = (c - n) * e + 1;
    return -tl + u * d;
  }, i = (c) => {
    const u = Math.exp(-c * e), d = (n - c) * (e * e);
    return u * d;
  });
  const a = 5 / e, l = xR(o, i, a);
  if (e = /* @__PURE__ */ Nt(e), isNaN(l))
    return {
      stiffness: Ke.stiffness,
      damping: Ke.damping,
      duration: e
    };
  {
    const c = Math.pow(l, 2) * r;
    return {
      stiffness: c,
      damping: s * 2 * Math.sqrt(r * c),
      duration: e
    };
  }
}
const CR = ["duration", "bounce"], TR = ["stiffness", "damping", "mass"];
function Rh(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function PR(e) {
  let t = {
    velocity: Ke.velocity,
    stiffness: Ke.stiffness,
    damping: Ke.damping,
    mass: Ke.mass,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!Rh(e, TR) && Rh(e, CR))
    if (t.velocity = 0, e.visualDuration) {
      const n = e.visualDuration, r = 2 * Math.PI / (n * 1.2), o = r * r, i = 2 * En(0.05, 1, 1 - (e.bounce || 0)) * Math.sqrt(o);
      t = {
        ...t,
        mass: Ke.mass,
        stiffness: o,
        damping: i
      };
    } else {
      const n = SR({ ...e, velocity: 0 });
      t = {
        ...t,
        ...n,
        mass: Ke.mass
      }, t.isResolvedFromDuration = !0;
    }
  return t;
}
function Is(e = Ke.visualDuration, t = Ke.bounce) {
  const n = typeof e != "object" ? {
    visualDuration: e,
    keyframes: [0, 1],
    bounce: t
  } : e;
  let { restSpeed: r, restDelta: o } = n;
  const i = n.keyframes[0], s = n.keyframes[n.keyframes.length - 1], a = { done: !1, value: i }, { stiffness: l, damping: c, mass: u, duration: d, velocity: f, isResolvedFromDuration: m } = PR({
    ...n,
    velocity: -/* @__PURE__ */ Ut(n.velocity || 0)
  }), p = f || 0, g = c / (2 * Math.sqrt(l * u)), y = s - i, b = /* @__PURE__ */ Ut(Math.sqrt(l / u)), x = Math.abs(y) < 5;
  r || (r = x ? Ke.restSpeed.granular : Ke.restSpeed.default), o || (o = x ? Ke.restDelta.granular : Ke.restDelta.default);
  let w, S, E, C, T, P;
  if (g < 1)
    E = mc(b, g), C = (p + g * b * y) / E, w = (k) => {
      const R = Math.exp(-g * b * k);
      return s - R * (C * Math.sin(E * k) + y * Math.cos(E * k));
    }, T = g * b * C + y * E, P = g * b * y - C * E, S = (k) => Math.exp(-g * b * k) * (T * Math.sin(E * k) + P * Math.cos(E * k));
  else if (g === 1) {
    w = (R) => s - Math.exp(-b * R) * (y + (p + b * y) * R);
    const k = p + b * y;
    S = (R) => Math.exp(-b * R) * (b * k * R - p);
  } else {
    const k = b * Math.sqrt(g * g - 1);
    w = ($) => {
      const z = Math.exp(-g * b * $), I = Math.min(k * $, 300);
      return s - z * ((p + g * b * y) * Math.sinh(I) + k * y * Math.cosh(I)) / k;
    };
    const R = (p + g * b * y) / k, O = g * b * R - y * k, _ = g * b * y - R * k;
    S = ($) => {
      const z = Math.exp(-g * b * $), I = Math.min(k * $, 300);
      return z * (O * Math.sinh(I) + _ * Math.cosh(I));
    };
  }
  const D = {
    calculatedDuration: m && d || null,
    velocity: (k) => /* @__PURE__ */ Nt(S(k)),
    next: (k) => {
      if (!m && g < 1) {
        const O = Math.exp(-g * b * k), _ = Math.sin(E * k), $ = Math.cos(E * k), z = s - O * (C * _ + y * $), I = /* @__PURE__ */ Nt(O * (T * _ + P * $));
        return a.done = Math.abs(I) <= r && Math.abs(s - z) <= o, a.value = a.done ? s : z, a;
      }
      const R = w(k);
      if (m)
        a.done = k >= d;
      else {
        const O = /* @__PURE__ */ Nt(S(k));
        a.done = Math.abs(O) <= r && Math.abs(s - R) <= o;
      }
      return a.value = a.done ? s : R, a;
    },
    toString: () => {
      const k = Math.min(pd(D), _s), R = ib((O) => D.next(k * O).value, k, 30);
      return k + "ms " + R;
    },
    toTransition: () => {
    }
  };
  return D;
}
Is.applyToOptions = (e) => {
  const t = bR(e, 100, Is);
  return e.ease = t.ease, e.duration = /* @__PURE__ */ Nt(t.duration), e.type = "keyframes", e;
};
const ER = 5;
function sb(e, t, n) {
  const r = Math.max(t - ER, 0);
  return /* @__PURE__ */ Vy(n - e(r), t - r);
}
function pc({ keyframes: e, velocity: t = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: o = 10, bounceStiffness: i = 500, modifyTarget: s, min: a, max: l, restDelta: c = 0.5, restSpeed: u }) {
  const d = e[0], f = {
    done: !1,
    value: d
  }, m = (P) => a !== void 0 && P < a || l !== void 0 && P > l, p = (P) => a === void 0 ? l : l === void 0 || Math.abs(a - P) < Math.abs(l - P) ? a : l;
  let g = n * t;
  const y = d + g, b = s === void 0 ? y : s(y);
  b !== y && (g = b - d);
  const x = (P) => -g * Math.exp(-P / r), w = (P) => b + x(P), S = (P) => {
    const D = x(P), k = w(P);
    f.done = Math.abs(D) <= c, f.value = f.done ? b : k;
  };
  let E, C;
  const T = (P) => {
    m(f.value) && (E = P, C = Is({
      keyframes: [f.value, p(f.value)],
      velocity: sb(w, P, f.value),
      // TODO: This should be passing * 1000
      damping: o,
      stiffness: i,
      restDelta: c,
      restSpeed: u
    }));
  };
  return T(0), {
    calculatedDuration: null,
    next: (P) => {
      let D = !1;
      return !C && E === void 0 && (D = !0, S(P), T(P)), E !== void 0 && P >= E ? C.next(P - E) : (!D && S(P), f);
    }
  };
}
function kR(e, t, n) {
  const r = [], o = n || Jn.mix || ob, i = e.length - 1;
  for (let s = 0; s < i; s++) {
    let a = o(e[s], e[s + 1]);
    if (t) {
      const l = Array.isArray(t) ? t[s] || Yt : t;
      a = ki(l, a);
    }
    r.push(a);
  }
  return r;
}
function ab(e, t, { clamp: n = !0, ease: r, mixer: o } = {}) {
  const i = e.length;
  if (sn(i === t.length, "Both input and output ranges must be the same length", "range-length"), i === 1)
    return () => t[0];
  if (i === 2 && t[0] === t[1])
    return () => t[1];
  const s = e[0] === e[1];
  e[0] > e[i - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const a = kR(t, r, o), l = a.length, c = (u) => {
    if (s && u < e[0])
      return t[0];
    let d = 0;
    if (l > 1)
      for (; d < e.length - 2 && !(u < e[d + 1]); d++)
        ;
    const f = /* @__PURE__ */ si(e[d], e[d + 1], u);
    return a[d](f);
  };
  return n ? (u) => c(En(e[0], e[i - 1], u)) : c;
}
function DR(e, t) {
  const n = e[e.length - 1];
  for (let r = 1; r <= t; r++) {
    const o = /* @__PURE__ */ si(0, t, r);
    e.push(Ne(n, 1, o));
  }
}
function RR(e) {
  const t = [0];
  return DR(t, e.length - 1), t;
}
function MR(e, t) {
  return e.map((n) => n * t);
}
function AR(e, t) {
  return e.map(() => t || Ky).splice(0, e.length - 1);
}
function Zr({ duration: e = 300, keyframes: t, times: n, ease: r = "easeInOut" }) {
  const o = /* @__PURE__ */ WD(r) ? r.map(Ch) : Ch(r), i = {
    done: !1,
    value: t[0]
  }, s = MR(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === t.length ? n : RR(t),
    e
  ), a = ab(s, t, {
    ease: Array.isArray(o) ? o : AR(t, o)
  });
  return {
    calculatedDuration: e,
    next: (l) => (i.value = a(l), i.done = l >= e, i)
  };
}
const OR = (e) => e !== null;
function va(e, { repeat: t, repeatType: n = "loop" }, r, o = 1) {
  const i = e.filter(OR), a = o < 0 || t && n !== "loop" && t % 2 === 1 ? 0 : i.length - 1;
  return !a || r === void 0 ? i[a] : r;
}
const NR = {
  decay: pc,
  inertia: pc,
  tween: Zr,
  keyframes: Zr,
  spring: Is
};
function lb(e) {
  typeof e.type == "string" && (e.type = NR[e.type]);
}
class gd {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((t) => {
      this.resolve = t;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(t, n) {
    return this.finished.then(t, n);
  }
}
const _R = (e) => e / 100;
class Ls extends gd {
  constructor(t) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.delayState = {
      done: !1,
      value: void 0
    }, this.stop = () => {
      var r, o;
      const { motionValue: n } = this.options;
      n && n.updatedAt !== Tt.now() && this.tick(Tt.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), (o = (r = this.options).onStop) == null || o.call(r));
    }, this.options = t, this.initAnimation(), this.play(), t.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: t } = this;
    lb(t);
    const { type: n = Zr, repeat: r = 0, repeatDelay: o = 0, repeatType: i, velocity: s = 0 } = t;
    let { keyframes: a } = t;
    const l = n || Zr;
    process.env.NODE_ENV !== "production" && l !== Zr && sn(a.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${a}`, "spring-two-frames"), l !== Zr && typeof a[0] != "number" && (this.mixKeyframes = ki(_R, ob(a[0], a[1])), a = [0, 100]);
    const c = l({ ...t, keyframes: a });
    i === "mirror" && (this.mirroredGenerator = l({
      ...t,
      keyframes: [...a].reverse(),
      velocity: -s
    })), c.calculatedDuration === null && (c.calculatedDuration = pd(c));
    const { calculatedDuration: u } = c;
    this.calculatedDuration = u, this.resolvedDuration = u + o, this.totalDuration = this.resolvedDuration * (r + 1) - o, this.generator = c;
  }
  updateTime(t) {
    const n = Math.round(t - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = n;
  }
  tick(t, n = !1) {
    const { generator: r, totalDuration: o, mixKeyframes: i, mirroredGenerator: s, resolvedDuration: a, calculatedDuration: l } = this;
    if (this.startTime === null)
      return r.next(0);
    const { delay: c = 0, keyframes: u, repeat: d, repeatType: f, repeatDelay: m, type: p, onUpdate: g, finalKeyframe: y } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, t) : this.speed < 0 && (this.startTime = Math.min(t - o / this.speed, this.startTime)), n ? this.currentTime = t : this.updateTime(t);
    const b = this.currentTime - c * (this.playbackSpeed >= 0 ? 1 : -1), x = this.playbackSpeed >= 0 ? b < 0 : b > o;
    this.currentTime = Math.max(b, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = o);
    let w = this.currentTime, S = r;
    if (d) {
      const P = Math.min(this.currentTime, o) / a;
      let D = Math.floor(P), k = P % 1;
      !k && P >= 1 && (k = 1), k === 1 && D--, D = Math.min(D, d + 1), !!(D % 2) && (f === "reverse" ? (k = 1 - k, m && (k -= m / a)) : f === "mirror" && (S = s)), w = En(0, 1, k) * a;
    }
    let E;
    x ? (this.delayState.value = u[0], E = this.delayState) : E = S.next(w), i && !x && (E.value = i(E.value));
    let { done: C } = E;
    !x && l !== null && (C = this.playbackSpeed >= 0 ? this.currentTime >= o : this.currentTime <= 0);
    const T = this.holdTime === null && (this.state === "finished" || this.state === "running" && C);
    return T && p !== pc && (E.value = va(u, this.options, y, this.speed)), g && g(E.value), T && this.finish(), E;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(t, n) {
    return this.finished.then(t, n);
  }
  get duration() {
    return /* @__PURE__ */ Ut(this.calculatedDuration);
  }
  get iterationDuration() {
    const { delay: t = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ Ut(t);
  }
  get time() {
    return /* @__PURE__ */ Ut(this.currentTime);
  }
  set time(t) {
    t = /* @__PURE__ */ Nt(t), this.currentTime = t, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = t : this.driver && (this.startTime = this.driver.now() - t / this.playbackSpeed), this.driver ? this.driver.start(!1) : (this.startTime = 0, this.state = "paused", this.holdTime = t, this.tick(t));
  }
  /**
   * Returns the generator's velocity at the current time in units/second.
   * Uses the analytical derivative when available (springs), avoiding
   * the MotionValue's frame-dependent velocity estimation.
   */
  getGeneratorVelocity() {
    const t = this.currentTime;
    if (t <= 0)
      return this.options.velocity || 0;
    if (this.generator.velocity)
      return this.generator.velocity(t);
    const n = this.generator.next(t).value;
    return sb((r) => this.generator.next(r).value, t, n);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(t) {
    const n = this.playbackSpeed !== t;
    n && this.driver && this.updateTime(Tt.now()), this.playbackSpeed = t, n && this.driver && (this.time = /* @__PURE__ */ Ut(this.currentTime));
  }
  play() {
    var o, i;
    if (this.isStopped)
      return;
    const { driver: t = yR, startTime: n } = this.options;
    this.driver || (this.driver = t((s) => this.tick(s))), (i = (o = this.options).onPlay) == null || i.call(o);
    const r = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = r) : this.holdTime !== null ? this.startTime = r - this.holdTime : this.startTime || (this.startTime = n ?? r), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime(Tt.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    var t, n;
    this.notifyFinished(), this.teardown(), this.state = "finished", (n = (t = this.options).onComplete) == null || n.call(t);
  }
  cancel() {
    var t, n;
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), (n = (t = this.options).onCancel) == null || n.call(t);
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(t) {
    return this.startTime = 0, this.tick(t, !0);
  }
  attachTimeline(t) {
    var n;
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), (n = this.driver) == null || n.stop(), t.observe(this);
  }
}
function IR(e) {
  for (let t = 1; t < e.length; t++)
    e[t] ?? (e[t] = e[t - 1]);
}
const fr = (e) => e * 180 / Math.PI, gc = (e) => {
  const t = fr(Math.atan2(e[1], e[0]));
  return vc(t);
}, LR = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: (e) => (Math.abs(e[0]) + Math.abs(e[3])) / 2,
  rotate: gc,
  rotateZ: gc,
  skewX: (e) => fr(Math.atan(e[1])),
  skewY: (e) => fr(Math.atan(e[2])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[2])) / 2
}, vc = (e) => (e = e % 360, e < 0 && (e += 360), e), Mh = gc, Ah = (e) => Math.sqrt(e[0] * e[0] + e[1] * e[1]), Oh = (e) => Math.sqrt(e[4] * e[4] + e[5] * e[5]), $R = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX: Ah,
  scaleY: Oh,
  scale: (e) => (Ah(e) + Oh(e)) / 2,
  rotateX: (e) => vc(fr(Math.atan2(e[6], e[5]))),
  rotateY: (e) => vc(fr(Math.atan2(-e[2], e[0]))),
  rotateZ: Mh,
  rotate: Mh,
  skewX: (e) => fr(Math.atan(e[4])),
  skewY: (e) => fr(Math.atan(e[1])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[4])) / 2
};
function yc(e) {
  return e.includes("scale") ? 1 : 0;
}
function bc(e, t) {
  if (!e || e === "none")
    return yc(t);
  const n = e.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let r, o;
  if (n)
    r = $R, o = n;
  else {
    const a = e.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    r = LR, o = a;
  }
  if (!o)
    return yc(t);
  const i = r[t], s = o[1].split(",").map(VR);
  return typeof i == "function" ? i(s) : s[i];
}
const FR = (e, t) => {
  const { transform: n = "none" } = getComputedStyle(e);
  return bc(n, t);
};
function VR(e) {
  return parseFloat(e.trim());
}
const Co = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], To = /* @__PURE__ */ new Set([...Co, "pathRotation"]), Nh = (e) => e === So || e === te, BR = /* @__PURE__ */ new Set(["x", "y", "z"]), WR = Co.filter((e) => !BR.has(e));
function zR(e) {
  const t = [];
  return WR.forEach((n) => {
    const r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t;
}
const Kn = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0", boxSizing: r }) => {
    const o = e.max - e.min;
    return r === "border-box" ? o : o - parseFloat(t) - parseFloat(n);
  },
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0", boxSizing: r }) => {
    const o = e.max - e.min;
    return r === "border-box" ? o : o - parseFloat(t) - parseFloat(n);
  },
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: (e, { transform: t }) => bc(t, "x"),
  y: (e, { transform: t }) => bc(t, "y")
};
Kn.translateX = Kn.x;
Kn.translateY = Kn.y;
const mr = /* @__PURE__ */ new Set();
let wc = !1, xc = !1, Sc = !1;
function cb() {
  if (xc) {
    const e = Array.from(mr).filter((r) => r.needsMeasurement), t = new Set(e.map((r) => r.element)), n = /* @__PURE__ */ new Map();
    t.forEach((r) => {
      const o = zR(r);
      o.length && (n.set(r, o), r.render());
    }), e.forEach((r) => r.measureInitialState()), t.forEach((r) => {
      r.render();
      const o = n.get(r);
      o && o.forEach(([i, s]) => {
        var a;
        (a = r.getValue(i)) == null || a.set(s);
      });
    }), e.forEach((r) => r.measureEndState()), e.forEach((r) => {
      r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
    });
  }
  xc = !1, wc = !1, mr.forEach((e) => e.complete(Sc)), mr.clear();
}
function ub() {
  mr.forEach((e) => {
    e.readKeyframes(), e.needsMeasurement && (xc = !0);
  });
}
function jR() {
  Sc = !0, ub(), cb(), Sc = !1;
}
class vd {
  constructor(t, n, r, o, i, s = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...t], this.onComplete = n, this.name = r, this.motionValue = o, this.element = i, this.isAsync = s;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (mr.add(this), wc || (wc = !0, _e.read(ub), _e.resolveKeyframes(cb))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, name: n, element: r, motionValue: o } = this;
    if (t[0] === null) {
      const i = o == null ? void 0 : o.get(), s = t[t.length - 1];
      if (i !== void 0)
        t[0] = i;
      else if (r && n) {
        const a = r.readValue(n, s);
        a != null && (t[0] = a);
      }
      t[0] === void 0 && (t[0] = s), o && i === void 0 && o.set(t[0]);
    }
    IR(t);
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete(t = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, t), mr.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (mr.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const HR = (e) => e.startsWith("--");
function db(e, t, n) {
  HR(t) ? e.style.setProperty(t, n) : e.style[t] = n;
}
const UR = {};
function fb(e, t) {
  const n = /* @__PURE__ */ Fy(e);
  return () => UR[t] ?? n();
}
const YR = /* @__PURE__ */ fb(() => window.ScrollTimeline !== void 0, "scrollTimeline"), hb = /* @__PURE__ */ fb(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), Lo = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`, _h = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ Lo([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ Lo([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ Lo([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ Lo([0.33, 1.53, 0.69, 0.99])
};
function mb(e, t) {
  if (e)
    return typeof e == "function" ? hb() ? ib(e, t) : "ease-out" : /* @__PURE__ */ Xy(e) ? Lo(e) : Array.isArray(e) ? e.map((n) => mb(n, t) || _h.easeOut) : _h[e];
}
function GR(e, t, n, { delay: r = 0, duration: o = 300, repeat: i = 0, repeatType: s = "loop", ease: a = "easeOut", times: l } = {}, c = void 0) {
  const u = {
    [t]: n
  };
  l && (u.offset = l);
  const d = mb(a, o);
  Array.isArray(d) && (u.easing = d);
  const f = {
    delay: r,
    duration: o,
    easing: Array.isArray(d) ? "linear" : d,
    fill: "both",
    iterations: i + 1,
    direction: s === "reverse" ? "alternate" : "normal"
  };
  return c && (f.pseudoElement = c), e.animate(u, f);
}
function pb(e) {
  return typeof e == "function" && "applyToOptions" in e;
}
function KR({ type: e, ...t }) {
  return pb(e) && hb() ? e.applyToOptions(t) : (t.duration ?? (t.duration = 300), t.ease ?? (t.ease = "easeOut"), t);
}
class gb extends gd {
  constructor(t) {
    if (super(), this.finishedTime = null, this.isStopped = !1, this.manualStartTime = null, !t)
      return;
    const { element: n, name: r, keyframes: o, pseudoElement: i, allowFlatten: s = !1, finalKeyframe: a, onComplete: l } = t;
    this.isPseudoElement = !!i, this.allowFlatten = s, this.options = t, sn(typeof t.type != "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
    const c = KR(t);
    this.animation = GR(n, r, o, c, i), c.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !i) {
        const u = va(o, this.options, a, this.speed);
        this.updateMotionValue && this.updateMotionValue(u), db(n, r, u), this.animation.cancel();
      }
      l == null || l(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.manualStartTime = null, this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    var t, n;
    (n = (t = this.animation).finish) == null || n.call(t);
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {
    }
  }
  stop() {
    if (this.isStopped)
      return;
    this.isStopped = !0;
    const { state: t } = this;
    t === "idle" || t === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    var n, r, o;
    const t = (n = this.options) == null ? void 0 : n.element;
    !this.isPseudoElement && (t != null && t.isConnected) && ((o = (r = this.animation).commitStyles) == null || o.call(r));
  }
  get duration() {
    var n, r;
    const t = ((r = (n = this.animation.effect) == null ? void 0 : n.getComputedTiming) == null ? void 0 : r.call(n).duration) || 0;
    return /* @__PURE__ */ Ut(Number(t));
  }
  get iterationDuration() {
    const { delay: t = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ Ut(t);
  }
  get time() {
    return /* @__PURE__ */ Ut(Number(this.animation.currentTime) || 0);
  }
  set time(t) {
    const n = this.finishedTime !== null;
    this.manualStartTime = null, this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ Nt(t), n && this.animation.pause();
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(t) {
    t < 0 && (this.finishedTime = null), this.animation.playbackRate = t;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return this.manualStartTime ?? Number(this.animation.startTime);
  }
  set startTime(t) {
    this.manualStartTime = this.animation.startTime = t;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({ timeline: t, rangeStart: n, rangeEnd: r, observe: o }) {
    var i;
    return this.allowFlatten && ((i = this.animation.effect) == null || i.updateTiming({ easing: "linear" })), this.animation.onfinish = null, t && YR() ? (this.animation.timeline = t, n && (this.animation.rangeStart = n), r && (this.animation.rangeEnd = r), Yt) : o(this);
  }
}
const vb = {
  anticipate: Uy,
  backInOut: Hy,
  circInOut: Gy
};
function XR(e) {
  return e in vb;
}
function qR(e) {
  typeof e.ease == "string" && XR(e.ease) && (e.ease = vb[e.ease]);
}
const nl = 10;
class QR extends gb {
  constructor(t) {
    qR(t), lb(t), super(t), t.startTime !== void 0 && t.autoplay !== !1 && (this.startTime = t.startTime), this.options = t;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read committed styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(t) {
    const { motionValue: n, onUpdate: r, onComplete: o, element: i, ...s } = this.options;
    if (!n)
      return;
    if (t !== void 0) {
      n.set(t);
      return;
    }
    const a = new Ls({
      ...s,
      autoplay: !1
    }), l = Math.max(nl, Tt.now() - this.startTime), c = En(0, nl, l - nl), u = a.sample(l).value, { name: d } = this.options;
    i && d && db(i, d, u), n.setWithVelocity(a.sample(Math.max(0, l - c)).value, u, c), a.stop();
  }
}
const Ih = (e, t) => t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
(on.test(e) || e === "0") && // And it contains numbers and/or colors
!e.startsWith("url("));
function ZR(e) {
  const t = e[0];
  if (e.length === 1)
    return !0;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t)
      return !0;
}
function JR(e, t, n, r) {
  const o = e[0];
  if (o === null)
    return !1;
  if (t === "display" || t === "visibility")
    return !0;
  const i = e[e.length - 1], s = Ih(o, t), a = Ih(i, t);
  return xo(s === a, `You are trying to animate ${t} from "${o}" to "${i}". "${s ? i : o}" is not an animatable value.`, "value-not-animatable"), !s || !a ? !1 : ZR(e) || (n === "spring" || pb(n)) && r;
}
function Cc(e) {
  e.duration = 0, e.type = "keyframes";
}
const yb = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]), eM = /^(?:oklch|oklab|lab|lch|color|color-mix|light-dark)\(/;
function tM(e) {
  for (let t = 0; t < e.length; t++)
    if (typeof e[t] == "string" && eM.test(e[t]))
      return !0;
  return !1;
}
const nM = /* @__PURE__ */ new Set([
  "color",
  "backgroundColor",
  "outlineColor",
  "fill",
  "stroke",
  "borderColor",
  "borderTopColor",
  "borderRightColor",
  "borderBottomColor",
  "borderLeftColor"
]), rM = /* @__PURE__ */ Fy(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function oM(e) {
  var d;
  const { motionValue: t, name: n, repeatDelay: r, repeatType: o, damping: i, type: s, keyframes: a } = e;
  if (!(((d = t == null ? void 0 : t.owner) == null ? void 0 : d.current) instanceof HTMLElement))
    return !1;
  const { onUpdate: c, transformTemplate: u } = t.owner.getProps();
  return rM() && n && /**
   * Force WAAPI for color properties with browser-only color formats
   * (oklch, oklab, lab, lch, etc.) that the JS animation path can't parse.
   */
  (yb.has(n) || nM.has(n) && tM(a)) && (n !== "transform" || !u) && /**
   * If we're outputting values to onUpdate then we can't use WAAPI as there's
   * no way to read the value from WAAPI every frame.
   */
  !c && !r && o !== "mirror" && i !== 0 && s !== "inertia";
}
const iM = 40;
class sM extends gd {
  constructor({ autoplay: t = !0, delay: n = 0, type: r = "keyframes", repeat: o = 0, repeatDelay: i = 0, repeatType: s = "loop", keyframes: a, name: l, motionValue: c, element: u, ...d }) {
    var p;
    super(), this.stop = () => {
      var g, y;
      this._animation && (this._animation.stop(), (g = this.stopTimeline) == null || g.call(this)), (y = this.keyframeResolver) == null || y.cancel();
    }, this.createdAt = Tt.now();
    const f = {
      autoplay: t,
      delay: n,
      type: r,
      repeat: o,
      repeatDelay: i,
      repeatType: s,
      name: l,
      motionValue: c,
      element: u,
      ...d
    }, m = (u == null ? void 0 : u.KeyframeResolver) || vd;
    this.keyframeResolver = new m(a, (g, y, b) => this.onKeyframesResolved(g, y, f, !b), l, c, u), (p = this.keyframeResolver) == null || p.scheduleResolve();
  }
  onKeyframesResolved(t, n, r, o) {
    var b, x;
    this.keyframeResolver = void 0;
    const { name: i, type: s, velocity: a, delay: l, isHandoff: c, onUpdate: u } = r;
    this.resolvedAt = Tt.now();
    let d = !0;
    JR(t, i, s, a) || (d = !1, (Jn.instantAnimations || !l) && (u == null || u(va(t, r, n))), t[0] = t[t.length - 1], Cc(r), r.repeat = 0);
    const m = {
      startTime: o ? this.resolvedAt ? this.resolvedAt - this.createdAt > iM ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
      finalKeyframe: n,
      ...r,
      keyframes: t
    }, p = d && !c && oM(m), g = (x = (b = m.motionValue) == null ? void 0 : b.owner) == null ? void 0 : x.current;
    let y;
    if (p)
      try {
        y = new QR({
          ...m,
          element: g
        });
      } catch {
        y = new Ls(m);
      }
    else
      y = new Ls(m);
    y.finished.then(() => {
      this.notifyFinished();
    }).catch(Yt), this.pendingTimeline && (this.stopTimeline = y.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = y;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(t, n) {
    return this.finished.finally(t).then(() => {
    });
  }
  get animation() {
    var t;
    return this._animation || ((t = this.keyframeResolver) == null || t.resume(), jR()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get iterationDuration() {
    return this.animation.iterationDuration;
  }
  get time() {
    return this.animation.time;
  }
  set time(t) {
    this.animation.time = t;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(t) {
    this.animation.speed = t;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(t) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(t) : this.pendingTimeline = t, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    var t;
    this._animation && this.animation.cancel(), (t = this.keyframeResolver) == null || t.cancel();
  }
}
function bb(e, t, n, r = 0, o = 1) {
  const i = Array.from(e).sort((c, u) => c.sortNodePosition(u)).indexOf(t), s = e.size, a = (s - 1) * r;
  return typeof n == "function" ? n(i, s) : o === 1 ? i * r : a - i * r;
}
const Lh = 30, aM = (e) => !isNaN(parseFloat(e)), jo = {
  current: void 0
};
class lM {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(t, n = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (r) => {
      var i;
      const o = Tt.now();
      if (this.updatedAt !== o && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && ((i = this.events.change) == null || i.notify(this.current), this.dependents))
        for (const s of this.dependents)
          s.dirty();
    }, this.hasAnimated = !1, this.setCurrent(t), this.owner = n.owner;
  }
  setCurrent(t) {
    this.current = t, this.updatedAt = Tt.now(), this.canTrackVelocity === null && t !== void 0 && (this.canTrackVelocity = aM(this.current));
  }
  setPrevFrameValue(t = this.current) {
    this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return process.env.NODE_ENV !== "production" && ld(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new ad());
    const r = this.events[t].add(n);
    return t === "change" ? () => {
      r(), _e.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t) {
    this.passiveEffect ? this.passiveEffect(t, this.updateAndNotify) : this.updateAndNotify(t);
  }
  setWithVelocity(t, n, r) {
    this.set(n), this.prev = void 0, this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt - r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t, n = !0) {
    this.updateAndNotify(t), this.prev = t, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    var t;
    (t = this.events.change) == null || t.notify(this.current);
  }
  addDependent(t) {
    this.dependents || (this.dependents = /* @__PURE__ */ new Set()), this.dependents.add(t);
  }
  removeDependent(t) {
    this.dependents && this.dependents.delete(t);
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return jo.current && jo.current.push(this), this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const t = Tt.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || t - this.updatedAt > Lh)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, Lh);
    return /* @__PURE__ */ Vy(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(t) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    var t, n;
    (t = this.dependents) == null || t.clear(), (n = this.events.destroy) == null || n.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Cr(e, t) {
  return new lM(e, t);
}
function wb(e, t) {
  if (e != null && e.inherit && t) {
    const { inherit: n, ...r } = e;
    return { ...t, ...r };
  }
  return e;
}
function yd(e, t) {
  const n = (e == null ? void 0 : e[t]) ?? (e == null ? void 0 : e.default) ?? e;
  return n !== e ? wb(n, e) : n;
}
const cM = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, uM = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), dM = {
  type: "keyframes",
  duration: 0.8
}, fM = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, hM = (e, { keyframes: t }) => t.length > 2 ? dM : To.has(e) ? e.startsWith("scale") ? uM(t[1]) : cM : fM, mM = /* @__PURE__ */ new Set([
  "when",
  "delay",
  "delayChildren",
  "staggerChildren",
  "staggerDirection",
  "repeat",
  "repeatType",
  "repeatDelay",
  "from",
  "elapsed"
]);
function pM(e) {
  for (const t in e)
    if (!mM.has(t))
      return !0;
  return !1;
}
const bd = (e, t, n, r = {}, o, i) => (s) => {
  const a = yd(r, e) || {}, l = a.delay || r.delay || 0;
  let { elapsed: c = 0 } = r;
  c = c - /* @__PURE__ */ Nt(l);
  const u = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: t.getVelocity(),
    ...a,
    delay: -c,
    onUpdate: (f) => {
      t.set(f), a.onUpdate && a.onUpdate(f);
    },
    onComplete: () => {
      s(), a.onComplete && a.onComplete();
    },
    name: e,
    motionValue: t,
    element: i ? void 0 : o
  };
  pM(a) || Object.assign(u, hM(e, u)), u.duration && (u.duration = /* @__PURE__ */ Nt(u.duration)), u.repeatDelay && (u.repeatDelay = /* @__PURE__ */ Nt(u.repeatDelay)), u.from !== void 0 && (u.keyframes[0] = u.from);
  let d = !1;
  if ((u.type === !1 || u.duration === 0 && !u.repeatDelay) && (Cc(u), u.delay === 0 && (d = !0)), (Jn.instantAnimations || Jn.skipAnimations || o != null && o.shouldSkipAnimations || a.skipAnimations) && (d = !0, Cc(u), u.delay = 0), u.allowFlatten = !a.type && !a.ease, d && !i && t.get() !== void 0) {
    const f = va(u.keyframes, a);
    if (f !== void 0) {
      _e.update(() => {
        u.onUpdate(f), u.onComplete();
      });
      return;
    }
  }
  return a.isSync ? new Ls(u) : new sM(u);
}, gM = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function vM(e) {
  const t = gM.exec(e);
  if (!t)
    return [,];
  const [, n, r, o] = t;
  return [`--${n ?? r}`, o];
}
const yM = 4;
function xb(e, t, n = 1) {
  sn(n <= yM, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
  const [r, o] = vM(e);
  if (!r)
    return;
  const i = window.getComputedStyle(t).getPropertyValue(r);
  if (i) {
    const s = i.trim();
    return Iy(s) ? parseFloat(s) : s;
  }
  return dd(o) ? xb(o, t, n + 1) : o;
}
function $h(e) {
  const t = [{}, {}];
  return e == null || e.values.forEach((n, r) => {
    t[0][r] = n.get(), t[1][r] = n.getVelocity();
  }), t;
}
function wd(e, t, n, r) {
  if (typeof t == "function") {
    const [o, i] = $h(r);
    t = t(n !== void 0 ? n : e.custom, o, i);
  }
  if (typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function") {
    const [o, i] = $h(r);
    t = t(n !== void 0 ? n : e.custom, o, i);
  }
  return t;
}
function pr(e, t, n) {
  const r = e.getProps();
  return wd(r, t, n !== void 0 ? n : r.custom, e);
}
const Sb = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...Co
]), Tc = (e) => Array.isArray(e);
function bM(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, Cr(n));
}
function wM(e) {
  return Tc(e) ? e[e.length - 1] || 0 : e;
}
function xM(e, t) {
  const n = pr(e, t);
  let { transitionEnd: r = {}, transition: o = {}, ...i } = n || {};
  i = { ...i, ...r };
  for (const s in i) {
    const a = wM(i[s]);
    bM(e, s, a);
  }
}
const ht = (e) => !!(e && e.getVelocity);
function SM(e) {
  return !!(ht(e) && e.add);
}
function Pc(e, t) {
  const n = e.getValue("willChange");
  if (SM(n))
    return n.add(t);
  if (!n && Jn.WillChange) {
    const r = new Jn.WillChange("auto");
    e.addValue("willChange", r), r.add(t);
  }
}
function xd(e) {
  return e.replace(/([A-Z])/g, (t) => `-${t.toLowerCase()}`);
}
const CM = "framerAppearId", Cb = "data-" + xd(CM);
function Tb(e) {
  return e.props[Cb];
}
function TM({ protectedKeys: e, needsAnimating: t }, n) {
  const r = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, r;
}
function Pb(e, t, { delay: n = 0, transitionOverride: r, type: o } = {}) {
  let { transition: i, transitionEnd: s, ...a } = t;
  const l = e.getDefaultTransition();
  i = i ? wb(i, l) : l;
  const c = i == null ? void 0 : i.reduceMotion, u = i == null ? void 0 : i.skipAnimations;
  r && (i = r);
  const d = [], f = o && e.animationState && e.animationState.getState()[o], m = i == null ? void 0 : i.path;
  m && m.animateVisualElement(e, a, i, n, d);
  for (const p in a) {
    const g = e.getValue(p, e.latestValues[p] ?? null), y = a[p];
    if (y === void 0 || f && TM(f, p))
      continue;
    const b = {
      delay: n,
      ...yd(i || {}, p)
    };
    u && (b.skipAnimations = !0);
    const x = g.get();
    if (x !== void 0 && !g.isAnimating() && !Array.isArray(y) && y === x && !b.velocity) {
      _e.update(() => g.set(y));
      continue;
    }
    let w = !1;
    if (window.MotionHandoffAnimation) {
      const C = Tb(e);
      if (C) {
        const T = window.MotionHandoffAnimation(C, p, _e);
        T !== null && (b.startTime = T, w = !0);
      }
    }
    Pc(e, p);
    const S = c ?? e.shouldReduceMotion;
    g.start(bd(p, g, y, S && Sb.has(p) ? { type: !1 } : b, e, w));
    const E = g.animation;
    E && d.push(E);
  }
  if (s) {
    const p = () => _e.update(() => {
      s && xM(e, s);
    });
    d.length ? Promise.all(d).then(p) : p();
  }
  return d;
}
function Ec(e, t, n = {}) {
  var l;
  const r = pr(e, t, n.type === "exit" ? (l = e.presenceContext) == null ? void 0 : l.custom : void 0);
  let { transition: o = e.getDefaultTransition() || {} } = r || {};
  n.transitionOverride && (o = n.transitionOverride);
  const i = r ? () => Promise.all(Pb(e, r, n)) : () => Promise.resolve(), s = e.variantChildren && e.variantChildren.size ? (c = 0) => {
    const { delayChildren: u = 0, staggerChildren: d, staggerDirection: f } = o;
    return PM(e, t, c, u, d, f, n);
  } : () => Promise.resolve(), { when: a } = o;
  if (a) {
    const [c, u] = a === "beforeChildren" ? [i, s] : [s, i];
    return c().then(() => u());
  } else
    return Promise.all([i(), s(n.delay)]);
}
function PM(e, t, n = 0, r = 0, o = 0, i = 1, s) {
  const a = [];
  for (const l of e.variantChildren)
    l.notify("AnimationStart", t), a.push(Ec(l, t, {
      ...s,
      delay: n + (typeof r == "function" ? 0 : r) + bb(e.variantChildren, l, r, o, i)
    }).then(() => l.notify("AnimationComplete", t)));
  return Promise.all(a);
}
function EM(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let r;
  if (Array.isArray(t)) {
    const o = t.map((i) => Ec(e, i, n));
    r = Promise.all(o);
  } else if (typeof t == "string")
    r = Ec(e, t, n);
  else {
    const o = typeof t == "function" ? pr(e, t, n.custom) : t;
    r = Promise.all(Pb(e, o, n));
  }
  return r.then(() => {
    e.notify("AnimationComplete", t);
  });
}
const kM = {
  test: (e) => e === "auto",
  parse: (e) => e
}, Eb = (e) => (t) => t.test(e), kb = [So, te, Sn, An, JD, ZD, kM], Fh = (e) => kb.find(Eb(e));
function DM(e) {
  return typeof e == "number" ? e === 0 : e !== null ? e === "none" || e === "0" || $y(e) : !0;
}
const RM = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function MM(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = n.match(fd) || [];
  if (!r)
    return e;
  const o = n.replace(r, "");
  let i = RM.has(t) ? 1 : 0;
  return r !== n && (i *= 100), t + "(" + i + o + ")";
}
const AM = /\b([a-z-]*)\(.*?\)/gu, kc = {
  ...on,
  getAnimatableNone: (e) => {
    const t = e.match(AM);
    return t ? t.map(MM).join(" ") : e;
  }
}, Dc = {
  ...on,
  getAnimatableNone: (e) => {
    const t = on.parse(e);
    return on.createTransformer(e)(t.map((r) => typeof r == "number" ? 0 : typeof r == "object" ? { ...r, alpha: 1 } : r));
  }
}, Vh = {
  ...So,
  transform: Math.round
}, OM = {
  rotate: An,
  /**
   * Internal channel for `transition.path` orientToPath. Composed onto
   * `rotate` at the transform-build sites so the user's `rotate` is
   * never read or overwritten. Not part of `transformPropOrder`.
   */
  pathRotation: An,
  rotateX: An,
  rotateY: An,
  rotateZ: An,
  scale: es,
  scaleX: es,
  scaleY: es,
  scaleZ: es,
  skew: An,
  skewX: An,
  skewY: An,
  distance: te,
  translateX: te,
  translateY: te,
  translateZ: te,
  x: te,
  y: te,
  z: te,
  perspective: te,
  transformPerspective: te,
  opacity: ai,
  originX: Ph,
  originY: Ph,
  originZ: te
}, $s = {
  // Border props
  borderWidth: te,
  borderTopWidth: te,
  borderRightWidth: te,
  borderBottomWidth: te,
  borderLeftWidth: te,
  borderRadius: te,
  borderTopLeftRadius: te,
  borderTopRightRadius: te,
  borderBottomRightRadius: te,
  borderBottomLeftRadius: te,
  // Positioning props
  width: te,
  maxWidth: te,
  height: te,
  maxHeight: te,
  top: te,
  right: te,
  bottom: te,
  left: te,
  inset: te,
  insetBlock: te,
  insetBlockStart: te,
  insetBlockEnd: te,
  insetInline: te,
  insetInlineStart: te,
  insetInlineEnd: te,
  // Spacing props
  padding: te,
  paddingTop: te,
  paddingRight: te,
  paddingBottom: te,
  paddingLeft: te,
  paddingBlock: te,
  paddingBlockStart: te,
  paddingBlockEnd: te,
  paddingInline: te,
  paddingInlineStart: te,
  paddingInlineEnd: te,
  margin: te,
  marginTop: te,
  marginRight: te,
  marginBottom: te,
  marginLeft: te,
  marginBlock: te,
  marginBlockStart: te,
  marginBlockEnd: te,
  marginInline: te,
  marginInlineStart: te,
  marginInlineEnd: te,
  // Typography
  fontSize: te,
  // Misc
  backgroundPositionX: te,
  backgroundPositionY: te,
  ...OM,
  zIndex: Vh,
  // SVG
  fillOpacity: ai,
  strokeOpacity: ai,
  numOctaves: Vh
}, NM = {
  ...$s,
  // Color props
  color: rt,
  backgroundColor: rt,
  outlineColor: rt,
  fill: rt,
  stroke: rt,
  // Border props
  borderColor: rt,
  borderTopColor: rt,
  borderRightColor: rt,
  borderBottomColor: rt,
  borderLeftColor: rt,
  filter: kc,
  WebkitFilter: kc,
  mask: Dc,
  WebkitMask: Dc
}, Db = (e) => NM[e], _M = /* @__PURE__ */ new Set([kc, Dc]);
function Rb(e, t) {
  let n = Db(e);
  return _M.has(n) || (n = on), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const IM = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function LM(e, t, n) {
  let r = 0, o;
  for (; r < e.length && !o; ) {
    const i = e[r];
    typeof i == "string" && !IM.has(i) && uo(i).values.length && (o = e[r]), r++;
  }
  if (o && n)
    for (const i of t)
      e[i] = Rb(n, o);
}
class $M extends vd {
  constructor(t, n, r, o, i) {
    super(t, n, r, o, i, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, element: n, name: r } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let u = 0; u < t.length; u++) {
      let d = t[u];
      if (typeof d == "string" && (d = d.trim(), dd(d))) {
        const f = xb(d, n.current);
        f !== void 0 && (t[u] = f), u === t.length - 1 && (this.finalKeyframe = d);
      }
    }
    if (this.resolveNoneKeyframes(), !Sb.has(r) || t.length !== 2)
      return;
    const [o, i] = t, s = Fh(o), a = Fh(i), l = Th(o), c = Th(i);
    if (l !== c && Kn[r]) {
      this.needsMeasurement = !0;
      return;
    }
    if (s !== a)
      if (Nh(s) && Nh(a))
        for (let u = 0; u < t.length; u++) {
          const d = t[u];
          typeof d == "string" && (t[u] = parseFloat(d));
        }
      else Kn[r] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: t, name: n } = this, r = [];
    for (let o = 0; o < t.length; o++)
      (t[o] === null || DM(t[o])) && r.push(o);
    r.length && LM(t, r, n);
  }
  measureInitialState() {
    const { element: t, unresolvedKeyframes: n, name: r } = this;
    if (!t || !t.current)
      return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = Kn[r](t.measureViewportBox(), window.getComputedStyle(t.current)), n[0] = this.measuredOrigin;
    const o = n[n.length - 1];
    o !== void 0 && t.getValue(r, o).jump(o, !1);
  }
  measureEndState() {
    var a;
    const { element: t, name: n, unresolvedKeyframes: r } = this;
    if (!t || !t.current)
      return;
    const o = t.getValue(n);
    o && o.jump(this.measuredOrigin, !1);
    const i = r.length - 1, s = r[i];
    r[i] = Kn[n](t.measureViewportBox(), window.getComputedStyle(t.current)), s !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = s), (a = this.removedTransforms) != null && a.length && this.removedTransforms.forEach(([l, c]) => {
      t.getValue(l).set(c);
    }), this.resolveNoneKeyframes();
  }
}
const Sd = [
  "borderTopLeftRadius",
  "borderTopRightRadius",
  "borderBottomRightRadius",
  "borderBottomLeftRadius"
];
function Mb(e, t, n) {
  if (e == null)
    return [];
  if (e instanceof EventTarget)
    return [e];
  if (typeof e == "string") {
    let r = document;
    const o = (n == null ? void 0 : n[e]) ?? r.querySelectorAll(e);
    return o ? Array.from(o) : [];
  }
  return Array.from(e).filter((r) => r != null);
}
const Rc = (e, t) => t && typeof e == "number" ? t.transform(e) : e;
function FM(e) {
  return Ly(e) && "offsetHeight" in e && !("ownerSVGElement" in e);
}
const { schedule: Cd } = /* @__PURE__ */ qy(queueMicrotask, !1), nn = {
  x: !1,
  y: !1
};
function Ab() {
  return nn.x || nn.y;
}
function VM(e) {
  return e === "x" || e === "y" ? nn[e] ? null : (nn[e] = !0, () => {
    nn[e] = !1;
  }) : nn.x || nn.y ? null : (nn.x = nn.y = !0, () => {
    nn.x = nn.y = !1;
  });
}
function Ob(e, t) {
  const n = Mb(e), r = new AbortController(), o = {
    passive: !0,
    ...t,
    signal: r.signal
  };
  return [n, o, () => r.abort()];
}
function BM(e) {
  return !(e.pointerType === "touch" || Ab());
}
function WM(e, t, n = {}) {
  const [r, o, i] = Ob(e, n);
  return r.forEach((s) => {
    let a = !1, l = !1, c;
    const u = () => {
      s.removeEventListener("pointerleave", p);
    }, d = (y) => {
      c && (c(y), c = void 0), u();
    }, f = (y) => {
      a = !1, window.removeEventListener("pointerup", f), window.removeEventListener("pointercancel", f), l && (l = !1, d(y));
    }, m = () => {
      a = !0, window.addEventListener("pointerup", f, o), window.addEventListener("pointercancel", f, o);
    }, p = (y) => {
      if (y.pointerType !== "touch") {
        if (a) {
          l = !0;
          return;
        }
        d(y);
      }
    }, g = (y) => {
      if (!BM(y))
        return;
      l = !1;
      const b = t(s, y);
      typeof b == "function" && (c = b, s.addEventListener("pointerleave", p, o));
    };
    s.addEventListener("pointerenter", g, o), s.addEventListener("pointerdown", m, o);
  }), i;
}
const Nb = (e, t) => t ? e === t ? !0 : Nb(e, t.parentElement) : !1, Td = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1, zM = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function jM(e) {
  return zM.has(e.tagName) || e.isContentEditable === !0;
}
const HM = /* @__PURE__ */ new Set(["INPUT", "SELECT", "TEXTAREA"]);
function UM(e) {
  return HM.has(e.tagName) || e.isContentEditable === !0;
}
const us = /* @__PURE__ */ new WeakSet();
function Bh(e) {
  return (t) => {
    t.key === "Enter" && e(t);
  };
}
function rl(e, t) {
  e.dispatchEvent(new PointerEvent("pointer" + t, { isPrimary: !0, bubbles: !0 }));
}
const YM = (e, t) => {
  const n = e.currentTarget;
  if (!n)
    return;
  const r = Bh(() => {
    if (us.has(n))
      return;
    rl(n, "down");
    const o = Bh(() => {
      rl(n, "up");
    }), i = () => rl(n, "cancel");
    n.addEventListener("keyup", o, t), n.addEventListener("blur", i, t);
  });
  n.addEventListener("keydown", r, t), n.addEventListener("blur", () => n.removeEventListener("keydown", r), t);
};
function Wh(e) {
  return Td(e) && !Ab();
}
const zh = /* @__PURE__ */ new WeakSet();
function GM(e, t, n = {}) {
  const [r, o, i] = Ob(e, n), s = (a) => {
    const l = a.currentTarget;
    if (!Wh(a) || zh.has(a))
      return;
    us.add(l), n.stopPropagation && zh.add(a);
    const c = t(l, a), u = { ...o, capture: !0 }, d = (p, g) => {
      window.removeEventListener("pointerup", f, u), window.removeEventListener("pointercancel", m, u), us.has(l) && us.delete(l), Wh(p) && typeof c == "function" && c(p, { success: g });
    }, f = (p) => {
      d(p, l === window || l === document || n.useGlobalTarget || Nb(l, p.target));
    }, m = (p) => {
      d(p, !1);
    };
    window.addEventListener("pointerup", f, u), window.addEventListener("pointercancel", m, u);
  };
  return r.forEach((a) => {
    (n.useGlobalTarget ? window : a).addEventListener("pointerdown", s, o), FM(a) && (a.addEventListener("focus", (c) => YM(c, o)), !jM(a) && !a.hasAttribute("tabindex") && (a.tabIndex = 0));
  }), i;
}
function Pd(e) {
  return Ly(e) && "ownerSVGElement" in e;
}
const ds = /* @__PURE__ */ new WeakMap();
let Yn;
const _b = (e, t, n) => (r, o) => o && o[0] ? o[0][e + "Size"] : Pd(r) && "getBBox" in r ? r.getBBox()[t] : r[n], KM = /* @__PURE__ */ _b("inline", "width", "offsetWidth"), XM = /* @__PURE__ */ _b("block", "height", "offsetHeight");
function qM({ target: e, borderBoxSize: t }) {
  var n;
  (n = ds.get(e)) == null || n.forEach((r) => {
    r(e, {
      get width() {
        return KM(e, t);
      },
      get height() {
        return XM(e, t);
      }
    });
  });
}
function QM(e) {
  e.forEach(qM);
}
function ZM() {
  typeof ResizeObserver > "u" || (Yn = new ResizeObserver(QM));
}
function JM(e, t) {
  Yn || ZM();
  const n = Mb(e);
  return n.forEach((r) => {
    let o = ds.get(r);
    o || (o = /* @__PURE__ */ new Set(), ds.set(r, o)), o.add(t), Yn == null || Yn.observe(r);
  }), () => {
    n.forEach((r) => {
      const o = ds.get(r);
      o == null || o.delete(t), o != null && o.size || Yn == null || Yn.unobserve(r);
    });
  };
}
const fs = /* @__PURE__ */ new Set();
let Jr;
function eA() {
  Jr = () => {
    const e = {
      get width() {
        return window.innerWidth;
      },
      get height() {
        return window.innerHeight;
      }
    };
    fs.forEach((t) => t(e));
  }, window.addEventListener("resize", Jr);
}
function tA(e) {
  return fs.add(e), Jr || eA(), () => {
    fs.delete(e), !fs.size && typeof Jr == "function" && (window.removeEventListener("resize", Jr), Jr = void 0);
  };
}
function jh(e, t) {
  return typeof e == "function" ? tA(e) : JM(e, t);
}
function nA(e) {
  return Pd(e) && e.tagName === "svg";
}
function rA(...e) {
  const t = !Array.isArray(e[0]), n = t ? 0 : -1, r = e[0 + n], o = e[1 + n], i = e[2 + n], s = e[3 + n], a = ab(o, i, s);
  return t ? a(r) : a;
}
const oA = [...kb, rt, on], iA = (e) => oA.find(Eb(e)), Hh = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), eo = () => ({
  x: Hh(),
  y: Hh()
}), Uh = () => ({ min: 0, max: 0 }), st = () => ({
  x: Uh(),
  y: Uh()
}), sA = /* @__PURE__ */ new WeakMap();
function ya(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
function li(e) {
  return typeof e == "string" || Array.isArray(e);
}
const Ed = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], kd = ["initial", ...Ed];
function ba(e) {
  return ya(e.animate) || kd.some((t) => li(e[t]));
}
function Ib(e) {
  return !!(ba(e) || e.variants);
}
function aA(e, t, n) {
  for (const r in t) {
    const o = t[r], i = n[r];
    if (ht(o))
      e.addValue(r, o);
    else if (ht(i))
      e.addValue(r, Cr(o, { owner: e }));
    else if (i !== o)
      if (e.hasValue(r)) {
        const s = e.getValue(r);
        s.liveStyle === !0 ? s.jump(o) : s.hasAnimated || s.set(o);
      } else {
        const s = e.getStaticValue(r);
        e.addValue(r, Cr(s !== void 0 ? s : o, { owner: e }));
      }
  }
  for (const r in n)
    t[r] === void 0 && e.removeValue(r);
  return t;
}
const Mc = { current: null }, Lb = { current: !1 }, lA = typeof window < "u";
function cA() {
  if (Lb.current = !0, !!lA)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => Mc.current = e.matches;
      e.addEventListener("change", t), t();
    } else
      Mc.current = !1;
}
const Yh = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
let Fs = {};
function $b(e) {
  Fs = e;
}
function uA() {
  return Fs;
}
class dA {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, n, r) {
    return {};
  }
  constructor({ parent: t, props: n, presenceContext: r, reducedMotionConfig: o, skipAnimations: i, blockInitialAnimation: s, visualState: a }, l = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.shouldSkipAnimations = !1, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = vd, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.hasBeenMounted = !1, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const m = Tt.now();
      this.renderScheduledAt < m && (this.renderScheduledAt = m, _e.render(this.render, !1, !0));
    };
    const { latestValues: c, renderState: u } = a;
    this.latestValues = c, this.baseTarget = { ...c }, this.initialValues = n.initial ? { ...c } : {}, this.renderState = u, this.parent = t, this.props = n, this.presenceContext = r, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = o, this.skipAnimationsConfig = i, this.options = l, this.blockInitialAnimation = !!s, this.isControllingVariants = ba(n), this.isVariantNode = Ib(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: d, ...f } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const m in f) {
      const p = f[m];
      c[m] !== void 0 && ht(p) && p.set(c[m]);
    }
  }
  mount(t) {
    var n, r;
    if (this.hasBeenMounted)
      for (const o in this.initialValues)
        (n = this.values.get(o)) == null || n.jump(this.initialValues[o]), this.latestValues[o] = this.initialValues[o];
    this.current = t, sA.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((o, i) => this.bindToMotionValue(i, o)), this.reducedMotionConfig === "never" ? this.shouldReduceMotion = !1 : this.reducedMotionConfig === "always" ? this.shouldReduceMotion = !0 : (Lb.current || cA(), this.shouldReduceMotion = Mc.current), process.env.NODE_ENV !== "production" && ld(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), this.shouldSkipAnimations = this.skipAnimationsConfig ?? !1, (r = this.parent) == null || r.addChild(this), this.update(this.props, this.presenceContext), this.hasBeenMounted = !0;
  }
  unmount() {
    var t;
    this.projection && this.projection.unmount(), Vn(this.notifyUpdate), Vn(this.render), this.valueSubscriptions.forEach((n) => n()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), (t = this.parent) == null || t.removeChild(this);
    for (const n in this.events)
      this.events[n].clear();
    for (const n in this.features) {
      const r = this.features[n];
      r && (r.unmount(), r.isMounted = !1);
    }
    this.current = null;
  }
  addChild(t) {
    this.children.add(t), this.enteringChildren ?? (this.enteringChildren = /* @__PURE__ */ new Set()), this.enteringChildren.add(t);
  }
  removeChild(t) {
    this.children.delete(t), this.enteringChildren && this.enteringChildren.delete(t);
  }
  bindToMotionValue(t, n) {
    if (this.valueSubscriptions.has(t) && this.valueSubscriptions.get(t)(), n.accelerate && yb.has(t) && this.current instanceof HTMLElement) {
      const { factory: s, keyframes: a, times: l, ease: c, duration: u } = n.accelerate, d = new gb({
        element: this.current,
        name: t,
        keyframes: a,
        times: l,
        ease: c,
        duration: /* @__PURE__ */ Nt(u)
      }), f = s(d);
      this.valueSubscriptions.set(t, () => {
        f(), d.cancel();
      });
      return;
    }
    const r = To.has(t);
    r && this.onBindTransform && this.onBindTransform();
    const o = n.on("change", (s) => {
      this.latestValues[t] = s, this.props.onUpdate && _e.preRender(this.notifyUpdate), r && this.projection && (this.projection.isTransformDirty = !0), this.scheduleRender();
    });
    let i;
    typeof window < "u" && window.MotionCheckAppearSync && (i = window.MotionCheckAppearSync(this, t, n)), this.valueSubscriptions.set(t, () => {
      o(), i && i();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  updateFeatures() {
    let t = "animation";
    for (t in Fs) {
      const n = Fs[t];
      if (!n)
        continue;
      const { isEnabled: r, Feature: o } = n;
      if (!this.features[t] && o && r(this.props) && (this.features[t] = new o(this)), this.features[t]) {
        const i = this.features[t];
        i.isMounted ? i.update() : (i.mount(), i.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : st();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < Yh.length; r++) {
      const o = Yh[r];
      this.propEventSubscriptions[o] && (this.propEventSubscriptions[o](), delete this.propEventSubscriptions[o]);
      const i = "on" + o, s = t[i];
      s && (this.propEventSubscriptions[o] = this.on(o, s));
    }
    this.prevMotionValues = aA(this, this.scrapeMotionValuesFromProps(t, this.prevProps || {}, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, n) {
    const r = this.values.get(t);
    n !== r && (r && this.removeValue(t), this.bindToMotionValue(t, n), this.values.set(t, n), this.latestValues[t] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let r = this.values.get(t);
    return r === void 0 && n !== void 0 && (r = Cr(n === null ? void 0 : n, { owner: this }), this.addValue(t, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t, n) {
    let r = this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : this.getBaseTargetFromProps(this.props, t) ?? this.readValueFromInstance(this.current, t, this.options);
    return r != null && (typeof r == "string" && (Iy(r) || $y(r)) ? r = parseFloat(r) : !iA(r) && on.test(n) && (r = Rb(t, n)), this.setBaseTarget(t, ht(r) ? r.get() : r)), ht(r) ? r.get() : r;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    var i;
    const { initial: n } = this.props;
    let r;
    if (typeof n == "string" || typeof n == "object") {
      const s = wd(this.props, n, (i = this.presenceContext) == null ? void 0 : i.custom);
      s && (r = s[t]);
    }
    if (n && r !== void 0)
      return r;
    const o = this.getBaseTargetFromProps(this.props, t);
    return o !== void 0 && !ht(o) ? o : this.initialValues[t] !== void 0 && r === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new ad()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
  scheduleRenderMicrotask() {
    Cd.render(this.render);
  }
}
class Fb extends dA {
  constructor() {
    super(...arguments), this.KeyframeResolver = $M;
  }
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    const r = t.style;
    return r ? r[n] : void 0;
  }
  removeValueFromRenderState(t, { vars: n, style: r }) {
    delete n[t], delete r[t];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    ht(t) && (this.childSubscription = t.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
class rr {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
function Vb({ top: e, left: t, right: n, bottom: r }) {
  return {
    x: { min: t, max: n },
    y: { min: e, max: r }
  };
}
function fA({ x: e, y: t }) {
  return { top: t.min, right: e.max, bottom: t.max, left: e.min };
}
function hA(e, t) {
  if (!t)
    return e;
  const n = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function ol(e) {
  return e === void 0 || e === 1;
}
function Ac({ scale: e, scaleX: t, scaleY: n }) {
  return !ol(e) || !ol(t) || !ol(n);
}
function lr(e) {
  return Ac(e) || Bb(e) || e.z || e.rotate || e.rotateX || e.rotateY || e.skewX || e.skewY;
}
function Bb(e) {
  return Gh(e.x) || Gh(e.y);
}
function Gh(e) {
  return e && e !== "0%";
}
function Vs(e, t, n) {
  const r = e - n, o = t * r;
  return n + o;
}
function Kh(e, t, n, r, o) {
  return o !== void 0 && (e = Vs(e, o, r)), Vs(e, n, r) + t;
}
function Oc(e, t = 0, n = 1, r, o) {
  e.min = Kh(e.min, t, n, r, o), e.max = Kh(e.max, t, n, r, o);
}
function Wb(e, { x: t, y: n }) {
  Oc(e.x, t.translate, t.scale, t.originPoint), Oc(e.y, n.translate, n.scale, n.originPoint);
}
const Xh = 0.999999999999, qh = 1.0000000000001;
function mA(e, t, n, r = !1) {
  var a;
  const o = n.length;
  if (!o)
    return;
  t.x = t.y = 1;
  let i, s;
  for (let l = 0; l < o; l++) {
    i = n[l], s = i.projectionDelta;
    const { visualElement: c } = i.options;
    c && c.props.style && c.props.style.display === "contents" || (r && i.options.layoutScroll && i.scroll && i !== i.root && (vn(e.x, -i.scroll.offset.x), vn(e.y, -i.scroll.offset.y)), s && (t.x *= s.x.scale, t.y *= s.y.scale, Wb(e, s)), r && lr(i.latestValues) && hs(e, i.latestValues, (a = i.layout) == null ? void 0 : a.layoutBox));
  }
  t.x < qh && t.x > Xh && (t.x = 1), t.y < qh && t.y > Xh && (t.y = 1);
}
function vn(e, t) {
  e.min += t, e.max += t;
}
function Qh(e, t, n, r, o = 0.5) {
  const i = Ne(e.min, e.max, o);
  Oc(e, t, n, i, r);
}
function Zh(e, t) {
  return typeof e == "string" ? parseFloat(e) / 100 * (t.max - t.min) : e;
}
function hs(e, t, n) {
  const r = n ?? e;
  Qh(e.x, Zh(t.x, r.x), t.scaleX, t.scale, t.originX), Qh(e.y, Zh(t.y, r.y), t.scaleY, t.scale, t.originY);
}
function zb(e, t) {
  return Vb(hA(e.getBoundingClientRect(), t));
}
function pA(e, t, n) {
  const r = zb(e, n), { scroll: o } = t;
  return o && (vn(r.x, o.offset.x), vn(r.y, o.offset.y)), r;
}
const gA = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, vA = Co.length;
function yA(e, t, n) {
  let r = "", o = !0;
  for (let s = 0; s < vA; s++) {
    const a = Co[s], l = e[a];
    if (l === void 0)
      continue;
    let c = !0;
    if (typeof l == "number")
      c = l === (a.startsWith("scale") ? 1 : 0);
    else {
      const u = parseFloat(l);
      c = a.startsWith("scale") ? u === 1 : u === 0;
    }
    if (!c || n) {
      const u = Rc(l, $s[a]);
      if (!c) {
        o = !1;
        const d = gA[a] || a;
        r += `${d}(${u}) `;
      }
      n && (t[a] = u);
    }
  }
  const i = e.pathRotation;
  return i && (o = !1, r += `rotate(${Rc(i, $s.pathRotation)}) `), r = r.trim(), n ? r = n(t, o ? "" : r) : o && (r = "none"), r;
}
function Dd(e, t, n) {
  const { style: r, vars: o, transformOrigin: i } = e;
  let s = !1, a = !1;
  for (const l in t) {
    const c = t[l];
    if (To.has(l)) {
      s = !0;
      continue;
    } else if (Zy(l)) {
      o[l] = c;
      continue;
    } else {
      const u = Rc(c, $s[l]);
      l.startsWith("origin") ? (a = !0, i[l] = u) : r[l] = u;
    }
  }
  if (t.transform || (s || n ? r.transform = yA(t, e.transform, n) : r.transform && (r.transform = "none")), a) {
    const { originX: l = "50%", originY: c = "50%", originZ: u = 0 } = i;
    r.transformOrigin = `${l} ${c} ${u}`;
  }
}
function jb(e, { style: t, vars: n }, r, o) {
  const i = e.style;
  let s;
  for (s in t)
    i[s] = t[s];
  o == null || o.applyProjectionStyles(i, r);
  for (s in n)
    i.setProperty(s, n[s]);
}
function Jh(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const Oo = {
  correct: (e, t) => {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (te.test(e))
        e = parseFloat(e);
      else
        return e;
    const n = Jh(e, t.target.x), r = Jh(e, t.target.y);
    return `${n}% ${r}%`;
  }
}, bA = {
  correct: (e, { treeScale: t, projectionDelta: n }) => {
    const r = e, o = on.parse(e);
    if (o.length > 5)
      return r;
    const i = on.createTransformer(e), s = typeof o[0] != "number" ? 1 : 0, a = n.x.scale * t.x, l = n.y.scale * t.y;
    o[0 + s] /= a, o[1 + s] /= l;
    const c = Ne(a, l, 0.5);
    return typeof o[2 + s] == "number" && (o[2 + s] /= c), typeof o[3 + s] == "number" && (o[3 + s] /= c), i(o);
  }
}, Nc = {
  borderRadius: {
    ...Oo,
    applyTo: [...Sd]
  },
  borderTopLeftRadius: Oo,
  borderTopRightRadius: Oo,
  borderBottomLeftRadius: Oo,
  borderBottomRightRadius: Oo,
  boxShadow: bA
};
function Hb(e, { layout: t, layoutId: n }) {
  return To.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!Nc[e] || e === "opacity");
}
function Rd(e, t, n) {
  var s;
  const r = e.style, o = t == null ? void 0 : t.style, i = {};
  if (!r)
    return i;
  for (const a in r)
    (ht(r[a]) || o && ht(o[a]) || Hb(a, e) || ((s = n == null ? void 0 : n.getValue(a)) == null ? void 0 : s.liveStyle) !== void 0) && (i[a] = r[a]);
  return i;
}
function wA(e) {
  return window.getComputedStyle(e);
}
class xA extends Fb {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = jb;
  }
  readValueFromInstance(t, n) {
    var r;
    if (To.has(n))
      return (r = this.projection) != null && r.isProjecting ? yc(n) : FR(t, n);
    {
      const o = wA(t), i = (Zy(n) ? o.getPropertyValue(n) : o[n]) || 0;
      return typeof i == "string" ? i.trim() : i;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: n }) {
    return zb(t, n);
  }
  build(t, n, r) {
    Dd(t, n, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return Rd(t, n, r);
  }
}
const SA = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, CA = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function TA(e, t, n = 1, r = 0, o = !0) {
  e.pathLength = 1;
  const i = o ? SA : CA;
  e[i.offset] = `${-r}`, e[i.array] = `${t} ${n}`;
}
const PA = [
  "offsetDistance",
  "offsetPath",
  "offsetRotate",
  "offsetAnchor"
];
function Ub(e, {
  attrX: t,
  attrY: n,
  attrScale: r,
  pathLength: o,
  pathSpacing: i = 1,
  pathOffset: s = 0,
  // This is object creation, which we try to avoid per-frame.
  ...a
}, l, c, u) {
  if (Dd(e, a, c), l) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: d, style: f } = e;
  d.transform && (f.transform = d.transform, delete d.transform), (f.transform || d.transformOrigin) && (f.transformOrigin = d.transformOrigin ?? "50% 50%", delete d.transformOrigin), f.transform && (f.transformBox = (u == null ? void 0 : u.transformBox) ?? "fill-box", delete d.transformBox);
  for (const m of PA)
    d[m] !== void 0 && (f[m] = d[m], delete d[m]);
  t !== void 0 && (d.x = t), n !== void 0 && (d.y = n), r !== void 0 && (d.scale = r), o !== void 0 && TA(d, o, i, s, !1);
}
const Yb = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]), Gb = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function EA(e, t, n, r) {
  jb(e, t, void 0, r);
  for (const o in t.attrs)
    e.setAttribute(Yb.has(o) ? o : xd(o), t.attrs[o]);
}
function Kb(e, t, n) {
  const r = Rd(e, t, n);
  for (const o in e)
    if (ht(e[o]) || ht(t[o])) {
      const i = Co.indexOf(o) !== -1 ? "attr" + o.charAt(0).toUpperCase() + o.substring(1) : o;
      r[i] = e[o];
    }
  return r;
}
class kA extends Fb {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = st;
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if (To.has(n)) {
      const r = Db(n);
      return r && r.default || 0;
    }
    return n = Yb.has(n) ? n : xd(n), t.getAttribute(n);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return Kb(t, n, r);
  }
  build(t, n, r) {
    Ub(t, n, this.isSVGTag, r.transformTemplate, r.style);
  }
  renderInstance(t, n, r, o) {
    EA(t, n, r, o);
  }
  mount(t) {
    this.isSVGTag = Gb(t.tagName), super.mount(t);
  }
}
const DA = kd.length;
function Xb(e) {
  if (!e)
    return;
  if (!e.isControllingVariants) {
    const n = e.parent ? Xb(e.parent) || {} : {};
    return e.props.initial !== void 0 && (n.initial = e.props.initial), n;
  }
  const t = {};
  for (let n = 0; n < DA; n++) {
    const r = kd[n], o = e.props[r];
    (li(o) || o === !1) && (t[r] = o);
  }
  return t;
}
function qb(e, t) {
  if (!Array.isArray(t))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
const RA = [...Ed].reverse(), MA = Ed.length;
function AA(e) {
  return (t) => Promise.all(t.map(({ animation: n, options: r }) => EM(e, n, r)));
}
function OA(e) {
  let t = AA(e), n = em(), r = !0, o = !1;
  const i = (c) => (u, d) => {
    var m;
    const f = pr(e, d, c === "exit" ? (m = e.presenceContext) == null ? void 0 : m.custom : void 0);
    if (f) {
      const { transition: p, transitionEnd: g, ...y } = f;
      u = { ...u, ...y, ...g };
    }
    return u;
  };
  function s(c) {
    t = c(e);
  }
  function a(c) {
    const { props: u } = e, d = Xb(e.parent) || {}, f = [], m = /* @__PURE__ */ new Set();
    let p = {}, g = 1 / 0;
    for (let b = 0; b < MA; b++) {
      const x = RA[b], w = n[x], S = u[x] !== void 0 ? u[x] : d[x], E = li(S), C = x === c ? w.isActive : null;
      C === !1 && (g = b);
      let T = S === d[x] && S !== u[x] && E;
      if (T && (r || o) && e.manuallyAnimateOnMount && (T = !1), w.protectedKeys = { ...p }, // If it isn't active and hasn't *just* been set as inactive
      !w.isActive && C === null || // If we didn't and don't have any defined prop for this animation type
      !S && !w.prevProp || // Or if the prop doesn't define an animation
      ya(S) || typeof S == "boolean")
        continue;
      if (x === "exit" && w.isActive && C !== !0) {
        w.prevResolvedValues && (p = {
          ...p,
          ...w.prevResolvedValues
        });
        continue;
      }
      const P = NA(w.prevProp, S);
      let D = P || // If we're making this variant active, we want to always make it active
      x === c && w.isActive && !T && E || // If we removed a higher-priority variant (i is in reverse order)
      b > g && E, k = !1;
      const R = Array.isArray(S) ? S : [S];
      let O = R.reduce(i(x), {});
      C === !1 && (O = {});
      const { prevResolvedValues: _ = {} } = w, $ = {
        ..._,
        ...O
      }, z = (M) => {
        D = !0, m.has(M) && (k = !0, m.delete(M)), w.needsAnimating[M] = !0;
        const F = e.getValue(M);
        F && (F.liveStyle = !1);
      };
      for (const M in $) {
        const F = O[M], W = _[M];
        if (p.hasOwnProperty(M))
          continue;
        let ne = !1;
        Tc(F) && Tc(W) ? ne = !qb(F, W) || P : ne = F !== W, ne ? F != null ? z(M) : m.add(M) : F !== void 0 && m.has(M) ? z(M) : w.protectedKeys[M] = !0;
      }
      w.prevProp = S, w.prevResolvedValues = O, w.isActive && (p = { ...p, ...O }), (r || o) && e.blockInitialAnimation && (D = !1);
      const I = T && P;
      D && (!I || k) && f.push(...R.map((M) => {
        const F = { type: x };
        if (typeof M == "string" && (r || o) && !I && e.manuallyAnimateOnMount && e.parent) {
          const { parent: W } = e, ne = pr(W, M);
          if (W.enteringChildren && ne) {
            const { delayChildren: N } = ne.transition || {};
            F.delay = bb(W.enteringChildren, e, N);
          }
        }
        return {
          animation: M,
          options: F
        };
      }));
    }
    if (m.size) {
      const b = {};
      if (typeof u.initial != "boolean") {
        const x = pr(e, Array.isArray(u.initial) ? u.initial[0] : u.initial);
        x && x.transition && (b.transition = x.transition);
      }
      m.forEach((x) => {
        const w = e.getBaseTarget(x), S = e.getValue(x);
        S && (S.liveStyle = !0), b[x] = w ?? null;
      }), f.push({ animation: b });
    }
    let y = !!f.length;
    return r && (u.initial === !1 || u.initial === u.animate) && !e.manuallyAnimateOnMount && (y = !1), r = !1, o = !1, y ? t(f) : Promise.resolve();
  }
  function l(c, u) {
    var f;
    if (n[c].isActive === u)
      return Promise.resolve();
    (f = e.variantChildren) == null || f.forEach((m) => {
      var p;
      return (p = m.animationState) == null ? void 0 : p.setActive(c, u);
    }), n[c].isActive = u;
    const d = a(c);
    for (const m in n)
      n[m].protectedKeys = {};
    return d;
  }
  return {
    animateChanges: a,
    setActive: l,
    setAnimateFunction: s,
    getState: () => n,
    reset: () => {
      n = em(), o = !0;
    }
  };
}
function NA(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !qb(t, e) : !1;
}
function sr(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function em() {
  return {
    animate: sr(!0),
    whileInView: sr(),
    whileHover: sr(),
    whileTap: sr(),
    whileDrag: sr(),
    whileFocus: sr(),
    exit: sr()
  };
}
function _c(e, t) {
  e.min = t.min, e.max = t.max;
}
function en(e, t) {
  _c(e.x, t.x), _c(e.y, t.y);
}
function tm(e, t) {
  e.translate = t.translate, e.scale = t.scale, e.originPoint = t.originPoint, e.origin = t.origin;
}
const Qb = 1e-4, _A = 1 - Qb, IA = 1 + Qb, Zb = 0.01, LA = 0 - Zb, $A = 0 + Zb;
function Pt(e) {
  return e.max - e.min;
}
function FA(e, t, n) {
  return Math.abs(e - t) <= n;
}
function nm(e, t, n, r = 0.5) {
  e.origin = r, e.originPoint = Ne(t.min, t.max, e.origin), e.scale = Pt(n) / Pt(t), e.translate = Ne(n.min, n.max, e.origin) - e.originPoint, (e.scale >= _A && e.scale <= IA || isNaN(e.scale)) && (e.scale = 1), (e.translate >= LA && e.translate <= $A || isNaN(e.translate)) && (e.translate = 0);
}
function Ho(e, t, n, r) {
  nm(e.x, t.x, n.x, r ? r.originX : void 0), nm(e.y, t.y, n.y, r ? r.originY : void 0);
}
function rm(e, t, n, r = 0) {
  const o = r ? Ne(n.min, n.max, r) : n.min;
  e.min = o + t.min, e.max = e.min + Pt(t);
}
function VA(e, t, n, r) {
  rm(e.x, t.x, n.x, r == null ? void 0 : r.x), rm(e.y, t.y, n.y, r == null ? void 0 : r.y);
}
function om(e, t, n, r = 0) {
  const o = r ? Ne(n.min, n.max, r) : n.min;
  e.min = t.min - o, e.max = e.min + Pt(t);
}
function Bs(e, t, n, r) {
  om(e.x, t.x, n.x, r == null ? void 0 : r.x), om(e.y, t.y, n.y, r == null ? void 0 : r.y);
}
function im(e, t, n, r, o) {
  return e -= t, e = Vs(e, 1 / n, r), o !== void 0 && (e = Vs(e, 1 / o, r)), e;
}
function BA(e, t = 0, n = 1, r = 0.5, o, i = e, s = e) {
  if (Sn.test(t) && (t = parseFloat(t), t = Ne(s.min, s.max, t / 100) - s.min), typeof t != "number")
    return;
  let a = Ne(i.min, i.max, r);
  e === i && (a -= t), e.min = im(e.min, t, n, a, o), e.max = im(e.max, t, n, a, o);
}
function sm(e, t, [n, r, o], i, s) {
  BA(e, t[n], t[r], t[o], t.scale, i, s);
}
const WA = ["x", "scaleX", "originX"], zA = ["y", "scaleY", "originY"];
function am(e, t, n, r) {
  sm(e.x, t, WA, n ? n.x : void 0, r ? r.x : void 0), sm(e.y, t, zA, n ? n.y : void 0, r ? r.y : void 0);
}
function lm(e) {
  return e.translate === 0 && e.scale === 1;
}
function Jb(e) {
  return lm(e.x) && lm(e.y);
}
function cm(e, t) {
  return e.min === t.min && e.max === t.max;
}
function jA(e, t) {
  return cm(e.x, t.x) && cm(e.y, t.y);
}
function um(e, t) {
  return Math.round(e.min) === Math.round(t.min) && Math.round(e.max) === Math.round(t.max);
}
function ew(e, t) {
  return um(e.x, t.x) && um(e.y, t.y);
}
function dm(e) {
  return Pt(e.x) / Pt(e.y);
}
function fm(e, t) {
  return e.translate === t.translate && e.scale === t.scale && e.originPoint === t.originPoint;
}
function gn(e) {
  return [e("x"), e("y")];
}
function HA(e, t, n) {
  let r = "";
  const o = e.x.translate / t.x, i = e.y.translate / t.y, s = (n == null ? void 0 : n.z) || 0;
  if ((o || i || s) && (r = `translate3d(${o}px, ${i}px, ${s}px) `), (t.x !== 1 || t.y !== 1) && (r += `scale(${1 / t.x}, ${1 / t.y}) `), n) {
    const { transformPerspective: c, rotate: u, pathRotation: d, rotateX: f, rotateY: m, skewX: p, skewY: g } = n;
    c && (r = `perspective(${c}px) ${r}`), u && (r += `rotate(${u}deg) `), d && (r += `rotate(${d}deg) `), f && (r += `rotateX(${f}deg) `), m && (r += `rotateY(${m}deg) `), p && (r += `skewX(${p}deg) `), g && (r += `skewY(${g}deg) `);
  }
  const a = e.x.scale * t.x, l = e.y.scale * t.y;
  return (a !== 1 || l !== 1) && (r += `scale(${a}, ${l})`), r || "none";
}
const UA = Sd.length, hm = (e) => typeof e == "string" ? parseFloat(e) : e, mm = (e) => typeof e == "number" || te.test(e);
function YA(e, t, n, r, o, i) {
  o ? (e.opacity = Ne(0, n.opacity ?? 1, GA(r)), e.opacityExit = Ne(t.opacity ?? 1, 0, KA(r))) : i && (e.opacity = Ne(t.opacity ?? 1, n.opacity ?? 1, r));
  for (let s = 0; s < UA; s++) {
    const a = Sd[s];
    let l = pm(t, a), c = pm(n, a);
    if (l === void 0 && c === void 0)
      continue;
    l || (l = 0), c || (c = 0), l === 0 || c === 0 || mm(l) === mm(c) ? (e[a] = Math.max(Ne(hm(l), hm(c), r), 0), (Sn.test(c) || Sn.test(l)) && (e[a] += "%")) : e[a] = c;
  }
  (t.rotate || n.rotate) && (e.rotate = Ne(t.rotate || 0, n.rotate || 0, r));
}
function pm(e, t) {
  return e[t] !== void 0 ? e[t] : e.borderRadius;
}
const GA = /* @__PURE__ */ tw(0, 0.5, Yy), KA = /* @__PURE__ */ tw(0.5, 0.95, Yt);
function tw(e, t, n) {
  return (r) => r < e ? 0 : r > t ? 1 : n(/* @__PURE__ */ si(e, t, r));
}
function XA(e, t, n) {
  const r = ht(e) ? e : Cr(e);
  return r.start(bd("", r, t, n)), r.animation;
}
function ci(e, t, n, r = { passive: !0 }) {
  return e.addEventListener(t, n, r), () => e.removeEventListener(t, n, r);
}
const qA = (e, t) => e.depth - t.depth;
class QA {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(t) {
    sd(this.children, t), this.isDirty = !0;
  }
  remove(t) {
    Os(this.children, t), this.isDirty = !0;
  }
  forEach(t) {
    this.isDirty && this.children.sort(qA), this.isDirty = !1, this.children.forEach(t);
  }
}
function ZA(e, t) {
  const n = Tt.now(), r = ({ timestamp: o }) => {
    const i = o - n;
    i >= t && (Vn(r), e(i - t));
  };
  return _e.setup(r, !0), () => Vn(r);
}
function ms(e) {
  return ht(e) ? e.get() : e;
}
class JA {
  constructor() {
    this.members = [];
  }
  add(t) {
    sd(this.members, t);
    for (let n = this.members.length - 1; n >= 0; n--) {
      const r = this.members[n];
      if (r === t || r === this.lead || r === this.prevLead)
        continue;
      const o = r.instance;
      (!o || o.isConnected === !1) && !r.snapshot && (Os(this.members, r), r.unmount());
    }
    t.scheduleRender();
  }
  remove(t) {
    if (Os(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(t) {
    var n;
    for (let r = this.members.indexOf(t) - 1; r >= 0; r--) {
      const o = this.members[r];
      if (o.isPresent !== !1 && ((n = o.instance) == null ? void 0 : n.isConnected) !== !1)
        return this.promote(o), !0;
    }
    return !1;
  }
  promote(t, n) {
    var o;
    const r = this.lead;
    if (t !== r && (this.prevLead = r, this.lead = t, t.show(), r)) {
      r.updateSnapshot(), t.scheduleRender();
      const { layoutDependency: i } = r.options, { layoutDependency: s } = t.options;
      (i === void 0 || i !== s) && (t.resumeFrom = r, n && (r.preserveOpacity = !0), r.snapshot && (t.snapshot = r.snapshot, t.snapshot.latestValues = r.animationValues || r.latestValues), (o = t.root) != null && o.isUpdating && (t.isLayoutDirty = !0)), t.options.crossfade === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((t) => {
      var n, r, o, i, s;
      (r = (n = t.options).onExitComplete) == null || r.call(n), (s = (o = t.resumingFrom) == null ? void 0 : (i = o.options).onExitComplete) == null || s.call(i);
    });
  }
  scheduleRender() {
    this.members.forEach((t) => t.instance && t.scheduleRender(!1));
  }
  removeLeadSnapshot() {
    var t;
    (t = this.lead) != null && t.snapshot && (this.lead.snapshot = void 0);
  }
}
const ps = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
}, il = ["", "X", "Y", "Z"], eO = 1e3;
let tO = 0;
function sl(e, t, n, r) {
  const { latestValues: o } = t;
  o[e] && (n[e] = o[e], t.setStaticValue(e, 0), r && (r[e] = 0));
}
function nw(e) {
  if (e.hasCheckedOptimisedAppear = !0, e.root === e)
    return;
  const { visualElement: t } = e.options;
  if (!t)
    return;
  const n = Tb(t);
  if (window.MotionHasOptimisedAnimation(n, "transform")) {
    const { layout: o, layoutId: i } = e.options;
    window.MotionCancelOptimisedAnimation(n, "transform", _e, !(o || i));
  }
  const { parent: r } = e;
  r && !r.hasCheckedOptimisedAppear && nw(r);
}
function rw({ attachResizeListener: e, defaultParent: t, measureScroll: n, checkIsScrollRoot: r, resetTransform: o }) {
  return class {
    constructor(s = {}, a = t == null ? void 0 : t()) {
      this.id = tO++, this.animationId = 0, this.animationCommitId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.layoutVersion = 0, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(oO), this.nodes.forEach(uO), this.nodes.forEach(dO), this.nodes.forEach(iO);
      }, this.resolvedRelativeTargetAt = 0, this.linkedParentVersion = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = s, this.root = a ? a.root || a : this, this.path = a ? [...a.path, a] : [], this.parent = a, this.depth = a ? a.depth + 1 : 0;
      for (let l = 0; l < this.path.length; l++)
        this.path[l].shouldResetTransform = !0;
      this.root === this && (this.nodes = new QA());
    }
    addEventListener(s, a) {
      return this.eventHandlers.has(s) || this.eventHandlers.set(s, new ad()), this.eventHandlers.get(s).add(a);
    }
    notifyListeners(s, ...a) {
      const l = this.eventHandlers.get(s);
      l && l.notify(...a);
    }
    hasListeners(s) {
      return this.eventHandlers.has(s);
    }
    /**
     * Lifecycles
     */
    mount(s) {
      if (this.instance)
        return;
      this.isSVG = Pd(s) && !nA(s), this.instance = s;
      const { layoutId: a, layout: l, visualElement: c } = this.options;
      if (c && !c.current && c.mount(s), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.root.hasTreeAnimated && (l || a) && (this.isLayoutDirty = !0), e) {
        let u, d = 0;
        const f = () => this.root.updateBlockedByResize = !1;
        _e.read(() => {
          d = window.innerWidth;
        }), e(s, () => {
          const m = window.innerWidth;
          m !== d && (d = m, this.root.updateBlockedByResize = !0, u && u(), u = ZA(f, 250), ps.hasAnimatedSinceResize && (ps.hasAnimatedSinceResize = !1, this.nodes.forEach(ym)));
        });
      }
      a && this.root.registerSharedNode(a, this), this.options.animate !== !1 && c && (a || l) && this.addEventListener("didUpdate", ({ delta: u, hasLayoutChanged: d, hasRelativeLayoutChanged: f, layout: m }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const p = this.options.transition || c.getDefaultTransition() || gO, { onLayoutAnimationStart: g, onLayoutAnimationComplete: y } = c.getProps(), b = !this.targetLayout || !ew(this.targetLayout, m), x = !d && f;
        if (this.options.layoutRoot || this.resumeFrom || x || d && (b || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0);
          const w = {
            ...yd(p, "layout"),
            onPlay: g,
            onComplete: y
          };
          (c.shouldReduceMotion || this.options.layoutRoot) && (w.delay = 0, w.type = !1), this.startAnimation(w), this.setAnimationOrigin(u, x, w.path);
        } else
          d || ym(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = m;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const s = this.getStack();
      s && s.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, this.eventHandlers.clear(), Vn(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(fO), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: s } = this.options;
      return s && s.getProps().transformTemplate;
    }
    willUpdate(s = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && nw(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let u = 0; u < this.path.length; u++) {
        const d = this.path[u];
        d.shouldResetTransform = !0, (typeof d.latestValues.x == "string" || typeof d.latestValues.y == "string") && (d.isLayoutDirty = !0), d.updateScroll("snapshot"), d.options.layoutRoot && d.willUpdate(!1);
      }
      const { layoutId: a, layout: l } = this.options;
      if (a === void 0 && !l)
        return;
      const c = this.getTransformTemplate();
      this.prevTransformTemplateValue = c ? c(this.latestValues, "") : void 0, this.updateSnapshot(), s && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        const l = this.updateBlockedByResize;
        this.unblockUpdate(), this.updateBlockedByResize = !1, this.clearAllSnapshots(), l && this.nodes.forEach(aO), this.nodes.forEach(gm);
        return;
      }
      if (this.animationId <= this.animationCommitId) {
        this.nodes.forEach(vm);
        return;
      }
      this.animationCommitId = this.animationId, this.isUpdating ? (this.isUpdating = !1, this.nodes.forEach(lO), this.nodes.forEach(cO), this.nodes.forEach(nO), this.nodes.forEach(rO)) : this.nodes.forEach(vm), this.clearAllSnapshots();
      const a = Tt.now();
      yt.delta = En(0, 1e3 / 60, a - yt.timestamp), yt.timestamp = a, yt.isProcessing = !0, Qa.update.process(yt), Qa.preRender.process(yt), Qa.render.process(yt), yt.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, Cd.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(sO), this.sharedNodes.forEach(hO);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, _e.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      _e.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !Pt(this.snapshot.measuredBox.x) && !Pt(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let l = 0; l < this.path.length; l++)
          this.path[l].updateScroll();
      const s = this.layout;
      this.layout = this.measure(!1), this.layoutVersion++, this.layoutCorrected || (this.layoutCorrected = st()), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: a } = this.options;
      a && a.notify("LayoutMeasure", this.layout.layoutBox, s ? s.layoutBox : void 0);
    }
    updateScroll(s = "measure") {
      let a = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === s && (a = !1), a && this.instance) {
        const l = r(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: s,
          isRoot: l,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : l
        };
      }
    }
    resetTransform() {
      if (!o)
        return;
      const s = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, a = this.projectionDelta && !Jb(this.projectionDelta), l = this.getTransformTemplate(), c = l ? l(this.latestValues, "") : void 0, u = c !== this.prevTransformTemplateValue;
      s && this.instance && (a || lr(this.latestValues) || u) && (o(this.instance, c), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(s = !0) {
      const a = this.measurePageBox();
      let l = this.removeElementScroll(a);
      return s && (l = this.removeTransform(l)), vO(l), {
        animationId: this.root.animationId,
        measuredBox: a,
        layoutBox: l,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var c;
      const { visualElement: s } = this.options;
      if (!s)
        return st();
      const a = s.measureViewportBox();
      if (!(((c = this.scroll) == null ? void 0 : c.wasRoot) || this.path.some(yO))) {
        const { scroll: u } = this.root;
        u && (vn(a.x, u.offset.x), vn(a.y, u.offset.y));
      }
      return a;
    }
    removeElementScroll(s) {
      var l;
      const a = st();
      if (en(a, s), (l = this.scroll) != null && l.wasRoot)
        return a;
      for (let c = 0; c < this.path.length; c++) {
        const u = this.path[c], { scroll: d, options: f } = u;
        u !== this.root && d && f.layoutScroll && (d.wasRoot && en(a, s), vn(a.x, d.offset.x), vn(a.y, d.offset.y));
      }
      return a;
    }
    applyTransform(s, a = !1, l) {
      var u, d;
      const c = l || st();
      en(c, s);
      for (let f = 0; f < this.path.length; f++) {
        const m = this.path[f];
        !a && m.options.layoutScroll && m.scroll && m !== m.root && (vn(c.x, -m.scroll.offset.x), vn(c.y, -m.scroll.offset.y)), lr(m.latestValues) && hs(c, m.latestValues, (u = m.layout) == null ? void 0 : u.layoutBox);
      }
      return lr(this.latestValues) && hs(c, this.latestValues, (d = this.layout) == null ? void 0 : d.layoutBox), c;
    }
    removeTransform(s) {
      var l;
      const a = st();
      en(a, s);
      for (let c = 0; c < this.path.length; c++) {
        const u = this.path[c];
        if (!lr(u.latestValues))
          continue;
        let d;
        u.instance && (Ac(u.latestValues) && u.updateSnapshot(), d = st(), en(d, u.measurePageBox())), am(a, u.latestValues, (l = u.snapshot) == null ? void 0 : l.layoutBox, d);
      }
      return lr(this.latestValues) && am(a, this.latestValues), a;
    }
    setTargetDelta(s) {
      this.targetDelta = s, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(s) {
      this.options = {
        ...this.options,
        ...s,
        crossfade: s.crossfade !== void 0 ? s.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== yt.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(s = !1) {
      var m;
      const a = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = a.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = a.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = a.isSharedProjectionDirty);
      const l = !!this.resumingFrom || this !== a;
      if (!(s || l && this.isSharedProjectionDirty || this.isProjectionDirty || (m = this.parent) != null && m.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: u, layoutId: d } = this.options;
      if (!this.layout || !(u || d))
        return;
      this.resolvedRelativeTargetAt = yt.timestamp;
      const f = this.getClosestProjectingParent();
      f && this.linkedParentVersion !== f.layoutVersion && !f.options.layoutRoot && this.removeRelativeTarget(), !this.targetDelta && !this.relativeTarget && (this.options.layoutAnchor !== !1 && f && f.layout ? this.createRelativeTarget(f, this.layout.layoutBox, f.layout.layoutBox) : this.removeRelativeTarget()), !(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = st(), this.targetWithTransforms = st()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), VA(this.target, this.relativeTarget, this.relativeParent.target, this.options.layoutAnchor || void 0)) : this.targetDelta ? (this.resumingFrom ? this.applyTransform(this.layout.layoutBox, !1, this.target) : en(this.target, this.layout.layoutBox), Wb(this.target, this.targetDelta)) : en(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget && (this.attemptToResolveRelativeTarget = !1, this.options.layoutAnchor !== !1 && f && !!f.resumingFrom == !!this.resumingFrom && !f.options.layoutScroll && f.target && this.animationProgress !== 1 ? this.createRelativeTarget(f, this.target, f.target) : this.relativeParent = this.relativeTarget = void 0));
    }
    getClosestProjectingParent() {
      if (!(!this.parent || Ac(this.parent.latestValues) || Bb(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    createRelativeTarget(s, a, l) {
      this.relativeParent = s, this.linkedParentVersion = s.layoutVersion, this.forceRelativeParentToResolveTarget(), this.relativeTarget = st(), this.relativeTargetOrigin = st(), Bs(this.relativeTargetOrigin, a, l, this.options.layoutAnchor || void 0), en(this.relativeTarget, this.relativeTargetOrigin);
    }
    removeRelativeTarget() {
      this.relativeParent = this.relativeTarget = void 0;
    }
    calcProjection() {
      var p;
      const s = this.getLead(), a = !!this.resumingFrom || this !== s;
      let l = !0;
      if ((this.isProjectionDirty || (p = this.parent) != null && p.isProjectionDirty) && (l = !1), a && (this.isSharedProjectionDirty || this.isTransformDirty) && (l = !1), this.resolvedRelativeTargetAt === yt.timestamp && (l = !1), l)
        return;
      const { layout: c, layoutId: u } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(c || u))
        return;
      en(this.layoutCorrected, this.layout.layoutBox);
      const d = this.treeScale.x, f = this.treeScale.y;
      mA(this.layoutCorrected, this.treeScale, this.path, a), s.layout && !s.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (s.target = s.layout.layoutBox, s.targetWithTransforms = st());
      const { target: m } = s;
      if (!m) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (tm(this.prevProjectionDelta.x, this.projectionDelta.x), tm(this.prevProjectionDelta.y, this.projectionDelta.y)), Ho(this.projectionDelta, this.layoutCorrected, m, this.latestValues), (this.treeScale.x !== d || this.treeScale.y !== f || !fm(this.projectionDelta.x, this.prevProjectionDelta.x) || !fm(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", m));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(s = !0) {
      var a;
      if ((a = this.options.visualElement) == null || a.scheduleRender(), s) {
        const l = this.getStack();
        l && l.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = eo(), this.projectionDelta = eo(), this.projectionDeltaWithTransform = eo();
    }
    setAnimationOrigin(s, a = !1, l) {
      const c = this.snapshot, u = c ? c.latestValues : {}, d = { ...this.latestValues }, f = eo();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !a;
      const m = st(), p = c ? c.source : void 0, g = this.layout ? this.layout.source : void 0, y = p !== g, b = this.getStack(), x = !b || b.members.length <= 1, w = !!(y && !x && this.options.crossfade === !0 && !this.path.some(pO));
      this.animationProgress = 0;
      let S;
      const E = l == null ? void 0 : l.interpolateProjection(s);
      this.mixTargetDelta = (C) => {
        const T = C / 1e3, P = E == null ? void 0 : E(T);
        P ? (f.x.translate = P.x, f.x.scale = Ne(s.x.scale, 1, T), f.x.origin = s.x.origin, f.x.originPoint = s.x.originPoint, f.y.translate = P.y, f.y.scale = Ne(s.y.scale, 1, T), f.y.origin = s.y.origin, f.y.originPoint = s.y.originPoint) : (bm(f.x, s.x, T), bm(f.y, s.y, T)), this.setTargetDelta(f), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (Bs(m, this.layout.layoutBox, this.relativeParent.layout.layoutBox, this.options.layoutAnchor || void 0), mO(this.relativeTarget, this.relativeTargetOrigin, m, T), S && jA(this.relativeTarget, S) && (this.isProjectionDirty = !1), S || (S = st()), en(S, this.relativeTarget)), y && (this.animationValues = d, YA(d, u, this.latestValues, T, w, x)), P && P.rotate !== void 0 && (this.animationValues || (this.animationValues = d), this.animationValues.pathRotation = P.rotate), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = T;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(s) {
      var a, l, c;
      this.notifyListeners("animationStart"), (a = this.currentAnimation) == null || a.stop(), (c = (l = this.resumingFrom) == null ? void 0 : l.currentAnimation) == null || c.stop(), this.pendingAnimation && (Vn(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = _e.update(() => {
        ps.hasAnimatedSinceResize = !0, this.motionValue || (this.motionValue = Cr(0)), this.motionValue.jump(0, !1), this.currentAnimation = XA(this.motionValue, [0, 1e3], {
          ...s,
          velocity: 0,
          isSync: !0,
          onUpdate: (u) => {
            this.mixTargetDelta(u), s.onUpdate && s.onUpdate(u);
          },
          onComplete: () => {
            s.onComplete && s.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const s = this.getStack();
      s && s.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(eO), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const s = this.getLead();
      let { targetWithTransforms: a, target: l, layout: c, latestValues: u } = s;
      if (!(!a || !l || !c)) {
        if (this !== s && this.layout && c && ow(this.options.animationType, this.layout.layoutBox, c.layoutBox)) {
          l = this.target || st();
          const d = Pt(this.layout.layoutBox.x);
          l.x.min = s.target.x.min, l.x.max = l.x.min + d;
          const f = Pt(this.layout.layoutBox.y);
          l.y.min = s.target.y.min, l.y.max = l.y.min + f;
        }
        en(a, l), hs(a, u), Ho(this.projectionDeltaWithTransform, this.layoutCorrected, a, u);
      }
    }
    registerSharedNode(s, a) {
      this.sharedNodes.has(s) || this.sharedNodes.set(s, new JA()), this.sharedNodes.get(s).add(a);
      const c = a.options.initialPromotionConfig;
      a.promote({
        transition: c ? c.transition : void 0,
        preserveFollowOpacity: c && c.shouldPreserveFollowOpacity ? c.shouldPreserveFollowOpacity(a) : void 0
      });
    }
    isLead() {
      const s = this.getStack();
      return s ? s.lead === this : !0;
    }
    getLead() {
      var a;
      const { layoutId: s } = this.options;
      return s ? ((a = this.getStack()) == null ? void 0 : a.lead) || this : this;
    }
    getPrevLead() {
      var a;
      const { layoutId: s } = this.options;
      return s ? (a = this.getStack()) == null ? void 0 : a.prevLead : void 0;
    }
    getStack() {
      const { layoutId: s } = this.options;
      if (s)
        return this.root.sharedNodes.get(s);
    }
    promote({ needsReset: s, transition: a, preserveFollowOpacity: l } = {}) {
      const c = this.getStack();
      c && c.promote(this, l), s && (this.projectionDelta = void 0, this.needsReset = !0), a && this.setOptions({ transition: a });
    }
    relegate() {
      const s = this.getStack();
      return s ? s.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: s } = this.options;
      if (!s)
        return;
      let a = !1;
      const { latestValues: l } = s;
      if ((l.z || l.rotate || l.rotateX || l.rotateY || l.rotateZ || l.skewX || l.skewY) && (a = !0), !a)
        return;
      const c = {};
      l.z && sl("z", s, c, this.animationValues);
      for (let u = 0; u < il.length; u++)
        sl(`rotate${il[u]}`, s, c, this.animationValues), sl(`skew${il[u]}`, s, c, this.animationValues);
      s.render();
      for (const u in c)
        s.setStaticValue(u, c[u]), this.animationValues && (this.animationValues[u] = c[u]);
      s.scheduleRender();
    }
    applyProjectionStyles(s, a) {
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible) {
        s.visibility = "hidden";
        return;
      }
      const l = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = !1, s.visibility = "", s.opacity = "", s.pointerEvents = ms(a == null ? void 0 : a.pointerEvents) || "", s.transform = l ? l(this.latestValues, "") : "none";
        return;
      }
      const c = this.getLead();
      if (!this.projectionDelta || !this.layout || !c.target) {
        this.options.layoutId && (s.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, s.pointerEvents = ms(a == null ? void 0 : a.pointerEvents) || ""), this.hasProjected && !lr(this.latestValues) && (s.transform = l ? l({}, "") : "none", this.hasProjected = !1);
        return;
      }
      s.visibility = "";
      const u = c.animationValues || c.latestValues;
      this.applyTransformsToTarget();
      let d = HA(this.projectionDeltaWithTransform, this.treeScale, u);
      l && (d = l(u, d)), s.transform = d;
      const { x: f, y: m } = this.projectionDelta;
      s.transformOrigin = `${f.origin * 100}% ${m.origin * 100}% 0`, c.animationValues ? s.opacity = c === this ? u.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : u.opacityExit : s.opacity = c === this ? u.opacity !== void 0 ? u.opacity : "" : u.opacityExit !== void 0 ? u.opacityExit : 0;
      for (const p in Nc) {
        if (u[p] === void 0)
          continue;
        const { correct: g, applyTo: y, isCSSVariable: b } = Nc[p], x = d === "none" ? u[p] : g(u[p], c);
        if (y) {
          const w = y.length;
          for (let S = 0; S < w; S++)
            s[y[S]] = x;
        } else
          b ? this.options.visualElement.renderState.vars[p] = x : s[p] = x;
      }
      this.options.layoutId && (s.pointerEvents = c === this ? ms(a == null ? void 0 : a.pointerEvents) || "" : "none");
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((s) => {
        var a;
        return (a = s.currentAnimation) == null ? void 0 : a.stop();
      }), this.root.nodes.forEach(gm), this.root.sharedNodes.clear();
    }
  };
}
function nO(e) {
  e.updateLayout();
}
function rO(e) {
  var n;
  const t = ((n = e.resumeFrom) == null ? void 0 : n.snapshot) || e.snapshot;
  if (e.isLead() && e.layout && t && e.hasListeners("didUpdate")) {
    const { layoutBox: r, measuredBox: o } = e.layout, { animationType: i } = e.options, s = t.source !== e.layout.source;
    if (i === "size")
      gn((d) => {
        const f = s ? t.measuredBox[d] : t.layoutBox[d], m = Pt(f);
        f.min = r[d].min, f.max = f.min + m;
      });
    else if (i === "x" || i === "y") {
      const d = i === "x" ? "y" : "x";
      _c(s ? t.measuredBox[d] : t.layoutBox[d], r[d]);
    } else ow(i, t.layoutBox, r) && gn((d) => {
      const f = s ? t.measuredBox[d] : t.layoutBox[d], m = Pt(r[d]);
      f.max = f.min + m, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[d].max = e.relativeTarget[d].min + m);
    });
    const a = eo();
    Ho(a, r, t.layoutBox);
    const l = eo();
    s ? Ho(l, e.applyTransform(o, !0), t.measuredBox) : Ho(l, r, t.layoutBox);
    const c = !Jb(a);
    let u = !1;
    if (!e.resumeFrom) {
      const d = e.getClosestProjectingParent();
      if (d && !d.resumeFrom) {
        const { snapshot: f, layout: m } = d;
        if (f && m) {
          const p = e.options.layoutAnchor || void 0, g = st();
          Bs(g, t.layoutBox, f.layoutBox, p);
          const y = st();
          Bs(y, r, m.layoutBox, p), ew(g, y) || (u = !0), d.options.layoutRoot && (e.relativeTarget = y, e.relativeTargetOrigin = g, e.relativeParent = d);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: r,
      snapshot: t,
      delta: l,
      layoutDelta: a,
      hasLayoutChanged: c,
      hasRelativeLayoutChanged: u
    });
  } else if (e.isLead()) {
    const { onExitComplete: r } = e.options;
    r && r();
  }
  e.options.transition = void 0;
}
function oO(e) {
  e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function iO(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function sO(e) {
  e.clearSnapshot();
}
function gm(e) {
  e.clearMeasurements();
}
function aO(e) {
  e.isLayoutDirty = !0, e.updateLayout();
}
function vm(e) {
  e.isLayoutDirty = !1;
}
function lO(e) {
  e.isAnimationBlocked && e.layout && !e.isLayoutDirty && (e.snapshot = e.layout, e.isLayoutDirty = !0);
}
function cO(e) {
  const { visualElement: t } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function ym(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function uO(e) {
  e.resolveTargetDelta();
}
function dO(e) {
  e.calcProjection();
}
function fO(e) {
  e.resetSkewAndRotation();
}
function hO(e) {
  e.removeLeadSnapshot();
}
function bm(e, t, n) {
  e.translate = Ne(t.translate, 0, n), e.scale = Ne(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function wm(e, t, n, r) {
  e.min = Ne(t.min, n.min, r), e.max = Ne(t.max, n.max, r);
}
function mO(e, t, n, r) {
  wm(e.x, t.x, n.x, r), wm(e.y, t.y, n.y, r);
}
function pO(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const gO = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, xm = (e) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(e), Sm = xm("applewebkit/") && !xm("chrome/") ? Math.round : Yt;
function Cm(e) {
  e.min = Sm(e.min), e.max = Sm(e.max);
}
function vO(e) {
  Cm(e.x), Cm(e.y);
}
function ow(e, t, n) {
  return e === "position" || e === "preserve-aspect" && !FA(dm(t), dm(n), 0.2);
}
function yO(e) {
  var t;
  return e !== e.root && ((t = e.scroll) == null ? void 0 : t.wasRoot);
}
const bO = rw({
  attachResizeListener: (e, t) => ci(e, "resize", t),
  measureScroll: () => {
    var e, t;
    return {
      x: document.documentElement.scrollLeft || ((e = document.body) == null ? void 0 : e.scrollLeft) || 0,
      y: document.documentElement.scrollTop || ((t = document.body) == null ? void 0 : t.scrollTop) || 0
    };
  },
  checkIsScrollRoot: () => !0
}), al = {
  current: void 0
}, iw = rw({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!al.current) {
      const e = new bO({});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), al.current = e;
    }
    return al.current;
  },
  resetTransform: (e, t) => {
    e.style.transform = t !== void 0 ? t : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), Md = Ye({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
});
function wO(e = !0) {
  const t = Pe(id);
  if (t === null)
    return [!0, null];
  const { isPresent: n, onExitComplete: r, register: o } = t, i = tx();
  de(() => {
    if (e)
      return o(i);
  }, [e]);
  const s = Fe(() => e && r && r(i), [i, r, e]);
  return !n && r ? [!1, s] : [!0];
}
const sw = Ye({ strict: !1 }), Tm = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
};
let Pm = !1;
function xO() {
  if (Pm)
    return;
  const e = {};
  for (const t in Tm)
    e[t] = {
      isEnabled: (n) => Tm[t].some((r) => !!n[r])
    };
  $b(e), Pm = !0;
}
function aw() {
  return xO(), uA();
}
function SO(e) {
  const t = aw();
  for (const n in e)
    t[n] = {
      ...t[n],
      ...e[n]
    };
  $b(t);
}
const CO = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "propagate",
  "ignoreStrict",
  "viewport"
]);
function Ws(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || CO.has(e);
}
let lw = (e) => !Ws(e);
function TO(e) {
  typeof e == "function" && (lw = (t) => t.startsWith("on") ? !Ws(t) : e(t));
}
try {
  TO(require("@emotion/is-prop-valid").default);
} catch {
}
function PO(e, t, n) {
  const r = {};
  for (const o in e)
    o === "values" && typeof e.values == "object" || ht(e[o]) || (lw(o) || n === !0 && Ws(o) || !t && !Ws(o) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && o.startsWith("onDrag")) && (r[o] = e[o]);
  return r;
}
const wa = /* @__PURE__ */ Ye({});
function EO(e, t) {
  if (ba(e)) {
    const { initial: n, animate: r } = e;
    return {
      initial: n === !1 || li(n) ? n : void 0,
      animate: li(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function kO(e) {
  const { initial: t, animate: n } = EO(e, Pe(wa));
  return pe(() => ({ initial: t, animate: n }), [Em(t), Em(n)]);
}
function Em(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const Ad = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function cw(e, t, n) {
  for (const r in t)
    !ht(t[r]) && !Hb(r, n) && (e[r] = t[r]);
}
function DO({ transformTemplate: e }, t) {
  return pe(() => {
    const n = Ad();
    return Dd(n, t, e), Object.assign({}, n.vars, n.style);
  }, [t]);
}
function RO(e, t) {
  const n = e.style || {}, r = {};
  return cw(r, n, e), Object.assign(r, DO(e, t)), r;
}
function MO(e, t) {
  const n = {}, r = RO(e, t);
  return e.drag && e.dragListener !== !1 && (n.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (n.tabIndex = 0), n.style = r, n;
}
const uw = () => ({
  ...Ad(),
  attrs: {}
});
function AO(e, t, n, r) {
  const o = pe(() => {
    const i = uw();
    return Ub(i, t, Gb(r), e.transformTemplate, e.style), {
      ...i.attrs,
      style: { ...i.style }
    };
  }, [t]);
  if (e.style) {
    const i = {};
    cw(i, e.style, e), o.style = { ...i, ...o.style };
  }
  return o;
}
const OO = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function Od(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(OO.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(e))
    )
  );
}
function NO(e, t, n, { latestValues: r }, o, i = !1, s) {
  const l = (s ?? Od(e) ? AO : MO)(t, r, o, e), c = PO(t, typeof e == "string", i), u = e !== Hs ? { ...c, ...l, ref: n } : {}, { children: d } = t, f = pe(() => ht(d) ? d.get() : d, [d]);
  return We(e, {
    ...u,
    children: f
  });
}
function _O({ scrapeMotionValuesFromProps: e, createRenderState: t }, n, r, o) {
  return {
    latestValues: IO(n, r, o, e),
    renderState: t()
  };
}
function IO(e, t, n, r) {
  const o = {}, i = r(e, {});
  for (const f in i)
    o[f] = ms(i[f]);
  let { initial: s, animate: a } = e;
  const l = ba(e), c = Ib(e);
  t && c && !l && e.inherit !== !1 && (s === void 0 && (s = t.initial), a === void 0 && (a = t.animate));
  let u = n ? n.initial === !1 : !1;
  u = u || s === !1;
  const d = u ? a : s;
  if (d && typeof d != "boolean" && !ya(d)) {
    const f = Array.isArray(d) ? d : [d];
    for (let m = 0; m < f.length; m++) {
      const p = wd(e, f[m]);
      if (p) {
        const { transitionEnd: g, transition: y, ...b } = p;
        for (const x in b) {
          let w = b[x];
          if (Array.isArray(w)) {
            const S = u ? w.length - 1 : 0;
            w = w[S];
          }
          w !== null && (o[x] = w);
        }
        for (const x in g)
          o[x] = g[x];
      }
    }
  }
  return o;
}
const dw = (e) => (t, n) => {
  const r = Pe(wa), o = Pe(id), i = () => _O(e, t, r, o);
  return n ? i() : Ei(i);
}, LO = /* @__PURE__ */ dw({
  scrapeMotionValuesFromProps: Rd,
  createRenderState: Ad
}), $O = /* @__PURE__ */ dw({
  scrapeMotionValuesFromProps: Kb,
  createRenderState: uw
}), FO = Symbol.for("motionComponentSymbol");
function VO(e, t, n) {
  const r = oe(n);
  xp(() => {
    r.current = n;
  });
  const o = oe(null);
  return Fe((i) => {
    var a;
    i && ((a = e.onMount) == null || a.call(e, i)), t && (i ? t.mount(i) : t.unmount());
    const s = r.current;
    if (typeof s == "function")
      if (i) {
        const l = s(i);
        typeof l == "function" && (o.current = l);
      } else o.current ? (o.current(), o.current = null) : s(i);
    else s && (s.current = i);
  }, [t]);
}
const fw = Ye({});
function Kr(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function BO(e, t, n, r, o, i) {
  var w, S;
  const { visualElement: s } = Pe(wa), a = Pe(sw), l = Pe(id), c = Pe(Md), u = c.reducedMotion, d = c.skipAnimations, f = oe(null), m = oe(!1);
  r = r || a.renderer, !f.current && r && (f.current = r(e, {
    visualState: t,
    parent: s,
    props: n,
    presenceContext: l,
    blockInitialAnimation: l ? l.initial === !1 : !1,
    reducedMotionConfig: u,
    skipAnimations: d,
    isSVG: i
  }), m.current && f.current && (f.current.manuallyAnimateOnMount = !0));
  const p = f.current, g = Pe(fw);
  p && !p.projection && o && (p.type === "html" || p.type === "svg") && WO(f.current, n, o, g);
  const y = oe(!1);
  xp(() => {
    p && y.current && p.update(n, l);
  });
  const b = n[Cb], x = oe(!!b && typeof window < "u" && !((w = window.MotionHandoffIsComplete) != null && w.call(window, b)) && ((S = window.MotionHasOptimisedAnimation) == null ? void 0 : S.call(window, b)));
  return _y(() => {
    m.current = !0, p && (y.current = !0, window.MotionIsMounted = !0, p.updateFeatures(), p.scheduleRenderMicrotask(), x.current && p.animationState && p.animationState.animateChanges());
  }), de(() => {
    p && (!x.current && p.animationState && p.animationState.animateChanges(), x.current && (queueMicrotask(() => {
      var E;
      (E = window.MotionHandoffMarkAsComplete) == null || E.call(window, b);
    }), x.current = !1), p.enteringChildren = void 0);
  }), p;
}
function WO(e, t, n, r) {
  const { layoutId: o, layout: i, drag: s, dragConstraints: a, layoutScroll: l, layoutRoot: c, layoutAnchor: u, layoutCrossfade: d } = t;
  e.projection = new n(e.latestValues, t["data-framer-portal-id"] ? void 0 : hw(e.parent)), e.projection.setOptions({
    layoutId: o,
    layout: i,
    alwaysMeasureLayout: !!s || a && Kr(a),
    visualElement: e,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof i == "string" ? i : "both",
    initialPromotionConfig: r,
    crossfade: d,
    layoutScroll: l,
    layoutRoot: c,
    layoutAnchor: u
  });
}
function hw(e) {
  if (e)
    return e.options.allowProjection !== !1 ? e.projection : hw(e.parent);
}
function ll(e, { forwardMotionProps: t = !1, type: n } = {}, r, o) {
  r && SO(r);
  const i = n ? n === "svg" : Od(e), s = i ? $O : LO;
  function a(c, u) {
    let d;
    const f = {
      ...Pe(Md),
      ...c,
      layoutId: zO(c)
    }, { isStatic: m } = f, p = kO(c), g = s(c, m);
    if (!m && typeof window < "u") {
      jO(f, r);
      const y = HO(f);
      d = y.MeasureLayout, p.visualElement = BO(e, g, f, o, y.ProjectionNode, i);
    }
    return L(wa.Provider, { value: p, children: [d && p.visualElement ? h(d, { visualElement: p.visualElement, ...f }) : null, NO(e, c, VO(g, p.visualElement, u), g, m, t, i)] });
  }
  a.displayName = `motion.${typeof e == "string" ? e : `create(${e.displayName ?? e.name ?? ""})`}`;
  const l = Ze(a);
  return l[FO] = e, l;
}
function zO({ layoutId: e }) {
  const t = Pe(Ny).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function jO(e, t) {
  const n = Pe(sw).strict;
  if (process.env.NODE_ENV !== "production" && t && n) {
    const r = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    e.ignoreStrict ? xo(!1, r, "lazy-strict-mode") : sn(!1, r, "lazy-strict-mode");
  }
}
function HO(e) {
  const t = aw(), { drag: n, layout: r } = t;
  if (!n && !r)
    return {};
  const o = { ...n, ...r };
  return {
    MeasureLayout: n != null && n.isEnabled(e) || r != null && r.isEnabled(e) ? o.MeasureLayout : void 0,
    ProjectionNode: o.ProjectionNode
  };
}
function UO(e, t) {
  if (typeof Proxy > "u")
    return ll;
  const n = /* @__PURE__ */ new Map(), r = (i, s) => ll(i, s, e, t), o = (i, s) => (process.env.NODE_ENV !== "production" && ld(!1, "motion() is deprecated. Use motion.create() instead."), r(i, s));
  return new Proxy(o, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (i, s) => s === "create" ? r : (n.has(s) || n.set(s, ll(s, void 0, e, t)), n.get(s))
  });
}
const YO = (e, t) => t.isSVG ?? Od(e) ? new kA(t) : new xA(t, {
  allowProjection: e !== Hs
});
class GO extends rr {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = OA(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    ya(t) && (this.unmountControls = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var t;
    this.node.animationState.reset(), (t = this.unmountControls) == null || t.call(this);
  }
}
let KO = 0;
class XO extends rr {
  constructor() {
    super(...arguments), this.id = KO++, this.isExitComplete = !1;
  }
  update() {
    var i;
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: n } = this.node.presenceContext, { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === r)
      return;
    if (t && r === !1) {
      if (this.isExitComplete) {
        const { initial: s, custom: a } = this.node.getProps();
        if (typeof s == "string" || typeof s == "object" && s !== null && !Array.isArray(s)) {
          const l = pr(this.node, s, a);
          if (l) {
            const { transition: c, transitionEnd: u, ...d } = l;
            for (const f in d)
              (i = this.node.getValue(f)) == null || i.jump(d[f]);
          }
        }
        this.node.animationState.reset(), this.node.animationState.animateChanges();
      } else
        this.node.animationState.setActive("exit", !1);
      this.isExitComplete = !1;
      return;
    }
    const o = this.node.animationState.setActive("exit", !t);
    n && !t && o.then(() => {
      this.isExitComplete = !0, n(this.id);
    });
  }
  mount() {
    const { register: t, onExitComplete: n } = this.node.presenceContext || {};
    n && n(this.id), t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const qO = {
  animation: {
    Feature: GO
  },
  exit: {
    Feature: XO
  }
};
function Mi(e) {
  return {
    point: {
      x: e.pageX,
      y: e.pageY
    }
  };
}
const QO = (e) => (t) => Td(t) && e(t, Mi(t));
function Uo(e, t, n, r) {
  return ci(e, t, QO(n), r);
}
const mw = ({ current: e }) => e ? e.ownerDocument.defaultView : null, km = (e, t) => Math.abs(e - t);
function ZO(e, t) {
  const n = km(e.x, t.x), r = km(e.y, t.y);
  return Math.sqrt(n ** 2 + r ** 2);
}
const Dm = /* @__PURE__ */ new Set(["auto", "scroll"]);
class pw {
  constructor(t, n, { transformPagePoint: r, contextWindow: o = window, dragSnapToOrigin: i = !1, distanceThreshold: s = 3, element: a } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.lastRawMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.scrollPositions = /* @__PURE__ */ new Map(), this.removeScrollListeners = null, this.onElementScroll = (p) => {
      this.handleScroll(p.target);
    }, this.onWindowScroll = () => {
      this.handleScroll(window);
    }, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      this.lastRawMoveEventInfo && (this.lastMoveEventInfo = ts(this.lastRawMoveEventInfo, this.transformPagePoint));
      const p = cl(this.lastMoveEventInfo, this.history), g = this.startEvent !== null, y = ZO(p.offset, { x: 0, y: 0 }) >= this.distanceThreshold;
      if (!g && !y)
        return;
      const { point: b } = p, { timestamp: x } = yt;
      this.history.push({ ...b, timestamp: x });
      const { onStart: w, onMove: S } = this.handlers;
      g || (w && w(this.lastMoveEvent, p), this.startEvent = this.lastMoveEvent), S && S(this.lastMoveEvent, p);
    }, this.handlePointerMove = (p, g) => {
      this.lastMoveEvent = p, this.lastRawMoveEventInfo = g, this.lastMoveEventInfo = ts(g, this.transformPagePoint), _e.update(this.updatePoint, !0);
    }, this.handlePointerUp = (p, g) => {
      this.end();
      const { onEnd: y, onSessionEnd: b, resumeAnimation: x } = this.handlers;
      if ((this.dragSnapToOrigin || !this.startEvent) && x && x(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const w = cl(p.type === "pointercancel" ? this.lastMoveEventInfo : ts(g, this.transformPagePoint), this.history);
      this.startEvent && y && y(p, w), b && b(p, w);
    }, !Td(t))
      return;
    this.dragSnapToOrigin = i, this.handlers = n, this.transformPagePoint = r, this.distanceThreshold = s, this.contextWindow = o || window;
    const l = Mi(t), c = ts(l, this.transformPagePoint), { point: u } = c, { timestamp: d } = yt;
    this.history = [{ ...u, timestamp: d }];
    const { onSessionStart: f } = n;
    f && f(t, cl(c, this.history));
    const m = { passive: !0, capture: !0 };
    this.removeListeners = ki(Uo(this.contextWindow, "pointermove", this.handlePointerMove, m), Uo(this.contextWindow, "pointerup", this.handlePointerUp, m), Uo(this.contextWindow, "pointercancel", this.handlePointerUp, m)), a && this.startScrollTracking(a);
  }
  /**
   * Start tracking scroll on ancestors and window.
   */
  startScrollTracking(t) {
    let n = t.parentElement;
    for (; n; ) {
      const r = getComputedStyle(n);
      (Dm.has(r.overflowX) || Dm.has(r.overflowY)) && this.scrollPositions.set(n, {
        x: n.scrollLeft,
        y: n.scrollTop
      }), n = n.parentElement;
    }
    this.scrollPositions.set(window, {
      x: window.scrollX,
      y: window.scrollY
    }), window.addEventListener("scroll", this.onElementScroll, {
      capture: !0
    }), window.addEventListener("scroll", this.onWindowScroll), this.removeScrollListeners = () => {
      window.removeEventListener("scroll", this.onElementScroll, {
        capture: !0
      }), window.removeEventListener("scroll", this.onWindowScroll);
    };
  }
  /**
   * Handle scroll compensation during drag.
   *
   * For element scroll: adjusts history origin since pageX/pageY doesn't change.
   * For window scroll: adjusts lastMoveEventInfo since pageX/pageY would change.
   */
  handleScroll(t) {
    const n = this.scrollPositions.get(t);
    if (!n)
      return;
    const r = t === window, o = r ? { x: window.scrollX, y: window.scrollY } : {
      x: t.scrollLeft,
      y: t.scrollTop
    }, i = { x: o.x - n.x, y: o.y - n.y };
    i.x === 0 && i.y === 0 || (r ? this.lastMoveEventInfo && (this.lastMoveEventInfo.point.x += i.x, this.lastMoveEventInfo.point.y += i.y) : this.history.length > 0 && (this.history[0].x -= i.x, this.history[0].y -= i.y), this.scrollPositions.set(t, o), _e.update(this.updatePoint, !0));
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    this.removeListeners && this.removeListeners(), this.removeScrollListeners && this.removeScrollListeners(), this.scrollPositions.clear(), Vn(this.updatePoint);
  }
}
function ts(e, t) {
  return t ? { point: t(e.point) } : e;
}
function Rm(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function cl({ point: e }, t) {
  return {
    point: e,
    delta: Rm(e, gw(t)),
    offset: Rm(e, JO(t)),
    velocity: eN(t, 0.1)
  };
}
function JO(e) {
  return e[0];
}
function gw(e) {
  return e[e.length - 1];
}
function eN(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let n = e.length - 1, r = null;
  const o = gw(e);
  for (; n >= 0 && (r = e[n], !(o.timestamp - r.timestamp > /* @__PURE__ */ Nt(t))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  r === e[0] && e.length > 2 && o.timestamp - r.timestamp > /* @__PURE__ */ Nt(t) * 2 && (r = e[1]);
  const i = /* @__PURE__ */ Ut(o.timestamp - r.timestamp);
  if (i === 0)
    return { x: 0, y: 0 };
  const s = {
    x: (o.x - r.x) / i,
    y: (o.y - r.y) / i
  };
  return s.x === 1 / 0 && (s.x = 0), s.y === 1 / 0 && (s.y = 0), s;
}
function tN(e, { min: t, max: n }, r) {
  return t !== void 0 && e < t ? e = r ? Ne(t, e, r.min) : Math.max(e, t) : n !== void 0 && e > n && (e = r ? Ne(n, e, r.max) : Math.min(e, n)), e;
}
function Mm(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function nN(e, { top: t, left: n, bottom: r, right: o }) {
  return {
    x: Mm(e.x, n, o),
    y: Mm(e.y, t, r)
  };
}
function Am(e, t) {
  let n = t.min - e.min, r = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([n, r] = [r, n]), { min: n, max: r };
}
function rN(e, t) {
  return {
    x: Am(e.x, t.x),
    y: Am(e.y, t.y)
  };
}
function oN(e, t) {
  let n = 0.5;
  const r = Pt(e), o = Pt(t);
  return o > r ? n = /* @__PURE__ */ si(t.min, t.max - r, e.min) : r > o && (n = /* @__PURE__ */ si(e.min, e.max - o, t.min)), En(0, 1, n);
}
function iN(e, t) {
  const n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
const Ic = 0.35;
function sN(e = Ic) {
  return e === !1 ? e = 0 : e === !0 && (e = Ic), {
    x: Om(e, "left", "right"),
    y: Om(e, "top", "bottom")
  };
}
function Om(e, t, n) {
  return {
    min: Nm(e, t),
    max: Nm(e, n)
  };
}
function Nm(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const aN = /* @__PURE__ */ new WeakMap();
class lN {
  constructor(t) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = st(), this.latestPointerEvent = null, this.latestPanInfo = null, this.visualElement = t;
  }
  start(t, { snapToCursor: n = !1, distanceThreshold: r } = {}) {
    const { presenceContext: o } = this.visualElement;
    if (o && o.isPresent === !1)
      return;
    const i = (d) => {
      n && this.snapToCursor(Mi(d).point), this.stopAnimation();
    }, s = (d, f) => {
      const { drag: m, dragPropagation: p, onDragStart: g } = this.getProps();
      if (m && !p && (this.openDragLock && this.openDragLock(), this.openDragLock = VM(m), !this.openDragLock))
        return;
      this.latestPointerEvent = d, this.latestPanInfo = f, this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), gn((b) => {
        let x = this.getAxisMotionValue(b).get() || 0;
        if (Sn.test(x)) {
          const { projection: w } = this.visualElement;
          if (w && w.layout) {
            const S = w.layout.layoutBox[b];
            S && (x = Pt(S) * (parseFloat(x) / 100));
          }
        }
        this.originPoint[b] = x;
      }), g && _e.update(() => g(d, f), !1, !0), Pc(this.visualElement, "transform");
      const { animationState: y } = this.visualElement;
      y && y.setActive("whileDrag", !0);
    }, a = (d, f) => {
      this.latestPointerEvent = d, this.latestPanInfo = f;
      const { dragPropagation: m, dragDirectionLock: p, onDirectionLock: g, onDrag: y } = this.getProps();
      if (!m && !this.openDragLock)
        return;
      const { offset: b } = f;
      if (p && this.currentDirection === null) {
        this.currentDirection = uN(b), this.currentDirection !== null && g && g(this.currentDirection);
        return;
      }
      this.updateAxis("x", f.point, b), this.updateAxis("y", f.point, b), this.visualElement.render(), y && _e.update(() => y(d, f), !1, !0);
    }, l = (d, f) => {
      this.latestPointerEvent = d, this.latestPanInfo = f, this.stop(d, f), this.latestPointerEvent = null, this.latestPanInfo = null;
    }, c = () => {
      const { dragSnapToOrigin: d } = this.getProps();
      (d || this.constraints) && this.startAnimation({ x: 0, y: 0 });
    }, { dragSnapToOrigin: u } = this.getProps();
    this.panSession = new pw(t, {
      onSessionStart: i,
      onStart: s,
      onMove: a,
      onSessionEnd: l,
      resumeAnimation: c
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: u,
      distanceThreshold: r,
      contextWindow: mw(this.visualElement),
      element: this.visualElement.current
    });
  }
  /**
   * @internal
   */
  stop(t, n) {
    const r = t || this.latestPointerEvent, o = n || this.latestPanInfo, i = this.isDragging;
    if (this.cancel(), !i || !o || !r)
      return;
    const { velocity: s } = o;
    this.startAnimation(s);
    const { onDragEnd: a } = this.getProps();
    a && _e.postRender(() => a(r, o));
  }
  /**
   * @internal
   */
  cancel() {
    this.isDragging = !1;
    const { projection: t, animationState: n } = this.visualElement;
    t && (t.isAnimationBlocked = !1), this.endPanSession();
    const { dragPropagation: r } = this.getProps();
    !r && this.openDragLock && (this.openDragLock(), this.openDragLock = null), n && n.setActive("whileDrag", !1);
  }
  /**
   * Clean up the pan session without modifying other drag state.
   * This is used during unmount to ensure event listeners are removed
   * without affecting projection animations or drag locks.
   * @internal
   */
  endPanSession() {
    this.panSession && this.panSession.end(), this.panSession = void 0;
  }
  updateAxis(t, n, r) {
    const { drag: o } = this.getProps();
    if (!r || !ns(t, o, this.currentDirection))
      return;
    const i = this.getAxisMotionValue(t);
    let s = this.originPoint[t] + r[t];
    this.constraints && this.constraints[t] && (s = tN(s, this.constraints[t], this.elastic[t])), i.set(s);
  }
  resolveConstraints() {
    var i;
    const { dragConstraints: t, dragElastic: n } = this.getProps(), r = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (i = this.visualElement.projection) == null ? void 0 : i.layout, o = this.constraints;
    t && Kr(t) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : t && r ? this.constraints = nN(r.layoutBox, t) : this.constraints = !1, this.elastic = sN(n), o !== this.constraints && !Kr(t) && r && this.constraints && !this.hasMutatedConstraints && gn((s) => {
      this.constraints !== !1 && this.getAxisMotionValue(s) && (this.constraints[s] = iN(r.layoutBox[s], this.constraints[s]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: t, onMeasureDragConstraints: n } = this.getProps();
    if (!t || !Kr(t))
      return !1;
    const r = t.current;
    sn(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
    const { projection: o } = this.visualElement;
    if (!o || !o.layout)
      return !1;
    o.root && (o.root.scroll = void 0, o.root.updateScroll());
    const i = pA(r, o.root, this.visualElement.getTransformPagePoint());
    let s = rN(o.layout.layoutBox, i);
    if (n) {
      const a = n(fA(s));
      this.hasMutatedConstraints = !!a, a && (s = Vb(a));
    }
    return s;
  }
  startAnimation(t) {
    const { drag: n, dragMomentum: r, dragElastic: o, dragTransition: i, dragSnapToOrigin: s, onDragTransitionEnd: a } = this.getProps(), l = this.constraints || {}, c = gn((u) => {
      if (!ns(u, n, this.currentDirection))
        return;
      let d = l && l[u] || {};
      (s === !0 || s === u) && (d = { min: 0, max: 0 });
      const f = o ? 200 : 1e6, m = o ? 40 : 1e7, p = {
        type: "inertia",
        velocity: r ? t[u] : 0,
        bounceStiffness: f,
        bounceDamping: m,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...i,
        ...d
      };
      return this.startAxisValueAnimation(u, p);
    });
    return Promise.all(c).then(a);
  }
  startAxisValueAnimation(t, n) {
    const r = this.getAxisMotionValue(t);
    return Pc(this.visualElement, t), r.start(bd(t, r, 0, n, this.visualElement, !1));
  }
  stopAnimation() {
    gn((t) => this.getAxisMotionValue(t).stop());
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(t) {
    const n = `_drag${t.toUpperCase()}`, o = this.visualElement.getProps()[n];
    return o || this.visualElement.getValue(t, this.visualElement.latestValues[t] ?? 0);
  }
  snapToCursor(t) {
    gn((n) => {
      const { drag: r } = this.getProps();
      if (!ns(n, r, this.currentDirection))
        return;
      const { projection: o } = this.visualElement, i = this.getAxisMotionValue(n);
      if (o && o.layout) {
        const { min: s, max: a } = o.layout.layoutBox[n], l = i.get() || 0;
        i.set(t[n] - Ne(s, a, 0.5) + l);
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: t, dragConstraints: n } = this.getProps(), { projection: r } = this.visualElement;
    if (!Kr(n) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const o = { x: 0, y: 0 };
    gn((s) => {
      const a = this.getAxisMotionValue(s);
      if (a && this.constraints !== !1) {
        const l = a.get();
        o[s] = oN({ min: l, max: l }, this.constraints[s]);
      }
    });
    const { transformTemplate: i } = this.visualElement.getProps();
    this.visualElement.current.style.transform = i ? i({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.constraints = !1, this.resolveConstraints(), gn((s) => {
      if (!ns(s, t, null))
        return;
      const a = this.getAxisMotionValue(s), { min: l, max: c } = this.constraints[s];
      a.set(Ne(l, c, o[s]));
    }), this.visualElement.render();
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    aN.set(this.visualElement, this);
    const t = this.visualElement.current, n = Uo(t, "pointerdown", (c) => {
      const { drag: u, dragListener: d = !0 } = this.getProps(), f = c.target, m = f !== t && UM(f);
      u && d && !m && this.start(c);
    });
    let r;
    const o = () => {
      const { dragConstraints: c } = this.getProps();
      Kr(c) && c.current && (this.constraints = this.resolveRefConstraints(), r || (r = cN(t, c.current, () => this.scalePositionWithinConstraints())));
    }, { projection: i } = this.visualElement, s = i.addEventListener("measure", o);
    i && !i.layout && (i.root && i.root.updateScroll(), i.updateLayout()), _e.read(o);
    const a = ci(window, "resize", () => this.scalePositionWithinConstraints()), l = i.addEventListener("didUpdate", ({ delta: c, hasLayoutChanged: u }) => {
      this.isDragging && u && (gn((d) => {
        const f = this.getAxisMotionValue(d);
        f && (this.originPoint[d] += c[d].translate, f.set(f.get() + c[d].translate));
      }), this.visualElement.render());
    });
    return () => {
      a(), n(), s(), l && l(), r && r();
    };
  }
  getProps() {
    const t = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: r = !1, dragPropagation: o = !1, dragConstraints: i = !1, dragElastic: s = Ic, dragMomentum: a = !0 } = t;
    return {
      ...t,
      drag: n,
      dragDirectionLock: r,
      dragPropagation: o,
      dragConstraints: i,
      dragElastic: s,
      dragMomentum: a
    };
  }
}
function _m(e) {
  let t = !0;
  return () => {
    if (t) {
      t = !1;
      return;
    }
    e();
  };
}
function cN(e, t, n) {
  const r = jh(e, _m(n)), o = jh(t, _m(n));
  return () => {
    r(), o();
  };
}
function ns(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function uN(e, t = 10) {
  let n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
class dN extends rr {
  constructor(t) {
    super(t), this.removeGroupControls = Yt, this.removeListeners = Yt, this.controls = new lN(t);
  }
  mount() {
    const { dragControls: t } = this.node.getProps();
    t && (this.removeGroupControls = t.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Yt;
  }
  update() {
    const { dragControls: t } = this.node.getProps(), { dragControls: n } = this.node.prevProps || {};
    t !== n && (this.removeGroupControls(), t && (this.removeGroupControls = t.subscribe(this.controls)));
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners(), this.controls.isDragging || this.controls.endPanSession();
  }
}
const ul = (e) => (t, n) => {
  e && _e.update(() => e(t, n), !1, !0);
};
class fN extends rr {
  constructor() {
    super(...arguments), this.removePointerDownListener = Yt;
  }
  onPointerDown(t) {
    this.session = new pw(t, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: mw(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: t, onPanStart: n, onPan: r, onPanEnd: o } = this.node.getProps();
    return {
      onSessionStart: ul(t),
      onStart: ul(n),
      onMove: ul(r),
      onEnd: (i, s) => {
        delete this.session, o && _e.postRender(() => o(i, s));
      }
    };
  }
  mount() {
    this.removePointerDownListener = Uo(this.node.current, "pointerdown", (t) => this.onPointerDown(t));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
let dl = !1;
class hN extends nx {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r, layoutId: o } = this.props, { projection: i } = t;
    i && (n.group && n.group.add(i), r && r.register && o && r.register(i), dl && i.root.didUpdate(), i.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), i.setOptions({
      ...i.options,
      layoutDependency: this.props.layoutDependency,
      onExitComplete: () => this.safeToRemove()
    })), ps.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(t) {
    const { layoutDependency: n, visualElement: r, drag: o, isPresent: i } = this.props, { projection: s } = r;
    return s && (s.isPresent = i, t.layoutDependency !== n && s.setOptions({
      ...s.options,
      layoutDependency: n
    }), dl = !0, o || t.layoutDependency !== n || n === void 0 || t.isPresent !== i ? s.willUpdate() : this.safeToRemove(), t.isPresent !== i && (i ? s.promote() : s.relegate() || _e.postRender(() => {
      const a = s.getStack();
      (!a || !a.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { visualElement: t, layoutAnchor: n } = this.props, { projection: r } = t;
    r && (r.options.layoutAnchor = n, r.root.didUpdate(), Cd.postRender(() => {
      !r.currentAnimation && r.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r } = this.props, { projection: o } = t;
    dl = !0, o && (o.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(o), r && r.deregister && r.deregister(o));
  }
  safeToRemove() {
    const { safeToRemove: t } = this.props;
    t && t();
  }
  render() {
    return null;
  }
}
function vw(e) {
  const [t, n] = wO(), r = Pe(Ny);
  return h(hN, { ...e, layoutGroup: r, switchLayoutGroup: Pe(fw), isPresent: t, safeToRemove: n });
}
const mN = {
  pan: {
    Feature: fN
  },
  drag: {
    Feature: dN,
    ProjectionNode: iw,
    MeasureLayout: vw
  }
};
function Im(e, t, n) {
  const { props: r } = e;
  e.animationState && r.whileHover && e.animationState.setActive("whileHover", n === "Start");
  const o = "onHover" + n, i = r[o];
  i && _e.postRender(() => i(t, Mi(t)));
}
class pN extends rr {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = WM(t, (n, r) => (Im(this.node, r, "Start"), (o) => Im(this.node, o, "End"))));
  }
  unmount() {
  }
}
class gN extends rr {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = ki(ci(this.node.current, "focus", () => this.onFocus()), ci(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
function Lm(e, t, n) {
  const { props: r } = e;
  if (e.current instanceof HTMLButtonElement && e.current.disabled)
    return;
  e.animationState && r.whileTap && e.animationState.setActive("whileTap", n === "Start");
  const o = "onTap" + (n === "End" ? "" : n), i = r[o];
  i && _e.postRender(() => i(t, Mi(t)));
}
class vN extends rr {
  mount() {
    const { current: t } = this.node;
    if (!t)
      return;
    const { globalTapTarget: n, propagate: r } = this.node.props;
    this.unmount = GM(t, (o, i) => (Lm(this.node, i, "Start"), (s, { success: a }) => Lm(this.node, s, a ? "End" : "Cancel")), {
      useGlobalTarget: n,
      stopPropagation: (r == null ? void 0 : r.tap) === !1
    });
  }
  unmount() {
  }
}
const Lc = /* @__PURE__ */ new WeakMap(), fl = /* @__PURE__ */ new WeakMap(), yN = (e) => {
  const t = Lc.get(e.target);
  t && t(e);
}, bN = (e) => {
  e.forEach(yN);
};
function wN({ root: e, ...t }) {
  const n = e || document;
  fl.has(n) || fl.set(n, {});
  const r = fl.get(n), o = JSON.stringify(t);
  return r[o] || (r[o] = new IntersectionObserver(bN, { root: e, ...t })), r[o];
}
function xN(e, t, n) {
  const r = wN(t);
  return Lc.set(e, n), r.observe(e), () => {
    Lc.delete(e), r.unobserve(e);
  };
}
const SN = {
  some: 0,
  all: 1
};
class CN extends rr {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    var l;
    (l = this.stopObserver) == null || l.call(this);
    const { viewport: t = {} } = this.node.getProps(), { root: n, margin: r, amount: o = "some", once: i } = t, s = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof o == "number" ? o : SN[o]
    }, a = (c) => {
      const { isIntersecting: u } = c;
      if (this.isInView === u || (this.isInView = u, i && !u && this.hasEnteredView))
        return;
      u && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", u);
      const { onViewportEnter: d, onViewportLeave: f } = this.node.getProps(), m = u ? d : f;
      m && m(c);
    };
    this.stopObserver = xN(this.node.current, s, a);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(TN(t, n)) && this.startObserver();
  }
  unmount() {
    var t;
    (t = this.stopObserver) == null || t.call(this), this.hasEnteredView = !1, this.isInView = !1;
  }
}
function TN({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (n) => e[n] !== t[n];
}
const PN = {
  inView: {
    Feature: CN
  },
  tap: {
    Feature: vN
  },
  focus: {
    Feature: gN
  },
  hover: {
    Feature: pN
  }
}, EN = {
  layout: {
    ProjectionNode: iw,
    MeasureLayout: vw
  }
}, kN = {
  ...qO,
  ...PN,
  ...mN,
  ...EN
}, ui = /* @__PURE__ */ UO(kN, YO);
function yw(e) {
  const t = Ei(() => Cr(e)), { isStatic: n } = Pe(Md);
  if (n) {
    const [, r] = ue(e);
    de(() => t.on("change", r), []);
  }
  return t;
}
function bw(e, t) {
  const n = yw(t()), r = () => n.set(t());
  return r(), _y(() => {
    const o = () => _e.preRender(r, !1, !0), i = e.map((s) => s.on("change", o));
    return () => {
      i.forEach((s) => s()), Vn(r);
    };
  }), n;
}
function DN(e) {
  jo.current = [], e();
  const t = bw(jo.current, e);
  return jo.current = void 0, t;
}
function RN(e, t, n, r) {
  if (typeof e == "function")
    return DN(e);
  const i = typeof t == "function" ? t : rA(t, n, r), s = Array.isArray(e) ? $m(e, i) : $m([e], ([l]) => i(l)), a = Array.isArray(e) ? void 0 : e.accelerate;
  return a && !a.isTransformed && typeof t != "function" && Array.isArray(n) && (r == null ? void 0 : r.clamp) !== !1 && (s.accelerate = {
    ...a,
    times: t,
    keyframes: n,
    isTransformed: !0
  }), s;
}
function $m(e, t) {
  const n = Ei(() => []);
  return bw(e, () => {
    n.length = 0;
    const r = e.length;
    for (let o = 0; o < r; o++)
      n[o] = e[o].get();
    return t(n);
  });
}
const ww = Ye(null);
function MN(e, t, n, r) {
  if (!r)
    return e;
  const o = e.findIndex((u) => u.value === t);
  if (o === -1)
    return e;
  const i = r > 0 ? 1 : -1, s = e[o + i];
  if (!s)
    return e;
  const a = e[o], l = s.layout, c = Ne(l.min, l.max, 0.5);
  return i === 1 && a.layout.max + n > c || i === -1 && a.layout.min + n < c ? ID(e, o, o + i) : e;
}
function AN({ children: e, as: t = "ul", axis: n = "y", onReorder: r, values: o, ...i }, s) {
  const a = Ei(() => ui[t]), l = [], c = oe(!1), u = oe(null);
  sn(!!o, "Reorder.Group must be provided a values prop", "reorder-values");
  const d = {
    axis: n,
    groupRef: u,
    registerItem: (p, g) => {
      const y = l.findIndex((b) => p === b.value);
      y !== -1 ? l[y].layout = g[n] : l.push({ value: p, layout: g[n] }), l.sort(NN);
    },
    updateOrder: (p, g, y) => {
      if (c.current)
        return;
      const b = MN(l, p, g, y);
      if (l !== b) {
        c.current = !0;
        const x = [...o];
        for (let w = 0; w < b.length; w++)
          if (l[w].value !== b[w].value) {
            const S = o.indexOf(l[w].value), E = o.indexOf(b[w].value);
            S !== -1 && E !== -1 && ([x[S], x[E]] = [x[E], x[S]]);
            break;
          }
        r(x);
      }
    }
  };
  de(() => {
    c.current = !1;
  });
  const f = (p) => {
    u.current = p, typeof s == "function" ? s(p) : s && (s.current = p);
  }, m = {
    overflowAnchor: "none",
    ...i.style
  };
  return h(a, { ...i, style: m, ref: f, ignoreStrict: !0, children: h(ww.Provider, { value: d, children: e }) });
}
const ON = /* @__PURE__ */ Ze(AN);
function NN(e, t) {
  return e.layout.min - t.layout.min;
}
const rs = 50, Fm = 25, _N = /* @__PURE__ */ new Set(["auto", "scroll"]), Yo = /* @__PURE__ */ new WeakMap(), Go = /* @__PURE__ */ new WeakMap();
let $o = null;
function IN() {
  if ($o) {
    const e = $c($o, "y");
    e && (Go.delete(e), Yo.delete(e));
    const t = $c($o, "x");
    t && t !== e && (Go.delete(t), Yo.delete(t)), $o = null;
  }
}
function LN(e, t) {
  const n = getComputedStyle(e), r = t === "x" ? n.overflowX : n.overflowY, o = e === document.body || e === document.documentElement;
  return _N.has(r) || o;
}
function $c(e, t) {
  let n = e == null ? void 0 : e.parentElement;
  for (; n; ) {
    if (LN(n, t))
      return n;
    n = n.parentElement;
  }
  return null;
}
function $N(e, t, n) {
  const r = t.getBoundingClientRect(), o = n === "x" ? Math.max(0, r.left) : Math.max(0, r.top), i = n === "x" ? Math.min(window.innerWidth, r.right) : Math.min(window.innerHeight, r.bottom), s = e - o, a = i - e;
  if (s < rs) {
    const l = 1 - s / rs;
    return { amount: -Fm * l * l, edge: "start" };
  } else if (a < rs) {
    const l = 1 - a / rs;
    return { amount: Fm * l * l, edge: "end" };
  }
  return { amount: 0, edge: null };
}
function FN(e, t, n, r) {
  if (!e)
    return;
  $o = e;
  const o = $c(e, n);
  if (!o)
    return;
  const i = t - (n === "x" ? window.scrollX : window.scrollY), { amount: s, edge: a } = $N(i, o, n);
  if (a === null) {
    Go.delete(o), Yo.delete(o);
    return;
  }
  const l = Go.get(o), c = o === document.body || o === document.documentElement;
  if (l !== a) {
    if (!(a === "start" && r < 0 || a === "end" && r > 0))
      return;
    Go.set(o, a);
    const d = n === "x" ? o.scrollWidth - (c ? window.innerWidth : o.clientWidth) : o.scrollHeight - (c ? window.innerHeight : o.clientHeight);
    Yo.set(o, d);
  }
  if (s > 0) {
    const u = Yo.get(o);
    if ((n === "x" ? c ? window.scrollX : o.scrollLeft : c ? window.scrollY : o.scrollTop) >= u)
      return;
  }
  n === "x" ? c ? window.scrollBy({ left: s }) : o.scrollLeft += s : c ? window.scrollBy({ top: s }) : o.scrollTop += s;
}
function Vm(e, t = 0) {
  return ht(e) ? e : yw(t);
}
function VN({ children: e, style: t = {}, value: n, as: r = "li", onDrag: o, onDragEnd: i, layout: s = !0, ...a }, l) {
  const c = Ei(() => ui[r]), u = Pe(ww), d = {
    x: Vm(t.x),
    y: Vm(t.y)
  }, f = RN([d.x, d.y], ([b, x]) => b || x ? 1 : "unset");
  sn(!!u, "Reorder.Item must be a child of Reorder.Group", "reorder-item-child");
  const { axis: m, registerItem: p, updateOrder: g, groupRef: y } = u;
  return h(c, { drag: m, ...a, dragSnapToOrigin: !0, style: { ...t, x: d.x, y: d.y, zIndex: f }, layout: s, onDrag: (b, x) => {
    const { velocity: w, point: S } = x, E = d[m].get();
    g(n, E, w[m]), FN(y.current, S[m], m, w[m]), o && o(b, x);
  }, onDragEnd: (b, x) => {
    IN(), i && i(b, x);
  }, onLayoutMeasure: (b) => {
    p(n, b);
  }, ref: l, ignoreStrict: !0, children: e });
}
const BN = /* @__PURE__ */ Ze(VN);
function xB({ id: e, children: t, className: n = "" }) {
  const {
    attributes: r,
    listeners: o,
    setNodeRef: i,
    transform: s,
    transition: a,
    isDragging: l
  } = OD({ id: e }), c = {
    transform: ii.Transform.toString(s),
    transition: a
  };
  return /* @__PURE__ */ h(
    ui.div,
    {
      ref: i,
      style: c,
      ...r,
      ...o,
      className: n,
      layout: !0,
      initial: { opacity: 0, y: 20 },
      animate: {
        opacity: l ? 0.5 : 1,
        y: 0,
        scale: l ? 1.05 : 1,
        rotateZ: l ? 2 : 0
      },
      exit: { opacity: 0, y: -20 },
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 30,
        opacity: { duration: 0.2 }
      },
      whileHover: {
        scale: l ? 1.05 : 1.02,
        transition: { duration: 0.2 }
      },
      whileTap: {
        scale: 0.98,
        transition: { duration: 0.1 }
      },
      drag: !0,
      dragConstraints: { left: 0, right: 0, top: 0, bottom: 0 },
      dragElastic: 0.1,
      children: t
    }
  );
}
function SB({
  options: e,
  onReorder: t,
  renderOption: n,
  showDragHandle: r = !0,
  showHeader: o = !0,
  customHeader: i,
  className: s = "",
  itemClassName: a = "",
  disabled: l = !1
}) {
  const c = (u, d) => /* @__PURE__ */ L(
    ui.div,
    {
      className: `grid grid-cols-3 gap-4 p-4 hover:bg-muted/50 transition-colors ${d % 2 === 0 ? "bg-card" : "bg-muted/30"}`,
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      exit: { opacity: 0 },
      children: [
        r && /* @__PURE__ */ h(ui.div, { className: "flex-shrink-0 cursor-grab active:cursor-grabbing p-1", children: /* @__PURE__ */ h(Sx, { size: 16, className: "text-muted-foreground" }) }),
        /* @__PURE__ */ h("div", { className: "text-sm font-medium text-foreground", children: u.name }),
        /* @__PURE__ */ h("div", { className: "text-sm text-muted-foreground", children: u.description || "No description" })
      ]
    }
  );
  return l ? /* @__PURE__ */ L("div", { className: `${s} bg-card border border-border rounded-lg overflow-hidden`, children: [
    o && (i || /* @__PURE__ */ L("div", { className: "grid grid-cols-3 gap-4 p-3 bg-muted border-b border-border font-medium text-sm text-muted-foreground", children: [
      /* @__PURE__ */ h("div", { children: "Product Name" }),
      /* @__PURE__ */ h("div", { children: "Description" }),
      /* @__PURE__ */ h("div", { children: "Actions" })
    ] })),
    /* @__PURE__ */ h("div", { className: "divide-y divide-border", children: e.map((u, d) => /* @__PURE__ */ h("div", { className: a, children: n ? n(u, d) : c(u, d) }, u.id)) })
  ] }) : /* @__PURE__ */ L("div", { className: `${s} bg-card border border-border rounded-lg overflow-hidden`, children: [
    o && (i || /* @__PURE__ */ L("div", { className: "grid grid-cols-3 gap-4 p-3 bg-muted border-b border-border font-medium text-sm text-muted-foreground", children: [
      /* @__PURE__ */ h("div", { children: "Product Name" }),
      /* @__PURE__ */ h("div", { children: "Description" }),
      /* @__PURE__ */ h("div", { children: "Actions" })
    ] })),
    /* @__PURE__ */ h(ON, { axis: "y", values: e, onReorder: t, className: "divide-y divide-border", children: e.map((u, d) => /* @__PURE__ */ h(
      BN,
      {
        value: u,
        className: "cursor-move",
        whileDrag: {
          scale: 1.02,
          boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
          zIndex: 10
        },
        children: n ? n(u, d) : c(u, d)
      },
      u.id
    )) })
  ] });
}
const WN = (e, t) => new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: t,
  minimumFractionDigits: t
}).format(e), zN = [
  // Percentage mask x 100
  {
    mask: /100#\.#+%$/,
    apply: (e, t) => {
      e = typeof e == "string" ? parseFloat(e) : e, e *= 100;
      const n = t.match(/100#\.(#+)%$/)[1].length;
      return `${e.toFixed(n)}%`;
    }
  },
  // Percentage mask
  {
    mask: /#\.#+%$/,
    apply: (e, t) => {
      e = typeof e == "string" ? parseFloat(e) : e;
      const n = t.match(/#\.(#+)%/)[1].length;
      return `${e.toFixed(n)}%`;
    }
  },
  // Dollar mask
  {
    mask: /\$#(\.#*)?$/,
    apply: (e, t) => {
      e = typeof e == "string" ? parseFloat(e) : e;
      const n = t.match(/\$#(\.(#*))?$/)[2], r = n ? n.length : 0;
      return WN(e, r);
    }
  },
  // Millions mask
  {
    mask: /#\.#+M$/,
    apply: (e, t) => {
      if (e) {
        const n = t.split("."), r = n != null && n[1] ? n[1].length - 1 : 0;
        e = Number(e);
        const o = new RegExp("\\.0+$|(?<=\\.[0-9]*[1-9])0+$");
        let i = (e / 1e6).toFixed(r).replace(o, "");
        return i.includes(".") || (i = i.concat(".0")), i.concat(" M");
      }
      return "";
    }
  },
  // Trillions mask (fixed)
  {
    mask: /#\.#+T$/,
    apply: (e, t) => {
      if (e) {
        const n = t.split("."), r = n != null && n[1] ? n[1].length - 1 : 0;
        e = Number(e);
        const o = new RegExp("\\.0+$|(?<=\\.[0-9]*[1-9])0+$");
        let i = (e / 1e12).toFixed(r).replace(o, "");
        return i.includes(".") || (i = i.concat(".0")), i.concat(" T");
      }
      return "";
    }
  },
  // Thousands mask
  {
    mask: /#\.#+K$/,
    apply: (e, t) => {
      if (e) {
        const n = t.split("."), r = n && n[1] ? n[1].length - 1 : 0;
        e = Number(e);
        const o = new RegExp("\\.0+$|(?<=\\.[0-9]*[1-9])0+$");
        let i = (e / 1e3).toFixed(r).replace(o, "");
        return i.includes(".") || (i = i.concat(".0")), i.concat(" K");
      }
      return "";
    }
  },
  // Decimal masks (fixed to include #.#####)
  {
    mask: ["#.#", "#.##", "#.###", "#.####", "#.#####"],
    apply: (e, t) => {
      if (e) {
        e = Number(e);
        const n = t.split("."), r = n && n[1] ? n[1].length : 0;
        return `${e.toFixed(r)}`;
      }
      return "";
    }
  },
  {
    mask: ["#"],
    apply: (e) => e ? `${Number(e).toFixed(0)}` : ""
  },
  {
    mask: ["#th"],
    apply: (e) => {
      e = Number(e);
      const t = e % 10, n = e % 100;
      return t === 1 && n !== 11 ? e + "st" : t === 2 && n !== 12 ? e + "nd" : t === 3 && n !== 13 ? e + "rd" : e + "th";
    }
  }
];
function Bm(e, t) {
  const n = zN.find(
    (r) => Array.isArray(r.mask) && r.mask.includes(t) || !Array.isArray(r.mask) && t.match(r.mask)
  );
  return n ? n.apply(e, t) : "Invalid Mask";
}
const jN = (e, t, n) => t && (typeof t == "function" ? t(e) : t[e]) || e;
function xw(e, t, n) {
  const r = t.filter(({ split: d }) => !d), o = r.map(({ key: d }) => d);
  let i = e;
  const s = i.columnNames(), a = t.filter(({ key: d }) => !s.includes(d)).map(({ key: d }) => d), l = r.filter(({ lookup: d }) => !!d), c = r.filter(({ componentProps: d }) => !!(d != null && d.options)), u = r.reduce((d, f) => {
    var m;
    if (f.group) {
      const p = (m = f.group) == null ? void 0 : m.filter(({ label: b }) => !!b), g = p == null ? void 0 : p.map(({ label: b }) => b), y = (g == null ? void 0 : g.join(" - ")) || "";
      d[`${f.key}`] = y != null && y.length ? `${y} - ${f.name}` : f.name;
    } else
      d[`${f.key}`] = f.name;
    return d;
  }, {});
  for (const d of a)
    i = i.derive({
      [d]: (f) => ""
    });
  if (i.print(), i = i.select(o), n) {
    const d = r.filter(({ mask: f, conditionalMask: m }) => !!f || !!m);
    for (const f of d)
      i = i.derive({
        [f.key]: to((m) => {
          let p = m[f.key] || "-";
          const g = f.dataType === "number" ? m[f.key] && m[f.key] < 0 : !1, y = f.negativeFormat ?? "brackets";
          return f.conditionalMask && (typeof m[f.key] == "number" || typeof m[f.key] == "string") && p !== "-" ? p = Bm(Math.abs(+m[f.key]), f.conditionalMask(f.key, f.name, m)) : f.mask && (typeof m[f.key] == "number" || typeof m[f.key] == "string") && p !== "-" && (p = Bm(Math.abs(+m[f.key]), f.mask)), p = `${f.prefix ?? ""}${p}${f.suffix ?? ""}`, y === "brackets" && g && p !== "-" && (p = `(${p})`), y === "minus" && g && p !== "-" && (p = `-${p}`), p;
        })
      });
  }
  for (const d of l)
    i = i.derive({
      [d.key]: to((f) => jN(f[d.key], d.lookup))
    });
  for (const d of c)
    i = i.derive({
      [d.key]: to((f) => {
        const m = d.componentProps.options, p = typeof m == "function" ? m(f.key, d, f) : m;
        if (!Array.isArray(p))
          return f[d.key];
        const g = p.find(({ key: y }) => y === f[d.key]);
        return (g == null ? void 0 : g.label) || f[d.key];
      })
    });
  return i = i.rename(u), i;
}
function HN({ tbl: e, columns: t, fileName: n, applyMasks: r }) {
  const o = xw(e, t, r), i = /* @__PURE__ */ new Date(), s = new Blob([o.toCSV()], { type: "text/csv" }), a = URL.createObjectURL(s), l = document.createElement("a");
  l.href = a, l.download = `${i.toISOString()}-${n || "exported.csv"}`, l.click(), l.remove();
}
function UN({ tables: e, fileName: t, applyMasks: n }) {
  if (!e || e.length === 0) {
    console.warn("No tables provided for export");
    return;
  }
  const r = [];
  for (let c = 0; c < e.length; c++) {
    const u = e[c];
    if (!u)
      continue;
    const { table: d, columns: f, sectionName: m } = u, p = typeof d == "function" ? d() : d;
    if (!p || !f || p.size === 0)
      continue;
    const g = xw(p, f, n), y = g.toCSV();
    if (m) {
      const b = g.columnNames().length, x = `"${m}",${",".repeat(b - 1)}`;
      r.push(x);
    }
    r.push(y), c < e.length - 1 && r.push("");
  }
  const o = r.join(`
`), i = /* @__PURE__ */ new Date(), s = new Blob([o], { type: "text/csv" }), a = URL.createObjectURL(s), l = document.createElement("a");
  l.href = a, l.download = `${i.toISOString()}-${t || "exported.csv"}`, l.click(), l.remove();
}
const CB = ({ tbl: e, columns: t, tables: n, fileName: r, applyMasks: o, disabled: i, iconOnly: s = !1, overrideMask: a }) => {
  const [l, c] = ue(!1), u = nd(), d = async () => {
    c(!0);
    try {
      if (n && n.length > 0) {
        const g = n.filter(({ table: b, columns: x }) => {
          const w = typeof b == "function" ? b() : b;
          return (w == null ? void 0 : w.size) && (x == null ? void 0 : x.length);
        });
        if (g.length === 0)
          return;
        const y = g.map(({ table: b, columns: x, sectionName: w }) => {
          const S = x.map((E) => ({
            ...E,
            mask: (a == null ? void 0 : a(E)) ?? E.mask
          }));
          return {
            table: typeof b == "function" ? b() : b,
            columns: (u == null ? void 0 : u.applyLookups(S)) ?? S,
            sectionName: w
          };
        });
        UN({ tables: y, fileName: r, applyMasks: o });
      } else {
        const g = typeof e == "function" ? e() : e;
        if (!(g != null && g.size) || !(t != null && t.length))
          return;
        const y = t.map((x) => ({
          ...x,
          mask: (a == null ? void 0 : a(x)) ?? x.mask
        })), b = (u == null ? void 0 : u.applyLookups(y)) ?? y;
        HN({ tbl: g, columns: b, fileName: r, applyMasks: o });
      }
    } catch (g) {
      console.error("ExportTableButton - Error trying to export csv", g);
    } finally {
      c(!1);
    }
  }, f = l || i || (() => {
    if (n && n.length > 0)
      return !n.some(({ table: g, columns: y }) => {
        const b = typeof g == "function" ? g() : g;
        return (b == null ? void 0 : b.size) && (y == null ? void 0 : y.length);
      });
    {
      const g = typeof e == "function" ? e() : e;
      return !(g != null && g.size) || !(t != null && t.length);
    }
  })(), p = /* @__PURE__ */ h(
    ke,
    {
      className: s ? "" : "icon-left",
      size: s ? "sm" : "default",
      variant: "outline",
      onClick: d,
      disabled: f,
      children: l ? /* @__PURE__ */ h(Sp, { className: "animate-spin size-5" }) : /* @__PURE__ */ L(Oe, { children: [
        /* @__PURE__ */ h(Cx, {}),
        !s && /* @__PURE__ */ h("span", { children: "Export" })
      ] })
    }
  );
  return /* @__PURE__ */ L(Oe, { children: [
    s ? /* @__PURE__ */ h(_u, { children: /* @__PURE__ */ L(na, { children: [
      /* @__PURE__ */ h(ra, { asChild: !0, children: p }),
      /* @__PURE__ */ h(bi, { children: "Export" })
    ] }) }) : p,
    !s && /* @__PURE__ */ h(Qo, { orientation: "vertical", className: "h-auto" })
  ] });
};
function we(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function Be(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
function bt(e, t) {
  const n = we(e);
  return isNaN(t) ? Be(e, NaN) : (t && n.setDate(n.getDate() + t), n);
}
function Kt(e, t) {
  const n = we(e);
  if (isNaN(t)) return Be(e, NaN);
  if (!t)
    return n;
  const r = n.getDate(), o = Be(e, n.getTime());
  o.setMonth(n.getMonth() + t + 1, 0);
  const i = o.getDate();
  return r >= i ? o : (n.setFullYear(
    o.getFullYear(),
    o.getMonth(),
    r
  ), n);
}
const Nd = 6048e5, YN = 864e5, GN = 6e4, KN = 36e5, XN = 1e3;
let qN = {};
function Lr() {
  return qN;
}
function zt(e, t) {
  var a, l, c, u;
  const n = Lr(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (a = t == null ? void 0 : t.locale) == null ? void 0 : a.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, o = we(e), i = o.getDay(), s = (i < r ? 7 : 0) + i - r;
  return o.setDate(o.getDate() - s), o.setHours(0, 0, 0, 0), o;
}
function Bn(e) {
  return zt(e, { weekStartsOn: 1 });
}
function Sw(e) {
  const t = we(e), n = t.getFullYear(), r = Be(e, 0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const o = Bn(r), i = Be(e, 0);
  i.setFullYear(n, 0, 4), i.setHours(0, 0, 0, 0);
  const s = Bn(i);
  return t.getTime() >= o.getTime() ? n + 1 : t.getTime() >= s.getTime() ? n : n - 1;
}
function fo(e) {
  const t = we(e);
  return t.setHours(0, 0, 0, 0), t;
}
function ho(e) {
  const t = we(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function xn(e, t) {
  const n = fo(e), r = fo(t), o = +n - ho(n), i = +r - ho(r);
  return Math.round((o - i) / YN);
}
function QN(e) {
  const t = Sw(e), n = Be(e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), Bn(n);
}
function Fc(e, t) {
  const n = t * 7;
  return bt(e, n);
}
function ZN(e, t) {
  return Kt(e, t * 12);
}
function JN(e) {
  let t;
  return e.forEach(function(n) {
    const r = we(n);
    (t === void 0 || t < r || isNaN(Number(r))) && (t = r);
  }), t || /* @__PURE__ */ new Date(NaN);
}
function e_(e) {
  let t;
  return e.forEach((n) => {
    const r = we(n);
    (!t || t > r || isNaN(+r)) && (t = r);
  }), t || /* @__PURE__ */ new Date(NaN);
}
function At(e, t) {
  const n = fo(e), r = fo(t);
  return +n == +r;
}
function _d(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function t_(e) {
  if (!_d(e) && typeof e != "number")
    return !1;
  const t = we(e);
  return !isNaN(Number(t));
}
function di(e, t) {
  const n = we(e), r = we(t), o = n.getFullYear() - r.getFullYear(), i = n.getMonth() - r.getMonth();
  return o * 12 + i;
}
function n_(e, t, n) {
  const r = zt(e, n), o = zt(t, n), i = +r - ho(r), s = +o - ho(o);
  return Math.round((i - s) / Nd);
}
function Id(e) {
  const t = we(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function _t(e) {
  const t = we(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function Cw(e) {
  const t = we(e), n = Be(e, 0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function Ld(e, t) {
  var a, l, c, u;
  const n = Lr(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (a = t == null ? void 0 : t.locale) == null ? void 0 : a.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, o = we(e), i = o.getDay(), s = (i < r ? -7 : 0) + 6 - (i - r);
  return o.setDate(o.getDate() + s), o.setHours(23, 59, 59, 999), o;
}
function Tw(e) {
  return Ld(e, { weekStartsOn: 1 });
}
const r_ = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, o_ = (e, t, n) => {
  let r;
  const o = r_[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function hl(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const i_ = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, s_ = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, a_ = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, l_ = {
  date: hl({
    formats: i_,
    defaultWidth: "full"
  }),
  time: hl({
    formats: s_,
    defaultWidth: "full"
  }),
  dateTime: hl({
    formats: a_,
    defaultWidth: "full"
  })
}, c_ = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, u_ = (e, t, n, r) => c_[e];
function No(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let o;
    if (r === "formatting" && e.formattingValues) {
      const s = e.defaultFormattingWidth || e.defaultWidth, a = n != null && n.width ? String(n.width) : s;
      o = e.formattingValues[a] || e.formattingValues[s];
    } else {
      const s = e.defaultWidth, a = n != null && n.width ? String(n.width) : e.defaultWidth;
      o = e.values[a] || e.values[s];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[i];
  };
}
const d_ = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, f_ = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, h_ = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, m_ = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, p_ = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, g_ = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, v_ = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, y_ = {
  ordinalNumber: v_,
  era: No({
    values: d_,
    defaultWidth: "wide"
  }),
  quarter: No({
    values: f_,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: No({
    values: h_,
    defaultWidth: "wide"
  }),
  day: No({
    values: m_,
    defaultWidth: "wide"
  }),
  dayPeriod: No({
    values: p_,
    defaultWidth: "wide",
    formattingValues: g_,
    defaultFormattingWidth: "wide"
  })
};
function _o(e) {
  return (t, n = {}) => {
    const r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], i = t.match(o);
    if (!i)
      return null;
    const s = i[0], a = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(a) ? w_(a, (d) => d.test(s)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      b_(a, (d) => d.test(s))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(c)
    ) : c;
    const u = t.slice(s.length);
    return { value: c, rest: u };
  };
}
function b_(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function w_(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function x_(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const o = r[0], i = t.match(e.parsePattern);
    if (!i) return null;
    let s = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    s = n.valueCallback ? n.valueCallback(s) : s;
    const a = t.slice(o.length);
    return { value: s, rest: a };
  };
}
const S_ = /^(\d+)(th|st|nd|rd)?/i, C_ = /\d+/i, T_ = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, P_ = {
  any: [/^b/i, /^(a|c)/i]
}, E_ = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, k_ = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, D_ = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, R_ = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, M_ = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, A_ = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, O_ = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, N_ = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, __ = {
  ordinalNumber: x_({
    matchPattern: S_,
    parsePattern: C_,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: _o({
    matchPatterns: T_,
    defaultMatchWidth: "wide",
    parsePatterns: P_,
    defaultParseWidth: "any"
  }),
  quarter: _o({
    matchPatterns: E_,
    defaultMatchWidth: "wide",
    parsePatterns: k_,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: _o({
    matchPatterns: D_,
    defaultMatchWidth: "wide",
    parsePatterns: R_,
    defaultParseWidth: "any"
  }),
  day: _o({
    matchPatterns: M_,
    defaultMatchWidth: "wide",
    parsePatterns: A_,
    defaultParseWidth: "any"
  }),
  dayPeriod: _o({
    matchPatterns: O_,
    defaultMatchWidth: "any",
    parsePatterns: N_,
    defaultParseWidth: "any"
  })
}, $d = {
  code: "en-US",
  formatDistance: o_,
  formatLong: l_,
  formatRelative: u_,
  localize: y_,
  match: __,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function I_(e) {
  const t = we(e);
  return xn(t, Cw(t)) + 1;
}
function Fd(e) {
  const t = we(e), n = +Bn(t) - +QN(t);
  return Math.round(n / Nd) + 1;
}
function Vd(e, t) {
  var u, d, f, m;
  const n = we(e), r = n.getFullYear(), o = Lr(), i = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((d = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((m = (f = o.locale) == null ? void 0 : f.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, s = Be(e, 0);
  s.setFullYear(r + 1, 0, i), s.setHours(0, 0, 0, 0);
  const a = zt(s, t), l = Be(e, 0);
  l.setFullYear(r, 0, i), l.setHours(0, 0, 0, 0);
  const c = zt(l, t);
  return n.getTime() >= a.getTime() ? r + 1 : n.getTime() >= c.getTime() ? r : r - 1;
}
function L_(e, t) {
  var a, l, c, u;
  const n = Lr(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((l = (a = t == null ? void 0 : t.locale) == null ? void 0 : a.options) == null ? void 0 : l.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, o = Vd(e, t), i = Be(e, 0);
  return i.setFullYear(o, 0, r), i.setHours(0, 0, 0, 0), zt(i, t);
}
function Bd(e, t) {
  const n = we(e), r = +zt(n, t) - +L_(n, t);
  return Math.round(r / Nd) + 1;
}
function Ae(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const Un = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return Ae(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : Ae(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return Ae(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return Ae(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return Ae(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return Ae(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return Ae(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return Ae(o, t.length);
  }
}, Hr = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Wm = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), o = r > 0 ? r : 1 - r;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return Un.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const o = Vd(e, r), i = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const s = i % 100;
      return Ae(s, 2);
    }
    return t === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : Ae(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = Sw(e);
    return Ae(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return Ae(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return Ae(r, 2);
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return Ae(r, 2);
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return Un.M(e, t);
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return Ae(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const o = Bd(e, r);
    return t === "wo" ? n.ordinalNumber(o, { unit: "week" }) : Ae(o, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = Fd(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : Ae(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : Un.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = I_(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : Ae(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const o = e.getDay(), i = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(i);
      case "ee":
        return Ae(i, 2);
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const o = e.getDay(), i = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(i);
      case "cc":
        return Ae(i, t.length);
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), o = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(o);
      case "ii":
        return Ae(o, t.length);
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r === 12 ? o = Hr.noon : r === 0 ? o = Hr.midnight : o = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r >= 17 ? o = Hr.evening : r >= 12 ? o = Hr.afternoon : r >= 4 ? o = Hr.morning : o = Hr.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return Un.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : Un.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : Ae(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : Ae(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Un.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : Un.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Un.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      case "X":
        return jm(r);
      case "XXXX":
      case "XX":
        return cr(r);
      case "XXXXX":
      case "XXX":
      default:
        return cr(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return jm(r);
      case "xxxx":
      case "xx":
        return cr(r);
      case "xxxxx":
      case "xxx":
      default:
        return cr(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + zm(r, ":");
      case "OOOO":
      default:
        return "GMT" + cr(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + zm(r, ":");
      case "zzzz":
      default:
        return "GMT" + cr(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(e.getTime() / 1e3);
    return Ae(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    const r = e.getTime();
    return Ae(r, t.length);
  }
};
function zm(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.trunc(r / 60), i = r % 60;
  return i === 0 ? n + String(o) : n + String(o) + t + Ae(i, 2);
}
function jm(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Ae(Math.abs(e) / 60, 2) : cr(e, t);
}
function cr(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Ae(Math.trunc(r / 60), 2), i = Ae(r % 60, 2);
  return n + o + t + i;
}
const Hm = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, Pw = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, $_ = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], o = n[2];
  if (!o)
    return Hm(e, t);
  let i;
  switch (r) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", Hm(r, t)).replace("{{time}}", Pw(o, t));
}, Vc = {
  p: Pw,
  P: $_
}, F_ = /^D+$/, V_ = /^Y+$/, B_ = ["D", "DD", "YY", "YYYY"];
function Ew(e) {
  return F_.test(e);
}
function kw(e) {
  return V_.test(e);
}
function Bc(e, t, n) {
  const r = W_(e, t, n);
  if (console.warn(r), B_.includes(e)) throw new RangeError(r);
}
function W_(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const z_ = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, j_ = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, H_ = /^'([^]*?)'?$/, U_ = /''/g, Y_ = /[a-zA-Z]/;
function Dn(e, t, n) {
  var u, d, f, m, p, g, y, b;
  const r = Lr(), o = (n == null ? void 0 : n.locale) ?? r.locale ?? $d, i = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((d = (u = n == null ? void 0 : n.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((m = (f = r.locale) == null ? void 0 : f.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, s = (n == null ? void 0 : n.weekStartsOn) ?? ((g = (p = n == null ? void 0 : n.locale) == null ? void 0 : p.options) == null ? void 0 : g.weekStartsOn) ?? r.weekStartsOn ?? ((b = (y = r.locale) == null ? void 0 : y.options) == null ? void 0 : b.weekStartsOn) ?? 0, a = we(e);
  if (!t_(a))
    throw new RangeError("Invalid time value");
  let l = t.match(j_).map((x) => {
    const w = x[0];
    if (w === "p" || w === "P") {
      const S = Vc[w];
      return S(x, o.formatLong);
    }
    return x;
  }).join("").match(z_).map((x) => {
    if (x === "''")
      return { isToken: !1, value: "'" };
    const w = x[0];
    if (w === "'")
      return { isToken: !1, value: G_(x) };
    if (Wm[w])
      return { isToken: !0, value: x };
    if (w.match(Y_))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + w + "`"
      );
    return { isToken: !1, value: x };
  });
  o.localize.preprocessor && (l = o.localize.preprocessor(a, l));
  const c = {
    firstWeekContainsDate: i,
    weekStartsOn: s,
    locale: o
  };
  return l.map((x) => {
    if (!x.isToken) return x.value;
    const w = x.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && kw(w) || !(n != null && n.useAdditionalDayOfYearTokens) && Ew(w)) && Bc(w, t, String(e));
    const S = Wm[w[0]];
    return S(a, w, o.localize, c);
  }).join("");
}
function G_(e) {
  const t = e.match(H_);
  return t ? t[1].replace(U_, "'") : e;
}
function K_(e) {
  const t = we(e), n = t.getFullYear(), r = t.getMonth(), o = Be(e, 0);
  return o.setFullYear(n, r + 1, 0), o.setHours(0, 0, 0, 0), o.getDate();
}
function X_() {
  return Object.assign({}, Lr());
}
function q_(e) {
  let n = we(e).getDay();
  return n === 0 && (n = 7), n;
}
function Q_(e) {
  return Math.trunc(+we(e) / 1e3);
}
function Z_(e) {
  const t = we(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(0, 0, 0, 0), t;
}
function J_(e, t) {
  return n_(
    Z_(e),
    _t(e),
    t
  ) + 1;
}
function Wc(e, t) {
  const n = we(e), r = we(t);
  return n.getTime() > r.getTime();
}
function Dw(e, t) {
  const n = we(e), r = we(t);
  return +n < +r;
}
function eI(e, t) {
  const n = t instanceof Date ? Be(t, 0) : new t(0);
  return n.setFullYear(
    e.getFullYear(),
    e.getMonth(),
    e.getDate()
  ), n.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), n;
}
const tI = 10;
class Rw {
  constructor() {
    J(this, "subPriority", 0);
  }
  validate(t, n) {
    return !0;
  }
}
class nI extends Rw {
  constructor(t, n, r, o, i) {
    super(), this.value = t, this.validateValue = n, this.setValue = r, this.priority = o, i && (this.subPriority = i);
  }
  validate(t, n) {
    return this.validateValue(t, this.value, n);
  }
  set(t, n, r) {
    return this.setValue(t, n, this.value, r);
  }
}
class rI extends Rw {
  constructor() {
    super(...arguments);
    J(this, "priority", tI);
    J(this, "subPriority", -1);
  }
  set(n, r) {
    return r.timestampIsSet ? n : Be(n, eI(n, Date));
  }
}
class Re {
  run(t, n, r, o) {
    const i = this.parse(t, n, r, o);
    return i ? {
      setter: new nI(
        i.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: i.rest
    } : null;
  }
  validate(t, n, r) {
    return !0;
  }
}
class oI extends Re {
  constructor() {
    super(...arguments);
    J(this, "priority", 140);
    J(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return o.era(n, { width: "abbreviated" }) || o.era(n, { width: "narrow" });
      case "GGGGG":
        return o.era(n, { width: "narrow" });
      case "GGGG":
      default:
        return o.era(n, { width: "wide" }) || o.era(n, { width: "abbreviated" }) || o.era(n, { width: "narrow" });
    }
  }
  set(n, r, o) {
    return r.era = o, n.setFullYear(o, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
const et = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, yn = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function tt(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function Xe(e, t) {
  const n = t.match(e);
  return n ? {
    value: parseInt(n[0], 10),
    rest: t.slice(n[0].length)
  } : null;
}
function bn(e, t) {
  const n = t.match(e);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  const r = n[1] === "+" ? 1 : -1, o = n[2] ? parseInt(n[2], 10) : 0, i = n[3] ? parseInt(n[3], 10) : 0, s = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: r * (o * KN + i * GN + s * XN),
    rest: t.slice(n[0].length)
  };
}
function Mw(e) {
  return Xe(et.anyDigitsSigned, e);
}
function Qe(e, t) {
  switch (e) {
    case 1:
      return Xe(et.singleDigit, t);
    case 2:
      return Xe(et.twoDigits, t);
    case 3:
      return Xe(et.threeDigits, t);
    case 4:
      return Xe(et.fourDigits, t);
    default:
      return Xe(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function zs(e, t) {
  switch (e) {
    case 1:
      return Xe(et.singleDigitSigned, t);
    case 2:
      return Xe(et.twoDigitsSigned, t);
    case 3:
      return Xe(et.threeDigitsSigned, t);
    case 4:
      return Xe(et.fourDigitsSigned, t);
    default:
      return Xe(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function Wd(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Aw(e, t) {
  const n = t > 0, r = n ? t : 1 - t;
  let o;
  if (r <= 50)
    o = e || 100;
  else {
    const i = r + 50, s = Math.trunc(i / 100) * 100, a = e >= i % 100;
    o = e + s - (a ? 100 : 0);
  }
  return n ? o : 1 - o;
}
function Ow(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class iI extends Re {
  constructor() {
    super(...arguments);
    J(this, "priority", 130);
    J(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, r, o) {
    const i = (s) => ({
      year: s,
      isTwoDigitYear: r === "yy"
    });
    switch (r) {
      case "y":
        return tt(Qe(4, n), i);
      case "yo":
        return tt(
          o.ordinalNumber(n, {
            unit: "year"
          }),
          i
        );
      default:
        return tt(Qe(r.length, n), i);
    }
  }
  validate(n, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(n, r, o) {
    const i = n.getFullYear();
    if (o.isTwoDigitYear) {
      const a = Aw(
        o.year,
        i
      );
      return n.setFullYear(a, 0, 1), n.setHours(0, 0, 0, 0), n;
    }
    const s = !("era" in r) || r.era === 1 ? o.year : 1 - o.year;
    return n.setFullYear(s, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class sI extends Re {
  constructor() {
    super(...arguments);
    J(this, "priority", 130);
    J(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    const i = (s) => ({
      year: s,
      isTwoDigitYear: r === "YY"
    });
    switch (r) {
      case "Y":
        return tt(Qe(4, n), i);
      case "Yo":
        return tt(
          o.ordinalNumber(n, {
            unit: "year"
          }),
          i
        );
      default:
        return tt(Qe(r.length, n), i);
    }
  }
  validate(n, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(n, r, o, i) {
    const s = Vd(n, i);
    if (o.isTwoDigitYear) {
      const l = Aw(
        o.year,
        s
      );
      return n.setFullYear(
        l,
        0,
        i.firstWeekContainsDate
      ), n.setHours(0, 0, 0, 0), zt(n, i);
    }
    const a = !("era" in r) || r.era === 1 ? o.year : 1 - o.year;
    return n.setFullYear(a, 0, i.firstWeekContainsDate), n.setHours(0, 0, 0, 0), zt(n, i);
  }
}
class aI extends Re {
  constructor() {
    super(...arguments);
    J(this, "priority", 130);
    J(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r) {
    return zs(r === "R" ? 4 : r.length, n);
  }
  set(n, r, o) {
    const i = Be(n, 0);
    return i.setFullYear(o, 0, 4), i.setHours(0, 0, 0, 0), Bn(i);
  }
}
class lI extends Re {
  constructor() {
    super(...arguments);
    J(this, "priority", 130);
    J(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, r) {
    return zs(r === "u" ? 4 : r.length, n);
  }
  set(n, r, o) {
    return n.setFullYear(o, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class cI extends Re {
  constructor() {
    super(...arguments);
    J(this, "priority", 120);
    J(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "Q":
      case "QQ":
        return Qe(r.length, n);
      case "Qo":
        return o.ordinalNumber(n, { unit: "quarter" });
      case "QQQ":
        return o.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return o.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return o.quarter(n, {
          width: "wide",
          context: "formatting"
        }) || o.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 4;
  }
  set(n, r, o) {
    return n.setMonth((o - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class uI extends Re {
  constructor() {
    super(...arguments);
    J(this, "priority", 120);
    J(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "q":
      case "qq":
        return Qe(r.length, n);
      case "qo":
        return o.ordinalNumber(n, { unit: "quarter" });
      case "qqq":
        return o.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return o.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return o.quarter(n, {
          width: "wide",
          context: "standalone"
        }) || o.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 4;
  }
  set(n, r, o) {
    return n.setMonth((o - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class dI extends Re {
  constructor() {
    super(...arguments);
    J(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    J(this, "priority", 110);
  }
  parse(n, r, o) {
    const i = (s) => s - 1;
    switch (r) {
      case "M":
        return tt(
          Xe(et.month, n),
          i
        );
      case "MM":
        return tt(Qe(2, n), i);
      case "Mo":
        return tt(
          o.ordinalNumber(n, {
            unit: "month"
          }),
          i
        );
      case "MMM":
        return o.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(n, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return o.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return o.month(n, { width: "wide", context: "formatting" }) || o.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 11;
  }
  set(n, r, o) {
    return n.setMonth(o, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class fI extends Re {
  constructor() {
    super(...arguments);
    J(this, "priority", 110);
    J(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    const i = (s) => s - 1;
    switch (r) {
      case "L":
        return tt(
          Xe(et.month, n),
          i
        );
      case "LL":
        return tt(Qe(2, n), i);
      case "Lo":
        return tt(
          o.ordinalNumber(n, {
            unit: "month"
          }),
          i
        );
      case "LLL":
        return o.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(n, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return o.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return o.month(n, { width: "wide", context: "standalone" }) || o.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 11;
  }
  set(n, r, o) {
    return n.setMonth(o, 1), n.setHours(0, 0, 0, 0), n;
  }
}
function hI(e, t, n) {
  const r = we(e), o = Bd(r, n) - t;
  return r.setDate(r.getDate() - o * 7), r;
}
class mI extends Re {
  constructor() {
    super(...arguments);
    J(this, "priority", 100);
    J(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "w":
        return Xe(et.week, n);
      case "wo":
        return o.ordinalNumber(n, { unit: "week" });
      default:
        return Qe(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 53;
  }
  set(n, r, o, i) {
    return zt(hI(n, o, i), i);
  }
}
function pI(e, t) {
  const n = we(e), r = Fd(n) - t;
  return n.setDate(n.getDate() - r * 7), n;
}
class gI extends Re {
  constructor() {
    super(...arguments);
    J(this, "priority", 100);
    J(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "I":
        return Xe(et.week, n);
      case "Io":
        return o.ordinalNumber(n, { unit: "week" });
      default:
        return Qe(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 53;
  }
  set(n, r, o) {
    return Bn(pI(n, o));
  }
}
const vI = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], yI = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class bI extends Re {
  constructor() {
    super(...arguments);
    J(this, "priority", 90);
    J(this, "subPriority", 1);
    J(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "d":
        return Xe(et.date, n);
      case "do":
        return o.ordinalNumber(n, { unit: "date" });
      default:
        return Qe(r.length, n);
    }
  }
  validate(n, r) {
    const o = n.getFullYear(), i = Ow(o), s = n.getMonth();
    return i ? r >= 1 && r <= yI[s] : r >= 1 && r <= vI[s];
  }
  set(n, r, o) {
    return n.setDate(o), n.setHours(0, 0, 0, 0), n;
  }
}
class wI extends Re {
  constructor() {
    super(...arguments);
    J(this, "priority", 90);
    J(this, "subpriority", 1);
    J(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "D":
      case "DD":
        return Xe(et.dayOfYear, n);
      case "Do":
        return o.ordinalNumber(n, { unit: "date" });
      default:
        return Qe(r.length, n);
    }
  }
  validate(n, r) {
    const o = n.getFullYear();
    return Ow(o) ? r >= 1 && r <= 366 : r >= 1 && r <= 365;
  }
  set(n, r, o) {
    return n.setMonth(0, o), n.setHours(0, 0, 0, 0), n;
  }
}
function zd(e, t, n) {
  var d, f, m, p;
  const r = Lr(), o = (n == null ? void 0 : n.weekStartsOn) ?? ((f = (d = n == null ? void 0 : n.locale) == null ? void 0 : d.options) == null ? void 0 : f.weekStartsOn) ?? r.weekStartsOn ?? ((p = (m = r.locale) == null ? void 0 : m.options) == null ? void 0 : p.weekStartsOn) ?? 0, i = we(e), s = i.getDay(), l = (t % 7 + 7) % 7, c = 7 - o, u = t < 0 || t > 6 ? t - (s + c) % 7 : (l + c) % 7 - (s + c) % 7;
  return bt(i, u);
}
class xI extends Re {
  constructor() {
    super(...arguments);
    J(this, "priority", 90);
    J(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return o.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return o.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return o.day(n, { width: "wide", context: "formatting" }) || o.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 6;
  }
  set(n, r, o, i) {
    return n = zd(n, o, i), n.setHours(0, 0, 0, 0), n;
  }
}
class SI extends Re {
  constructor() {
    super(...arguments);
    J(this, "priority", 90);
    J(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o, i) {
    const s = (a) => {
      const l = Math.floor((a - 1) / 7) * 7;
      return (a + i.weekStartsOn + 6) % 7 + l;
    };
    switch (r) {
      case "e":
      case "ee":
        return tt(Qe(r.length, n), s);
      case "eo":
        return tt(
          o.ordinalNumber(n, {
            unit: "day"
          }),
          s
        );
      case "eee":
        return o.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
      case "eeeee":
        return o.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return o.day(n, { width: "wide", context: "formatting" }) || o.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 6;
  }
  set(n, r, o, i) {
    return n = zd(n, o, i), n.setHours(0, 0, 0, 0), n;
  }
}
class CI extends Re {
  constructor() {
    super(...arguments);
    J(this, "priority", 90);
    J(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(n, r, o, i) {
    const s = (a) => {
      const l = Math.floor((a - 1) / 7) * 7;
      return (a + i.weekStartsOn + 6) % 7 + l;
    };
    switch (r) {
      case "c":
      case "cc":
        return tt(Qe(r.length, n), s);
      case "co":
        return tt(
          o.ordinalNumber(n, {
            unit: "day"
          }),
          s
        );
      case "ccc":
        return o.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(n, { width: "short", context: "standalone" }) || o.day(n, { width: "narrow", context: "standalone" });
      case "ccccc":
        return o.day(n, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return o.day(n, { width: "short", context: "standalone" }) || o.day(n, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return o.day(n, { width: "wide", context: "standalone" }) || o.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(n, { width: "short", context: "standalone" }) || o.day(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 6;
  }
  set(n, r, o, i) {
    return n = zd(n, o, i), n.setHours(0, 0, 0, 0), n;
  }
}
function TI(e, t) {
  const n = we(e), r = q_(n), o = t - r;
  return bt(n, o);
}
class PI extends Re {
  constructor() {
    super(...arguments);
    J(this, "priority", 90);
    J(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    const i = (s) => s === 0 ? 7 : s;
    switch (r) {
      case "i":
      case "ii":
        return Qe(r.length, n);
      case "io":
        return o.ordinalNumber(n, { unit: "day" });
      case "iii":
        return tt(
          o.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      case "iiiii":
        return tt(
          o.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      case "iiiiii":
        return tt(
          o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      case "iiii":
      default:
        return tt(
          o.day(n, {
            width: "wide",
            context: "formatting"
          }) || o.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 7;
  }
  set(n, r, o) {
    return n = TI(n, o), n.setHours(0, 0, 0, 0), n;
  }
}
class EI extends Re {
  constructor() {
    super(...arguments);
    J(this, "priority", 80);
    J(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "a":
      case "aa":
      case "aaa":
        return o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return o.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, r, o) {
    return n.setHours(Wd(o), 0, 0, 0), n;
  }
}
class kI extends Re {
  constructor() {
    super(...arguments);
    J(this, "priority", 80);
    J(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "b":
      case "bb":
      case "bbb":
        return o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return o.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, r, o) {
    return n.setHours(Wd(o), 0, 0, 0), n;
  }
}
class DI extends Re {
  constructor() {
    super(...arguments);
    J(this, "priority", 80);
    J(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "B":
      case "BB":
      case "BBB":
        return o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return o.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, r, o) {
    return n.setHours(Wd(o), 0, 0, 0), n;
  }
}
class RI extends Re {
  constructor() {
    super(...arguments);
    J(this, "priority", 70);
    J(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "h":
        return Xe(et.hour12h, n);
      case "ho":
        return o.ordinalNumber(n, { unit: "hour" });
      default:
        return Qe(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 12;
  }
  set(n, r, o) {
    const i = n.getHours() >= 12;
    return i && o < 12 ? n.setHours(o + 12, 0, 0, 0) : !i && o === 12 ? n.setHours(0, 0, 0, 0) : n.setHours(o, 0, 0, 0), n;
  }
}
class MI extends Re {
  constructor() {
    super(...arguments);
    J(this, "priority", 70);
    J(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "H":
        return Xe(et.hour23h, n);
      case "Ho":
        return o.ordinalNumber(n, { unit: "hour" });
      default:
        return Qe(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 23;
  }
  set(n, r, o) {
    return n.setHours(o, 0, 0, 0), n;
  }
}
class AI extends Re {
  constructor() {
    super(...arguments);
    J(this, "priority", 70);
    J(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "K":
        return Xe(et.hour11h, n);
      case "Ko":
        return o.ordinalNumber(n, { unit: "hour" });
      default:
        return Qe(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 11;
  }
  set(n, r, o) {
    return n.getHours() >= 12 && o < 12 ? n.setHours(o + 12, 0, 0, 0) : n.setHours(o, 0, 0, 0), n;
  }
}
class OI extends Re {
  constructor() {
    super(...arguments);
    J(this, "priority", 70);
    J(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "k":
        return Xe(et.hour24h, n);
      case "ko":
        return o.ordinalNumber(n, { unit: "hour" });
      default:
        return Qe(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 24;
  }
  set(n, r, o) {
    const i = o <= 24 ? o % 24 : o;
    return n.setHours(i, 0, 0, 0), n;
  }
}
class NI extends Re {
  constructor() {
    super(...arguments);
    J(this, "priority", 60);
    J(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "m":
        return Xe(et.minute, n);
      case "mo":
        return o.ordinalNumber(n, { unit: "minute" });
      default:
        return Qe(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 59;
  }
  set(n, r, o) {
    return n.setMinutes(o, 0, 0), n;
  }
}
class _I extends Re {
  constructor() {
    super(...arguments);
    J(this, "priority", 50);
    J(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "s":
        return Xe(et.second, n);
      case "so":
        return o.ordinalNumber(n, { unit: "second" });
      default:
        return Qe(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 59;
  }
  set(n, r, o) {
    return n.setSeconds(o, 0), n;
  }
}
class II extends Re {
  constructor() {
    super(...arguments);
    J(this, "priority", 30);
    J(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, r) {
    const o = (i) => Math.trunc(i * Math.pow(10, -r.length + 3));
    return tt(Qe(r.length, n), o);
  }
  set(n, r, o) {
    return n.setMilliseconds(o), n;
  }
}
class LI extends Re {
  constructor() {
    super(...arguments);
    J(this, "priority", 10);
    J(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(n, r) {
    switch (r) {
      case "X":
        return bn(
          yn.basicOptionalMinutes,
          n
        );
      case "XX":
        return bn(yn.basic, n);
      case "XXXX":
        return bn(
          yn.basicOptionalSeconds,
          n
        );
      case "XXXXX":
        return bn(
          yn.extendedOptionalSeconds,
          n
        );
      case "XXX":
      default:
        return bn(yn.extended, n);
    }
  }
  set(n, r, o) {
    return r.timestampIsSet ? n : Be(
      n,
      n.getTime() - ho(n) - o
    );
  }
}
class $I extends Re {
  constructor() {
    super(...arguments);
    J(this, "priority", 10);
    J(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(n, r) {
    switch (r) {
      case "x":
        return bn(
          yn.basicOptionalMinutes,
          n
        );
      case "xx":
        return bn(yn.basic, n);
      case "xxxx":
        return bn(
          yn.basicOptionalSeconds,
          n
        );
      case "xxxxx":
        return bn(
          yn.extendedOptionalSeconds,
          n
        );
      case "xxx":
      default:
        return bn(yn.extended, n);
    }
  }
  set(n, r, o) {
    return r.timestampIsSet ? n : Be(
      n,
      n.getTime() - ho(n) - o
    );
  }
}
class FI extends Re {
  constructor() {
    super(...arguments);
    J(this, "priority", 40);
    J(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return Mw(n);
  }
  set(n, r, o) {
    return [Be(n, o * 1e3), { timestampIsSet: !0 }];
  }
}
class VI extends Re {
  constructor() {
    super(...arguments);
    J(this, "priority", 20);
    J(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return Mw(n);
  }
  set(n, r, o) {
    return [Be(n, o), { timestampIsSet: !0 }];
  }
}
const BI = {
  G: new oI(),
  y: new iI(),
  Y: new sI(),
  R: new aI(),
  u: new lI(),
  Q: new cI(),
  q: new uI(),
  M: new dI(),
  L: new fI(),
  w: new mI(),
  I: new gI(),
  d: new bI(),
  D: new wI(),
  E: new xI(),
  e: new SI(),
  c: new CI(),
  i: new PI(),
  a: new EI(),
  b: new kI(),
  B: new DI(),
  h: new RI(),
  H: new MI(),
  K: new AI(),
  k: new OI(),
  m: new NI(),
  s: new _I(),
  S: new II(),
  X: new LI(),
  x: new $I(),
  t: new FI(),
  T: new VI()
}, WI = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, zI = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, jI = /^'([^]*?)'?$/, HI = /''/g, UI = /\S/, YI = /[a-zA-Z]/;
function GI(e, t, n, r) {
  var g, y, b, x;
  const o = X_(), i = o.locale ?? $d, s = o.firstWeekContainsDate ?? ((y = (g = o.locale) == null ? void 0 : g.options) == null ? void 0 : y.firstWeekContainsDate) ?? 1, a = o.weekStartsOn ?? ((x = (b = o.locale) == null ? void 0 : b.options) == null ? void 0 : x.weekStartsOn) ?? 0, l = {
    firstWeekContainsDate: s,
    weekStartsOn: a,
    locale: i
  }, c = [new rI()], u = t.match(zI).map((w) => {
    const S = w[0];
    if (S in Vc) {
      const E = Vc[S];
      return E(w, i.formatLong);
    }
    return w;
  }).join("").match(WI), d = [];
  for (let w of u) {
    kw(w) && Bc(w, t, e), Ew(w) && Bc(w, t, e);
    const S = w[0], E = BI[S];
    if (E) {
      const { incompatibleTokens: C } = E;
      if (Array.isArray(C)) {
        const P = d.find(
          (D) => C.includes(D.token) || D.token === S
        );
        if (P)
          throw new RangeError(
            `The format string mustn't contain \`${P.fullToken}\` and \`${w}\` at the same time`
          );
      } else if (E.incompatibleTokens === "*" && d.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${w}\` and any other token at the same time`
        );
      d.push({ token: S, fullToken: w });
      const T = E.run(
        e,
        w,
        i.match,
        l
      );
      if (!T)
        return Be(n, NaN);
      c.push(T.setter), e = T.rest;
    } else {
      if (S.match(YI))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + S + "`"
        );
      if (w === "''" ? w = "'" : S === "'" && (w = KI(w)), e.indexOf(w) === 0)
        e = e.slice(w.length);
      else
        return Be(n, NaN);
    }
  }
  if (e.length > 0 && UI.test(e))
    return Be(n, NaN);
  const f = c.map((w) => w.priority).sort((w, S) => S - w).filter((w, S, E) => E.indexOf(w) === S).map(
    (w) => c.filter((S) => S.priority === w).sort((S, E) => E.subPriority - S.subPriority)
  ).map((w) => w[0]);
  let m = we(n);
  if (isNaN(m.getTime()))
    return Be(n, NaN);
  const p = {};
  for (const w of f) {
    if (!w.validate(m, l))
      return Be(n, NaN);
    const S = w.set(m, p, l);
    Array.isArray(S) ? (m = S[0], Object.assign(p, S[1])) : m = S;
  }
  return Be(n, m);
}
function KI(e) {
  return e.match(jI)[1].replace(HI, "'");
}
function jd(e, t) {
  const n = we(e), r = we(t);
  return n.getFullYear() === r.getFullYear() && n.getMonth() === r.getMonth();
}
function XI(e, t) {
  const n = we(e), r = we(t);
  return n.getFullYear() === r.getFullYear();
}
function ml(e, t) {
  return bt(e, -t);
}
function pl(e, t) {
  const n = we(e), r = n.getFullYear(), o = n.getDate(), i = Be(e, 0);
  i.setFullYear(r, t, 15), i.setHours(0, 0, 0, 0);
  const s = K_(i);
  return n.setMonth(t, Math.min(o, s)), n;
}
function Um(e, t) {
  const n = we(e);
  return isNaN(+n) ? Be(e, NaN) : (n.setFullYear(t), n);
}
var ce = function() {
  return ce = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, ce.apply(this, arguments);
};
function qI(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function Nw(e, t, n) {
  for (var r = 0, o = t.length, i; r < o; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
function Ai(e) {
  return e.mode === "multiple";
}
function Oi(e) {
  return e.mode === "range";
}
function xa(e) {
  return e.mode === "single";
}
var QI = {
  root: "rdp",
  multiple_months: "rdp-multiple_months",
  with_weeknumber: "rdp-with_weeknumber",
  vhidden: "rdp-vhidden",
  button_reset: "rdp-button_reset",
  button: "rdp-button",
  caption: "rdp-caption",
  caption_start: "rdp-caption_start",
  caption_end: "rdp-caption_end",
  caption_between: "rdp-caption_between",
  caption_label: "rdp-caption_label",
  caption_dropdowns: "rdp-caption_dropdowns",
  dropdown: "rdp-dropdown",
  dropdown_month: "rdp-dropdown_month",
  dropdown_year: "rdp-dropdown_year",
  dropdown_icon: "rdp-dropdown_icon",
  months: "rdp-months",
  month: "rdp-month",
  table: "rdp-table",
  tbody: "rdp-tbody",
  tfoot: "rdp-tfoot",
  head: "rdp-head",
  head_row: "rdp-head_row",
  head_cell: "rdp-head_cell",
  nav: "rdp-nav",
  nav_button: "rdp-nav_button",
  nav_button_previous: "rdp-nav_button_previous",
  nav_button_next: "rdp-nav_button_next",
  nav_icon: "rdp-nav_icon",
  row: "rdp-row",
  weeknumber: "rdp-weeknumber",
  cell: "rdp-cell",
  day: "rdp-day",
  day_today: "rdp-day_today",
  day_outside: "rdp-day_outside",
  day_selected: "rdp-day_selected",
  day_disabled: "rdp-day_disabled",
  day_hidden: "rdp-day_hidden",
  day_range_start: "rdp-day_range_start",
  day_range_end: "rdp-day_range_end",
  day_range_middle: "rdp-day_range_middle"
};
function ZI(e, t) {
  return Dn(e, "LLLL y", t);
}
function JI(e, t) {
  return Dn(e, "d", t);
}
function eL(e, t) {
  return Dn(e, "LLLL", t);
}
function tL(e) {
  return "".concat(e);
}
function nL(e, t) {
  return Dn(e, "cccccc", t);
}
function rL(e, t) {
  return Dn(e, "yyyy", t);
}
var oL = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  formatCaption: ZI,
  formatDay: JI,
  formatMonthCaption: eL,
  formatWeekNumber: tL,
  formatWeekdayName: nL,
  formatYearCaption: rL
}), iL = function(e, t, n) {
  return Dn(e, "do MMMM (EEEE)", n);
}, sL = function() {
  return "Month: ";
}, aL = function() {
  return "Go to next month";
}, lL = function() {
  return "Go to previous month";
}, cL = function(e, t) {
  return Dn(e, "cccc", t);
}, uL = function(e) {
  return "Week n. ".concat(e);
}, dL = function() {
  return "Year: ";
}, fL = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  labelDay: iL,
  labelMonthDropdown: sL,
  labelNext: aL,
  labelPrevious: lL,
  labelWeekNumber: uL,
  labelWeekday: cL,
  labelYearDropdown: dL
});
function hL() {
  var e = "buttons", t = QI, n = $d, r = {}, o = {}, i = 1, s = {}, a = /* @__PURE__ */ new Date();
  return {
    captionLayout: e,
    classNames: t,
    formatters: oL,
    labels: fL,
    locale: n,
    modifiersClassNames: r,
    modifiers: o,
    numberOfMonths: i,
    styles: s,
    today: a,
    mode: "default"
  };
}
function mL(e) {
  var t = e.fromYear, n = e.toYear, r = e.fromMonth, o = e.toMonth, i = e.fromDate, s = e.toDate;
  return r ? i = _t(r) : t && (i = new Date(t, 0, 1)), o ? s = Id(o) : n && (s = new Date(n, 11, 31)), {
    fromDate: i ? fo(i) : void 0,
    toDate: s ? fo(s) : void 0
  };
}
var _w = Ye(void 0);
function pL(e) {
  var t, n = e.initialProps, r = hL(), o = mL(n), i = o.fromDate, s = o.toDate, a = (t = n.captionLayout) !== null && t !== void 0 ? t : r.captionLayout;
  a !== "buttons" && (!i || !s) && (a = "buttons");
  var l;
  (xa(n) || Ai(n) || Oi(n)) && (l = n.onSelect);
  var c = ce(ce(ce({}, r), n), { captionLayout: a, classNames: ce(ce({}, r.classNames), n.classNames), components: ce({}, n.components), formatters: ce(ce({}, r.formatters), n.formatters), fromDate: i, labels: ce(ce({}, r.labels), n.labels), mode: n.mode || r.mode, modifiers: ce(ce({}, r.modifiers), n.modifiers), modifiersClassNames: ce(ce({}, r.modifiersClassNames), n.modifiersClassNames), onSelect: l, styles: ce(ce({}, r.styles), n.styles), toDate: s });
  return h(_w.Provider, { value: c, children: e.children });
}
function ze() {
  var e = Pe(_w);
  if (!e)
    throw new Error("useDayPicker must be used within a DayPickerProvider.");
  return e;
}
function Iw(e) {
  var t = ze(), n = t.locale, r = t.classNames, o = t.styles, i = t.formatters.formatCaption;
  return h("div", { className: r.caption_label, style: o.caption_label, "aria-live": "polite", role: "presentation", id: e.id, children: i(e.displayMonth, { locale: n }) });
}
function gL(e) {
  return h("svg", ce({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, e, { children: h("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function Lw(e) {
  var t, n, r = e.onChange, o = e.value, i = e.children, s = e.caption, a = e.className, l = e.style, c = ze(), u = (n = (t = c.components) === null || t === void 0 ? void 0 : t.IconDropdown) !== null && n !== void 0 ? n : gL;
  return L("div", { className: a, style: l, children: [h("span", { className: c.classNames.vhidden, children: e["aria-label"] }), h("select", { name: e.name, "aria-label": e["aria-label"], className: c.classNames.dropdown, style: c.styles.dropdown, value: o, onChange: r, children: i }), L("div", { className: c.classNames.caption_label, style: c.styles.caption_label, "aria-hidden": "true", children: [s, h(u, { className: c.classNames.dropdown_icon, style: c.styles.dropdown_icon })] })] });
}
function vL(e) {
  var t, n = ze(), r = n.fromDate, o = n.toDate, i = n.styles, s = n.locale, a = n.formatters.formatMonthCaption, l = n.classNames, c = n.components, u = n.labels.labelMonthDropdown;
  if (!r)
    return h(Oe, {});
  if (!o)
    return h(Oe, {});
  var d = [];
  if (XI(r, o))
    for (var f = _t(r), m = r.getMonth(); m <= o.getMonth(); m++)
      d.push(pl(f, m));
  else
    for (var f = _t(/* @__PURE__ */ new Date()), m = 0; m <= 11; m++)
      d.push(pl(f, m));
  var p = function(y) {
    var b = Number(y.target.value), x = pl(_t(e.displayMonth), b);
    e.onChange(x);
  }, g = (t = c == null ? void 0 : c.Dropdown) !== null && t !== void 0 ? t : Lw;
  return h(g, { name: "months", "aria-label": u(), className: l.dropdown_month, style: i.dropdown_month, onChange: p, value: e.displayMonth.getMonth(), caption: a(e.displayMonth, { locale: s }), children: d.map(function(y) {
    return h("option", { value: y.getMonth(), children: a(y, { locale: s }) }, y.getMonth());
  }) });
}
function yL(e) {
  var t, n = e.displayMonth, r = ze(), o = r.fromDate, i = r.toDate, s = r.locale, a = r.styles, l = r.classNames, c = r.components, u = r.formatters.formatYearCaption, d = r.labels.labelYearDropdown, f = [];
  if (!o)
    return h(Oe, {});
  if (!i)
    return h(Oe, {});
  for (var m = o.getFullYear(), p = i.getFullYear(), g = m; g <= p; g++)
    f.push(Um(Cw(/* @__PURE__ */ new Date()), g));
  var y = function(x) {
    var w = Um(_t(n), Number(x.target.value));
    e.onChange(w);
  }, b = (t = c == null ? void 0 : c.Dropdown) !== null && t !== void 0 ? t : Lw;
  return h(b, { name: "years", "aria-label": d(), className: l.dropdown_year, style: a.dropdown_year, onChange: y, value: n.getFullYear(), caption: u(n, { locale: s }), children: f.map(function(x) {
    return h("option", { value: x.getFullYear(), children: u(x, { locale: s }) }, x.getFullYear());
  }) });
}
function bL(e, t) {
  var n = ue(e), r = n[0], o = n[1], i = t === void 0 ? r : t;
  return [i, o];
}
function wL(e) {
  var t = e.month, n = e.defaultMonth, r = e.today, o = t || n || r || /* @__PURE__ */ new Date(), i = e.toDate, s = e.fromDate, a = e.numberOfMonths, l = a === void 0 ? 1 : a;
  if (i && di(i, o) < 0) {
    var c = -1 * (l - 1);
    o = Kt(i, c);
  }
  return s && di(o, s) < 0 && (o = s), _t(o);
}
function xL() {
  var e = ze(), t = wL(e), n = bL(t, e.month), r = n[0], o = n[1], i = function(s) {
    var a;
    if (!e.disableNavigation) {
      var l = _t(s);
      o(l), (a = e.onMonthChange) === null || a === void 0 || a.call(e, l);
    }
  };
  return [r, i];
}
function SL(e, t) {
  for (var n = t.reverseMonths, r = t.numberOfMonths, o = _t(e), i = _t(Kt(o, r)), s = di(i, o), a = [], l = 0; l < s; l++) {
    var c = Kt(o, l);
    a.push(c);
  }
  return n && (a = a.reverse()), a;
}
function CL(e, t) {
  if (!t.disableNavigation) {
    var n = t.toDate, r = t.pagedNavigation, o = t.numberOfMonths, i = o === void 0 ? 1 : o, s = r ? i : 1, a = _t(e);
    if (!n)
      return Kt(a, s);
    var l = di(n, e);
    if (!(l < i))
      return Kt(a, s);
  }
}
function TL(e, t) {
  if (!t.disableNavigation) {
    var n = t.fromDate, r = t.pagedNavigation, o = t.numberOfMonths, i = o === void 0 ? 1 : o, s = r ? i : 1, a = _t(e);
    if (!n)
      return Kt(a, -s);
    var l = di(a, n);
    if (!(l <= 0))
      return Kt(a, -s);
  }
}
var $w = Ye(void 0);
function PL(e) {
  var t = ze(), n = xL(), r = n[0], o = n[1], i = SL(r, t), s = CL(r, t), a = TL(r, t), l = function(d) {
    return i.some(function(f) {
      return jd(d, f);
    });
  }, c = function(d, f) {
    l(d) || (f && Dw(d, f) ? o(Kt(d, 1 + t.numberOfMonths * -1)) : o(d));
  }, u = {
    currentMonth: r,
    displayMonths: i,
    goToMonth: o,
    goToDate: c,
    previousMonth: a,
    nextMonth: s,
    isDateDisplayed: l
  };
  return h($w.Provider, { value: u, children: e.children });
}
function Ni() {
  var e = Pe($w);
  if (!e)
    throw new Error("useNavigation must be used within a NavigationProvider");
  return e;
}
function Ym(e) {
  var t, n = ze(), r = n.classNames, o = n.styles, i = n.components, s = Ni().goToMonth, a = function(u) {
    s(Kt(u, e.displayIndex ? -e.displayIndex : 0));
  }, l = (t = i == null ? void 0 : i.CaptionLabel) !== null && t !== void 0 ? t : Iw, c = h(l, { id: e.id, displayMonth: e.displayMonth });
  return L("div", { className: r.caption_dropdowns, style: o.caption_dropdowns, children: [h("div", { className: r.vhidden, children: c }), h(vL, { onChange: a, displayMonth: e.displayMonth }), h(yL, { onChange: a, displayMonth: e.displayMonth })] });
}
function EL(e) {
  return h("svg", ce({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: h("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function kL(e) {
  return h("svg", ce({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: h("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" }) }));
}
var js = Ze(function(e, t) {
  var n = ze(), r = n.classNames, o = n.styles, i = [r.button_reset, r.button];
  e.className && i.push(e.className);
  var s = i.join(" "), a = ce(ce({}, o.button_reset), o.button);
  return e.style && Object.assign(a, e.style), h("button", ce({}, e, { ref: t, type: "button", className: s, style: a }));
});
function DL(e) {
  var t, n, r = ze(), o = r.dir, i = r.locale, s = r.classNames, a = r.styles, l = r.labels, c = l.labelPrevious, u = l.labelNext, d = r.components;
  if (!e.nextMonth && !e.previousMonth)
    return h(Oe, {});
  var f = c(e.previousMonth, { locale: i }), m = [
    s.nav_button,
    s.nav_button_previous
  ].join(" "), p = u(e.nextMonth, { locale: i }), g = [
    s.nav_button,
    s.nav_button_next
  ].join(" "), y = (t = d == null ? void 0 : d.IconRight) !== null && t !== void 0 ? t : kL, b = (n = d == null ? void 0 : d.IconLeft) !== null && n !== void 0 ? n : EL;
  return L("div", { className: s.nav, style: a.nav, children: [!e.hidePrevious && h(js, { name: "previous-month", "aria-label": f, className: m, style: a.nav_button_previous, disabled: !e.previousMonth, onClick: e.onPreviousClick, children: o === "rtl" ? h(y, { className: s.nav_icon, style: a.nav_icon }) : h(b, { className: s.nav_icon, style: a.nav_icon }) }), !e.hideNext && h(js, { name: "next-month", "aria-label": p, className: g, style: a.nav_button_next, disabled: !e.nextMonth, onClick: e.onNextClick, children: o === "rtl" ? h(b, { className: s.nav_icon, style: a.nav_icon }) : h(y, { className: s.nav_icon, style: a.nav_icon }) })] });
}
function Gm(e) {
  var t = ze().numberOfMonths, n = Ni(), r = n.previousMonth, o = n.nextMonth, i = n.goToMonth, s = n.displayMonths, a = s.findIndex(function(p) {
    return jd(e.displayMonth, p);
  }), l = a === 0, c = a === s.length - 1, u = t > 1 && (l || !c), d = t > 1 && (c || !l), f = function() {
    r && i(r);
  }, m = function() {
    o && i(o);
  };
  return h(DL, { displayMonth: e.displayMonth, hideNext: u, hidePrevious: d, nextMonth: o, previousMonth: r, onPreviousClick: f, onNextClick: m });
}
function RL(e) {
  var t, n = ze(), r = n.classNames, o = n.disableNavigation, i = n.styles, s = n.captionLayout, a = n.components, l = (t = a == null ? void 0 : a.CaptionLabel) !== null && t !== void 0 ? t : Iw, c;
  return o ? c = h(l, { id: e.id, displayMonth: e.displayMonth }) : s === "dropdown" ? c = h(Ym, { displayMonth: e.displayMonth, id: e.id }) : s === "dropdown-buttons" ? c = L(Oe, { children: [h(Ym, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id }), h(Gm, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id })] }) : c = L(Oe, { children: [h(l, { id: e.id, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), h(Gm, { displayMonth: e.displayMonth, id: e.id })] }), h("div", { className: r.caption, style: i.caption, children: c });
}
function ML(e) {
  var t = ze(), n = t.footer, r = t.styles, o = t.classNames.tfoot;
  return n ? h("tfoot", { className: o, style: r.tfoot, children: h("tr", { children: h("td", { colSpan: 8, children: n }) }) }) : h(Oe, {});
}
function AL(e, t, n) {
  for (var r = n ? Bn(/* @__PURE__ */ new Date()) : zt(/* @__PURE__ */ new Date(), { locale: e, weekStartsOn: t }), o = [], i = 0; i < 7; i++) {
    var s = bt(r, i);
    o.push(s);
  }
  return o;
}
function OL() {
  var e = ze(), t = e.classNames, n = e.styles, r = e.showWeekNumber, o = e.locale, i = e.weekStartsOn, s = e.ISOWeek, a = e.formatters.formatWeekdayName, l = e.labels.labelWeekday, c = AL(o, i, s);
  return L("tr", { style: n.head_row, className: t.head_row, children: [r && h("td", { style: n.head_cell, className: t.head_cell }), c.map(function(u, d) {
    return h("th", { scope: "col", className: t.head_cell, style: n.head_cell, "aria-label": l(u, { locale: o }), children: a(u, { locale: o }) }, d);
  })] });
}
function NL() {
  var e, t = ze(), n = t.classNames, r = t.styles, o = t.components, i = (e = o == null ? void 0 : o.HeadRow) !== null && e !== void 0 ? e : OL;
  return h("thead", { style: r.head, className: n.head, children: h(i, {}) });
}
function _L(e) {
  var t = ze(), n = t.locale, r = t.formatters.formatDay;
  return h(Oe, { children: r(e.date, { locale: n }) });
}
var Hd = Ye(void 0);
function IL(e) {
  if (!Ai(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        disabled: []
      }
    };
    return h(Hd.Provider, { value: t, children: e.children });
  }
  return h(LL, { initialProps: e.initialProps, children: e.children });
}
function LL(e) {
  var t = e.initialProps, n = e.children, r = t.selected, o = t.min, i = t.max, s = function(c, u, d) {
    var f, m;
    (f = t.onDayClick) === null || f === void 0 || f.call(t, c, u, d);
    var p = !!(u.selected && o && (r == null ? void 0 : r.length) === o);
    if (!p) {
      var g = !!(!u.selected && i && (r == null ? void 0 : r.length) === i);
      if (!g) {
        var y = r ? Nw([], r) : [];
        if (u.selected) {
          var b = y.findIndex(function(x) {
            return At(c, x);
          });
          y.splice(b, 1);
        } else
          y.push(c);
        (m = t.onSelect) === null || m === void 0 || m.call(t, y, c, u, d);
      }
    }
  }, a = {
    disabled: []
  };
  r && a.disabled.push(function(c) {
    var u = i && r.length > i - 1, d = r.some(function(f) {
      return At(f, c);
    });
    return !!(u && !d);
  });
  var l = {
    selected: r,
    onDayClick: s,
    modifiers: a
  };
  return h(Hd.Provider, { value: l, children: n });
}
function Ud() {
  var e = Pe(Hd);
  if (!e)
    throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
  return e;
}
function $L(e, t) {
  var n = t || {}, r = n.from, o = n.to;
  return r && o ? At(o, e) && At(r, e) ? void 0 : At(o, e) ? { from: o, to: void 0 } : At(r, e) ? void 0 : Wc(r, e) ? { from: e, to: o } : { from: r, to: e } : o ? Wc(e, o) ? { from: o, to: e } : { from: e, to: o } : r ? Dw(e, r) ? { from: e, to: r } : { from: r, to: e } : { from: e, to: void 0 };
}
var Yd = Ye(void 0);
function FL(e) {
  if (!Oi(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
      }
    };
    return h(Yd.Provider, { value: t, children: e.children });
  }
  return h(VL, { initialProps: e.initialProps, children: e.children });
}
function VL(e) {
  var t = e.initialProps, n = e.children, r = t.selected, o = r || {}, i = o.from, s = o.to, a = t.min, l = t.max, c = function(m, p, g) {
    var y, b;
    (y = t.onDayClick) === null || y === void 0 || y.call(t, m, p, g);
    var x = $L(m, r);
    (b = t.onSelect) === null || b === void 0 || b.call(t, x, m, p, g);
  }, u = {
    range_start: [],
    range_end: [],
    range_middle: [],
    disabled: []
  };
  if (i ? (u.range_start = [i], s ? (u.range_end = [s], At(i, s) || (u.range_middle = [
    {
      after: i,
      before: s
    }
  ])) : u.range_end = [i]) : s && (u.range_start = [s], u.range_end = [s]), a && (i && !s && u.disabled.push({
    after: ml(i, a - 1),
    before: bt(i, a - 1)
  }), i && s && u.disabled.push({
    after: i,
    before: bt(i, a - 1)
  }), !i && s && u.disabled.push({
    after: ml(s, a - 1),
    before: bt(s, a - 1)
  })), l) {
    if (i && !s && (u.disabled.push({
      before: bt(i, -l + 1)
    }), u.disabled.push({
      after: bt(i, l - 1)
    })), i && s) {
      var d = xn(s, i) + 1, f = l - d;
      u.disabled.push({
        before: ml(i, f)
      }), u.disabled.push({
        after: bt(s, f)
      });
    }
    !i && s && (u.disabled.push({
      before: bt(s, -l + 1)
    }), u.disabled.push({
      after: bt(s, l - 1)
    }));
  }
  return h(Yd.Provider, { value: { selected: r, onDayClick: c, modifiers: u }, children: n });
}
function Gd() {
  var e = Pe(Yd);
  if (!e)
    throw new Error("useSelectRange must be used within a SelectRangeProvider");
  return e;
}
function gs(e) {
  return Array.isArray(e) ? Nw([], e) : e !== void 0 ? [e] : [];
}
function BL(e) {
  var t = {};
  return Object.entries(e).forEach(function(n) {
    var r = n[0], o = n[1];
    t[r] = gs(o);
  }), t;
}
var an;
(function(e) {
  e.Outside = "outside", e.Disabled = "disabled", e.Selected = "selected", e.Hidden = "hidden", e.Today = "today", e.RangeStart = "range_start", e.RangeEnd = "range_end", e.RangeMiddle = "range_middle";
})(an || (an = {}));
var WL = an.Selected, Mn = an.Disabled, zL = an.Hidden, jL = an.Today, gl = an.RangeEnd, vl = an.RangeMiddle, yl = an.RangeStart, HL = an.Outside;
function UL(e, t, n) {
  var r, o = (r = {}, r[WL] = gs(e.selected), r[Mn] = gs(e.disabled), r[zL] = gs(e.hidden), r[jL] = [e.today], r[gl] = [], r[vl] = [], r[yl] = [], r[HL] = [], r);
  return e.fromDate && o[Mn].push({ before: e.fromDate }), e.toDate && o[Mn].push({ after: e.toDate }), Ai(e) ? o[Mn] = o[Mn].concat(t.modifiers[Mn]) : Oi(e) && (o[Mn] = o[Mn].concat(n.modifiers[Mn]), o[yl] = n.modifiers[yl], o[vl] = n.modifiers[vl], o[gl] = n.modifiers[gl]), o;
}
var Fw = Ye(void 0);
function YL(e) {
  var t = ze(), n = Ud(), r = Gd(), o = UL(t, n, r), i = BL(t.modifiers), s = ce(ce({}, o), i);
  return h(Fw.Provider, { value: s, children: e.children });
}
function Vw() {
  var e = Pe(Fw);
  if (!e)
    throw new Error("useModifiers must be used within a ModifiersProvider");
  return e;
}
function GL(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function KL(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function XL(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function qL(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function QL(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function ZL(e, t) {
  var n, r = t.from, o = t.to;
  if (r && o) {
    var i = xn(o, r) < 0;
    i && (n = [o, r], r = n[0], o = n[1]);
    var s = xn(e, r) >= 0 && xn(o, e) >= 0;
    return s;
  }
  return o ? At(o, e) : r ? At(r, e) : !1;
}
function JL(e) {
  return _d(e);
}
function e$(e) {
  return Array.isArray(e) && e.every(_d);
}
function t$(e, t) {
  return t.some(function(n) {
    if (typeof n == "boolean")
      return n;
    if (JL(n))
      return At(e, n);
    if (e$(n))
      return n.includes(e);
    if (KL(n))
      return ZL(e, n);
    if (QL(n))
      return n.dayOfWeek.includes(e.getDay());
    if (GL(n)) {
      var r = xn(n.before, e), o = xn(n.after, e), i = r > 0, s = o < 0, a = Wc(n.before, n.after);
      return a ? s && i : i || s;
    }
    return XL(n) ? xn(e, n.after) > 0 : qL(n) ? xn(n.before, e) > 0 : typeof n == "function" ? n(e) : !1;
  });
}
function Kd(e, t, n) {
  var r = Object.keys(t).reduce(function(i, s) {
    var a = t[s];
    return t$(e, a) && i.push(s), i;
  }, []), o = {};
  return r.forEach(function(i) {
    return o[i] = !0;
  }), n && !jd(e, n) && (o.outside = !0), o;
}
function n$(e, t) {
  for (var n = _t(e[0]), r = Id(e[e.length - 1]), o, i, s = n; s <= r; ) {
    var a = Kd(s, t), l = !a.disabled && !a.hidden;
    if (!l) {
      s = bt(s, 1);
      continue;
    }
    if (a.selected)
      return s;
    a.today && !i && (i = s), o || (o = s), s = bt(s, 1);
  }
  return i || o;
}
var r$ = 365;
function Bw(e, t) {
  var n = t.moveBy, r = t.direction, o = t.context, i = t.modifiers, s = t.retry, a = s === void 0 ? { count: 0, lastFocused: e } : s, l = o.weekStartsOn, c = o.fromDate, u = o.toDate, d = o.locale, f = {
    day: bt,
    week: Fc,
    month: Kt,
    year: ZN,
    startOfWeek: function(y) {
      return o.ISOWeek ? Bn(y) : zt(y, { locale: d, weekStartsOn: l });
    },
    endOfWeek: function(y) {
      return o.ISOWeek ? Tw(y) : Ld(y, { locale: d, weekStartsOn: l });
    }
  }, m = f[n](e, r === "after" ? 1 : -1);
  r === "before" && c ? m = JN([c, m]) : r === "after" && u && (m = e_([u, m]));
  var p = !0;
  if (i) {
    var g = Kd(m, i);
    p = !g.disabled && !g.hidden;
  }
  return p ? m : a.count > r$ ? a.lastFocused : Bw(m, {
    moveBy: n,
    direction: r,
    context: o,
    modifiers: i,
    retry: ce(ce({}, a), { count: a.count + 1 })
  });
}
var Ww = Ye(void 0);
function o$(e) {
  var t = Ni(), n = Vw(), r = ue(), o = r[0], i = r[1], s = ue(), a = s[0], l = s[1], c = n$(t.displayMonths, n), u = o ?? (a && t.isDateDisplayed(a)) ? a : c, d = function() {
    l(o), i(void 0);
  }, f = function(y) {
    i(y);
  }, m = ze(), p = function(y, b) {
    if (o) {
      var x = Bw(o, {
        moveBy: y,
        direction: b,
        context: m,
        modifiers: n
      });
      At(o, x) || (t.goToDate(x, o), f(x));
    }
  }, g = {
    focusedDay: o,
    focusTarget: u,
    blur: d,
    focus: f,
    focusDayAfter: function() {
      return p("day", "after");
    },
    focusDayBefore: function() {
      return p("day", "before");
    },
    focusWeekAfter: function() {
      return p("week", "after");
    },
    focusWeekBefore: function() {
      return p("week", "before");
    },
    focusMonthBefore: function() {
      return p("month", "before");
    },
    focusMonthAfter: function() {
      return p("month", "after");
    },
    focusYearBefore: function() {
      return p("year", "before");
    },
    focusYearAfter: function() {
      return p("year", "after");
    },
    focusStartOfWeek: function() {
      return p("startOfWeek", "before");
    },
    focusEndOfWeek: function() {
      return p("endOfWeek", "after");
    }
  };
  return h(Ww.Provider, { value: g, children: e.children });
}
function Xd() {
  var e = Pe(Ww);
  if (!e)
    throw new Error("useFocusContext must be used within a FocusProvider");
  return e;
}
function i$(e, t) {
  var n = Vw(), r = Kd(e, n, t);
  return r;
}
var qd = Ye(void 0);
function s$(e) {
  if (!xa(e.initialProps)) {
    var t = {
      selected: void 0
    };
    return h(qd.Provider, { value: t, children: e.children });
  }
  return h(a$, { initialProps: e.initialProps, children: e.children });
}
function a$(e) {
  var t = e.initialProps, n = e.children, r = function(i, s, a) {
    var l, c, u;
    if ((l = t.onDayClick) === null || l === void 0 || l.call(t, i, s, a), s.selected && !t.required) {
      (c = t.onSelect) === null || c === void 0 || c.call(t, void 0, i, s, a);
      return;
    }
    (u = t.onSelect) === null || u === void 0 || u.call(t, i, i, s, a);
  }, o = {
    selected: t.selected,
    onDayClick: r
  };
  return h(qd.Provider, { value: o, children: n });
}
function zw() {
  var e = Pe(qd);
  if (!e)
    throw new Error("useSelectSingle must be used within a SelectSingleProvider");
  return e;
}
function l$(e, t) {
  var n = ze(), r = zw(), o = Ud(), i = Gd(), s = Xd(), a = s.focusDayAfter, l = s.focusDayBefore, c = s.focusWeekAfter, u = s.focusWeekBefore, d = s.blur, f = s.focus, m = s.focusMonthBefore, p = s.focusMonthAfter, g = s.focusYearBefore, y = s.focusYearAfter, b = s.focusStartOfWeek, x = s.focusEndOfWeek, w = function(A) {
    var M, F, W, ne;
    xa(n) ? (M = r.onDayClick) === null || M === void 0 || M.call(r, e, t, A) : Ai(n) ? (F = o.onDayClick) === null || F === void 0 || F.call(o, e, t, A) : Oi(n) ? (W = i.onDayClick) === null || W === void 0 || W.call(i, e, t, A) : (ne = n.onDayClick) === null || ne === void 0 || ne.call(n, e, t, A);
  }, S = function(A) {
    var M;
    f(e), (M = n.onDayFocus) === null || M === void 0 || M.call(n, e, t, A);
  }, E = function(A) {
    var M;
    d(), (M = n.onDayBlur) === null || M === void 0 || M.call(n, e, t, A);
  }, C = function(A) {
    var M;
    (M = n.onDayMouseEnter) === null || M === void 0 || M.call(n, e, t, A);
  }, T = function(A) {
    var M;
    (M = n.onDayMouseLeave) === null || M === void 0 || M.call(n, e, t, A);
  }, P = function(A) {
    var M;
    (M = n.onDayPointerEnter) === null || M === void 0 || M.call(n, e, t, A);
  }, D = function(A) {
    var M;
    (M = n.onDayPointerLeave) === null || M === void 0 || M.call(n, e, t, A);
  }, k = function(A) {
    var M;
    (M = n.onDayTouchCancel) === null || M === void 0 || M.call(n, e, t, A);
  }, R = function(A) {
    var M;
    (M = n.onDayTouchEnd) === null || M === void 0 || M.call(n, e, t, A);
  }, O = function(A) {
    var M;
    (M = n.onDayTouchMove) === null || M === void 0 || M.call(n, e, t, A);
  }, _ = function(A) {
    var M;
    (M = n.onDayTouchStart) === null || M === void 0 || M.call(n, e, t, A);
  }, $ = function(A) {
    var M;
    (M = n.onDayKeyUp) === null || M === void 0 || M.call(n, e, t, A);
  }, z = function(A) {
    var M;
    switch (A.key) {
      case "ArrowLeft":
        A.preventDefault(), A.stopPropagation(), n.dir === "rtl" ? a() : l();
        break;
      case "ArrowRight":
        A.preventDefault(), A.stopPropagation(), n.dir === "rtl" ? l() : a();
        break;
      case "ArrowDown":
        A.preventDefault(), A.stopPropagation(), c();
        break;
      case "ArrowUp":
        A.preventDefault(), A.stopPropagation(), u();
        break;
      case "PageUp":
        A.preventDefault(), A.stopPropagation(), A.shiftKey ? g() : m();
        break;
      case "PageDown":
        A.preventDefault(), A.stopPropagation(), A.shiftKey ? y() : p();
        break;
      case "Home":
        A.preventDefault(), A.stopPropagation(), b();
        break;
      case "End":
        A.preventDefault(), A.stopPropagation(), x();
        break;
    }
    (M = n.onDayKeyDown) === null || M === void 0 || M.call(n, e, t, A);
  }, I = {
    onClick: w,
    onFocus: S,
    onBlur: E,
    onKeyDown: z,
    onKeyUp: $,
    onMouseEnter: C,
    onMouseLeave: T,
    onPointerEnter: P,
    onPointerLeave: D,
    onTouchCancel: k,
    onTouchEnd: R,
    onTouchMove: O,
    onTouchStart: _
  };
  return I;
}
function c$() {
  var e = ze(), t = zw(), n = Ud(), r = Gd(), o = xa(e) ? t.selected : Ai(e) ? n.selected : Oi(e) ? r.selected : void 0;
  return o;
}
function u$(e) {
  return Object.values(an).includes(e);
}
function d$(e, t) {
  var n = [e.classNames.day];
  return Object.keys(t).forEach(function(r) {
    var o = e.modifiersClassNames[r];
    if (o)
      n.push(o);
    else if (u$(r)) {
      var i = e.classNames["day_".concat(r)];
      i && n.push(i);
    }
  }), n;
}
function f$(e, t) {
  var n = ce({}, e.styles.day);
  return Object.keys(t).forEach(function(r) {
    var o;
    n = ce(ce({}, n), (o = e.modifiersStyles) === null || o === void 0 ? void 0 : o[r]);
  }), n;
}
function h$(e, t, n) {
  var r, o, i, s = ze(), a = Xd(), l = i$(e, t), c = l$(e, l), u = c$(), d = !!(s.onDayClick || s.mode !== "default");
  de(function() {
    var C;
    l.outside || a.focusedDay && d && At(a.focusedDay, e) && ((C = n.current) === null || C === void 0 || C.focus());
  }, [
    a.focusedDay,
    e,
    n,
    d,
    l.outside
  ]);
  var f = d$(s, l).join(" "), m = f$(s, l), p = !!(l.outside && !s.showOutsideDays || l.hidden), g = (i = (o = s.components) === null || o === void 0 ? void 0 : o.DayContent) !== null && i !== void 0 ? i : _L, y = h(g, { date: e, displayMonth: t, activeModifiers: l }), b = {
    style: m,
    className: f,
    children: y,
    role: "gridcell"
  }, x = a.focusTarget && At(a.focusTarget, e) && !l.outside, w = a.focusedDay && At(a.focusedDay, e), S = ce(ce(ce({}, b), (r = { disabled: l.disabled, role: "gridcell" }, r["aria-selected"] = l.selected, r.tabIndex = w || x ? 0 : -1, r)), c), E = {
    isButton: d,
    isHidden: p,
    activeModifiers: l,
    selectedDays: u,
    buttonProps: S,
    divProps: b
  };
  return E;
}
function m$(e) {
  var t = oe(null), n = h$(e.date, e.displayMonth, t);
  return n.isHidden ? h("div", { role: "gridcell" }) : n.isButton ? h(js, ce({ name: "day", ref: t }, n.buttonProps)) : h("div", ce({}, n.divProps));
}
function p$(e) {
  var t = e.number, n = e.dates, r = ze(), o = r.onWeekNumberClick, i = r.styles, s = r.classNames, a = r.locale, l = r.labels.labelWeekNumber, c = r.formatters.formatWeekNumber, u = c(Number(t), { locale: a });
  if (!o)
    return h("span", { className: s.weeknumber, style: i.weeknumber, children: u });
  var d = l(Number(t), { locale: a }), f = function(m) {
    o(t, n, m);
  };
  return h(js, { name: "week-number", "aria-label": d, className: s.weeknumber, style: i.weeknumber, onClick: f, children: u });
}
function g$(e) {
  var t, n, r = ze(), o = r.styles, i = r.classNames, s = r.showWeekNumber, a = r.components, l = (t = a == null ? void 0 : a.Day) !== null && t !== void 0 ? t : m$, c = (n = a == null ? void 0 : a.WeekNumber) !== null && n !== void 0 ? n : p$, u;
  return s && (u = h("td", { className: i.cell, style: o.cell, children: h(c, { number: e.weekNumber, dates: e.dates }) })), L("tr", { className: i.row, style: o.row, children: [u, e.dates.map(function(d) {
    return h("td", { className: i.cell, style: o.cell, role: "presentation", children: h(l, { displayMonth: e.displayMonth, date: d }) }, Q_(d));
  })] });
}
function Km(e, t, n) {
  for (var r = n != null && n.ISOWeek ? Tw(t) : Ld(t, n), o = n != null && n.ISOWeek ? Bn(e) : zt(e, n), i = xn(r, o), s = [], a = 0; a <= i; a++)
    s.push(bt(o, a));
  var l = s.reduce(function(c, u) {
    var d = n != null && n.ISOWeek ? Fd(u) : Bd(u, n), f = c.find(function(m) {
      return m.weekNumber === d;
    });
    return f ? (f.dates.push(u), c) : (c.push({
      weekNumber: d,
      dates: [u]
    }), c);
  }, []);
  return l;
}
function v$(e, t) {
  var n = Km(_t(e), Id(e), t);
  if (t != null && t.useFixedWeeks) {
    var r = J_(e, t);
    if (r < 6) {
      var o = n[n.length - 1], i = o.dates[o.dates.length - 1], s = Fc(i, 6 - r), a = Km(Fc(i, 1), s, t);
      n.push.apply(n, a);
    }
  }
  return n;
}
function y$(e) {
  var t, n, r, o = ze(), i = o.locale, s = o.classNames, a = o.styles, l = o.hideHead, c = o.fixedWeeks, u = o.components, d = o.weekStartsOn, f = o.firstWeekContainsDate, m = o.ISOWeek, p = v$(e.displayMonth, {
    useFixedWeeks: !!c,
    ISOWeek: m,
    locale: i,
    weekStartsOn: d,
    firstWeekContainsDate: f
  }), g = (t = u == null ? void 0 : u.Head) !== null && t !== void 0 ? t : NL, y = (n = u == null ? void 0 : u.Row) !== null && n !== void 0 ? n : g$, b = (r = u == null ? void 0 : u.Footer) !== null && r !== void 0 ? r : ML;
  return L("table", { id: e.id, className: s.table, style: a.table, role: "grid", "aria-labelledby": e["aria-labelledby"], children: [!l && h(g, {}), h("tbody", { className: s.tbody, style: a.tbody, children: p.map(function(x) {
    return h(y, { displayMonth: e.displayMonth, dates: x.dates, weekNumber: x.weekNumber }, x.weekNumber);
  }) }), h(b, { displayMonth: e.displayMonth })] });
}
function b$() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var w$ = b$() ? Dr : de, bl = !1, x$ = 0;
function Xm() {
  return "react-day-picker-".concat(++x$);
}
function S$(e) {
  var t, n = e ?? (bl ? Xm() : null), r = ue(n), o = r[0], i = r[1];
  return w$(function() {
    o === null && i(Xm());
  }, []), de(function() {
    bl === !1 && (bl = !0);
  }, []), (t = e ?? o) !== null && t !== void 0 ? t : void 0;
}
function C$(e) {
  var t, n, r = ze(), o = r.dir, i = r.classNames, s = r.styles, a = r.components, l = Ni().displayMonths, c = S$(r.id ? "".concat(r.id, "-").concat(e.displayIndex) : void 0), u = r.id ? "".concat(r.id, "-grid-").concat(e.displayIndex) : void 0, d = [i.month], f = s.month, m = e.displayIndex === 0, p = e.displayIndex === l.length - 1, g = !m && !p;
  o === "rtl" && (t = [m, p], p = t[0], m = t[1]), m && (d.push(i.caption_start), f = ce(ce({}, f), s.caption_start)), p && (d.push(i.caption_end), f = ce(ce({}, f), s.caption_end)), g && (d.push(i.caption_between), f = ce(ce({}, f), s.caption_between));
  var y = (n = a == null ? void 0 : a.Caption) !== null && n !== void 0 ? n : RL;
  return L("div", { className: d.join(" "), style: f, children: [h(y, { id: c, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), h(y$, { id: u, "aria-labelledby": c, displayMonth: e.displayMonth })] }, e.displayIndex);
}
function T$(e) {
  var t = ze(), n = t.classNames, r = t.styles;
  return h("div", { className: n.months, style: r.months, children: e.children });
}
function P$(e) {
  var t, n, r = e.initialProps, o = ze(), i = Xd(), s = Ni(), a = ue(!1), l = a[0], c = a[1];
  de(function() {
    o.initialFocus && i.focusTarget && (l || (i.focus(i.focusTarget), c(!0)));
  }, [
    o.initialFocus,
    l,
    i.focus,
    i.focusTarget,
    i
  ]);
  var u = [o.classNames.root, o.className];
  o.numberOfMonths > 1 && u.push(o.classNames.multiple_months), o.showWeekNumber && u.push(o.classNames.with_weeknumber);
  var d = ce(ce({}, o.styles.root), o.style), f = Object.keys(r).filter(function(p) {
    return p.startsWith("data-");
  }).reduce(function(p, g) {
    var y;
    return ce(ce({}, p), (y = {}, y[g] = r[g], y));
  }, {}), m = (n = (t = r.components) === null || t === void 0 ? void 0 : t.Months) !== null && n !== void 0 ? n : T$;
  return h("div", ce({ className: u.join(" "), style: d, dir: o.dir, id: o.id, nonce: r.nonce, title: r.title, lang: r.lang }, f, { children: h(m, { children: s.displayMonths.map(function(p, g) {
    return h(C$, { displayIndex: g, displayMonth: p }, g);
  }) }) }));
}
function E$(e) {
  var t = e.children, n = qI(e, ["children"]);
  return h(pL, { initialProps: n, children: h(PL, { children: h(s$, { initialProps: n, children: h(IL, { initialProps: n, children: h(FL, { initialProps: n, children: h(YL, { children: h(o$, { children: t }) }) }) }) }) }) });
}
function k$(e) {
  return h(E$, ce({}, e, { children: h(P$, { initialProps: e }) }));
}
var D$ = Object.defineProperty, Ce = (e, t) => D$(e, "name", { value: t, configurable: !0 });
function jw(e, t) {
  return v.useReducer((n, r) => t[n][r] ?? n, e);
}
Ce(jw, "useStateMachine");
var Hw = "ScrollArea", [Uw, TB] = /* @__PURE__ */ It(Hw), [R$, qt] = Uw(Hw), Yw = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ Ce(function(t, n) {
    const {
      __scopeScrollArea: r,
      type: o = "hover",
      dir: i,
      scrollHideDelay: s = 600,
      ...a
    } = t, [l, c] = v.useState(null), [u, d] = v.useState(null), [f, m] = v.useState(null), [p, g] = v.useState(null), [y, b] = v.useState(null), [x, w] = v.useState(0), [S, E] = v.useState(0), [C, T] = v.useState(!1), [P, D] = v.useState(!1), k = be(n, c), R = Lu(i);
    return /* @__PURE__ */ h(
      R$,
      {
        scope: r,
        type: o,
        dir: R,
        scrollHideDelay: s,
        scrollArea: l,
        viewport: u,
        onViewportChange: d,
        content: f,
        onContentChange: m,
        scrollbarX: p,
        onScrollbarXChange: g,
        scrollbarXEnabled: C,
        onScrollbarXEnabledChange: T,
        scrollbarY: y,
        onScrollbarYChange: b,
        scrollbarYEnabled: P,
        onScrollbarYEnabledChange: D,
        onCornerWidthChange: w,
        onCornerHeightChange: E,
        children: /* @__PURE__ */ h(
          me.div,
          {
            dir: R,
            ...a,
            ref: k,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": x + "px",
              "--radix-scroll-area-corner-height": S + "px",
              ...t.style
            }
          }
        )
      }
    );
  }, "ScrollArea")
), M$ = "ScrollAreaViewport", A$ = /* @__PURE__ */ v.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ Ce(function(t, n) {
    const { __scopeScrollArea: r, children: o, nonce: i, ...s } = t, a = qt(M$, r), l = v.useRef(null), c = be(n, l, a.onViewportChange);
    return /* @__PURE__ */ L(Oe, { children: [
      /* @__PURE__ */ h(O$, { nonce: i }),
      /* @__PURE__ */ h(
        me.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...s,
          ref: c,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: a.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: a.scrollbarYEnabled ? "scroll" : "hidden",
            ...t.style
          },
          children: /* @__PURE__ */ h("div", { ref: a.onContentChange, style: { minWidth: "100%", display: "table" }, children: o })
        }
      )
    ] });
  }, "ScrollAreaViewport")
), O$ = /* @__PURE__ */ v.memo(
  /* @__PURE__ */ Ce(function({ nonce: t }) {
    return /* @__PURE__ */ h(
      "style",
      {
        dangerouslySetInnerHTML: {
          __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
        },
        nonce: t
      }
    );
  }, "ScrollAreaViewportStyle"),
  (e, t) => e.nonce === t.nonce
), zn = "ScrollAreaScrollbar", Gw = /* @__PURE__ */ v.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ Ce(function(t, n) {
    const { forceMount: r, ...o } = t, i = qt(zn, t.__scopeScrollArea), { onScrollbarXEnabledChange: s, onScrollbarYEnabledChange: a } = i, l = t.orientation === "horizontal";
    return v.useEffect(() => (l ? s(!0) : a(!0), () => {
      l ? s(!1) : a(!1);
    }), [l, s, a]), i.type === "hover" ? /* @__PURE__ */ h(N$, { ...o, ref: n, forceMount: r }) : i.type === "scroll" ? /* @__PURE__ */ h(_$, { ...o, ref: n, forceMount: r }) : i.type === "auto" ? /* @__PURE__ */ h(Kw, { ...o, ref: n, forceMount: r }) : i.type === "always" ? /* @__PURE__ */ h(Qd, { ...o, ref: n, "data-state": "visible" }) : null;
  }, "ScrollAreaScrollbar")
), N$ = /* @__PURE__ */ v.forwardRef(/* @__PURE__ */ Ce(function(t, n) {
  const { forceMount: r, ...o } = t, i = qt(zn, t.__scopeScrollArea), [s, a] = v.useState(!1);
  return v.useEffect(() => {
    const l = i.scrollArea;
    let c = 0;
    if (l) {
      const u = /* @__PURE__ */ Ce(() => {
        window.clearTimeout(c), a(!0);
      }, "handlePointerEnter"), d = /* @__PURE__ */ Ce(() => {
        c = window.setTimeout(() => a(!1), i.scrollHideDelay);
      }, "handlePointerLeave");
      return l.addEventListener("pointerenter", u), l.addEventListener("pointerleave", d), () => {
        window.clearTimeout(c), l.removeEventListener("pointerenter", u), l.removeEventListener("pointerleave", d);
      };
    }
  }, [i.scrollArea, i.scrollHideDelay]), /* @__PURE__ */ h(Lt, { present: r || s, children: /* @__PURE__ */ h(
    Kw,
    {
      "data-state": s ? "visible" : "hidden",
      ...o,
      ref: n
    }
  ) });
}, "ScrollAreaScrollbarHover")), _$ = /* @__PURE__ */ v.forwardRef(/* @__PURE__ */ Ce(function(t, n) {
  const { forceMount: r, ...o } = t, i = qt(zn, t.__scopeScrollArea), s = t.orientation === "horizontal", a = Ii(() => c("SCROLL_END"), 100), [l, c] = jw("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return v.useEffect(() => {
    if (l === "idle") {
      const u = window.setTimeout(() => c("HIDE"), i.scrollHideDelay);
      return () => window.clearTimeout(u);
    }
  }, [l, i.scrollHideDelay, c]), v.useEffect(() => {
    const u = i.viewport, d = s ? "scrollLeft" : "scrollTop";
    if (u) {
      let f = u[d];
      const m = /* @__PURE__ */ Ce(() => {
        const p = u[d];
        f !== p && (c("SCROLL"), a()), f = p;
      }, "handleScroll");
      return u.addEventListener("scroll", m), () => u.removeEventListener("scroll", m);
    }
  }, [i.viewport, s, c, a]), /* @__PURE__ */ h(Lt, { present: r || l !== "hidden", children: /* @__PURE__ */ h(
    Qd,
    {
      "data-state": l === "hidden" ? "hidden" : "visible",
      ...o,
      ref: n,
      onPointerEnter: re(t.onPointerEnter, () => c("POINTER_ENTER")),
      onPointerLeave: re(t.onPointerLeave, () => c("POINTER_LEAVE"))
    }
  ) });
}, "ScrollAreaScrollbarScroll")), Kw = /* @__PURE__ */ v.forwardRef(/* @__PURE__ */ Ce(function(t, n) {
  const r = qt(zn, t.__scopeScrollArea), { forceMount: o, ...i } = t, [s, a] = v.useState(!1), l = t.orientation === "horizontal", c = Ii(() => {
    if (r.viewport) {
      const u = r.viewport.offsetWidth < r.viewport.scrollWidth, d = r.viewport.offsetHeight < r.viewport.scrollHeight;
      a(l ? u : d);
    }
  }, 10);
  return Tr(r.viewport, c), Tr(r.content, c), /* @__PURE__ */ h(Lt, { present: o || s, children: /* @__PURE__ */ h(
    Qd,
    {
      "data-state": s ? "visible" : "hidden",
      ...i,
      ref: n
    }
  ) });
}, "ScrollAreaScrollbarAuto")), Qd = /* @__PURE__ */ v.forwardRef(/* @__PURE__ */ Ce(function(t, n) {
  const { orientation: r = "vertical", ...o } = t, i = qt(zn, t.__scopeScrollArea), s = v.useRef(null), a = v.useRef(0), [l, c] = v.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), u = Zd(l.viewport, l.content), d = {
    ...o,
    sizes: l,
    onSizesChange: c,
    hasThumb: u > 0 && u < 1,
    onThumbChange: /* @__PURE__ */ Ce((m) => s.current = m, "onThumbChange"),
    onThumbPointerUp: /* @__PURE__ */ Ce(() => a.current = 0, "onThumbPointerUp"),
    onThumbPointerDown: /* @__PURE__ */ Ce((m) => a.current = m, "onThumbPointerDown")
  };
  function f(m, p) {
    return Zw(m, a.current, l, p);
  }
  return Ce(f, "getScrollPosition"), r === "horizontal" ? /* @__PURE__ */ h(
    I$,
    {
      ...d,
      ref: n,
      onThumbPositionChange: () => {
        if (i.viewport && s.current) {
          const m = i.viewport.scrollLeft, p = jc(m, l, i.dir);
          s.current.style.transform = `translate3d(${p}px, 0, 0)`;
        }
      },
      onWheelScroll: (m) => {
        i.viewport && (i.viewport.scrollLeft = m);
      },
      onDragScroll: (m) => {
        i.viewport && (i.viewport.scrollLeft = f(m, i.dir));
      }
    }
  ) : r === "vertical" ? /* @__PURE__ */ h(
    L$,
    {
      ...d,
      ref: n,
      onThumbPositionChange: () => {
        if (i.viewport && s.current) {
          const m = i.viewport.scrollTop, p = jc(m, l);
          s.current.style.transform = `translate3d(0, ${p}px, 0)`;
        }
      },
      onWheelScroll: (m) => {
        i.viewport && (i.viewport.scrollTop = m);
      },
      onDragScroll: (m) => {
        i.viewport && (i.viewport.scrollTop = f(m));
      }
    }
  ) : null;
}, "ScrollAreaScrollbarVisible")), I$ = /* @__PURE__ */ v.forwardRef(/* @__PURE__ */ Ce(function(t, n) {
  const { sizes: r, onSizesChange: o, ...i } = t, s = qt(zn, t.__scopeScrollArea), [a, l] = v.useState(), c = v.useRef(null), u = be(n, c, s.onScrollbarXChange);
  return v.useEffect(() => {
    c.current && l(getComputedStyle(c.current));
  }, [c]), /* @__PURE__ */ h(
    qw,
    {
      "data-orientation": "horizontal",
      ...i,
      ref: u,
      sizes: r,
      style: {
        bottom: 0,
        left: s.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: s.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": _i(r) + "px",
        ...t.style
      },
      onThumbPointerDown: (d) => t.onThumbPointerDown(d.x),
      onDragScroll: (d) => t.onDragScroll(d.x),
      onWheelScroll: (d, f) => {
        if (s.viewport) {
          const m = s.viewport.scrollLeft + d.deltaX;
          t.onWheelScroll(m), ef(m, f) && d.preventDefault();
        }
      },
      onResize: () => {
        c.current && s.viewport && a && o({
          content: s.viewport.scrollWidth,
          viewport: s.viewport.offsetWidth,
          scrollbar: {
            size: c.current.clientWidth,
            paddingStart: fi(a.paddingLeft),
            paddingEnd: fi(a.paddingRight)
          }
        });
      }
    }
  );
}, "ScrollAreaScrollbarX")), L$ = /* @__PURE__ */ v.forwardRef(/* @__PURE__ */ Ce(function(t, n) {
  const { sizes: r, onSizesChange: o, ...i } = t, s = qt(zn, t.__scopeScrollArea), [a, l] = v.useState(), c = v.useRef(null), u = be(n, c, s.onScrollbarYChange);
  return v.useEffect(() => {
    c.current && l(getComputedStyle(c.current));
  }, [c]), /* @__PURE__ */ h(
    qw,
    {
      "data-orientation": "vertical",
      ...i,
      ref: u,
      sizes: r,
      style: {
        top: 0,
        right: s.dir === "ltr" ? 0 : void 0,
        left: s.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": _i(r) + "px",
        ...t.style
      },
      onThumbPointerDown: (d) => t.onThumbPointerDown(d.y),
      onDragScroll: (d) => t.onDragScroll(d.y),
      onWheelScroll: (d, f) => {
        if (s.viewport) {
          const m = s.viewport.scrollTop + d.deltaY;
          t.onWheelScroll(m), ef(m, f) && d.preventDefault();
        }
      },
      onResize: () => {
        c.current && s.viewport && a && o({
          content: s.viewport.scrollHeight,
          viewport: s.viewport.offsetHeight,
          scrollbar: {
            size: c.current.clientHeight,
            paddingStart: fi(a.paddingTop),
            paddingEnd: fi(a.paddingBottom)
          }
        });
      }
    }
  );
}, "ScrollAreaScrollbarY")), [$$, Xw] = Uw(zn), qw = /* @__PURE__ */ v.forwardRef(/* @__PURE__ */ Ce(function(t, n) {
  const {
    __scopeScrollArea: r,
    sizes: o,
    hasThumb: i,
    onThumbChange: s,
    onThumbPointerUp: a,
    onThumbPointerDown: l,
    onThumbPositionChange: c,
    onDragScroll: u,
    onWheelScroll: d,
    onResize: f,
    ...m
  } = t, p = qt(zn, r), [g, y] = v.useState(null), b = be(n, y), x = v.useRef(null), w = v.useRef(""), S = p.viewport, E = o.content - o.viewport, C = Je(d), T = Je(c), P = Ii(f, 10);
  function D(k) {
    if (x.current) {
      const R = k.clientX - x.current.left, O = k.clientY - x.current.top;
      u({ x: R, y: O });
    }
  }
  return Ce(D, "handleDragScroll"), v.useEffect(() => {
    const k = /* @__PURE__ */ Ce((R) => {
      const O = R.target;
      (g == null ? void 0 : g.contains(O)) && C(R, E);
    }, "handleWheel");
    return document.addEventListener("wheel", k, { passive: !1 }), () => document.removeEventListener("wheel", k, { passive: !1 });
  }, [S, g, E, C]), v.useEffect(T, [o, T]), Tr(g, P), Tr(p.content, P), /* @__PURE__ */ h(
    $$,
    {
      scope: r,
      scrollbar: g,
      hasThumb: i,
      onThumbChange: Je(s),
      onThumbPointerUp: Je(a),
      onThumbPositionChange: T,
      onThumbPointerDown: Je(l),
      children: /* @__PURE__ */ h(
        me.div,
        {
          ...m,
          ref: b,
          style: { position: "absolute", ...m.style },
          onPointerDown: re(t.onPointerDown, (k) => {
            k.button === 0 && (k.target.setPointerCapture(k.pointerId), x.current = g.getBoundingClientRect(), w.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", p.viewport && (p.viewport.style.scrollBehavior = "auto"), D(k));
          }),
          onPointerMove: re(t.onPointerMove, D),
          onPointerUp: re(t.onPointerUp, (k) => {
            const R = k.target;
            R.hasPointerCapture(k.pointerId) && R.releasePointerCapture(k.pointerId), document.body.style.webkitUserSelect = w.current, p.viewport && (p.viewport.style.scrollBehavior = ""), x.current = null;
          })
        }
      )
    }
  );
}, "ScrollAreaScrollbarImpl")), zc = "ScrollAreaThumb", F$ = /* @__PURE__ */ v.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ Ce(function(t, n) {
    const { forceMount: r, ...o } = t, i = Xw(zc, t.__scopeScrollArea);
    return /* @__PURE__ */ h(Lt, { present: r || i.hasThumb, children: /* @__PURE__ */ h(V$, { ref: n, ...o }) });
  }, "ScrollAreaThumb")
), V$ = /* @__PURE__ */ v.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ Ce(function(t, n) {
    const { __scopeScrollArea: r, style: o, ...i } = t, s = qt(zc, r), a = Xw(zc, r), { onThumbPositionChange: l } = a, c = be(n, a.onThumbChange), u = v.useRef(void 0), d = Ii(() => {
      u.current && (u.current(), u.current = void 0);
    }, 100);
    return v.useEffect(() => {
      const f = s.viewport;
      if (f) {
        const m = /* @__PURE__ */ Ce(() => {
          if (d(), !u.current) {
            const p = z$(f, l);
            u.current = p, l();
          }
        }, "handleScroll");
        return l(), f.addEventListener("scroll", m), () => f.removeEventListener("scroll", m);
      }
    }, [s.viewport, d, l]), /* @__PURE__ */ h(
      me.div,
      {
        "data-state": a.hasThumb ? "visible" : "hidden",
        ...i,
        ref: c,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...o
        },
        onPointerDownCapture: re(t.onPointerDownCapture, (f) => {
          const p = f.target.getBoundingClientRect(), g = f.clientX - p.left, y = f.clientY - p.top;
          a.onThumbPointerDown({ x: g, y });
        }),
        onPointerUp: re(t.onPointerUp, a.onThumbPointerUp)
      }
    );
  }, "ScrollAreaThumbImpl")
), Qw = "ScrollAreaCorner", B$ = /* @__PURE__ */ v.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ Ce(function(t, n) {
    const r = qt(Qw, t.__scopeScrollArea), o = !!(r.scrollbarX && r.scrollbarY);
    return r.type !== "scroll" && o ? /* @__PURE__ */ h(W$, { ...t, ref: n }) : null;
  }, "ScrollAreaCorner")
), W$ = /* @__PURE__ */ v.forwardRef(/* @__PURE__ */ Ce(function(t, n) {
  const { __scopeScrollArea: r, ...o } = t, i = qt(Qw, r), [s, a] = v.useState(0), [l, c] = v.useState(0), u = !!(s && l), { onCornerWidthChange: d, onCornerHeightChange: f } = i;
  return Tr(i.scrollbarX, () => {
    var p;
    const m = ((p = i.scrollbarX) == null ? void 0 : p.offsetHeight) || 0;
    i.onCornerHeightChange(m), c(m);
  }), Tr(i.scrollbarY, () => {
    var p;
    const m = ((p = i.scrollbarY) == null ? void 0 : p.offsetWidth) || 0;
    i.onCornerWidthChange(m), a(m);
  }), v.useEffect(() => () => {
    d(0), f(0);
  }, [d, f]), u ? /* @__PURE__ */ h(
    me.div,
    {
      ...o,
      ref: n,
      style: {
        width: s,
        height: l,
        position: "absolute",
        right: i.dir === "ltr" ? 0 : void 0,
        left: i.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...t.style
      }
    }
  ) : null;
}, "ScrollAreaCornerImpl"));
function fi(e) {
  return e ? parseInt(e, 10) : 0;
}
Ce(fi, "toInt");
function Zd(e, t) {
  const n = e / t;
  return isNaN(n) ? 0 : n;
}
Ce(Zd, "getThumbRatio");
function _i(e) {
  const t = Zd(e.viewport, e.content), n = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, r = (e.scrollbar.size - n) * t;
  return Math.max(r, 18);
}
Ce(_i, "getThumbSize");
function Zw(e, t, n, r = "ltr") {
  const o = _i(n), i = o / 2, s = t || i, a = o - s, l = n.scrollbar.paddingStart + s, c = n.scrollbar.size - n.scrollbar.paddingEnd - a, u = n.content - n.viewport, d = r === "ltr" ? [0, u] : [u * -1, 0];
  return Jd([l, c], d)(e);
}
Ce(Zw, "getScrollPositionFromPointer");
function jc(e, t, n = "ltr") {
  const r = _i(t), o = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, i = t.scrollbar.size - o, s = t.content - t.viewport, a = i - r, l = n === "ltr" ? [0, s] : [s * -1, 0], c = ks(e, l);
  return Jd([0, s], [0, a])(c);
}
Ce(jc, "getThumbOffsetFromScroll");
function Jd(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const r = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + r * (n - e[0]);
  };
}
Ce(Jd, "linearScale");
function ef(e, t) {
  return e > 0 && e < t;
}
Ce(ef, "isScrollingWithinScrollbarBounds");
var z$ = /* @__PURE__ */ Ce((e, t = () => {
}) => {
  let n = { left: e.scrollLeft, top: e.scrollTop }, r = 0;
  return (/* @__PURE__ */ Ce(function o() {
    const i = { left: e.scrollLeft, top: e.scrollTop }, s = n.left !== i.left, a = n.top !== i.top;
    (s || a) && t(), n = i, r = window.requestAnimationFrame(o);
  }, "loop"))(), () => window.cancelAnimationFrame(r);
}, "addUnlinkedScrollListener");
function Ii(e, t) {
  const n = Je(e), r = v.useRef(0);
  return v.useEffect(() => () => window.clearTimeout(r.current), []), v.useCallback(() => {
    window.clearTimeout(r.current), r.current = window.setTimeout(n, t);
  }, [n, t]);
}
Ce(Ii, "useDebounceCallback");
function Tr(e, t) {
  const n = Je(t);
  qe(() => {
    let r = 0;
    if (e) {
      const o = new ResizeObserver(() => {
        cancelAnimationFrame(r), r = window.requestAnimationFrame(n);
      });
      return o.observe(e), () => {
        window.cancelAnimationFrame(r), o.unobserve(e);
      };
    }
  }, [e, n]);
}
Ce(Tr, "useResizeObserver");
const Jw = v.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ L(Yw, { ref: r, className: Q("relative overflow-hidden", e), ...n, children: [
  /* @__PURE__ */ h(A$, { className: "h-full w-full rounded-[inherit]", children: t }),
  /* @__PURE__ */ h(e0, {}),
  /* @__PURE__ */ h(B$, {})
] }));
Jw.displayName = Yw.displayName;
const e0 = v.forwardRef(({ className: e, orientation: t = "vertical", ...n }, r) => /* @__PURE__ */ h(
  Gw,
  {
    ref: r,
    orientation: t,
    className: Q(
      "flex touch-none select-none transition-colors",
      t === "vertical" && "h-full w-2.5 border-l border-l-transparent p-[1px]",
      t === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-[1px]",
      e
    ),
    ...n,
    children: /* @__PURE__ */ h(F$, { className: "relative flex-1 rounded-full bg-button-primary-bg" })
  }
));
e0.displayName = Gw.displayName;
function tf({ className: e, classNames: t, showOutsideDays: n = !0, ...r }) {
  return /* @__PURE__ */ h(
    k$,
    {
      showOutsideDays: n,
      className: Q("p-3", e),
      classNames: {
        months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
        month: "space-y-4",
        caption: "flex justify-center pt-1 relative items-center",
        caption_label: "text-sm font-medium",
        caption_dropdowns: "flex justify-center gap-1 w-48",
        nav: "space-x-1 flex items-center",
        nav_button: Q(Il({ variant: "minimal" }), "icon bg-transparent p-0"),
        nav_button_previous: "absolute left-1",
        nav_button_next: "absolute right-1",
        table: "w-full border-collapse space-y-1",
        head_row: "flex",
        head_cell: "text-muted-foreground rounded-md w-9 font-normal text-[0.8rem]",
        row: "flex w-full mt-2",
        cell: "h-9 w-9 text-center text-sm p-0 relative [&:has([aria-selected].day-range-end)]:rounded-r-md [&:has([aria-selected].day-outside)]:bg-accent/50 [&:has([aria-selected])]:bg-accent first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20",
        day: Q(Il({ variant: "ghost" }), "h-9 w-9 p-0 font-normal aria-selected:opacity-100"),
        day_range_end: "day-range-end",
        day_selected: "bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground",
        day_today: "bg-accent text-accent-foreground",
        day_outside: "day-outside text-muted-foreground opacity-50 aria-selected:bg-accent/50 aria-selected:text-muted-foreground aria-selected:opacity-30",
        day_disabled: "text-muted-foreground opacity-30 cursor-not-allowed pointer-events-none",
        day_range_middle: "aria-selected:bg-accent aria-selected:text-accent-foreground",
        day_hidden: "invisible",
        vhidden: "vhidden hidden",
        ...t
      },
      components: {
        Dropdown: ({ value: o, onChange: i, children: s, ...a }) => {
          var d;
          const l = v.Children.toArray(s), c = l.find((f) => f.props.value === o), u = (f) => {
            const m = {
              target: { value: f }
            };
            i == null || i(m);
          };
          return /* @__PURE__ */ L(
            sa,
            {
              value: o == null ? void 0 : o.toString(),
              onValueChange: (f) => {
                u(f);
              },
              children: [
                /* @__PURE__ */ h(aa, { className: "pr-1.5 focus:ring-0", children: /* @__PURE__ */ h(Hu, { children: (d = c == null ? void 0 : c.props) == null ? void 0 : d.children }) }),
                /* @__PURE__ */ h(la, { position: "popper", children: /* @__PURE__ */ h(Jw, { className: "h-80", children: l.map((f, m) => {
                  var p;
                  return /* @__PURE__ */ h(ca, { value: ((p = f.props.value) == null ? void 0 : p.toString()) ?? "", children: f.props.children }, `${f.props.value}-${m}`);
                }) }) })
              ]
            }
          );
        },
        IconLeft: ({ ...o }) => /* @__PURE__ */ h(Px, { className: "h-4 w-4" }),
        IconRight: ({ ...o }) => /* @__PURE__ */ h(Tx, { className: "h-4 w-4" })
      },
      ...r
    }
  );
}
tf.displayName = "Calendar";
function j$(e, t) {
  if (!e || !(e instanceof Date) || isNaN(e.getTime()))
    return t;
  try {
    return Dn(e, "PPP");
  } catch {
    return t;
  }
}
function qm(e) {
  const t = e.selected ? j$(e.selected, e.placeholder || "Pick a date") : e.placeholder || "Pick a date";
  return /* @__PURE__ */ L(
    ke,
    {
      disabled: !!e.disabled,
      size: "md",
      variant: "ghost",
      className: "group control justify-between text-left w-full border-0",
      children: [
        /* @__PURE__ */ h(
          "span",
          {
            "aria-disabled": !!e.disabled || void 0,
            "aria-checked": !!e.selected || void 0,
            className: "text-input-text-secondary aria-[checked]:text-input-text aria-[disabled]:opacity-50",
            children: t
          }
        ),
        /* @__PURE__ */ h(nu, { className: "ml-2 h-4 w-4 text-input-active" })
      ]
    }
  );
}
function PB(e) {
  const [t, n] = ue(!1), r = (i, s, a, l) => {
    var c;
    (c = e.onSelect) == null || c.call(e, i, s, a, l), i && n(!1);
  }, o = (i) => {
    n(i), i && window.dispatchEvent(new CustomEvent("datepicker-opening", { detail: { source: e.label } }));
  };
  return Z.useEffect(() => {
    const i = (a) => {
      var l;
      ((l = a.detail) == null ? void 0 : l.source) !== e.label && t && n(!1);
    }, s = () => {
      console.log("LabeledDatePicker: Received force-close-all-popovers event, current open state:", t), t && (console.log("LabeledDatePicker: Closing picker for label:", e.label), n(!1), setTimeout(() => {
        document.querySelectorAll("[data-radix-popper-content-wrapper]").forEach((c) => {
          const u = c;
          u.style.pointerEvents !== "none" && (u.style.display = "none", u.style.pointerEvents = "none");
        }), document.querySelectorAll("[data-radix-portal]").forEach((c) => {
          const u = c;
          u.contains(document.querySelector("[data-radix-popper-content-wrapper]")) && (u.style.display = "none", u.style.pointerEvents = "none");
        });
      }, 50));
    };
    return window.addEventListener("datepicker-opening", i), window.addEventListener("force-close-all-popovers", s), () => {
      window.removeEventListener("datepicker-opening", i), window.removeEventListener("force-close-all-popovers", s);
    };
  }, [t, e.label]), Z.useEffect(() => {
    var i;
    (i = e.onOpenChange) == null || i.call(e, t);
  }, [t, e.onOpenChange]), e.disabled ? /* @__PURE__ */ h(
    Gt,
    {
      label: e.label,
      error: e.error,
      disabled: !!e.disabled || void 0,
      className: e.className,
      children: /* @__PURE__ */ h(qm, { ...e })
    }
  ) : /* @__PURE__ */ L(Sr, { modal: e.modal, open: t, onOpenChange: o, children: [
    /* @__PURE__ */ h(wo, { asChild: !0, children: /* @__PURE__ */ h("div", { className: e.className, children: /* @__PURE__ */ h(
      Gt,
      {
        label: e.label,
        error: e.error,
        disabled: !!e.disabled || void 0,
        className: e.className,
        children: /* @__PURE__ */ h(Ci, { children: /* @__PURE__ */ h(qm, { ...e }) })
      }
    ) }) }),
    /* @__PURE__ */ h(
      _r,
      {
        className: Q("w-auto min-w-[280px] p-0", e.modal && "z-[100]"),
        renderOnBody: !e.modal,
        onInteractOutside: e.modal && !e.allowOutsideClose ? (i) => i.preventDefault() : void 0,
        onPointerDownOutside: e.modal && !e.allowOutsideClose ? (i) => i.preventDefault() : void 0,
        children: /* @__PURE__ */ h(
          tf,
          {
            ...e,
            onSelect: r,
            disabled: e.disabledDate,
            className: Q("bg-input-bg", e.className),
            mode: "single",
            initialFocus: !0,
            captionLayout: "dropdown-buttons",
            fromYear: 2e3,
            toYear: (/* @__PURE__ */ new Date()).getFullYear() + 5,
            defaultMonth: e.selected || void 0
          }
        )
      }
    )
  ] });
}
function Qm(e) {
  if (!e || !(e instanceof Date) || isNaN(e.getTime()))
    return "";
  try {
    return Dn(e, "MM/dd/yyyy");
  } catch {
    return "";
  }
}
function Zm(e) {
  const { from: t, to: n } = (e == null ? void 0 : e.selected) || {}, r = Qm(t), o = Qm(n), i = r ? `${r} ${o ? `to ${o}` : ""}` : e.placeholder || "Pick a range";
  return /* @__PURE__ */ L(
    ke,
    {
      disabled: !!e.disabled,
      variant: "ghost",
      className: "input group justify-between text-left w-full border-0 ",
      children: [
        /* @__PURE__ */ h(
          "span",
          {
            "aria-disabled": !!e.disabled || void 0,
            "aria-checked": !!e.selected || void 0,
            className: "text-input-text-secondary aria-[checked]:text-input-text aria-[disabled]:opacity-50",
            children: i
          }
        ),
        /* @__PURE__ */ h(Ex, { className: "ml-2 h-4 w-4 text-input-active" })
      ]
    }
  );
}
function EB(e) {
  return e.disabled ? /* @__PURE__ */ h(
    Gt,
    {
      label: e.label,
      error: e.error,
      disabled: !!e.disabled || void 0,
      className: e.className,
      children: /* @__PURE__ */ h(Zm, { ...e })
    }
  ) : /* @__PURE__ */ L(Sr, { children: [
    /* @__PURE__ */ h(wo, { asChild: !0, children: /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(
      Gt,
      {
        label: e.label,
        error: e.error,
        disabled: !!e.disabled || void 0,
        className: e.className,
        children: /* @__PURE__ */ h(Ci, { children: /* @__PURE__ */ h(Zm, { ...e }) })
      }
    ) }) }),
    /* @__PURE__ */ h(_r, { className: "w-auto p-0", align: "start", children: /* @__PURE__ */ h(
      tf,
      {
        mode: "range",
        className: Q("bg-input-bg", e.className),
        disabled: e.disabledDate,
        initialFocus: !0,
        selected: e.selected,
        onSelect: e.onSelect,
        numberOfMonths: 2,
        captionLayout: "dropdown-buttons",
        fromYear: 2e3,
        toYear: (/* @__PURE__ */ new Date()).getFullYear()
      }
    ) })
  ] });
}
const H$ = "text-xxs px-4 py-0 font-normal", U$ = Rr(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 cursor-pointer min-h-[18px]",
  {
    variants: {
      variant: {
        default: "border border-button-primary-bg text-button-primary-txt bg-button-primary-bg hover:bg-button-primary-hover hover:border-button-primary-hover ",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        disabled: "border bg-button-primary-disabled border-button-primary-disabled cursor-not-allowed text-neutral-text-secondary/50",
        outline: "text-foreground",
        "scenario-count": `${H$} px-2 border-status-primary-border bg-status-primary-bg text-status-primary-text`
        // [`scenario-${ScenarioStatusSchema.enum.DRAFT}`]: `${scenarioStatusVariatsCommonStyles} border-status-grey-border bg-status-grey-bg text-status-grey-text`,
        // [`scenario-${ScenarioStatusSchema.enum.GENERATING}`]: `${scenarioStatusVariatsCommonStyles} border-status-yellow-border bg-status-yellow-bg text-status-yellow-text`,
        // [`scenario-${ScenarioStatusSchema.enum.FAILED}`]: `${scenarioStatusVariatsCommonStyles} border-status-danger-border bg-status-danger-bg text-status-danger-text`,
        // [`scenario-${ScenarioStatusSchema.enum.WORKING}`]: `${scenarioStatusVariatsCommonStyles} border-status-primary-border bg-status-primary-bg text-status-primary-text`,
        // [`scenario-${ScenarioStatusSchema.enum.READY}`]: `${scenarioStatusVariatsCommonStyles} border-status-primary-border-2 bg-status-primary-bg-2 text-status-primary-text-2`,
        // [`scenario-${ScenarioStatusSchema.enum['PRE ALIGNMENT']}`]: `${scenarioStatusVariatsCommonStyles} border-status-secondary-border-2 bg-status-secondary-bg-2 text-status-secondary-text-2`,
        // [`scenario-${ScenarioStatusSchema.enum['SENT FOR APPROVAL']}`]: `${scenarioStatusVariatsCommonStyles} border-status-secondary-border-2 bg-status-secondary-bg-2 text-status-secondary-text-2`,
        // [`scenario-${ScenarioStatusSchema.enum['ALIGNED.PROCESSING']}`]: `${scenarioStatusVariatsCommonStyles} border-status-yellow-border bg-status-yellow-bg text-status-yellow-text`,
        // [`scenario-${ScenarioStatusSchema.enum.ALIGNED}`]: `${scenarioStatusVariatsCommonStyles} border-status-secondary-border-2 bg-status-secondary-bg-2 text-status-secondary-text-2`,
        // [`scenario-${ScenarioStatusSchema.enum.APPROVED}`]: `${scenarioStatusVariatsCommonStyles} border-status-secondary-border-2 bg-status-secondary-bg-2 text-status-secondary-text-2`,
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), t0 = Ze(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ h("div", { ref: r, className: Q(U$({ variant: t }), e), ...n }));
t0.displayName = "Badge";
var Jm = 1, Y$ = 0.9, G$ = 0.8, K$ = 0.17, wl = 0.1, xl = 0.999, X$ = 0.9999, q$ = 0.99, Q$ = /[\\\/_+.#"@\[\(\{&]/, Z$ = /[\\\/_+.#"@\[\(\{&]/g, J$ = /[\s-]/, n0 = /[\s-]/g;
function Hc(e, t, n, r, o, i, s) {
  if (i === t.length) return o === e.length ? Jm : q$;
  var a = `${o},${i}`;
  if (s[a] !== void 0) return s[a];
  for (var l = r.charAt(i), c = n.indexOf(l, o), u = 0, d, f, m, p; c >= 0; ) d = Hc(e, t, n, r, c + 1, i + 1, s), d > u && (c === o ? d *= Jm : Q$.test(e.charAt(c - 1)) ? (d *= G$, m = e.slice(o, c - 1).match(Z$), m && o > 0 && (d *= Math.pow(xl, m.length))) : J$.test(e.charAt(c - 1)) ? (d *= Y$, p = e.slice(o, c - 1).match(n0), p && o > 0 && (d *= Math.pow(xl, p.length))) : (d *= K$, o > 0 && (d *= Math.pow(xl, c - o))), e.charAt(c) !== t.charAt(i) && (d *= X$)), (d < wl && n.charAt(c - 1) === r.charAt(i + 1) || r.charAt(i + 1) === r.charAt(i) && n.charAt(c - 1) !== r.charAt(i)) && (f = Hc(e, t, n, r, c + 1, i + 2, s), f * wl > d && (d = f * wl)), d > u && (u = d), c = n.indexOf(l, c + 1);
  return s[a] = u, u;
}
function ep(e) {
  return e.toLowerCase().replace(n0, " ");
}
function eF(e, t, n) {
  return e = n && n.length > 0 ? `${e + " " + n.join(" ")}` : e, Hc(e, t, ep(e), ep(t), 0, 0, {});
}
function Et() {
  return Et = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Et.apply(null, arguments);
}
function io(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented) return t == null ? void 0 : t(o);
  };
}
function tF(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function r0(...e) {
  return (t) => e.forEach(
    (n) => tF(n, t)
  );
}
function Li(...e) {
  return Fe(r0(...e), e);
}
function nF(e, t) {
  const n = /* @__PURE__ */ Ye(t);
  function r(i) {
    const { children: s, ...a } = i, l = pe(
      () => a,
      Object.values(a)
    );
    return /* @__PURE__ */ We(n.Provider, {
      value: l
    }, s);
  }
  function o(i) {
    const s = Pe(n);
    if (s) return s;
    if (t !== void 0) return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return r.displayName = e + "Provider", [
    r,
    o
  ];
}
function rF(e, t = []) {
  let n = [];
  function r(i, s) {
    const a = /* @__PURE__ */ Ye(s), l = n.length;
    n = [
      ...n,
      s
    ];
    function c(d) {
      const { scope: f, children: m, ...p } = d, g = (f == null ? void 0 : f[e][l]) || a, y = pe(
        () => p,
        Object.values(p)
      );
      return /* @__PURE__ */ We(g.Provider, {
        value: y
      }, m);
    }
    function u(d, f) {
      const m = (f == null ? void 0 : f[e][l]) || a, p = Pe(m);
      if (p) return p;
      if (s !== void 0) return s;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return c.displayName = i + "Provider", [
      c,
      u
    ];
  }
  const o = () => {
    const i = n.map((s) => /* @__PURE__ */ Ye(s));
    return function(a) {
      const l = (a == null ? void 0 : a[e]) || i;
      return pe(
        () => ({
          [`__scope${e}`]: {
            ...a,
            [e]: l
          }
        }),
        [
          a,
          l
        ]
      );
    };
  };
  return o.scopeName = e, [
    r,
    oF(o, ...t)
  ];
}
function oF(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map(
      (o) => ({
        useScope: o(),
        scopeName: o.scopeName
      })
    );
    return function(i) {
      const s = r.reduce((a, { useScope: l, scopeName: c }) => {
        const d = l(i)[`__scope${c}`];
        return {
          ...a,
          ...d
        };
      }, {});
      return pe(
        () => ({
          [`__scope${t.scopeName}`]: s
        }),
        [
          s
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
const Uc = globalThis != null && globalThis.document ? Dr : () => {
}, iF = v.useId || (() => {
});
let sF = 0;
function Sl(e) {
  const [t, n] = v.useState(iF());
  return Uc(() => {
    n(
      (r) => r ?? String(sF++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
function Pr(e) {
  const t = oe(e);
  return de(() => {
    t.current = e;
  }), pe(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
function aF({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = lF({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, s = i ? e : r, a = Pr(n), l = Fe((c) => {
    if (i) {
      const d = typeof c == "function" ? c(e) : c;
      d !== e && a(d);
    } else o(c);
  }, [
    i,
    e,
    o,
    a
  ]);
  return [
    s,
    l
  ];
}
function lF({ defaultProp: e, onChange: t }) {
  const n = ue(e), [r] = n, o = oe(r), i = Pr(t);
  return de(() => {
    o.current !== r && (i(r), o.current = r);
  }, [
    r,
    o,
    i
  ]), n;
}
const nf = /* @__PURE__ */ Ze((e, t) => {
  const { children: n, ...r } = e, o = hr.toArray(n), i = o.find(uF);
  if (i) {
    const s = i.props.children, a = o.map((l) => l === i ? hr.count(s) > 1 ? hr.only(null) : /* @__PURE__ */ ws(s) ? s.props.children : null : l);
    return /* @__PURE__ */ We(Yc, Et({}, r, {
      ref: t
    }), /* @__PURE__ */ ws(s) ? /* @__PURE__ */ Jc(s, void 0, a) : null);
  }
  return /* @__PURE__ */ We(Yc, Et({}, r, {
    ref: t
  }), n);
});
nf.displayName = "Slot";
const Yc = /* @__PURE__ */ Ze((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ ws(n) ? /* @__PURE__ */ Jc(n, {
    ...dF(r, n.props),
    ref: t ? r0(t, n.ref) : n.ref
  }) : hr.count(n) > 1 ? hr.only(null) : null;
});
Yc.displayName = "SlotClone";
const cF = ({ children: e }) => /* @__PURE__ */ We(Hs, null, e);
function uF(e) {
  return /* @__PURE__ */ ws(e) && e.type === cF;
}
function dF(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...a) => {
      i(...a), o(...a);
    } : o && (n[r] = o) : r === "style" ? n[r] = {
      ...o,
      ...i
    } : r === "className" && (n[r] = [
      o,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const fF = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Qt = fF.reduce((e, t) => {
  const n = /* @__PURE__ */ Ze((r, o) => {
    const { asChild: i, ...s } = r, a = i ? nf : t;
    return de(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ We(a, Et({}, s, {
      ref: o
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function hF(e, t) {
  e && ru(
    () => e.dispatchEvent(t)
  );
}
function mF(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Pr(e);
  de(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r), () => t.removeEventListener("keydown", r);
  }, [
    n,
    t
  ]);
}
const Gc = "dismissableLayer.update", pF = "dismissableLayer.pointerDownOutside", gF = "dismissableLayer.focusOutside";
let tp;
const vF = /* @__PURE__ */ Ye({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), yF = /* @__PURE__ */ Ze((e, t) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: o, onPointerDownOutside: i, onFocusOutside: s, onInteractOutside: a, onDismiss: l, ...c } = e, u = Pe(vF), [d, f] = ue(null), m = (n = d == null ? void 0 : d.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, p] = ue({}), g = Li(
    t,
    (P) => f(P)
  ), y = Array.from(u.layers), [b] = [
    ...u.layersWithOutsidePointerEventsDisabled
  ].slice(-1), x = y.indexOf(b), w = d ? y.indexOf(d) : -1, S = u.layersWithOutsidePointerEventsDisabled.size > 0, E = w >= x, C = bF((P) => {
    const D = P.target, k = [
      ...u.branches
    ].some(
      (R) => R.contains(D)
    );
    !E || k || (i == null || i(P), a == null || a(P), P.defaultPrevented || l == null || l());
  }, m), T = wF((P) => {
    const D = P.target;
    [
      ...u.branches
    ].some(
      (R) => R.contains(D)
    ) || (s == null || s(P), a == null || a(P), P.defaultPrevented || l == null || l());
  }, m);
  return mF((P) => {
    w === u.layers.size - 1 && (o == null || o(P), !P.defaultPrevented && l && (P.preventDefault(), l()));
  }, m), de(() => {
    if (d)
      return r && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (tp = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), np(), () => {
        r && u.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = tp);
      };
  }, [
    d,
    m,
    r,
    u
  ]), de(() => () => {
    d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), np());
  }, [
    d,
    u
  ]), de(() => {
    const P = () => p({});
    return document.addEventListener(Gc, P), () => document.removeEventListener(Gc, P);
  }, []), /* @__PURE__ */ We(Qt.div, Et({}, c, {
    ref: g,
    style: {
      pointerEvents: S ? E ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: io(e.onFocusCapture, T.onFocusCapture),
    onBlurCapture: io(e.onBlurCapture, T.onBlurCapture),
    onPointerDownCapture: io(e.onPointerDownCapture, C.onPointerDownCapture)
  }));
});
function bF(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Pr(e), r = oe(!1), o = oe(() => {
  });
  return de(() => {
    const i = (a) => {
      if (a.target && !r.current) {
        let c = function() {
          o0(pF, n, l, {
            discrete: !0
          });
        };
        const l = {
          originalEvent: a
        };
        a.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = c, t.addEventListener("click", o.current, {
          once: !0
        })) : c();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function wF(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Pr(e), r = oe(!1);
  return de(() => {
    const o = (i) => {
      i.target && !r.current && o0(gF, n, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function np() {
  const e = new CustomEvent(Gc);
  document.dispatchEvent(e);
}
function o0(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && o.addEventListener(e, t, {
    once: !0
  }), r ? hF(o, i) : o.dispatchEvent(i);
}
const Cl = "focusScope.autoFocusOnMount", Tl = "focusScope.autoFocusOnUnmount", rp = {
  bubbles: !1,
  cancelable: !0
}, xF = /* @__PURE__ */ Ze((e, t) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: o, onUnmountAutoFocus: i, ...s } = e, [a, l] = ue(null), c = Pr(o), u = Pr(i), d = oe(null), f = Li(
    t,
    (g) => l(g)
  ), m = oe({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  de(() => {
    if (r) {
      let g = function(w) {
        if (m.paused || !a) return;
        const S = w.target;
        a.contains(S) ? d.current = S : Gn(d.current, {
          select: !0
        });
      }, y = function(w) {
        if (m.paused || !a) return;
        const S = w.relatedTarget;
        S !== null && (a.contains(S) || Gn(d.current, {
          select: !0
        }));
      }, b = function(w) {
        if (document.activeElement === document.body)
          for (const E of w) E.removedNodes.length > 0 && Gn(a);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", y);
      const x = new MutationObserver(b);
      return a && x.observe(a, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", y), x.disconnect();
      };
    }
  }, [
    r,
    a,
    m.paused
  ]), de(() => {
    if (a) {
      ip.add(m);
      const g = document.activeElement;
      if (!a.contains(g)) {
        const b = new CustomEvent(Cl, rp);
        a.addEventListener(Cl, c), a.dispatchEvent(b), b.defaultPrevented || (SF(kF(i0(a)), {
          select: !0
        }), document.activeElement === g && Gn(a));
      }
      return () => {
        a.removeEventListener(Cl, c), setTimeout(() => {
          const b = new CustomEvent(Tl, rp);
          a.addEventListener(Tl, u), a.dispatchEvent(b), b.defaultPrevented || Gn(g ?? document.body, {
            select: !0
          }), a.removeEventListener(Tl, u), ip.remove(m);
        }, 0);
      };
    }
  }, [
    a,
    c,
    u,
    m
  ]);
  const p = Fe((g) => {
    if (!n && !r || m.paused) return;
    const y = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, b = document.activeElement;
    if (y && b) {
      const x = g.currentTarget, [w, S] = CF(x);
      w && S ? !g.shiftKey && b === S ? (g.preventDefault(), n && Gn(w, {
        select: !0
      })) : g.shiftKey && b === w && (g.preventDefault(), n && Gn(S, {
        select: !0
      })) : b === x && g.preventDefault();
    }
  }, [
    n,
    r,
    m.paused
  ]);
  return /* @__PURE__ */ We(Qt.div, Et({
    tabIndex: -1
  }, s, {
    ref: f,
    onKeyDown: p
  }));
});
function SF(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Gn(r, {
      select: t
    }), document.activeElement !== n) return;
}
function CF(e) {
  const t = i0(e), n = op(t, e), r = op(t.reverse(), e);
  return [
    n,
    r
  ];
}
function i0(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function op(e, t) {
  for (const n of e)
    if (!TF(n, {
      upTo: t
    })) return n;
}
function TF(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function PF(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Gn(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && PF(e) && t && e.select();
  }
}
const ip = EF();
function EF() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = sp(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = sp(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function sp(e, t) {
  const n = [
    ...e
  ], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function kF(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const DF = /* @__PURE__ */ Ze((e, t) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...o } = e;
  return r ? /* @__PURE__ */ Dx.createPortal(/* @__PURE__ */ We(Qt.div, Et({}, o, {
    ref: t
  })), r) : null;
});
function RF(e, t) {
  return rx((n, r) => {
    const o = t[n][r];
    return o ?? n;
  }, e);
}
const Sa = (e) => {
  const { present: t, children: n } = e, r = MF(t), o = typeof n == "function" ? n({
    present: r.isPresent
  }) : hr.only(n), i = Li(r.ref, o.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ Jc(o, {
    ref: i
  }) : null;
};
Sa.displayName = "Presence";
function MF(e) {
  const [t, n] = ue(), r = oe({}), o = oe(e), i = oe("none"), s = e ? "mounted" : "unmounted", [a, l] = RF(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return de(() => {
    const c = os(r.current);
    i.current = a === "mounted" ? c : "none";
  }, [
    a
  ]), Uc(() => {
    const c = r.current, u = o.current;
    if (u !== e) {
      const f = i.current, m = os(c);
      e ? l("MOUNT") : m === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(u && f !== m ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [
    e,
    l
  ]), Uc(() => {
    if (t) {
      const c = (d) => {
        const m = os(r.current).includes(d.animationName);
        d.target === t && m && ru(
          () => l("ANIMATION_END")
        );
      }, u = (d) => {
        d.target === t && (i.current = os(r.current));
      };
      return t.addEventListener("animationstart", u), t.addEventListener("animationcancel", c), t.addEventListener("animationend", c), () => {
        t.removeEventListener("animationstart", u), t.removeEventListener("animationcancel", c), t.removeEventListener("animationend", c);
      };
    } else
      l("ANIMATION_END");
  }, [
    t,
    l
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(a),
    ref: Fe((c) => {
      c && (r.current = getComputedStyle(c)), n(c);
    }, [])
  };
}
function os(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
let Pl = 0;
function AF() {
  de(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : ap()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : ap()), Pl++, () => {
      Pl === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), Pl--;
    };
  }, []);
}
function ap() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var s0 = ag(), El = function() {
}, Ca = v.forwardRef(function(e, t) {
  var n = v.useRef(null), r = v.useState({
    onScrollCapture: El,
    onWheelCapture: El,
    onTouchMoveCapture: El
  }), o = r[0], i = r[1], s = e.forwardProps, a = e.children, l = e.className, c = e.removeScrollBar, u = e.enabled, d = e.shards, f = e.sideCar, m = e.noIsolation, p = e.inert, g = e.allowPinchZoom, y = e.as, b = y === void 0 ? "div" : y, x = fu(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), w = f, S = sg([n, t]), E = xt(xt({}, x), o);
  return v.createElement(
    v.Fragment,
    null,
    u && v.createElement(w, { sideCar: s0, removeScrollBar: c, shards: d, noIsolation: m, inert: p, setCallbacks: i, allowPinchZoom: !!g, lockRef: n }),
    s ? v.cloneElement(v.Children.only(a), xt(xt({}, E), { ref: S })) : v.createElement(b, xt({}, E, { className: l, ref: S }), a)
  );
});
Ca.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Ca.classNames = {
  fullWidth: Bo,
  zeroRight: Vo
};
var Kc = !1;
if (typeof window < "u")
  try {
    var is = Object.defineProperty({}, "passive", {
      get: function() {
        return Kc = !0, !0;
      }
    });
    window.addEventListener("test", is, is), window.removeEventListener("test", is, is);
  } catch {
    Kc = !1;
  }
var Ur = Kc ? { passive: !1 } : !1, OF = function(e) {
  return e.tagName === "TEXTAREA";
}, a0 = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !OF(e) && n[t] === "visible")
  );
}, NF = function(e) {
  return a0(e, "overflowY");
}, _F = function(e) {
  return a0(e, "overflowX");
}, lp = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = l0(e, n);
    if (r) {
      var o = c0(e, n), i = o[1], s = o[2];
      if (i > s)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, IF = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, LF = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, l0 = function(e, t) {
  return e === "v" ? NF(t) : _F(t);
}, c0 = function(e, t) {
  return e === "v" ? IF(t) : LF(t);
}, $F = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, FF = function(e, t, n, r, o) {
  var i = $F(e, window.getComputedStyle(t).direction), s = i * r, a = n.target, l = t.contains(a), c = !1, u = s > 0, d = 0, f = 0;
  do {
    var m = c0(e, a), p = m[0], g = m[1], y = m[2], b = g - y - i * p;
    (p || b) && l0(e, a) && (d += b, f += p), a = a.parentNode;
  } while (
    // portaled content
    !l && a !== document.body || // self content
    l && (t.contains(a) || t === a)
  );
  return (u && d === 0 || !u && f === 0) && (c = !0), c;
}, ss = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, cp = function(e) {
  return [e.deltaX, e.deltaY];
}, up = function(e) {
  return e && "current" in e ? e.current : e;
}, VF = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, BF = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, WF = 0, Yr = [];
function zF(e) {
  var t = v.useRef([]), n = v.useRef([0, 0]), r = v.useRef(), o = v.useState(WF++)[0], i = v.useState(function() {
    return hu();
  })[0], s = v.useRef(e);
  v.useEffect(function() {
    s.current = e;
  }, [e]), v.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var g = ig([e.lockRef.current], (e.shards || []).map(up), !0).filter(Boolean);
      return g.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), g.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var a = v.useCallback(function(g, y) {
    if ("touches" in g && g.touches.length === 2)
      return !s.current.allowPinchZoom;
    var b = ss(g), x = n.current, w = "deltaX" in g ? g.deltaX : x[0] - b[0], S = "deltaY" in g ? g.deltaY : x[1] - b[1], E, C = g.target, T = Math.abs(w) > Math.abs(S) ? "h" : "v";
    if ("touches" in g && T === "h" && C.type === "range")
      return !1;
    var P = lp(T, C);
    if (!P)
      return !0;
    if (P ? E = T : (E = T === "v" ? "h" : "v", P = lp(T, C)), !P)
      return !1;
    if (!r.current && "changedTouches" in g && (w || S) && (r.current = E), !E)
      return !0;
    var D = r.current || E;
    return FF(D, y, g, D === "h" ? w : S);
  }, []), l = v.useCallback(function(g) {
    var y = g;
    if (!(!Yr.length || Yr[Yr.length - 1] !== i)) {
      var b = "deltaY" in y ? cp(y) : ss(y), x = t.current.filter(function(E) {
        return E.name === y.type && E.target === y.target && VF(E.delta, b);
      })[0];
      if (x && x.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!x) {
        var w = (s.current.shards || []).map(up).filter(Boolean).filter(function(E) {
          return E.contains(y.target);
        }), S = w.length > 0 ? a(y, w[0]) : !s.current.noIsolation;
        S && y.cancelable && y.preventDefault();
      }
    }
  }, []), c = v.useCallback(function(g, y, b, x) {
    var w = { name: g, delta: y, target: b, should: x };
    t.current.push(w), setTimeout(function() {
      t.current = t.current.filter(function(S) {
        return S !== w;
      });
    }, 1);
  }, []), u = v.useCallback(function(g) {
    n.current = ss(g), r.current = void 0;
  }, []), d = v.useCallback(function(g) {
    c(g.type, cp(g), g.target, a(g, e.lockRef.current));
  }, []), f = v.useCallback(function(g) {
    c(g.type, ss(g), g.target, a(g, e.lockRef.current));
  }, []);
  v.useEffect(function() {
    return Yr.push(i), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", l, Ur), document.addEventListener("touchmove", l, Ur), document.addEventListener("touchstart", u, Ur), function() {
      Yr = Yr.filter(function(g) {
        return g !== i;
      }), document.removeEventListener("wheel", l, Ur), document.removeEventListener("touchmove", l, Ur), document.removeEventListener("touchstart", u, Ur);
    };
  }, []);
  var m = e.removeScrollBar, p = e.inert;
  return v.createElement(
    v.Fragment,
    null,
    p ? v.createElement(i, { styles: BF(o) }) : null,
    m ? v.createElement(dg, { gapMode: "margin" }) : null
  );
}
const jF = cg(s0, zF);
var u0 = v.forwardRef(function(e, t) {
  return v.createElement(Ca, xt({}, e, { ref: t, sideCar: jF }));
});
u0.classNames = Ca.classNames;
const d0 = "Dialog", [f0] = rF(d0), [HF, $r] = f0(d0), UF = (e) => {
  const { __scopeDialog: t, children: n, open: r, defaultOpen: o, onOpenChange: i, modal: s = !0 } = e, a = oe(null), l = oe(null), [c = !1, u] = aF({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ We(HF, {
    scope: t,
    triggerRef: a,
    contentRef: l,
    contentId: Sl(),
    titleId: Sl(),
    descriptionId: Sl(),
    open: c,
    onOpenChange: u,
    onOpenToggle: Fe(
      () => u(
        (d) => !d
      ),
      [
        u
      ]
    ),
    modal: s
  }, n);
}, h0 = "DialogPortal", [YF, m0] = f0(h0, {
  forceMount: void 0
}), GF = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, i = $r(h0, t);
  return /* @__PURE__ */ We(YF, {
    scope: t,
    forceMount: n
  }, hr.map(
    r,
    (s) => /* @__PURE__ */ We(Sa, {
      present: n || i.open
    }, /* @__PURE__ */ We(DF, {
      asChild: !0,
      container: o
    }, s))
  ));
}, Xc = "DialogOverlay", KF = /* @__PURE__ */ Ze((e, t) => {
  const n = m0(Xc, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = $r(Xc, e.__scopeDialog);
  return i.modal ? /* @__PURE__ */ We(Sa, {
    present: r || i.open
  }, /* @__PURE__ */ We(XF, Et({}, o, {
    ref: t
  }))) : null;
}), XF = /* @__PURE__ */ Ze((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = $r(Xc, n);
  return (
    // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ We(u0, {
      as: nf,
      allowPinchZoom: !0,
      shards: [
        o.contentRef
      ]
    }, /* @__PURE__ */ We(Qt.div, Et({
      "data-state": g0(o.open)
    }, r, {
      ref: t,
      style: {
        pointerEvents: "auto",
        ...r.style
      }
    })))
  );
}), mo = "DialogContent", qF = /* @__PURE__ */ Ze((e, t) => {
  const n = m0(mo, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = $r(mo, e.__scopeDialog);
  return /* @__PURE__ */ We(Sa, {
    present: r || i.open
  }, i.modal ? /* @__PURE__ */ We(QF, Et({}, o, {
    ref: t
  })) : /* @__PURE__ */ We(ZF, Et({}, o, {
    ref: t
  })));
}), QF = /* @__PURE__ */ Ze((e, t) => {
  const n = $r(mo, e.__scopeDialog), r = oe(null), o = Li(t, n.contentRef, r);
  return de(() => {
    const i = r.current;
    if (i) return Gs(i);
  }, []), /* @__PURE__ */ We(p0, Et({}, e, {
    ref: o,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: io(e.onCloseAutoFocus, (i) => {
      var s;
      i.preventDefault(), (s = n.triggerRef.current) === null || s === void 0 || s.focus();
    }),
    onPointerDownOutside: io(e.onPointerDownOutside, (i) => {
      const s = i.detail.originalEvent, a = s.button === 0 && s.ctrlKey === !0;
      (s.button === 2 || a) && i.preventDefault();
    }),
    onFocusOutside: io(
      e.onFocusOutside,
      (i) => i.preventDefault()
    )
  }));
}), ZF = /* @__PURE__ */ Ze((e, t) => {
  const n = $r(mo, e.__scopeDialog), r = oe(!1), o = oe(!1);
  return /* @__PURE__ */ We(p0, Et({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (i) => {
      var s;
      if ((s = e.onCloseAutoFocus) === null || s === void 0 || s.call(e, i), !i.defaultPrevented) {
        var a;
        r.current || (a = n.triggerRef.current) === null || a === void 0 || a.focus(), i.preventDefault();
      }
      r.current = !1, o.current = !1;
    },
    onInteractOutside: (i) => {
      var s, a;
      (s = e.onInteractOutside) === null || s === void 0 || s.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
      const l = i.target;
      ((a = n.triggerRef.current) === null || a === void 0 ? void 0 : a.contains(l)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
    }
  }));
}), p0 = /* @__PURE__ */ Ze((e, t) => {
  const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: i, ...s } = e, a = $r(mo, n), l = oe(null), c = Li(t, l);
  return AF(), /* @__PURE__ */ We(Hs, null, /* @__PURE__ */ We(xF, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i
  }, /* @__PURE__ */ We(yF, Et({
    role: "dialog",
    id: a.contentId,
    "aria-describedby": a.descriptionId,
    "aria-labelledby": a.titleId,
    "data-state": g0(a.open)
  }, s, {
    ref: c,
    onDismiss: () => a.onOpenChange(!1)
  }))), !1);
}), JF = "DialogTitle";
function g0(e) {
  return e ? "open" : "closed";
}
const e2 = "DialogTitleWarning";
nF(e2, {
  contentName: mo,
  titleName: JF,
  docsSlug: "dialog"
});
const t2 = UF, n2 = GF, r2 = KF, o2 = qF;
var Io = '[cmdk-group=""]', kl = '[cmdk-group-items=""]', i2 = '[cmdk-group-heading=""]', rf = '[cmdk-item=""]', dp = `${rf}:not([aria-disabled="true"])`, qc = "cmdk-item-select", ur = "data-value", s2 = (e, t, n) => eF(e, t, n), v0 = v.createContext(void 0), $i = () => v.useContext(v0), y0 = v.createContext(void 0), of = () => v.useContext(y0), b0 = v.createContext(void 0), w0 = v.forwardRef((e, t) => {
  let n = Xr(() => {
    var N, Y;
    return { search: "", value: (Y = (N = e.value) != null ? N : e.defaultValue) != null ? Y : "", filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), r = Xr(() => /* @__PURE__ */ new Set()), o = Xr(() => /* @__PURE__ */ new Map()), i = Xr(() => /* @__PURE__ */ new Map()), s = Xr(() => /* @__PURE__ */ new Set()), a = x0(e), { label: l, children: c, value: u, onValueChange: d, filter: f, shouldFilter: m, loop: p, disablePointerSelection: g = !1, vimBindings: y = !0, ...b } = e, x = v.useId(), w = v.useId(), S = v.useId(), E = v.useRef(null), C = v2();
  Er(() => {
    if (u !== void 0) {
      let N = u.trim();
      n.current.value = N, T.emit();
    }
  }, [u]), Er(() => {
    C(6, _);
  }, []);
  let T = v.useMemo(() => ({ subscribe: (N) => (s.current.add(N), () => s.current.delete(N)), snapshot: () => n.current, setState: (N, Y, H) => {
    var U, fe, ge;
    if (!Object.is(n.current[N], Y)) {
      if (n.current[N] = Y, N === "search") O(), k(), C(1, R);
      else if (N === "value" && (H || C(5, _), ((U = a.current) == null ? void 0 : U.value) !== void 0)) {
        let X = Y ?? "";
        (ge = (fe = a.current).onValueChange) == null || ge.call(fe, X);
        return;
      }
      T.emit();
    }
  }, emit: () => {
    s.current.forEach((N) => N());
  } }), []), P = v.useMemo(() => ({ value: (N, Y, H) => {
    var U;
    Y !== ((U = i.current.get(N)) == null ? void 0 : U.value) && (i.current.set(N, { value: Y, keywords: H }), n.current.filtered.items.set(N, D(Y, H)), C(2, () => {
      k(), T.emit();
    }));
  }, item: (N, Y) => (r.current.add(N), Y && (o.current.has(Y) ? o.current.get(Y).add(N) : o.current.set(Y, /* @__PURE__ */ new Set([N]))), C(3, () => {
    O(), k(), n.current.value || R(), T.emit();
  }), () => {
    i.current.delete(N), r.current.delete(N), n.current.filtered.items.delete(N);
    let H = $();
    C(4, () => {
      O(), (H == null ? void 0 : H.getAttribute("id")) === N && R(), T.emit();
    });
  }), group: (N) => (o.current.has(N) || o.current.set(N, /* @__PURE__ */ new Set()), () => {
    i.current.delete(N), o.current.delete(N);
  }), filter: () => a.current.shouldFilter, label: l || e["aria-label"], disablePointerSelection: g, listId: x, inputId: S, labelId: w, listInnerRef: E }), []);
  function D(N, Y) {
    var H, U;
    let fe = (U = (H = a.current) == null ? void 0 : H.filter) != null ? U : s2;
    return N ? fe(N, n.current.search, Y) : 0;
  }
  function k() {
    if (!n.current.search || a.current.shouldFilter === !1) return;
    let N = n.current.filtered.items, Y = [];
    n.current.filtered.groups.forEach((U) => {
      let fe = o.current.get(U), ge = 0;
      fe.forEach((X) => {
        let se = N.get(X);
        ge = Math.max(se, ge);
      }), Y.push([U, ge]);
    });
    let H = E.current;
    z().sort((U, fe) => {
      var ge, X;
      let se = U.getAttribute("id"), ee = fe.getAttribute("id");
      return ((ge = N.get(ee)) != null ? ge : 0) - ((X = N.get(se)) != null ? X : 0);
    }).forEach((U) => {
      let fe = U.closest(kl);
      fe ? fe.appendChild(U.parentElement === fe ? U : U.closest(`${kl} > *`)) : H.appendChild(U.parentElement === H ? U : U.closest(`${kl} > *`));
    }), Y.sort((U, fe) => fe[1] - U[1]).forEach((U) => {
      let fe = E.current.querySelector(`${Io}[${ur}="${encodeURIComponent(U[0])}"]`);
      fe == null || fe.parentElement.appendChild(fe);
    });
  }
  function R() {
    let N = z().find((H) => H.getAttribute("aria-disabled") !== "true"), Y = N == null ? void 0 : N.getAttribute(ur);
    T.setState("value", Y || void 0);
  }
  function O() {
    var N, Y, H, U;
    if (!n.current.search || a.current.shouldFilter === !1) {
      n.current.filtered.count = r.current.size;
      return;
    }
    n.current.filtered.groups = /* @__PURE__ */ new Set();
    let fe = 0;
    for (let ge of r.current) {
      let X = (Y = (N = i.current.get(ge)) == null ? void 0 : N.value) != null ? Y : "", se = (U = (H = i.current.get(ge)) == null ? void 0 : H.keywords) != null ? U : [], ee = D(X, se);
      n.current.filtered.items.set(ge, ee), ee > 0 && fe++;
    }
    for (let [ge, X] of o.current) for (let se of X) if (n.current.filtered.items.get(se) > 0) {
      n.current.filtered.groups.add(ge);
      break;
    }
    n.current.filtered.count = fe;
  }
  function _() {
    var N, Y, H;
    let U = $();
    U && (((N = U.parentElement) == null ? void 0 : N.firstChild) === U && ((H = (Y = U.closest(Io)) == null ? void 0 : Y.querySelector(i2)) == null || H.scrollIntoView({ block: "nearest" })), U.scrollIntoView({ block: "nearest" }));
  }
  function $() {
    var N;
    return (N = E.current) == null ? void 0 : N.querySelector(`${rf}[aria-selected="true"]`);
  }
  function z() {
    var N;
    return Array.from((N = E.current) == null ? void 0 : N.querySelectorAll(dp));
  }
  function I(N) {
    let Y = z()[N];
    Y && T.setState("value", Y.getAttribute(ur));
  }
  function A(N) {
    var Y;
    let H = $(), U = z(), fe = U.findIndex((X) => X === H), ge = U[fe + N];
    (Y = a.current) != null && Y.loop && (ge = fe + N < 0 ? U[U.length - 1] : fe + N === U.length ? U[0] : U[fe + N]), ge && T.setState("value", ge.getAttribute(ur));
  }
  function M(N) {
    let Y = $(), H = Y == null ? void 0 : Y.closest(Io), U;
    for (; H && !U; ) H = N > 0 ? p2(H, Io) : g2(H, Io), U = H == null ? void 0 : H.querySelector(dp);
    U ? T.setState("value", U.getAttribute(ur)) : A(N);
  }
  let F = () => I(z().length - 1), W = (N) => {
    N.preventDefault(), N.metaKey ? F() : N.altKey ? M(1) : A(1);
  }, ne = (N) => {
    N.preventDefault(), N.metaKey ? I(0) : N.altKey ? M(-1) : A(-1);
  };
  return v.createElement(Qt.div, { ref: t, tabIndex: -1, ...b, "cmdk-root": "", onKeyDown: (N) => {
    var Y;
    if ((Y = b.onKeyDown) == null || Y.call(b, N), !N.defaultPrevented) switch (N.key) {
      case "n":
      case "j": {
        y && N.ctrlKey && W(N);
        break;
      }
      case "ArrowDown": {
        W(N);
        break;
      }
      case "p":
      case "k": {
        y && N.ctrlKey && ne(N);
        break;
      }
      case "ArrowUp": {
        ne(N);
        break;
      }
      case "Home": {
        N.preventDefault(), I(0);
        break;
      }
      case "End": {
        N.preventDefault(), F();
        break;
      }
      case "Enter":
        if (!N.nativeEvent.isComposing && N.keyCode !== 229) {
          N.preventDefault();
          let H = $();
          if (H) {
            let U = new Event(qc);
            H.dispatchEvent(U);
          }
        }
    }
  } }, v.createElement("label", { "cmdk-label": "", htmlFor: P.inputId, id: P.labelId, style: b2 }, l), Ta(e, (N) => v.createElement(y0.Provider, { value: T }, v.createElement(v0.Provider, { value: P }, N))));
}), a2 = v.forwardRef((e, t) => {
  var n, r;
  let o = v.useId(), i = v.useRef(null), s = v.useContext(b0), a = $i(), l = x0(e), c = (r = (n = l.current) == null ? void 0 : n.forceMount) != null ? r : s == null ? void 0 : s.forceMount;
  Er(() => {
    if (!c) return a.item(o, s == null ? void 0 : s.id);
  }, [c]);
  let u = S0(o, i, [e.value, e.children, i], e.keywords), d = of(), f = kr((C) => C.value && C.value === u.current), m = kr((C) => c || a.filter() === !1 ? !0 : C.search ? C.filtered.items.get(o) > 0 : !0);
  v.useEffect(() => {
    let C = i.current;
    if (!(!C || e.disabled)) return C.addEventListener(qc, p), () => C.removeEventListener(qc, p);
  }, [m, e.onSelect, e.disabled]);
  function p() {
    var C, T;
    g(), (T = (C = l.current).onSelect) == null || T.call(C, u.current);
  }
  function g() {
    d.setState("value", u.current, !0);
  }
  if (!m) return null;
  let { disabled: y, value: b, onSelect: x, forceMount: w, keywords: S, ...E } = e;
  return v.createElement(Qt.div, { ref: hi([i, t]), ...E, id: o, "cmdk-item": "", role: "option", "aria-disabled": !!y, "aria-selected": !!f, "data-disabled": !!y, "data-selected": !!f, onPointerMove: y || a.disablePointerSelection ? void 0 : g, onClick: y ? void 0 : p }, e.children);
}), l2 = v.forwardRef((e, t) => {
  let { heading: n, children: r, forceMount: o, ...i } = e, s = v.useId(), a = v.useRef(null), l = v.useRef(null), c = v.useId(), u = $i(), d = kr((m) => o || u.filter() === !1 ? !0 : m.search ? m.filtered.groups.has(s) : !0);
  Er(() => u.group(s), []), S0(s, a, [e.value, e.heading, l]);
  let f = v.useMemo(() => ({ id: s, forceMount: o }), [o]);
  return v.createElement(Qt.div, { ref: hi([a, t]), ...i, "cmdk-group": "", role: "presentation", hidden: d ? void 0 : !0 }, n && v.createElement("div", { ref: l, "cmdk-group-heading": "", "aria-hidden": !0, id: c }, n), Ta(e, (m) => v.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": n ? c : void 0 }, v.createElement(b0.Provider, { value: f }, m))));
}), c2 = v.forwardRef((e, t) => {
  let { alwaysRender: n, ...r } = e, o = v.useRef(null), i = kr((s) => !s.search);
  return !n && !i ? null : v.createElement(Qt.div, { ref: hi([o, t]), ...r, "cmdk-separator": "", role: "separator" });
}), u2 = v.forwardRef((e, t) => {
  let { onValueChange: n, ...r } = e, o = e.value != null, i = of(), s = kr((u) => u.search), a = kr((u) => u.value), l = $i(), c = v.useMemo(() => {
    var u;
    let d = (u = l.listInnerRef.current) == null ? void 0 : u.querySelector(`${rf}[${ur}="${encodeURIComponent(a)}"]`);
    return d == null ? void 0 : d.getAttribute("id");
  }, []);
  return v.useEffect(() => {
    e.value != null && i.setState("search", e.value);
  }, [e.value]), v.createElement(Qt.input, { ref: t, ...r, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": l.listId, "aria-labelledby": l.labelId, "aria-activedescendant": c, id: l.inputId, type: "text", value: o ? e.value : s, onChange: (u) => {
    o || i.setState("search", u.target.value), n == null || n(u.target.value);
  } });
}), d2 = v.forwardRef((e, t) => {
  let { children: n, label: r = "Suggestions", ...o } = e, i = v.useRef(null), s = v.useRef(null), a = $i();
  return v.useEffect(() => {
    if (s.current && i.current) {
      let l = s.current, c = i.current, u, d = new ResizeObserver(() => {
        u = requestAnimationFrame(() => {
          let f = l.offsetHeight;
          c.style.setProperty("--cmdk-list-height", f.toFixed(1) + "px");
        });
      });
      return d.observe(l), () => {
        cancelAnimationFrame(u), d.unobserve(l);
      };
    }
  }, []), v.createElement(Qt.div, { ref: hi([i, t]), ...o, "cmdk-list": "", role: "listbox", "aria-label": r, id: a.listId }, Ta(e, (l) => v.createElement("div", { ref: hi([s, a.listInnerRef]), "cmdk-list-sizer": "" }, l)));
}), f2 = v.forwardRef((e, t) => {
  let { open: n, onOpenChange: r, overlayClassName: o, contentClassName: i, container: s, ...a } = e;
  return v.createElement(t2, { open: n, onOpenChange: r }, v.createElement(n2, { container: s }, v.createElement(r2, { "cmdk-overlay": "", className: o }), v.createElement(o2, { "aria-label": e.label, "cmdk-dialog": "", className: i }, v.createElement(w0, { ref: t, ...a }))));
}), h2 = v.forwardRef((e, t) => kr((n) => n.filtered.count === 0) ? v.createElement(Qt.div, { ref: t, ...e, "cmdk-empty": "", role: "presentation" }) : null), m2 = v.forwardRef((e, t) => {
  let { progress: n, children: r, label: o = "Loading...", ...i } = e;
  return v.createElement(Qt.div, { ref: t, ...i, "cmdk-loading": "", role: "progressbar", "aria-valuenow": n, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": o }, Ta(e, (s) => v.createElement("div", { "aria-hidden": !0 }, s)));
}), kt = Object.assign(w0, { List: d2, Item: a2, Input: u2, Group: l2, Separator: c2, Dialog: f2, Empty: h2, Loading: m2 });
function p2(e, t) {
  let n = e.nextElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.nextElementSibling;
  }
}
function g2(e, t) {
  let n = e.previousElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.previousElementSibling;
  }
}
function x0(e) {
  let t = v.useRef(e);
  return Er(() => {
    t.current = e;
  }), t;
}
var Er = typeof window > "u" ? v.useEffect : v.useLayoutEffect;
function Xr(e) {
  let t = v.useRef();
  return t.current === void 0 && (t.current = e()), t;
}
function hi(e) {
  return (t) => {
    e.forEach((n) => {
      typeof n == "function" ? n(t) : n != null && (n.current = t);
    });
  };
}
function kr(e) {
  let t = of(), n = () => e(t.snapshot());
  return v.useSyncExternalStore(t.subscribe, n, n);
}
function S0(e, t, n, r = []) {
  let o = v.useRef(), i = $i();
  return Er(() => {
    var s;
    let a = (() => {
      var c;
      for (let u of n) {
        if (typeof u == "string") return u.trim();
        if (typeof u == "object" && "current" in u) return u.current ? (c = u.current.textContent) == null ? void 0 : c.trim() : o.current;
      }
    })(), l = r.map((c) => c.trim());
    i.value(e, a, l), (s = t.current) == null || s.setAttribute(ur, a), o.current = a;
  }), o;
}
var v2 = () => {
  let [e, t] = v.useState(), n = Xr(() => /* @__PURE__ */ new Map());
  return Er(() => {
    n.current.forEach((r) => r()), n.current = /* @__PURE__ */ new Map();
  }, [e]), (r, o) => {
    n.current.set(r, o), t({});
  };
};
function y2(e) {
  let t = e.type;
  return typeof t == "function" ? t(e.props) : "render" in t ? t.render(e.props) : e;
}
function Ta({ asChild: e, children: t }, n) {
  return e && v.isValidElement(t) ? v.cloneElement(y2(t), { ref: t.ref }, n(t.props.children)) : n(t);
}
var b2 = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
const sf = v.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  kt,
  {
    ref: n,
    className: Q(
      "flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground",
      e
    ),
    ...t
  }
));
sf.displayName = kt.displayName;
const kB = ({ children: e, ...t }) => /* @__PURE__ */ h(Tg, { ...t, children: /* @__PURE__ */ h(wu, { className: "overflow-hidden p-0 shadow-lg", children: /* @__PURE__ */ h(sf, { className: "[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5", children: e }) }) }), w2 = v.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ L("div", { className: "flex items-center border-b px-3", "cmdk-input-wrapper": "", children: [
  /* @__PURE__ */ h(kx, { className: "mr-2 h-4 w-4 shrink-0 opacity-50" }),
  /* @__PURE__ */ h(
    kt.Input,
    {
      ref: n,
      className: Q(
        "flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ...t
    }
  )
] }));
w2.displayName = kt.Input.displayName;
const C0 = v.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  kt.List,
  {
    ref: n,
    className: Q("max-h-[300px] overflow-y-auto overflow-x-hidden", e),
    ...t
  }
));
C0.displayName = kt.List.displayName;
const T0 = v.forwardRef((e, t) => /* @__PURE__ */ h(kt.Empty, { ref: t, className: "py-6 text-center text-sm", ...e }));
T0.displayName = kt.Empty.displayName;
const x2 = v.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  kt.Group,
  {
    ref: n,
    className: Q(
      "overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground",
      e
    ),
    ...t
  }
));
x2.displayName = kt.Group.displayName;
const S2 = v.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(kt.Separator, { ref: n, className: Q("-mx-1 h-px bg-border", e), ...t }));
S2.displayName = kt.Separator.displayName;
const P0 = v.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  kt.Item,
  {
    ref: n,
    className: Q(
      "relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none data-[disabled=true]:pointer-events-none data-[selected='true']:bg-accent data-[selected=true]:text-accent-foreground data-[disabled=true]:opacity-50",
      e
    ),
    ...t
  }
));
P0.displayName = kt.Item.displayName;
const C2 = ({ className: e, ...t }) => /* @__PURE__ */ h("span", { className: Q("ml-auto text-xs tracking-widest text-muted-foreground", e), ...t });
C2.displayName = "CommandShortcut";
const E0 = Ye(null), Pa = () => {
  const e = Pe(E0);
  if (!e)
    throw new Error("useMultiSelect must be used within MultiSelectProvider");
  return e;
}, T2 = ({
  values: e,
  options: t,
  onValuesChange: n,
  loop: r = !1,
  className: o,
  children: i,
  dir: s,
  disabled: a,
  ...l
}) => {
  const [c, u] = ue(""), [d, f] = ue(!1), [m, p] = ue(-1), g = Z.useRef(null), [y, b] = Z.useState(!1), [x, w] = Z.useState(""), S = Fe(
    (T) => {
      e.some((P) => P === T) ? n(e.filter((P) => P !== T)) : n([...e, T]);
    },
    [e]
  ), E = Z.useCallback(
    (T) => {
      T.preventDefault();
      const P = T.currentTarget, D = P.value.substring(P.selectionStart ?? 0, P.selectionEnd ?? 0);
      w(D), b(D === c);
    },
    [c]
  ), C = Fe(
    (T) => {
      T.stopPropagation();
      const P = g.current;
      if (!P) return;
      const D = () => {
        const O = m + 1;
        p(O > e.length - 1 ? r ? 0 : -1 : O);
      }, k = () => {
        const O = m - 1;
        p(O < 0 ? e.length - 1 : O);
      }, R = () => {
        const O = m - 1 <= 0 ? e.length - 1 === 0 ? -1 : 0 : m - 1;
        p(O);
      };
      switch (T.key) {
        case "ArrowLeft":
          s === "rtl" ? e.length > 0 && (m !== -1 || r) && D() : e.length > 0 && P.selectionStart === 0 && k();
          break;
        case "ArrowRight":
          s === "rtl" ? e.length > 0 && P.selectionStart === 0 && k() : e.length > 0 && (m !== -1 || r) && D();
          break;
        case "Backspace":
        case "Delete":
          e.length > 0 && (m !== -1 && m < e.length ? (S(e[m]), R()) : P.selectionStart === 0 && (x === c || y) && S(e[e.length - 1]));
          break;
        case "Enter":
          f(!0);
          break;
        case "Escape":
          m !== -1 ? p(-1) : d && f(!1);
          break;
      }
    },
    [e, c, m, r]
  );
  return /* @__PURE__ */ h(
    E0.Provider,
    {
      value: {
        value: e,
        options: t,
        onValueChange: S,
        open: d,
        setOpen: f,
        inputValue: c,
        setInputValue: u,
        activeIndex: m,
        setActiveIndex: p,
        ref: g,
        handleSelect: E,
        disabled: a
      },
      children: /* @__PURE__ */ h(sf, { onKeyDown: C, className: Q("flex flex-row bg-transparent", o), dir: s, ...l, children: i })
    }
  );
}, k0 = Ze(
  ({ className: e, children: t, ...n }, r) => {
    const { value: o, options: i, onValueChange: s, activeIndex: a, disabled: l } = Pa(), [c, u] = ue(!1), [d, f] = ue(!1), m = oe(null), p = Fe((b) => {
      b.preventDefault(), b.stopPropagation();
    }, []), g = (b) => {
      const x = b.currentTarget, w = x.scrollLeft, S = x.scrollWidth, E = x.clientWidth;
      w > 10 ? u(!0) : u(!1), w + E < S - 20 ? f(!0) : f(!1);
    }, y = () => {
      var b;
      (b = m.current) == null || b.scrollIntoView({ behavior: "smooth" });
    };
    return de(() => {
      y();
    }, [o]), /* @__PURE__ */ L(
      "div",
      {
        ref: r,
        onScroll: g,
        className: Q(
          "flex overflow-x-auto overflow-y-hidden rounded-lg max-w-[80%] relative pretty-scrollbar-thin",
          e,
          "before:opacity-0 before:block before:shrink-0 before:sticky before:w-4 before:-ml-4 before:h-full before:bg-gradient-to-r before:from-white before:-left-px before:transition-opacity before:duration-150",
          "after:opacity-0 after:block after:shrink-0 after:sticky after:w-4 after:-mr-4 after:h-full after:bg-gradient-to-l after:from-white after:-right-px after:transition-opacity after:duration-150",
          c && "before:opacity-100",
          d && "after:opacity-100"
        ),
        ...n,
        children: [
          o.map((b, x) => {
            const w = i.find((S) => S.value === b);
            return /* @__PURE__ */ L(
              t0,
              {
                className: Q(
                  "m-1 my-2 py-0 rounded-xl flex items-center gap-1",
                  a === x && "ring-2 ring-muted-foreground "
                ),
                variant: l ? "disabled" : "default",
                children: [
                  /* @__PURE__ */ h("span", { className: "text-xxs text-nowrap", children: w == null ? void 0 : w.label }),
                  /* @__PURE__ */ L(
                    "button",
                    {
                      "aria-label": `Remove ${w == null ? void 0 : w.label} option`,
                      "aria-roledescription": "button to remove option",
                      type: "button",
                      onMouseDown: p,
                      onClick: () => w && s(w.value),
                      disabled: l,
                      className: Q(l && "cursor-not-allowed"),
                      children: [
                        /* @__PURE__ */ L("span", { className: "sr-only", children: [
                          "Remove ",
                          w == null ? void 0 : w.label,
                          " option"
                        ] }),
                        /* @__PURE__ */ h(eu, { className: "h-4 w-4" })
                      ]
                    }
                  )
                ]
              },
              w == null ? void 0 : w.value
            );
          }),
          /* @__PURE__ */ h("div", { ref: m }),
          t
        ]
      }
    );
  }
);
k0.displayName = "MultiSelectorTrigger";
const D0 = Ze(({ className: e, ...t }, n) => {
  const {
    value: r,
    setOpen: o,
    inputValue: i,
    setInputValue: s,
    activeIndex: a,
    setActiveIndex: l,
    handleSelect: c,
    ref: u,
    disabled: d
  } = Pa(), f = () => r.length === 0 ? t.placeholder : `${r.length.toString()} selected`;
  return /* @__PURE__ */ h(
    kt.Input,
    {
      ...t,
      placeholder: f(),
      tabIndex: 0,
      ref: u,
      value: i,
      onValueChange: a === -1 ? s : void 0,
      onSelect: c,
      onBlur: () => o(!1),
      onFocus: () => o(!0),
      onClick: () => l(-1),
      className: Q(
        "w-24 shrink-0 text-input-text-secondary aria-[checked]:text-input-text aria-[disabled]:opacity-50 outline-none aria-disabled:text-neutral-text-secondary/50",
        e,
        a !== -1 && "caret-transparent"
      ),
      "aria-disabled": d,
      disabled: d
    }
  );
});
D0.displayName = "MultiSelectorInput";
const R0 = Ze(({ children: e }, t) => {
  const { open: n } = Pa();
  return /* @__PURE__ */ h("div", { ref: t, className: " absolute left-0 right-0 top-[calc(100%+.25rem)] z-40", children: n && e });
});
R0.displayName = "MultiSelectorContent";
const M0 = Ze(({ className: e, children: t }, n) => /* @__PURE__ */ L(
  C0,
  {
    ref: n,
    className: Q(
      "bg-input-bg flex flex-col rounded-md scrollbar-thin scrollbar-track-transparent transition-colors scrollbar-thumb-muted-foreground dark:scrollbar-thumb-muted scrollbar-thumb-rounded-lg w-full absolute shadow-md z-10 border top-0",
      e
    ),
    children: [
      t,
      /* @__PURE__ */ h(T0, { children: /* @__PURE__ */ h("span", { className: "text-muted-foreground", children: "No results found" }) })
    ]
  }
));
M0.displayName = "MultiSelectorList";
const A0 = Ze(({ className: e, value: t, children: n, ...r }, o) => {
  const { value: i, onValueChange: s, setInputValue: a } = Pa(), l = Fe((u) => {
    u.preventDefault(), u.stopPropagation();
  }, []), c = i.includes(t);
  return /* @__PURE__ */ L(
    P0,
    {
      ref: o,
      ...r,
      onSelect: () => {
        s(t), a("");
      },
      className: Q(
        "flex control cursor-default border select-none items-center text-sm outline-none rounded-none justify-between data-[selected=true]:bg-input-hover",
        e,
        c && "bg-input-active text-input-bg data-[selected=true]::bg-input-hover",
        r.disabled && "pointer-events-none opacity-50"
      ),
      onMouseDown: l,
      children: [
        n,
        c && /* @__PURE__ */ h(tu, { className: "h-4 w-4" })
      ]
    }
  );
});
A0.displayName = "MultiSelectorItem";
const P2 = Rr("", {
  variants: {
    size: {
      sm: "input-sm",
      default: "input",
      md: "input-md"
    }
  },
  defaultVariants: {
    size: "default"
  }
});
function E2({
  value: e,
  options: t,
  onChange: n,
  size: r,
  placeholder: o,
  disabled: i,
  className: s
}) {
  return /* @__PURE__ */ L(
    T2,
    {
      values: e,
      options: t,
      onValuesChange: n,
      loop: !0,
      disablePointerSelection: !0,
      disabled: i,
      className: Q(s),
      children: [
        /* @__PURE__ */ h(k0, {}),
        /* @__PURE__ */ h(D0, { className: Q("bg-transparent", P2({ size: r })), placeholder: o }),
        /* @__PURE__ */ h(R0, { children: /* @__PURE__ */ h(M0, { children: t.map((a) => /* @__PURE__ */ h(A0, { value: a.value, children: a.label }, a.value)) }) })
      ]
    }
  );
}
const DB = (e) => /* @__PURE__ */ h(Gt, { label: e.label, error: e.error, disabled: e.disabled, hideOverflow: !1, children: /* @__PURE__ */ h(E2, { placeholder: e.placeholder, ...e, className: Q(e.className) }) }), k2 = ({ label: e, className: t, text: n }) => /* @__PURE__ */ h(
  Gt,
  {
    label: e,
    className: He("select-none cursor-pointer !flex w-full max-h-10 first:*:w-full first:*:flex"),
    children: /* @__PURE__ */ h("div", { className: He("p-2 whitespace-nowrap text-ellipsis overflow-hidden w-0 grow"), children: n })
  }
), RB = ({
  maxToShowInLabel: e,
  onSelect: t,
  options: n,
  allSelectedLabel: r,
  lookup: o,
  noneSelectedLabel: i,
  value: s,
  className: a,
  label: l,
  onClose: c
}) => {
  const u = (p) => {
    t(p);
  }, d = (s == null ? void 0 : s.length) || 0;
  let f;
  switch (!0) {
    case d === 0:
      f = i || "Please select";
      break;
    case d <= e:
      f = s.map((p) => (o == null ? void 0 : o[p]) || p).join(", ");
      break;
    case d === n.length:
      f = r || "All Selected";
      break;
    default:
      f = `${d} selected`;
      break;
  }
  const m = async (p) => n.filter((g) => g.label.toLocaleLowerCase().includes(p.toLocaleLowerCase())).map((g) => g.key);
  return /* @__PURE__ */ h("div", { className: a, children: /* @__PURE__ */ h(
    Uv,
    {
      onClose: c,
      activeFilters: (s == null ? void 0 : s.map((p) => ({ key: p, label: (o == null ? void 0 : o[p]) || p }))) || [],
      onApply: (p) => u(p.map((g) => g.key)),
      onLoadFilters: m,
      lookup: (p) => (o == null ? void 0 : o[p]) || p,
      trigger: /* @__PURE__ */ h(k2, { text: f, label: l })
    }
  ) });
};
function af(e) {
  const t = e.formState || {};
  return /* @__PURE__ */ L("div", { className: "form-control w-full", children: [
    /* @__PURE__ */ h("div", { className: "label mb-[8px]", children: /* @__PURE__ */ h("span", { className: "label-text", children: e.label }) }),
    e.children,
    /* @__PURE__ */ h("div", { className: "label mt-[5px]", children: /* @__PURE__ */ h("span", { className: "label-text-alt text-error h-2", children: t.fieldErrors[e.name] }) })
  ] });
}
function MB(e) {
  const t = e.formState || {};
  return /* @__PURE__ */ h(af, { formState: t, label: e.label, name: e.name, children: /* @__PURE__ */ h(
    Ti,
    {
      type: "text",
      name: e.name,
      defaultValue: e.initialValue,
      placeholder: e.placeholder,
      className: He("input", "input-bordered", "w-full", {
        "border-error": t.fieldErrors[e.name]
      })
    }
  ) });
}
function AB(e) {
  const t = e.formState || {};
  return /* @__PURE__ */ h(af, { formState: t, label: e.label, name: e.name, children: /* @__PURE__ */ h(
    Ti,
    {
      type: "date",
      name: e.name,
      defaultValue: e.initialValue,
      className: He("input", "input-bordered", "w-full", {
        "border-error": t.fieldErrors[e.name]
      })
    }
  ) });
}
function OB(e) {
  const t = e.formState || {};
  return /* @__PURE__ */ h(af, { formState: t, label: e.label, name: e.name, children: /* @__PURE__ */ L(sa, { name: e.name, defaultValue: e.initialValue ?? "", children: [
    /* @__PURE__ */ h(Fu, { className: "w-[180px]", children: /* @__PURE__ */ h(mv, { placeholder: "-- Select an option --" }) }),
    /* @__PURE__ */ h(Vu, { children: e.options.map((n, r) => /* @__PURE__ */ h(Wu, { value: n[0], children: n[1] }, r)) })
  ] }) });
}
const O0 = ({
  fullContractData: e,
  scenarioContractData: t
}) => {
  let n = "indeterminate";
  return e.forEach(({ id: r, children: o }) => {
    const i = t.find(({ id: s }) => s === r);
    o && (i != null && i.children) ? n = O0({ fullContractData: o, scenarioContractData: i.children }) : n = e.length === t.length || "indeterminate";
  }), n;
}, D2 = (e, t) => {
  const n = [];
  return e.forEach(({ id: r, label: o, children: i }) => {
    const s = { id: r, label: o, childrenNodes: [], checked: !1 }, a = t.find((l) => l.id === r);
    a && (s.checked = a.children && i ? O0({ fullContractData: i, scenarioContractData: a.children }) : !0), i && (s.childrenNodes = D2(i, a != null && a.children ? a.children : [])), n.push(s);
  }), n;
}, N0 = (e) => {
  var n;
  if (!((n = e.childrenNodes) != null && n.length))
    return e.checked ? { id: e.id } : void 0;
  const t = e.childrenNodes.map(N0).filter(Boolean);
  return t.length ? { id: e.id, children: t } : void 0;
}, NB = (e) => e.map(N0).filter(Boolean), _0 = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], I0 = (e, t) => `${e}-${t < 10 ? `0${t}` : t}`, R2 = (e) => {
  try {
    const [t, n] = e.split("-");
    return `${_0[Number(n) - 1]} ${t == null ? void 0 : t.substring(2, 4)}`;
  } catch {
    return "-";
  }
};
function fp({
  mode: e,
  monthOrYear: t,
  index: n,
  selectedYearValue: r,
  onChange: o,
  currentYear: i,
  currentMonth: s,
  isDisabled: a
}) {
  const l = n + 1;
  return /* @__PURE__ */ h(
    ke,
    {
      variant: (e === "year" || s === l) && i === r ? "default" : "minimal",
      size: "sm",
      value: e === "year" ? t : l,
      onClick: () => o(e === "year" ? t : I0(r, l)),
      disabled: a,
      children: t
    },
    e === "year" ? t : l
  );
}
const hp = ({ mode: e, value: t, index: n, selectedYearOrDecadeValue: r, minDate: o, maxDate: i }) => {
  if (e === "month") {
    const s = I0(r, n + 1);
    return !!i && s > i || !!o && s < o;
  } else
    return !!(o && t < o || i && t > i);
};
function lf({ mode: e, value: t = "", maxDate: n = "", minDate: r = "", onChange: o }) {
  const [i, s] = pe(() => {
    const m = t && e === "month" ? Number(t.split("-")[1]) : void 0;
    return t ? e === "year" ? [parseInt(t), m] : [Number(t.split("-")[0]), m] : [(/* @__PURE__ */ new Date()).getFullYear(), m];
  }, [t, e]), a = pe(() => parseInt(i.toString().slice(0, -1)), [i]), [l, c] = pe(() => {
    if (e === "year") {
      const g = "2024", y = (i + 10).toString();
      return [r || g, n || y];
    }
    const m = "2024-01", p = `${i + 10}-12`;
    return [r || m, n || p];
  }, [e, i, r, n]), [u, d] = ue(
    e === "year" ? a : i
  ), f = pe(
    () => [...Array(10).keys()].map((m) => `${u}${m}`),
    [u]
  );
  return /* @__PURE__ */ L("div", { className: "flex flex-col gap-2 p-4 w-80", children: [
    /* @__PURE__ */ L("div", { className: "flex justify-between items-center", children: [
      /* @__PURE__ */ h(
        ke,
        {
          variant: "minimal",
          size: "sm",
          onClick: () => d((m) => m - 1),
          disabled: !!l && `${u}` <= l,
          children: /* @__PURE__ */ h(Xo, { size: "18" })
        }
      ),
      /* @__PURE__ */ L("span", { className: "text-xs font-medium text-button-primary-outline-default", children: [
        u,
        e === "year" && "0s"
      ] }),
      /* @__PURE__ */ h(
        ke,
        {
          variant: "minimal",
          size: "sm",
          onClick: () => d((m) => m + 1),
          disabled: !!c && `${u + 1}` > c,
          children: /* @__PURE__ */ h(so, { size: "18" })
        }
      )
    ] }),
    /* @__PURE__ */ h("div", { className: `grid ${e === "year" ? "grid-cols-2" : "grid-cols-3"} gap-x-2`, children: e === "year" ? f.map((m, p) => /* @__PURE__ */ h(
      fp,
      {
        mode: e,
        monthOrYear: m,
        index: p,
        selectedYearValue: i,
        onChange: o,
        currentYear: parseInt(m),
        currentMonth: s,
        isDisabled: hp({ mode: e, value: m, index: p, selectedYearOrDecadeValue: u, minDate: l, maxDate: c })
      },
      p
    )) : _0.map((m, p) => /* @__PURE__ */ h(
      fp,
      {
        mode: e,
        monthOrYear: m,
        index: p,
        selectedYearValue: u,
        onChange: o,
        currentYear: i,
        currentMonth: s,
        isDisabled: hp({ mode: e, value: m, index: p, selectedYearOrDecadeValue: u, minDate: l, maxDate: c })
      },
      p
    )) })
  ] });
}
function mp(e) {
  return /* @__PURE__ */ L(
    ke,
    {
      disabled: !!e.disabled,
      size: "md",
      variant: "ghost",
      className: "group control justify-between text-left w-full border-0",
      children: [
        /* @__PURE__ */ h(
          "span",
          {
            "aria-disabled": !!e.disabled || void 0,
            "aria-checked": !!e.value || void 0,
            className: "text-input-text-secondary aria-[checked]:text-input-text aria-[disabled]:opacity-50",
            children: e.value ? R2(e.value) : e.placeholder || "Pick a date"
          }
        ),
        /* @__PURE__ */ h(nu, { className: "ml-2 h-4 w-4 text-input-active" })
      ]
    }
  );
}
function M2(e) {
  const [t, n] = v.useState(!1), r = (o) => {
    e.onChange(o), n(!1);
  };
  return e.disabled ? /* @__PURE__ */ h(
    Gt,
    {
      label: e.label,
      error: e.error,
      disabled: !!e.disabled || void 0,
      className: e.className,
      children: /* @__PURE__ */ h(mp, { ...e })
    }
  ) : /* @__PURE__ */ L(Sr, { open: t, onOpenChange: (o) => n(o), children: [
    /* @__PURE__ */ h(wo, { asChild: !0, children: /* @__PURE__ */ h("div", { className: e.className, children: /* @__PURE__ */ h(
      Gt,
      {
        label: e.label,
        error: e.error,
        disabled: !!e.disabled || void 0,
        className: e.className,
        children: /* @__PURE__ */ h(Ci, { children: /* @__PURE__ */ h(mp, { ...e }) })
      }
    ) }) }),
    /* @__PURE__ */ h(_r, { renderOnBody: !1, className: "w-auto p-0", children: /* @__PURE__ */ h(
      lf,
      {
        mode: "month",
        onChange: r,
        value: e.value,
        maxDate: e.maxDate,
        minDate: e.minDate
      }
    ) })
  ] });
}
function _B({
  loading: e,
  onChange: t,
  value: n,
  minDate: r,
  maxDate: o
}) {
  const i = (s) => {
    if (n) {
      const a = Dn(Kt(GI(n, "yyyy-MM", /* @__PURE__ */ new Date()), s), "yyyy-MM");
      t(a);
    }
  };
  return /* @__PURE__ */ L("div", { className: "flex gap-2 relative items-center", children: [
    /* @__PURE__ */ h(ke, { variant: "minimal", size: "sm", onClick: () => i(-1), disabled: !!r && n <= r, children: /* @__PURE__ */ h(Xo, { size: "18" }) }),
    /* @__PURE__ */ h(
      M2,
      {
        label: "Date",
        value: n,
        onChange: t,
        disabled: e,
        minDate: r,
        maxDate: o
      }
    ),
    /* @__PURE__ */ h(ke, { variant: "minimal", size: "sm", onClick: () => i(1), disabled: !!o && n >= o, children: /* @__PURE__ */ h(so, { size: "18" }) }),
    e && /* @__PURE__ */ h(gr, { cover: !0 })
  ] });
}
function pp(e) {
  return /* @__PURE__ */ L(
    ke,
    {
      disabled: !!e.disabled,
      size: "md",
      variant: "ghost",
      className: "group control justify-between text-left w-full border-0",
      children: [
        /* @__PURE__ */ h(
          "span",
          {
            "aria-disabled": !!e.disabled || void 0,
            "aria-checked": !!e.value || void 0,
            className: "text-input-text-secondary aria-[checked]:text-input-text aria-[disabled]:opacity-50",
            children: e.value ? e.value : e.placeholder || "Pick a date"
          }
        ),
        /* @__PURE__ */ h(nu, { className: "ml-2 h-4 w-4 text-input-active" })
      ]
    }
  );
}
function A2(e) {
  const [t, n] = v.useState(!1), r = (o) => {
    e.onChange(o), n(!1);
  };
  return e.disabled ? /* @__PURE__ */ h(
    Gt,
    {
      label: e.label,
      error: e.error,
      disabled: !!e.disabled || void 0,
      className: e.className,
      children: /* @__PURE__ */ h(pp, { ...e })
    }
  ) : /* @__PURE__ */ L(Sr, { open: t, onOpenChange: (o) => n(o), children: [
    /* @__PURE__ */ h(wo, { asChild: !0, children: /* @__PURE__ */ h("div", { className: e.className, children: /* @__PURE__ */ h(
      Gt,
      {
        label: e.label,
        error: e.error,
        disabled: !!e.disabled || void 0,
        className: e.className,
        children: /* @__PURE__ */ h(Ci, { children: /* @__PURE__ */ h(pp, { ...e }) })
      }
    ) }) }),
    /* @__PURE__ */ h(_r, { renderOnBody: !1, className: "w-auto p-0", children: /* @__PURE__ */ h(
      lf,
      {
        mode: "year",
        onChange: r,
        value: e.value,
        maxDate: e.maxDate,
        minDate: e.minDate
      }
    ) })
  ] });
}
function IB({
  loading: e,
  onChange: t,
  value: n,
  minDate: r,
  maxDate: o
}) {
  return /* @__PURE__ */ L("div", { className: "flex gap-2 relative items-center", children: [
    /* @__PURE__ */ h(
      ke,
      {
        variant: "minimal",
        size: "sm",
        onClick: () => n && t(`${parseInt(n) - 1}`),
        disabled: !!r && n <= r,
        children: /* @__PURE__ */ h(Xo, { size: "18" })
      }
    ),
    /* @__PURE__ */ h(
      A2,
      {
        label: "Date",
        value: n,
        onChange: t,
        disabled: e,
        minDate: r,
        maxDate: o
      }
    ),
    /* @__PURE__ */ h(
      ke,
      {
        variant: "minimal",
        size: "sm",
        onClick: () => n && t(`${parseInt(n) + 1}`),
        disabled: !!o && n >= o,
        children: /* @__PURE__ */ h(so, { size: "18" })
      }
    ),
    e && /* @__PURE__ */ h(gr, { cover: !0 })
  ] });
}
const gp = ({ disabled: e, value: t, placeholder: n, isOpen: r }) => /* @__PURE__ */ h(
  ke,
  {
    disabled: !!e,
    size: "sm",
    variant: r ? "default" : "outline",
    className: "group justify-center text-left w-full min-w-20",
    children: t || n || "Pick a year"
  }
);
function LB(e) {
  const { disabled: t, onChange: n, maxDate: r, minDate: o, value: i } = e, [s, a] = v.useState(!1), c = i || (/* @__PURE__ */ new Date()).getFullYear().toString();
  return t ? /* @__PURE__ */ L("div", { className: "flex items-center justify-center gap-1", children: [
    /* @__PURE__ */ h(
      ke,
      {
        variant: "minimal",
        size: "sm",
        onClick: () => n(`${parseInt(c) - 1}`),
        disabled: !!o && `${i}` <= o,
        children: /* @__PURE__ */ h(Xo, { size: "18" })
      }
    ),
    /* @__PURE__ */ h(gp, { ...e, isOpen: s }),
    /* @__PURE__ */ h(
      ke,
      {
        variant: "minimal",
        size: "sm",
        onClick: () => n(`${parseInt(c) + 1}`),
        disabled: !!r && `${parseInt(c) + 1}` > r,
        children: /* @__PURE__ */ h(so, { size: "18" })
      }
    )
  ] }) : /* @__PURE__ */ L(Sr, { open: s, onOpenChange: a, children: [
    /* @__PURE__ */ L("div", { className: "flex items-center justify-center gap-2 relative", children: [
      /* @__PURE__ */ h(
        ke,
        {
          variant: "minimal",
          size: "sm",
          onClick: () => n(`${parseInt(c) - 1}`),
          disabled: !!o && `${i}` <= o,
          children: /* @__PURE__ */ h(Xo, { size: "18" })
        }
      ),
      /* @__PURE__ */ h(wo, { asChild: !0, children: /* @__PURE__ */ h(Ci, { children: /* @__PURE__ */ h(gp, { ...e, isOpen: s }) }) }),
      /* @__PURE__ */ h(
        ke,
        {
          variant: "minimal",
          size: "sm",
          onClick: () => n(`${parseInt(c) + 1}`),
          disabled: !!r && `${parseInt(c) + 1}` > r,
          children: /* @__PURE__ */ h(so, { size: "18" })
        }
      ),
      e.loading && /* @__PURE__ */ h(gr, { cover: !0, iconSize: 30 })
    ] }),
    /* @__PURE__ */ h(_r, { className: "w-auto p-0", children: /* @__PURE__ */ h(lf, { mode: "year", ...e }) })
  ] });
}
const O2 = v.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  Ju,
  {
    ref: n,
    className: Q(
      "peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
      e
    ),
    ...t,
    children: /* @__PURE__ */ h(zv, { className: Q("flex items-center justify-center text-current"), children: /* @__PURE__ */ h(tu, { className: "h-4 w-4" }) })
  }
));
O2.displayName = Ju.displayName;
var N2 = Object.defineProperty, $e = (e, t) => N2(e, "name", { value: t, configurable: !0 }), L0 = "ToastProvider", [cf, $0, _2] = /* @__PURE__ */ wi("Toast"), [F0, $B] = /* @__PURE__ */ It("Toast", [_2]), [I2, Ea] = F0(L0), L2 = /* @__PURE__ */ $e((e) => {
  const {
    __scopeToast: t,
    label: n = "Notification",
    duration: r = 5e3,
    swipeDirection: o = "right",
    swipeThreshold: i = 50,
    announcerContainer: s,
    children: a
  } = e, [l, c] = v.useState(null), [u, d] = v.useState(0), f = v.useRef(!1);
  return n.trim() || console.error(
    `Invalid prop \`label\` supplied to \`${L0}\`. Expected non-empty \`string\`.`
  ), /* @__PURE__ */ h(cf.Provider, { scope: t, children: /* @__PURE__ */ h(
    I2,
    {
      scope: t,
      label: n,
      duration: r,
      swipeDirection: o,
      swipeThreshold: i,
      toastCount: u,
      viewport: l,
      onViewportChange: c,
      onToastAdd: v.useCallback(() => d((m) => m + 1), []),
      onToastRemove: v.useCallback(() => d((m) => m - 1), []),
      isClosePausedRef: f,
      announcerContainer: s,
      children: a
    }
  ) });
}, "ToastProvider"), $2 = "ToastViewport", F2 = ["F8"], Qc = "toast.viewportPause", Zc = "toast.viewportResume", V0 = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ $e(function(t, n) {
    const {
      __scopeToast: r,
      hotkey: o = F2,
      label: i = "Notifications ({hotkey})",
      ...s
    } = t, a = Ea($2, r), l = $0(r), c = v.useRef(null), u = v.useRef(null), d = v.useRef(null), f = v.useRef(null), m = be(n, f, a.onViewportChange), p = o.join("+").replace(/Key/g, "").replace(/Digit/g, ""), g = a.toastCount > 0;
    v.useEffect(() => {
      const b = /* @__PURE__ */ $e((x) => {
        var S;
        o.length !== 0 && o.every((E) => x[E] || x.code === E) && ((S = f.current) == null || S.focus());
      }, "handleKeyDown");
      return document.addEventListener("keydown", b), () => document.removeEventListener("keydown", b);
    }, [o]), v.useEffect(() => {
      const b = c.current, x = f.current;
      if (g && b && x) {
        const w = /* @__PURE__ */ $e(() => {
          if (!a.isClosePausedRef.current) {
            const T = new CustomEvent(Qc);
            x.dispatchEvent(T), a.isClosePausedRef.current = !0;
          }
        }, "handlePause"), S = /* @__PURE__ */ $e(() => {
          if (a.isClosePausedRef.current) {
            const T = new CustomEvent(Zc);
            x.dispatchEvent(T), a.isClosePausedRef.current = !1;
          }
        }, "handleResume"), E = /* @__PURE__ */ $e((T) => {
          !b.contains(T.relatedTarget) && S();
        }, "handleFocusOutResume"), C = /* @__PURE__ */ $e(() => {
          b.contains(document.activeElement) || S();
        }, "handlePointerLeaveResume");
        return b.addEventListener("focusin", w), b.addEventListener("focusout", E), b.addEventListener("pointermove", w), b.addEventListener("pointerleave", C), window.addEventListener("blur", w), window.addEventListener("focus", S), () => {
          b.removeEventListener("focusin", w), b.removeEventListener("focusout", E), b.removeEventListener("pointermove", w), b.removeEventListener("pointerleave", C), window.removeEventListener("blur", w), window.removeEventListener("focus", S);
        };
      }
    }, [g, a.isClosePausedRef]);
    const y = v.useCallback(
      ({ tabbingDirection: b }) => {
        const w = l().map((S) => {
          const E = S.ref.current, C = [E, ...G0(E)];
          return b === "forwards" ? C : C.reverse();
        });
        return (b === "forwards" ? w.reverse() : w).flat();
      },
      [l]
    );
    return v.useEffect(() => {
      const b = f.current;
      if (b) {
        const x = /* @__PURE__ */ $e((w) => {
          var C, T, P;
          const S = w.altKey || w.ctrlKey || w.metaKey;
          if (w.key === "Tab" && !S) {
            const D = document.activeElement, k = w.shiftKey;
            if (w.target === b && k) {
              (C = u.current) == null || C.focus();
              return;
            }
            const _ = y({ tabbingDirection: k ? "backwards" : "forwards" }), $ = _.findIndex((z) => z === D);
            vs(_.slice($ + 1)) ? w.preventDefault() : k ? (T = u.current) == null || T.focus() : (P = d.current) == null || P.focus();
          }
        }, "handleKeyDown");
        return b.addEventListener("keydown", x), () => b.removeEventListener("keydown", x);
      }
    }, [l, y]), /* @__PURE__ */ L(
      VS,
      {
        ref: c,
        role: "region",
        "aria-label": i.replace("{hotkey}", p),
        tabIndex: -1,
        style: { pointerEvents: g ? void 0 : "none" },
        children: [
          g && /* @__PURE__ */ h(
            vp,
            {
              ref: u,
              onFocusFromOutsideViewport: () => {
                const b = y({
                  tabbingDirection: "forwards"
                });
                vs(b);
              }
            }
          ),
          /* @__PURE__ */ h(cf.Slot, { scope: r, children: /* @__PURE__ */ h(me.ol, { tabIndex: -1, ...s, ref: m }) }),
          g && /* @__PURE__ */ h(
            vp,
            {
              ref: d,
              onFocusFromOutsideViewport: () => {
                const b = y({
                  tabbingDirection: "backwards"
                });
                vs(b);
              }
            }
          )
        ]
      }
    );
  }, "ToastViewport")
), V2 = "ToastFocusProxy", vp = /* @__PURE__ */ v.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ $e(function(t, n) {
    const { __scopeToast: r, onFocusFromOutsideViewport: o, ...i } = t, s = Ea(V2, r);
    return /* @__PURE__ */ h(
      Mu,
      {
        tabIndex: 0,
        ...i,
        ref: n,
        style: { position: "fixed" },
        onFocus: (a) => {
          var u;
          const l = a.relatedTarget;
          !((u = s.viewport) != null && u.contains(l)) && o();
        }
      }
    );
  }, "ToastFocusProxy")
), ka = "Toast", B2 = "toast.swipeStart", W2 = "toast.swipeMove", z2 = "toast.swipeCancel", j2 = "toast.swipeEnd", B0 = /* @__PURE__ */ v.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ $e(function(t, n) {
    const { forceMount: r, open: o, defaultOpen: i, onOpenChange: s, ...a } = t, [l, c] = qn({
      prop: o,
      defaultProp: i ?? !0,
      onChange: s,
      caller: ka
    });
    return /* @__PURE__ */ h(Lt, { present: r || l, children: /* @__PURE__ */ h(
      Y2,
      {
        open: l,
        ...a,
        ref: n,
        onClose: () => c(!1),
        onPause: Je(t.onPause),
        onResume: Je(t.onResume),
        onSwipeStart: re(t.onSwipeStart, (u) => {
          u.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: re(t.onSwipeMove, (u) => {
          const { x: d, y: f } = u.detail.delta;
          u.currentTarget.setAttribute("data-swipe", "move"), u.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${d}px`), u.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${f}px`);
        }),
        onSwipeCancel: re(t.onSwipeCancel, (u) => {
          u.currentTarget.setAttribute("data-swipe", "cancel"), u.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), u.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), u.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), u.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: re(t.onSwipeEnd, (u) => {
          const { x: d, y: f } = u.detail.delta;
          u.currentTarget.setAttribute("data-swipe", "end"), u.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), u.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), u.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${d}px`), u.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${f}px`), c(!1);
        })
      }
    ) });
  }, "Toast")
), [H2, U2] = F0(ka, {
  onClose() {
  }
}), Y2 = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ $e(function(t, n) {
    const {
      __scopeToast: r,
      type: o = "foreground",
      duration: i,
      open: s,
      onClose: a,
      onEscapeKeyDown: l,
      onPause: c,
      onResume: u,
      onSwipeStart: d,
      onSwipeMove: f,
      onSwipeCancel: m,
      onSwipeEnd: p,
      ...g
    } = t, y = Ea(ka, r), b = $0(r), [x, w] = v.useState(null), S = be(n, w), E = v.useRef(null), C = v.useRef(null), T = i || y.duration, P = v.useRef(0), D = v.useRef(T), k = v.useRef(0), { onToastAdd: R, onToastRemove: O } = y, _ = Je(() => {
      var A;
      (x == null ? void 0 : x.contains(document.activeElement)) && ((A = y.viewport) == null || A.focus()), a();
    }), $ = v.useCallback(
      (I) => {
        !I || I === 1 / 0 || (window.clearTimeout(k.current), P.current = (/* @__PURE__ */ new Date()).getTime(), k.current = window.setTimeout(_, I));
      },
      [_]
    );
    v.useEffect(() => {
      const I = y.viewport;
      if (I) {
        const A = /* @__PURE__ */ $e(() => {
          $(D.current), u == null || u();
        }, "handleResume"), M = /* @__PURE__ */ $e(() => {
          const F = (/* @__PURE__ */ new Date()).getTime() - P.current;
          D.current = D.current - F, window.clearTimeout(k.current), c == null || c();
        }, "handlePause");
        return I.addEventListener(Qc, M), I.addEventListener(Zc, A), () => {
          I.removeEventListener(Qc, M), I.removeEventListener(Zc, A);
        };
      }
    }, [y.viewport, T, c, u, $]), v.useEffect(() => {
      s && !y.isClosePausedRef.current && $(T);
    }, [s, T, y.isClosePausedRef, $]), v.useEffect(() => () => {
      window.clearTimeout(k.current);
    }, []), v.useEffect(() => (R(), () => O()), [R, O]);
    const z = v.useMemo(() => x ? df(x) : null, [x]);
    return y.viewport ? /* @__PURE__ */ L(Oe, { children: [
      z && /* @__PURE__ */ h(
        G2,
        {
          __scopeToast: r,
          role: "status",
          "aria-live": o === "foreground" ? "assertive" : "polite",
          children: z
        }
      ),
      /* @__PURE__ */ h(H2, { scope: r, onClose: _, children: po.createPortal(
        /* @__PURE__ */ h(cf.ItemSlot, { scope: r, children: /* @__PURE__ */ h(
          pi,
          {
            asChild: !0,
            onEscapeKeyDown: re(l, (I) => {
              b().some(
                (M) => {
                  var F;
                  return (F = M.ref.current) == null ? void 0 : F.contains(I.target);
                }
              ) || _();
            }),
            children: /* @__PURE__ */ h(
              me.li,
              {
                tabIndex: 0,
                "data-state": s ? "open" : "closed",
                "data-swipe-direction": y.swipeDirection,
                ...g,
                ref: S,
                style: { userSelect: "none", touchAction: "none", ...t.style },
                onKeyDown: re(t.onKeyDown, (I) => {
                  I.key === "Escape" && (l == null || l(I.nativeEvent), I.nativeEvent.defaultPrevented || _());
                }),
                onPointerDown: re(t.onPointerDown, (I) => {
                  I.button === 0 && (E.current = { x: I.clientX, y: I.clientY });
                }),
                onPointerMove: re(t.onPointerMove, (I) => {
                  if (!E.current) return;
                  const A = I.clientX - E.current.x, M = I.clientY - E.current.y, F = !!C.current, W = ["left", "right"].includes(y.swipeDirection), ne = ["left", "up"].includes(y.swipeDirection) ? Math.min : Math.max, N = W ? ne(0, A) : 0, Y = W ? 0 : ne(0, M), H = I.pointerType === "touch" ? 10 : 2, U = { x: N, y: Y }, fe = { originalEvent: I, delta: U };
                  F ? (C.current = U, Fo(W2, f, fe, {
                    discrete: !1
                  })) : yp(U, y.swipeDirection, H) ? (C.current = U, Fo(B2, d, fe, {
                    discrete: !1
                  }), I.target.setPointerCapture(I.pointerId)) : (Math.abs(A) > H || Math.abs(M) > H) && (E.current = null);
                }),
                onPointerUp: re(t.onPointerUp, (I) => {
                  const A = C.current, M = I.target;
                  if (M.hasPointerCapture(I.pointerId) && M.releasePointerCapture(I.pointerId), C.current = null, E.current = null, A) {
                    const F = I.currentTarget, W = { originalEvent: I, delta: A };
                    yp(A, y.swipeDirection, y.swipeThreshold) ? Fo(j2, p, W, {
                      discrete: !0
                    }) : Fo(
                      z2,
                      m,
                      W,
                      {
                        discrete: !0
                      }
                    ), F.addEventListener("click", (ne) => ne.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        y.viewport
      ) })
    ] }) : null;
  }, "ToastImpl")
), G2 = /* @__PURE__ */ $e((e) => {
  const { __scopeToast: t, children: n, ...r } = e, o = Ea(ka, t), [i, s] = v.useState(!1), [a, l] = v.useState(!1);
  return U0(() => s(!0)), v.useEffect(() => {
    const c = window.setTimeout(() => l(!0), 1e3);
    return () => window.clearTimeout(c);
  }, []), a ? null : /* @__PURE__ */ h(gi, { asChild: !0, container: o.announcerContainer || void 0, children: /* @__PURE__ */ h(Mu, { ...r, children: i && /* @__PURE__ */ L(Oe, { children: [
    o.label,
    " ",
    n
  ] }) }) });
}, "ToastAnnounce"), W0 = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ $e(function(t, n) {
    const { __scopeToast: r, ...o } = t;
    return /* @__PURE__ */ h(me.div, { ...o, ref: n });
  }, "ToastTitle")
), z0 = /* @__PURE__ */ v.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ $e(function(t, n) {
    const { __scopeToast: r, ...o } = t;
    return /* @__PURE__ */ h(me.div, { ...o, ref: n });
  }, "ToastDescription")
), K2 = "ToastAction", j0 = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ $e(function(t, n) {
    const { altText: r, ...o } = t;
    return r.trim() ? /* @__PURE__ */ h(H0, { altText: r, asChild: !0, children: /* @__PURE__ */ h(uf, { ...o, ref: n }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${K2}\`. Expected non-empty \`string\`.`
    ), null);
  }, "ToastAction")
), X2 = "ToastClose", uf = /* @__PURE__ */ v.forwardRef(
  /* @__PURE__ */ $e(function(t, n) {
    const { __scopeToast: r, ...o } = t, i = U2(X2, r);
    return /* @__PURE__ */ h(H0, { asChild: !0, children: /* @__PURE__ */ h(
      me.button,
      {
        type: "button",
        ...o,
        ref: n,
        onClick: re(t.onClick, i.onClose)
      }
    ) });
  }, "ToastClose")
), H0 = /* @__PURE__ */ v.forwardRef(/* @__PURE__ */ $e(function(t, n) {
  const { __scopeToast: r, altText: o, ...i } = t;
  return /* @__PURE__ */ h(
    me.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": o || void 0,
      ...i,
      ref: n
    }
  );
}, "ToastAnnounceExclude"));
function df(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((r) => {
    if (r.nodeType === r.TEXT_NODE && r.textContent && t.push(r.textContent), Y0(r)) {
      const o = r.ariaHidden || r.hidden || r.style.display === "none", i = r.dataset.radixToastAnnounceExclude === "";
      if (!o)
        if (i) {
          const s = r.dataset.radixToastAnnounceAlt;
          s && t.push(s);
        } else
          t.push(...df(r));
    }
  }), t;
}
$e(df, "getAnnounceTextContent");
function Fo(e, t, n, { discrete: r }) {
  const o = n.originalEvent.currentTarget, i = new CustomEvent(e, { bubbles: !0, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? su(o, i) : o.dispatchEvent(i);
}
$e(Fo, "handleAndDispatchCustomEvent");
var yp = /* @__PURE__ */ $e((e, t, n = 0) => {
  const r = Math.abs(e.x), o = Math.abs(e.y), i = r > o;
  return t === "left" || t === "right" ? i && r > n : !i && o > n;
}, "isDeltaInDirection");
function U0(e = () => {
}) {
  const t = Je(e);
  qe(() => {
    let n = 0, r = 0;
    return n = window.requestAnimationFrame(() => r = window.requestAnimationFrame(t)), () => {
      window.cancelAnimationFrame(n), window.cancelAnimationFrame(r);
    };
  }, [t]);
}
$e(U0, "useNextFrame");
function Y0(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
$e(Y0, "isHTMLElement");
function G0(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: /* @__PURE__ */ $e((r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }, "acceptNode")
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
$e(G0, "getTabbableCandidates");
function vs(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
$e(vs, "focusFirst");
const q2 = L2, K0 = v.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  V0,
  {
    ref: n,
    className: Q(
      "fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]",
      e
    ),
    ...t
  }
));
K0.displayName = V0.displayName;
const Q2 = Rr(
  "group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border p-6 pr-8 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full",
  {
    variants: {
      variant: {
        default: "border bg-background text-foreground",
        destructive: "destructive group border-destructive bg-destructive text-destructive-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), X0 = v.forwardRef(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ h(B0, { ref: r, className: Q(Q2({ variant: t }), e), ...n }));
X0.displayName = B0.displayName;
const Z2 = v.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  j0,
  {
    ref: n,
    className: Q(
      "inline-flex h-8 shrink-0 items-center justify-center rounded-md border bg-transparent px-3 text-sm font-medium ring-offset-background transition-colors hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 group-[.destructive]:border-muted/40 group-[.destructive]:hover:border-destructive/30 group-[.destructive]:hover:bg-destructive group-[.destructive]:hover:text-destructive-foreground group-[.destructive]:focus:ring-destructive",
      e
    ),
    ...t
  }
));
Z2.displayName = j0.displayName;
const q0 = v.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  uf,
  {
    ref: n,
    className: Q(
      "absolute right-2 top-2 rounded-md p-1 text-foreground/50 opacity-0 transition-opacity hover:text-foreground focus:opacity-100 focus:outline-none focus:ring-2 group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600",
      e
    ),
    "toast-close": "",
    ...t,
    children: /* @__PURE__ */ h(eu, { className: "h-4 w-4" })
  }
));
q0.displayName = uf.displayName;
const Q0 = v.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(W0, { ref: n, className: Q("text-sm font-semibold", e), ...t }));
Q0.displayName = W0.displayName;
const Z0 = v.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(z0, { ref: n, className: Q("text-sm opacity-90", e), ...t }));
Z0.displayName = z0.displayName;
const J2 = 1, eV = 3e3;
let Dl = 0;
function tV() {
  return Dl = (Dl + 1) % Number.MAX_SAFE_INTEGER, Dl.toString();
}
const Rl = /* @__PURE__ */ new Map(), bp = (e) => {
  if (Rl.has(e))
    return;
  const t = setTimeout(() => {
    Rl.delete(e), Ko({
      type: "REMOVE_TOAST",
      toastId: e
    });
  }, eV);
  Rl.set(e, t);
}, nV = (e, t) => {
  switch (t.type) {
    case "ADD_TOAST":
      return {
        ...e,
        toasts: [t.toast, ...e.toasts].slice(0, J2)
      };
    case "UPDATE_TOAST":
      return {
        ...e,
        toasts: e.toasts.map((n) => n.id === t.toast.id ? { ...n, ...t.toast } : n)
      };
    case "DISMISS_TOAST": {
      const { toastId: n } = t;
      return n ? bp(n) : e.toasts.forEach((r) => {
        bp(r.id);
      }), {
        ...e,
        toasts: e.toasts.map(
          (r) => r.id === n || n === void 0 ? {
            ...r,
            open: !1
          } : r
        )
      };
    }
    case "REMOVE_TOAST":
      return t.toastId === void 0 ? {
        ...e,
        toasts: []
      } : {
        ...e,
        toasts: e.toasts.filter((n) => n.id !== t.toastId)
      };
  }
}, ys = [];
let bs = { toasts: [] };
function Ko(e) {
  bs = nV(bs, e), ys.forEach((t) => {
    t(bs);
  });
}
function rV({ ...e }) {
  const t = tV(), n = (o) => Ko({
    type: "UPDATE_TOAST",
    toast: { ...o, id: t }
  }), r = () => Ko({ type: "DISMISS_TOAST", toastId: t });
  return Ko({
    type: "ADD_TOAST",
    toast: {
      ...e,
      id: t,
      open: !0,
      onOpenChange: (o) => {
        o || r();
      }
    }
  }), {
    id: t,
    dismiss: r,
    update: n
  };
}
function oV() {
  const [e, t] = v.useState(bs);
  return v.useEffect(() => (ys.push(t), () => {
    const n = ys.indexOf(t);
    n > -1 && ys.splice(n, 1);
  }), [e]), {
    ...e,
    toast: rV,
    dismiss: (n) => Ko({ type: "DISMISS_TOAST", toastId: n })
  };
}
function FB() {
  const { toasts: e } = oV();
  return /* @__PURE__ */ L(q2, { children: [
    e.map(function({ id: t, title: n, description: r, action: o, ...i }) {
      return /* @__PURE__ */ L(X0, { ...i, children: [
        /* @__PURE__ */ L("div", { className: "grid gap-1", children: [
          n && /* @__PURE__ */ h(Q0, { children: n }),
          r && /* @__PURE__ */ h(Z0, { children: r })
        ] }),
        o,
        /* @__PURE__ */ h(q0, {})
      ] }, t);
    }),
    /* @__PURE__ */ h(K0, {})
  ] });
}
export {
  Ty as Alert,
  Ey as AlertDescription,
  Py as AlertTitle,
  t0 as Badge,
  yB as BulkUpdateButton,
  nD as BulkUpdater,
  Sk as BulkUpdaterColumnSelectBox,
  Ck as BulkUpdaterOptionBox,
  ke as Button,
  tf as Calendar,
  O2 as Checkbox,
  Mr as ClipedValueRenderer,
  wV as ColumnSplit,
  sf as Command,
  kB as CommandDialog,
  T0 as CommandEmpty,
  x2 as CommandGroup,
  w2 as CommandInput,
  P0 as CommandItem,
  C0 as CommandList,
  S2 as CommandSeparator,
  C2 as CommandShortcut,
  vV as ConfirmationModalProvider,
  WC as ContractExpandBar,
  sv as CustomTooltip,
  WE as DATATABLE_MARGIN,
  O1 as DEFAULT_COPY_OPTIONS,
  BE as DEFAULT_MIN_COLUMN_WIDTH,
  _V as Datatable,
  LV as DatatableBooleanInput,
  E1 as DatatableColumnFilter,
  V1 as DatatableColumnSort,
  IV as DatatableFixedHeightLoader,
  VV as DatatableHeader,
  $V as DatatableHeaderLeft,
  FV as DatatableHeaderRight,
  jV as DatatableHideColumnButton,
  XE as DatatableHideGroupButton,
  BV as DatatableInput,
  zE as DatatableKeyAction,
  NV as DatatableLabelProvider,
  HV as DatatableMoveColumnButton,
  B1 as DatatableNumberInput,
  UV as DatatableOrderColumnButton,
  W1 as DatatablePercentageInput,
  TE as DatatableRow,
  Ds as DatatableSelectInput,
  $1 as DatatableSpacerRow,
  Yv as DatatableStatus,
  YV as DatatableStickyToggle,
  lh as DatatableTr,
  lf as DatePickerContent,
  fp as DatePickerContentButton,
  Tg as Dialog,
  pV as DialogClose,
  wu as DialogContent,
  FC as DialogDescription,
  Eg as DialogFooter,
  $C as DialogHeader,
  Pg as DialogOverlay,
  LC as DialogPortal,
  kg as DialogTitle,
  mV as DialogTrigger,
  wy as Drawer,
  vB as DrawerClose,
  Sy as DrawerContent,
  eD as DrawerDescription,
  Jk as DrawerFooter,
  Zk as DrawerHeader,
  xy as DrawerOverlay,
  Qk as DrawerPortal,
  Cy as DrawerTitle,
  gB as DrawerTrigger,
  CB as ExportTableButton,
  Uv as FilterPopover,
  gP as GroupColumn,
  k1 as GroupTh,
  f1 as HoverInfo,
  Ti as Input,
  Bv as Label,
  Gt as LabeledContainer,
  PB as LabeledDatePicker,
  EB as LabeledDateRangePicker,
  qu as LabeledInput,
  M2 as LabeledMonthPicker,
  _B as LabeledMonthPickerWithButtons,
  DB as LabeledMultiselect,
  RB as LabeledOptionPopoverPicker,
  ch as LabeledSelect,
  A2 as LabeledYearPicker,
  IB as LabeledYearPickerWithButtons,
  AB as LabelledFormDateInput,
  af as LabelledFormInput,
  OB as LabelledFormSelectInput,
  MB as LabelledFormTextInput,
  gr as LoadingOverlay,
  xV as LockedColumnSplit,
  SV as LockedColumnSplitRight,
  T2 as MultiSelector,
  R0 as MultiSelectorContent,
  D0 as MultiSelectorInput,
  A0 as MultiSelectorItem,
  M0 as MultiSelectorList,
  k0 as MultiSelectorTrigger,
  Xv as NestedCheckbox,
  z1 as NestedCheckboxItem,
  ay as NestedCheckboxes,
  PE as NoopRender,
  Sr as Popover,
  _r as PopoverContent,
  wo as PopoverTrigger,
  WV as ResizeableTd,
  _P as ResizeableTh,
  Jw as ScrollArea,
  e0 as ScrollBar,
  sa as Select,
  la as SelectContent,
  Cv as SelectGroup,
  ca as SelectItem,
  xE as SelectLabel,
  Pv as SelectScrollDownButton,
  Tv as SelectScrollUpButton,
  SE as SelectSeparator,
  aa as SelectTrigger,
  Hu as SelectValue,
  k2 as SelectionLabelBox,
  Qo as Separator,
  SB as SortList,
  xB as SortableItem,
  D1 as SplitterTh,
  fV as TestBtn,
  X0 as Toast,
  Z2 as ToastAction,
  q0 as ToastClose,
  Z0 as ToastDescription,
  q2 as ToastProvider,
  Q0 as ToastTitle,
  K0 as ToastViewport,
  FB as Toaster,
  na as Tooltip,
  bi as TooltipContent,
  _u as TooltipProvider,
  ra as TooltipTrigger,
  td as TriStateCheckbox,
  zV as ValueRenderer,
  LB as YearPicker,
  UE as areAllSubgroupsCollapsed,
  HE as areGroupPathEquals,
  U$ as badgeVariants,
  dV as bigNumFormat,
  sh as blockSelect,
  OV as buildFilterLoaderFromTable,
  Il as buttonVariants,
  Gv as cellsToChanges,
  Q as cn,
  S1 as filterTable,
  N0 as filterUncheckedNodes,
  Al as format,
  co as formatText,
  Ro as generateChangesFromEditingCell,
  D2 as getCheckboxesFromData,
  C1 as getLength,
  ly as getMinHeightClass,
  NB as getPartialDataFromCheckboxes,
  oc as getRow,
  rc as getTopLevelCollapsedGroupPathIfExists,
  l1 as inputVariants,
  Do as isCellDisabledByValidation,
  pP as isCellRefEqual,
  mP as isCellRefEqualAtIndex,
  Hv as isRecordDisabledByValidation,
  AV as maskLookupFromColumns,
  RV as maxFn,
  MV as minFn,
  jr as moveSelectedCell,
  x1 as onLoadFiltersByColumn,
  DV as onSortColumn,
  nV as reducer,
  Ax as roundWithPrecision,
  T1 as shouldCharEnableEditing,
  P1 as shouldIgnoreGroupBecauseRowspan,
  rV as toast,
  I1 as useAdvancedCopy,
  A1 as useCellValidations,
  gV as useConfirmationModal,
  TV as useDatableFilters,
  PV as useDatatable,
  nd as useDatatableLabels,
  pk as useDebounceCallback,
  bB as usePersistentFilters,
  L1 as usePersistentSelection,
  oV as useToast
};
